import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  Upload: any;
};


export type AcceptAdditionalWorkResponse = {
  __typename?: 'AcceptAdditionalWorkResponse';
  quote?: Maybe<Scalars['JSON']>;
};

export type AcceptQuoteResponse = {
  __typename?: 'AcceptQuoteResponse';
  quote?: Maybe<Scalars['JSON']>;
};

export type AcceptedActivity = Activity & {
  __typename?: 'AcceptedActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: AcceptedActivityDetails;
};

export type AcceptedActivityDetails = ActivityDetails & {
  __typename?: 'AcceptedActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  signature?: Maybe<Scalars['String']>;
  additional?: Maybe<Scalars['Boolean']>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
};

export type AcknowledgeCheckoutResponse = {
  __typename?: 'AcknowledgeCheckoutResponse';
  billingId?: Maybe<Scalars['String']>;
};

export type Activity = {
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  trashed?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  details: ActivityDetails;
  assignedUsers?: Maybe<Scalars['JSON']>;
};

export type ActivityContact = {
  __typename?: 'ActivityContact';
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  secondaryFirstName?: Maybe<Scalars['String']>;
  secondaryLastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  preferredContactMethod?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
};

export type ActivityDeal = {
  __typename?: 'ActivityDeal';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
  stage?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  assignedUsers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ActivityDetails = {
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
};

export type ActivityEmail = {
  __typename?: 'ActivityEmail';
  to?: Maybe<Array<Maybe<Scalars['String']>>>;
  smsTo?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};

export type ActivityJobAddress = {
  __typename?: 'ActivityJobAddress';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
};

export type ActivityMessage = {
  __typename?: 'ActivityMessage';
  deleted?: Maybe<Scalars['Boolean']>;
  from: ActivityMessageFrom;
  smsTo?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  readAt?: Maybe<Scalars['Float']>;
};

export type ActivityMessageFrom = {
  __typename?: 'ActivityMessageFrom';
  userId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  isCustomer?: Maybe<Scalars['Boolean']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
};

export type ActivityQuote = {
  __typename?: 'ActivityQuote';
  id: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['Boolean']>;
  dealId?: Maybe<Scalars['String']>;
  int_ext?: Maybe<QuoteType>;
};

export type AddPaymentResult = {
  __typename?: 'AddPaymentResult';
  success: Scalars['Boolean'];
  paymentId?: Maybe<Scalars['String']>;
  /** Human-readable list of what happened, including anything that was sent. */
  changes: Array<Scalars['String']>;
};

export type AddProcessingPaymentResponse = {
  __typename?: 'AddProcessingPaymentResponse';
  updatedQuote: Scalars['JSON'];
};

export type AddSubscriptionAddonResponse = {
  __typename?: 'AddSubscriptionAddonResponse';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  embed?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['Int']>;
  expires_at?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Int']>;
  resource_version?: Maybe<Scalars['Int']>;
};

export type AdminDashboardStats = {
  __typename?: 'AdminDashboardStats';
  activeClients?: Maybe<Scalars['Int']>;
  activeUsers?: Maybe<Scalars['Int']>;
  newTrials?: Maybe<Scalars['Int']>;
  expiringTrials?: Maybe<Scalars['Int']>;
  currentTrials?: Maybe<Scalars['Int']>;
  newActiveClients?: Maybe<Scalars['Int']>;
  newActiveUsers?: Maybe<Scalars['Int']>;
};

export type AdminIntegrationsConfigResponse = {
  __typename?: 'AdminIntegrationsConfigResponse';
  provider?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
  error?: Maybe<Scalars['JSON']>;
};

export type AdminLeaderboardResponse = {
  __typename?: 'AdminLeaderboardResponse';
  totalRows?: Maybe<Scalars['Int']>;
  updatedDate?: Maybe<Scalars['Float']>;
  rows?: Maybe<Array<Maybe<AdminLeaderboardRow>>>;
};

export type AdminLeaderboardRow = {
  __typename?: 'AdminLeaderboardRow';
  rank?: Maybe<Scalars['Int']>;
  playerName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  totalSold?: Maybe<Scalars['Float']>;
  winRate?: Maybe<Scalars['Float']>;
  numberSold?: Maybe<Scalars['Int']>;
  customAvatar?: Maybe<Scalars['String']>;
  totalSoldComment?: Maybe<Scalars['String']>;
  winRateComment?: Maybe<Scalars['String']>;
};

export type AdminPaymentEntry = {
  __typename?: 'AdminPaymentEntry';
  id?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Boolean']>;
  surcharge?: Maybe<Scalars['Float']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  requestActivityId?: Maybe<Scalars['String']>;
  forPaymentId?: Maybe<Scalars['String']>;
  providerDetails?: Maybe<Scalars['JSON']>;
  /**
   * The Payrix txn id, read from either place it is stored. Null means this payment cannot be
   * synced against the portal.
   */
  txnId?: Maybe<Scalars['String']>;
  /** Deep link to the payment in the provider's portal, when there is one. */
  portalLink?: Maybe<Scalars['String']>;
};

export type AdminPaymentQuote = {
  __typename?: 'AdminPaymentQuote';
  id: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
  isInvoice: Scalars['Boolean'];
  contactName?: Maybe<Scalars['String']>;
  amountPaid: Scalars['Float'];
  balanceDue: Scalars['Float'];
  paymentProcessing: Scalars['Boolean'];
  paymentError: Scalars['Boolean'];
  payments: Array<AdminPaymentEntry>;
};

export type ApiKeyDocument = {
  __typename?: 'ApiKeyDocument';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  owner?: Maybe<Owner>;
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type ApiKeyOwnerInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type AppDocsResponse = {
  __typename?: 'AppDocsResponse';
  options?: Maybe<Scalars['JSON']>;
  companyDetails?: Maybe<Scalars['JSON']>;
  rates?: Maybe<Scalars['JSON']>;
  companies?: Maybe<Scalars['JSON']>;
  preferences?: Maybe<Scalars['JSON']>;
  remainingQuotes?: Maybe<Scalars['Int']>;
};

export type AppMetaDataUserCompany = {
  __typename?: 'AppMetaDataUserCompany';
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  banned?: Maybe<Scalars['Boolean']>;
  billingId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  flaggedTrial?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isTrial?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nonBilling?: Maybe<Scalars['Boolean']>;
  parentCompanyId?: Maybe<Scalars['String']>;
  paymentExpiryNotice?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  subscription?: Maybe<CompanySubscription>;
  trialExpired?: Maybe<Scalars['Boolean']>;
  trialExpiry?: Maybe<Scalars['Int']>;
};

export type AppMetadata = {
  __typename?: 'AppMetadata';
  companyId?: Maybe<Scalars['String']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  roles: Array<Scalars['String']>;
  seatType?: Maybe<Scalars['String']>;
  accountOwner?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  integrations?: Maybe<Scalars['JSON']>;
  active?: Maybe<Scalars['Boolean']>;
  forceFollowUps?: Maybe<Scalars['Boolean']>;
  user?: Maybe<AppMetadataUser>;
  elasticsearch?: Maybe<Scalars['Boolean']>;
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  mfa_enrolled?: Maybe<Scalars['Boolean']>;
  mfa_excluded?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Scalars['String']>;
  company?: Maybe<AppMetaDataUserCompany>;
  customPermissions?: Maybe<Scalars['JSON']>;
  painterType?: Maybe<Scalars['String']>;
  lastPermissionsUpdated?: Maybe<Scalars['String']>;
  resolvedPermissions?: Maybe<Array<Scalars['String']>>;
};

export type AppMetadataInput = {
  roles: Array<Scalars['String']>;
  seatType?: Maybe<Scalars['String']>;
  accountOwner?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  integrations?: Maybe<Scalars['JSON']>;
  companyId?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  elasticsearch?: Maybe<Scalars['Boolean']>;
  user?: Maybe<AppMetadataUserInput>;
  needsOnboarding?: Maybe<Scalars['Boolean']>;
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  customPermissions?: Maybe<Scalars['JSON']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  painterType?: Maybe<Scalars['String']>;
};

export type AppMetadataUser = {
  __typename?: 'AppMetadataUser';
  _id?: Maybe<Scalars['String']>;
};

export type AppMetadataUserInput = {
  _id?: Maybe<Scalars['String']>;
};

export type ApplyPaymentSyncResult = {
  __typename?: 'ApplyPaymentSyncResult';
  success: Scalars['Boolean'];
  /** Human-readable list of what changed, for the confirmation snackbar. */
  changes: Array<Scalars['String']>;
};

export enum AssignedCsm {
  Sam = 'sam',
  Becca = 'becca'
}

export type AssignmentActivity = Activity & {
  __typename?: 'AssignmentActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: AssignmentActivityDetails;
};

export type AssignmentActivityDetails = ActivityDetails & {
  __typename?: 'AssignmentActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  assignees?: Maybe<Array<Maybe<Scalars['String']>>>;
  assigner?: Maybe<Scalars['String']>;
};

export type AttachTxnIdResult = {
  __typename?: 'AttachTxnIdResult';
  success: Scalars['Boolean'];
  changes: Array<Scalars['String']>;
};

export type Auth0LogEntry = {
  __typename?: 'Auth0LogEntry';
  date?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  connection?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  user_agent?: Maybe<Scalars['String']>;
  log_id?: Maybe<Scalars['String']>;
};

export type Auth0LogsResult = {
  __typename?: 'Auth0LogsResult';
  logs: Array<Auth0LogEntry>;
  truncated: Scalars['Boolean'];
};

export type BasicActivity = Activity & {
  __typename?: 'BasicActivity';
  _id: Scalars['String'];
  _rev: Scalars['String'];
  _deleted?: Maybe<Scalars['Boolean']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  docIds: Array<Maybe<Scalars['String']>>;
  details: BasicActivityDetails;
  assignedUsers?: Maybe<Scalars['JSON']>;
};

export type BasicActivityDetails = ActivityDetails & {
  __typename?: 'BasicActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type BulkDocsResponseObject = {
  __typename?: 'BulkDocsResponseObject';
  _id?: Maybe<Scalars['String']>;
  _rev?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['JSON']>;
  error?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export enum CancellationFlowStatus {
  None = 'none',
  CoachingCallShown = 'coaching_call_shown',
  CoachingCallBooked = 'coaching_call_booked',
  OfferShown = 'offer_shown',
  Saved = 'saved',
  EscalatedToSupport = 'escalated_to_support',
  CancellationScheduled = 'cancellation_scheduled',
  Cancelled = 'cancelled',
  Reactivated = 'reactivated'
}

export type CancellationImpactSummary = {
  __typename?: 'CancellationImpactSummary';
  totalQuotes: Scalars['Float'];
  totalContacts: Scalars['Float'];
  yearsOfHistory: Scalars['Float'];
};

export enum CancellationReason {
  TooExpensive = 'too_expensive',
  SlowSeason = 'slow_season',
  TooBusy = 'too_busy',
  NotUsing = 'not_using',
  MissingFeature = 'missing_feature',
  TooHard = 'too_hard',
  Competitor = 'competitor',
  Closing = 'closing',
  SupportUnhelpful = 'support_unhelpful',
  Other = 'other'
}

export type ChargebeeAddon = {
  __typename?: 'ChargebeeAddon';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
};

export type ChargebeeAddonSummary = {
  __typename?: 'ChargebeeAddonSummary';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ChargebeeBillingContact = {
  __typename?: 'ChargebeeBillingContact';
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ChargebeeCharge = {
  __typename?: 'ChargebeeCharge';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Int']>;
};

export type ChargebeeCoupon = {
  __typename?: 'ChargebeeCoupon';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  discount_type?: Maybe<Scalars['String']>;
  discount_amount?: Maybe<Scalars['Int']>;
  discount_percentage?: Maybe<Scalars['Float']>;
  duration_type?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
};

export type ChargebeeDiscount = {
  __typename?: 'ChargebeeDiscount';
  id?: Maybe<Scalars['String']>;
  invoice_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  duration_type?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['Int']>;
  period_unit?: Maybe<Scalars['String']>;
  apply_on?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Float']>;
  object?: Maybe<Scalars['String']>;
  apply_till?: Maybe<Scalars['Float']>;
  applied_count?: Maybe<Scalars['Int']>;
  currency_code?: Maybe<Scalars['String']>;
};

export type ChargebeeItemPrice = {
  __typename?: 'ChargebeeItemPrice';
  id: Scalars['ID'];
  name: Scalars['String'];
  internalName?: Maybe<Scalars['String']>;
  itemType: Scalars['String'];
  pricingModel: Scalars['String'];
  price: Scalars['Int'];
  currencyCode: Scalars['String'];
};

export type ChargebeeOneTimeCharge = {
  __typename?: 'ChargebeeOneTimeCharge';
  id: Scalars['String'];
  description: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Int']>;
  discountAmount?: Maybe<Scalars['Int']>;
  currencyCode?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Float']>;
  itemPriceId?: Maybe<Scalars['String']>;
  isAdhoc: Scalars['Boolean'];
  invoiceId: Scalars['String'];
  invoiceStatus?: Maybe<Scalars['String']>;
};

export type ChargebeePlan = {
  __typename?: 'ChargebeePlan';
  name?: Maybe<Scalars['String']>;
  invoice_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ChargebeeSubscription = {
  __typename?: 'ChargebeeSubscription';
  plan_id?: Maybe<Scalars['String']>;
  plan_amount?: Maybe<Scalars['Int']>;
  plan_quantity?: Maybe<Scalars['Int']>;
  plan_unit_price?: Maybe<Scalars['Int']>;
  currency_code?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  mrr?: Maybe<Scalars['Float']>;
  billing_period?: Maybe<Scalars['Int']>;
  billing_period_unit?: Maybe<Scalars['String']>;
  current_term_start?: Maybe<Scalars['Float']>;
  current_term_end?: Maybe<Scalars['Float']>;
  subscription_start?: Maybe<Scalars['Float']>;
  subscription_activated?: Maybe<Scalars['Float']>;
  started_at?: Maybe<Scalars['Float']>;
  cancelled_at?: Maybe<Scalars['Float']>;
  time_to_churn?: Maybe<Scalars['Int']>;
  addons?: Maybe<Array<Maybe<ChargebeeAddon>>>;
  charges?: Maybe<Array<Maybe<ChargebeeCharge>>>;
  coupons?: Maybe<Array<Maybe<ChargebeeCoupon>>>;
  discounts?: Maybe<Array<Maybe<ChargebeeDiscount>>>;
  plan?: Maybe<ChargebeePlan>;
  coreSeatsAvailable?: Maybe<Scalars['Int']>;
  teamSeatsAvailable?: Maybe<Scalars['Int']>;
  crewSeatsAvailable?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  officeSeatsAvailable?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  fullSeatsAvailable?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  liteSeatsAvailable?: Maybe<Scalars['Int']>;
  billingContact?: Maybe<ChargebeeBillingContact>;
  diff?: Maybe<Scalars['JSON']>;
  cf_production_pricing_migration_timestamp?: Maybe<Scalars['Float']>;
};

export type ChargebeeSubscriptionSummary = {
  __typename?: 'ChargebeeSubscriptionSummary';
  status?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  billing_period_unit?: Maybe<Scalars['String']>;
  current_term_end?: Maybe<Scalars['Float']>;
  cf_production_pricing_migration_timestamp?: Maybe<Scalars['Float']>;
  addons?: Maybe<Array<Maybe<ChargebeeAddonSummary>>>;
  coreSeatsAvailable?: Maybe<Scalars['Int']>;
  teamSeatsAvailable?: Maybe<Scalars['Int']>;
  crewSeatsAvailable?: Maybe<Scalars['Int']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  sender: Scalars['String'];
  text: Scalars['String'];
  toolCalls?: Maybe<Scalars['JSON']>;
  model?: Maybe<Scalars['String']>;
  usage?: Maybe<ChatMessageUsage>;
  error?: Maybe<Scalars['Boolean']>;
};

export type ChatMessageActivity = Activity & {
  __typename?: 'ChatMessageActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: ChatMessageActivityDetails;
};

export type ChatMessageActivityDetails = ActivityDetails & {
  __typename?: 'ChatMessageActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  chatMessage: ChatMessage;
  rating?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
  undo?: Maybe<Scalars['Boolean']>;
  conversationTitle?: Maybe<Scalars['String']>;
};

export type ChatMessageUsage = {
  __typename?: 'ChatMessageUsage';
  inputTokens?: Maybe<Scalars['Float']>;
  outputTokens?: Maybe<Scalars['Float']>;
  cacheReadTokens?: Maybe<Scalars['Float']>;
  cacheCreationTokens?: Maybe<Scalars['Float']>;
  estimatedCostUsd?: Maybe<Scalars['Float']>;
};

export type CheckoutAddonInput = {
  itemPriceId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
};

export type CheckoutCoupon = {
  __typename?: 'CheckoutCoupon';
  id: Scalars['ID'];
  name: Scalars['String'];
  discountType: Scalars['String'];
  discountAmount?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Float']>;
};

export type CheckoutEstimate = {
  __typename?: 'CheckoutEstimate';
  lineItems: Array<CheckoutEstimateLineItem>;
  subTotal: Scalars['Int'];
  discountTotal: Scalars['Int'];
  taxTotal: Scalars['Int'];
  total: Scalars['Int'];
  currencyCode: Scalars['String'];
};

export type CheckoutEstimateLineItem = {
  __typename?: 'CheckoutEstimateLineItem';
  description: Scalars['String'];
  quantity: Scalars['Int'];
  amount: Scalars['Int'];
  isCharge: Scalars['Boolean'];
};

export type CheckoutInput = {
  companyId: Scalars['ID'];
  planItemPriceId: Scalars['ID'];
  seats: Scalars['Int'];
  addons: Array<CheckoutAddonInput>;
  couponId?: Maybe<Scalars['ID']>;
  salesRepId: Scalars['ID'];
  internalNote?: Maybe<Scalars['String']>;
  customerFirstName: Scalars['String'];
  customerLastName: Scalars['String'];
  customerEmail: Scalars['String'];
  customerPhone?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
};

export type CheckoutResult = {
  __typename?: 'CheckoutResult';
  url: Scalars['String'];
  expiresAt: Scalars['Int'];
  estimate: CheckoutEstimate;
  emailStatus: Scalars['String'];
};

export type ClientAggregates = {
  __typename?: 'ClientAggregates';
  totalQuotes?: Maybe<Scalars['Int']>;
  totalInvoices?: Maybe<Scalars['Int']>;
  totalBidValue?: Maybe<Scalars['Float']>;
  averageBidValue?: Maybe<Scalars['Float']>;
  closeRate?: Maybe<Scalars['Float']>;
  closedQuotes?: Maybe<Scalars['Int']>;
  closedValue?: Maybe<Scalars['Float']>;
  averageCloseValue?: Maybe<Scalars['Float']>;
};

export type ClientAggregatesInput = {
  totalQuotes?: Maybe<Scalars['Int']>;
  totalInvoices?: Maybe<Scalars['Int']>;
  totalBidValue?: Maybe<Scalars['Float']>;
  averageBidValue?: Maybe<Scalars['Float']>;
  closeRate?: Maybe<Scalars['Float']>;
  closedQuotes?: Maybe<Scalars['Int']>;
  closedValue?: Maybe<Scalars['Float']>;
  averageCloseValue?: Maybe<Scalars['Float']>;
};

export type ClientCancellationFlow = {
  __typename?: 'ClientCancellationFlow';
  reason?: Maybe<CancellationReason>;
  reasonKey?: Maybe<Scalars['String']>;
  reasonText?: Maybe<Scalars['String']>;
  competitorTool?: Maybe<Scalars['String']>;
  status?: Maybe<CancellationFlowStatus>;
  coachingCallStatus?: Maybe<CoachingCallStatus>;
  coachingCallShownAt?: Maybe<Scalars['Float']>;
  coachingCallBookedAt?: Maybe<Scalars['Float']>;
  discountRedeemedAt?: Maybe<Scalars['Float']>;
  cancellationScheduledFor?: Maybe<Scalars['Float']>;
  pauseScheduledFor?: Maybe<Scalars['Float']>;
  pauseResumesAt?: Maybe<Scalars['Float']>;
  downgradeRequestedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type ClientCancellationFlowInput = {
  reason?: Maybe<CancellationReason>;
  reasonKey?: Maybe<Scalars['String']>;
  reasonText?: Maybe<Scalars['String']>;
  competitorTool?: Maybe<Scalars['String']>;
  status?: Maybe<CancellationFlowStatus>;
  coachingCallStatus?: Maybe<CoachingCallStatus>;
};

export type ClientDunning = {
  __typename?: 'ClientDunning';
  status?: Maybe<DunningStatus>;
  firstPaymentFailedAt?: Maybe<Scalars['Float']>;
  restrictedAt?: Maybe<Scalars['Float']>;
  lockedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type ClientMeta = {
  __typename?: 'ClientMeta';
  _id?: Maybe<Scalars['String']>;
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  banned?: Maybe<Scalars['Boolean']>;
  skipHubspotSync?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Scalars['String']>;
  trialExpiry?: Maybe<Scalars['Float']>;
  trialExpired?: Maybe<Scalars['Boolean']>;
  billingId?: Maybe<Scalars['String']>;
  parentCompanyId?: Maybe<Scalars['String']>;
  nonBilling?: Maybe<Scalars['Boolean']>;
  includeInLeaderboards?: Maybe<Scalars['Boolean']>;
  excludeFromLeaderboards?: Maybe<Scalars['Boolean']>;
  paymentExpiryNotice?: Maybe<Scalars['Boolean']>;
  subscription?: Maybe<ClientMetaSubscription>;
  userCounts?: Maybe<ClientUserCounts>;
  aggregates?: Maybe<ClientAggregates>;
  plan?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  product?: Maybe<ClientProduct>;
  updated?: Maybe<Scalars['Float']>;
  created?: Maybe<Scalars['Float']>;
  delete?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ClientOptions>;
  cancellationFlow?: Maybe<ClientCancellationFlow>;
  dunning?: Maybe<ClientDunning>;
};

export type ClientMetaInput = {
  _id?: Maybe<Scalars['String']>;
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  banned?: Maybe<Scalars['Boolean']>;
  skipHubspotSync?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Scalars['String']>;
  trialExpiry?: Maybe<Scalars['Float']>;
  trialExpired?: Maybe<Scalars['Boolean']>;
  billingId?: Maybe<Scalars['String']>;
  parentCompanyId?: Maybe<Scalars['String']>;
  nonBilling?: Maybe<Scalars['Boolean']>;
  includeInLeaderboards?: Maybe<Scalars['Boolean']>;
  excludeFromLeaderboards?: Maybe<Scalars['Boolean']>;
  paymentExpiryNotice?: Maybe<Scalars['Boolean']>;
  subscription?: Maybe<ClientMetaSubscriptionInput>;
  aggregates?: Maybe<ClientAggregatesInput>;
  userCounts?: Maybe<ClientUserCountsInput>;
  plan?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  product?: Maybe<ClientProduct>;
  updated?: Maybe<Scalars['Float']>;
  created?: Maybe<Scalars['Float']>;
  delete?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ClientOptionsInput>;
};

export type ClientMetaSubscription = {
  __typename?: 'ClientMetaSubscription';
  plan_id?: Maybe<Scalars['String']>;
  current_term_start?: Maybe<Scalars['Float']>;
  current_term_end?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
};

export type ClientMetaSubscriptionInput = {
  plan_id?: Maybe<Scalars['String']>;
  current_term_start?: Maybe<Scalars['Float']>;
  current_term_end?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
};

export type ClientOptions = {
  __typename?: 'ClientOptions';
  allowDecline?: Maybe<Scalars['Boolean']>;
  companyCity?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<Scalars['String']>;
  companyCoordinates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  companyEmail?: Maybe<Scalars['String']>;
  companyCountry?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  companyPostal?: Maybe<Scalars['String']>;
  companyProv?: Maybe<Scalars['String']>;
  customCss?: Maybe<Scalars['String']>;
  crmBCCEmail?: Maybe<Scalars['String']>;
  acceptDisclaimer?: Maybe<Scalars['String']>;
  acceptAdditionalDisclaimer?: Maybe<Scalars['String']>;
  declineDisclaimer?: Maybe<Scalars['String']>;
  phoneNumberSeparator?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  wisetackSignupDate?: Maybe<Scalars['Int']>;
};

export type ClientOptionsInput = {
  allowDecline?: Maybe<Scalars['Boolean']>;
  companyCity?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<Scalars['String']>;
  companyCoordinates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  companyEmail?: Maybe<Scalars['String']>;
  companyCountry?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  companyPostal?: Maybe<Scalars['String']>;
  companyProv?: Maybe<Scalars['String']>;
  customCss?: Maybe<Scalars['String']>;
  crmBCCEmail?: Maybe<Scalars['String']>;
  acceptDisclaimer?: Maybe<Scalars['String']>;
  acceptAdditionalDisclaimer?: Maybe<Scalars['String']>;
  declineDisclaimer?: Maybe<Scalars['String']>;
  phoneNumberSeparator?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  wisetackSignupDate?: Maybe<Scalars['Int']>;
};

export enum ClientProduct {
  Ps = 'ps'
}

export type ClientResponse = {
  __typename?: 'ClientResponse';
  meta?: Maybe<ClientMeta>;
  options?: Maybe<Scalars['JSON']>;
  internalOptions?: Maybe<Scalars['JSON']>;
  rates?: Maybe<Scalars['JSON']>;
  sequence?: Maybe<Scalars['JSON']>;
  companies?: Maybe<Scalars['JSON']>;
};

export type ClientUserCounts = {
  __typename?: 'ClientUserCounts';
  all?: Maybe<Scalars['Float']>;
};

export type ClientUserCountsInput = {
  all?: Maybe<Scalars['Float']>;
};

export type CloudinaryFile = {
  __typename?: 'CloudinaryFile';
  public_id?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  signature?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  format?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  bytes?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  secure_url?: Maybe<Scalars['String']>;
  overwritten?: Maybe<Scalars['Boolean']>;
  original_filename?: Maybe<Scalars['String']>;
  original_extension?: Maybe<Scalars['String']>;
};

export enum CoachingCallStatus {
  NotShown = 'not_shown',
  Shown = 'shown',
  Booked = 'booked',
  Skipped = 'skipped'
}

export type Company = {
  __typename?: 'Company';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Boolean']>;
  trashed?: Maybe<Scalars['Boolean']>;
  trashedBy?: Maybe<Scalars['String']>;
  deleteDate?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  phone_ext?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Float']>;
  updated?: Maybe<Scalars['Float']>;
  owner?: Maybe<Owner>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  tags?: Maybe<Scalars['JSON']>;
  lead_source?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['JSON']>;
};

export type CompanySubscription = {
  __typename?: 'CompanySubscription';
  plan_id?: Maybe<Scalars['String']>;
  current_term_end?: Maybe<Scalars['Int']>;
  current_term_start?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type Contact = CouchDocument & {
  __typename?: 'Contact';
  _id: Scalars['String'];
  _rev: Scalars['String'];
  _deleted?: Maybe<Scalars['Boolean']>;
  trashed?: Maybe<Scalars['Boolean']>;
  trashedBy?: Maybe<Scalars['String']>;
  deleteDate?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  demo?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  secondary_first_name?: Maybe<Scalars['String']>;
  secondary_last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  alternate_email?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['JSON']>;
  shippingAddress?: Maybe<Scalars['JSON']>;
  isBillingShipping?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  geocode?: Maybe<ContactGeocode>;
  phone_number?: Maybe<Scalars['String']>;
  phone_ext?: Maybe<Scalars['String']>;
  alternate_phone?: Maybe<Scalars['String']>;
  alternate_phone_ext?: Maybe<Scalars['String']>;
  sms_undeliverable?: Maybe<Scalars['Boolean']>;
  sms_undeliverable_reason?: Maybe<Scalars['String']>;
  sms_undeliverable_at?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  companyDocId?: Maybe<Scalars['String']>;
  contact_type?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['Float']>;
  updated_date?: Maybe<Scalars['Float']>;
  source_id?: Maybe<Scalars['String']>;
  source_user_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  lead_source?: Maybe<Scalars['String']>;
  acquisitionSource?: Maybe<Scalars['String']>;
  stAppointmentDate?: Maybe<Scalars['String']>;
  pldDeals?: Maybe<Scalars['JSON']>;
  salesforceOpportunities?: Maybe<Scalars['JSON']>;
  internal_note?: Maybe<Scalars['String']>;
  preferred_contact_method?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  files?: Maybe<Scalars['JSON']>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  owner?: Maybe<Owner>;
  wisetackPrequal?: Maybe<WisetackPrequal>;
  wisetackLoanApplication?: Maybe<WisetackLoanApplication>;
  wisetackLoanApplications?: Maybe<Array<Maybe<WisetackLoanApplication>>>;
  PK?: Maybe<Scalars['String']>;
  SK?: Maybe<Scalars['String']>;
};

export type ContactGeocode = {
  __typename?: 'ContactGeocode';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type ConvertedFile = {
  __typename?: 'ConvertedFile';
  src: Scalars['String'];
  s3PublicKey: Scalars['String'];
  bucket: Scalars['String'];
  format: Scalars['String'];
  type: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export type CouchDocument = {
  _id?: Maybe<Scalars['String']>;
  _rev?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type CreateClientInput = {
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JSON']>;
  meta?: Maybe<Scalars['JSON']>;
  template?: Maybe<Scalars['String']>;
};

export type CreateNoteResponse = {
  __typename?: 'CreateNoteResponse';
  activity?: Maybe<NoteActivity>;
};

export type CreatePaymentActivityResponse = {
  __typename?: 'CreatePaymentActivityResponse';
  activity?: Maybe<PaymentActivity>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  user_metadata: UserMetadataInput;
  app_metadata: AppMetadataInput;
};

export type CsmBookingInfo = {
  __typename?: 'CsmBookingInfo';
  csm?: Maybe<AssignedCsm>;
  bookingUrl: Scalars['String'];
};

export type CsvOwner = {
  value?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
};

export type CustomAvatar = {
  __typename?: 'CustomAvatar';
  label?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
  cdnValue?: Maybe<Scalars['String']>;
  cloudinaryId?: Maybe<Scalars['String']>;
  s3PublicKey?: Maybe<Scalars['String']>;
};

export type CustomAvatarInput = {
  label?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
  cdnValue?: Maybe<Scalars['String']>;
  cloudinaryId?: Maybe<Scalars['String']>;
  s3PublicKey?: Maybe<Scalars['String']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  start?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['Float']>;
};

export type DateRangeInput = {
  start?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['Float']>;
};

export type Deal = CouchDocument & {
  __typename?: 'Deal';
  _id: Scalars['String'];
  _rev: Scalars['String'];
  _deleted?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  contact?: Maybe<DealContact>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
  valueBeforeTax?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
  quoteType?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  stage?: Maybe<DealStage>;
  jobAddress?: Maybe<Scalars['JSON']>;
  geocode?: Maybe<DealGeocode>;
  job_identifier?: Maybe<Scalars['String']>;
  enteredStage?: Maybe<Scalars['Float']>;
  history?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Float']>;
  updated?: Maybe<Scalars['Float']>;
  files?: Maybe<Scalars['JSON']>;
  source_id?: Maybe<Scalars['String']>;
  source_user_id?: Maybe<Scalars['String']>;
  lead_source?: Maybe<Scalars['String']>;
  acquisitionSource?: Maybe<Scalars['String']>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  owner?: Maybe<Owner>;
  ownerHistory?: Maybe<Scalars['JSON']>;
  estimator?: Maybe<Owner>;
  projectManager?: Maybe<Owner>;
  tags?: Maybe<Scalars['JSON']>;
  deletedTags?: Maybe<Scalars['JSON']>;
  pipeline?: Maybe<DealPipeline>;
  archived?: Maybe<Scalars['Boolean']>;
  trashed?: Maybe<Scalars['Boolean']>;
  trashedBy?: Maybe<Scalars['String']>;
  trashedDate?: Maybe<Scalars['Float']>;
  deleteDate?: Maybe<Scalars['Float']>;
  status?: Maybe<DealStatus>;
  linkedQuoteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedInvoiceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  trashedLinkedQuoteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  trashedLinkedInvoiceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedProductionEventIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasProductionEvent?: Maybe<Scalars['Boolean']>;
  taskTemplateOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobCosting?: Maybe<JobCosting>;
  jobEndDate?: Maybe<Scalars['Float']>;
};

export type DealContact = {
  __typename?: 'DealContact';
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  preferredContactMethod?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
};

export type DealGeocode = {
  __typename?: 'DealGeocode';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type DealPipeline = {
  __typename?: 'DealPipeline';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DealStage = {
  __typename?: 'DealStage';
  value: Scalars['String'];
};

export enum DealStatus {
  Draft = 'draft',
  Open = 'open',
  Won = 'won',
  Lost = 'lost'
}

export type DealSummaryResponse = {
  __typename?: 'DealSummaryResponse';
  totalDeals: Scalars['Float'];
  totalDealValue: Scalars['Float'];
};

export type DeclineQuoteResponse = {
  __typename?: 'DeclineQuoteResponse';
  quote?: Maybe<Scalars['JSON']>;
};

export type DeclinedActivity = Activity & {
  __typename?: 'DeclinedActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: DeclinedActivityDetails;
};

export type DeclinedActivityDetails = ActivityDetails & {
  __typename?: 'DeclinedActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
};

export type DeletePaymentResponse = {
  __typename?: 'DeletePaymentResponse';
  updatedQuote: Scalars['JSON'];
};

export type DowngradeSubscriptionResponse = {
  __typename?: 'DowngradeSubscriptionResponse';
  downgradeRequestedAt?: Maybe<Scalars['Float']>;
  scheduledForEndOfTerm: Scalars['Boolean'];
  changed: Scalars['Boolean'];
};

export enum DunningStatus {
  None = 'none',
  Restricted = 'restricted',
  Locked = 'locked'
}

export type EscalateToSupportResponse = {
  __typename?: 'EscalateToSupportResponse';
  status?: Maybe<CancellationFlowStatus>;
};

export type Estimator = {
  __typename?: 'Estimator';
  user_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['JSON']>;
  signature?: Maybe<Scalars['String']>;
};

export type EventActivity = Activity & {
  __typename?: 'EventActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: EventActivityDetails;
};

export type EventActivityDetails = ActivityDetails & {
  __typename?: 'EventActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  quoteType?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  geocode?: Maybe<EventGeocode>;
  start?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  crew?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Int']>;
  previousProgress?: Maybe<Scalars['Int']>;
  production?: Maybe<Scalars['Boolean']>;
  canceled?: Maybe<Scalars['Boolean']>;
  sendReminderEmails?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  attendees?: Maybe<Scalars['Int']>;
};

export type EventEmailSentActivity = Activity & {
  __typename?: 'EventEmailSentActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: EventEmailSentActivityDetails;
};

export type EventEmailSentActivityDetails = ActivityDetails & {
  __typename?: 'EventEmailSentActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  geocode?: Maybe<EventGeocode>;
  start?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  canceled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<ActivityEmail>;
};

export type EventGeocode = {
  __typename?: 'EventGeocode';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type ExportClientsResponse = {
  __typename?: 'ExportClientsResponse';
  csv?: Maybe<Scalars['JSON']>;
  rows?: Maybe<Scalars['Int']>;
};

export type ExportCompaniesResponse = {
  __typename?: 'ExportCompaniesResponse';
  csv?: Maybe<Scalars['JSON']>;
  rows?: Maybe<Scalars['Int']>;
};

export type ExportContactsResponse = {
  __typename?: 'ExportContactsResponse';
  csv?: Maybe<Scalars['JSON']>;
  rows?: Maybe<Scalars['Int']>;
};

export type ExportDealsResponse = {
  __typename?: 'ExportDealsResponse';
  csv?: Maybe<Scalars['JSON']>;
  rows?: Maybe<Scalars['Int']>;
};

export type ExportLineItemsResponse = {
  __typename?: 'ExportLineItemsResponse';
  csv?: Maybe<Scalars['JSON']>;
};

export type ExportProductResponse = {
  __typename?: 'ExportProductResponse';
  csv?: Maybe<Scalars['JSON']>;
};

export type ExportProductionRatesResponse = {
  __typename?: 'ExportProductionRatesResponse';
  csv?: Maybe<Scalars['JSON']>;
};

export type ExportQuotesResponse = {
  __typename?: 'ExportQuotesResponse';
  csv?: Maybe<Scalars['JSON']>;
  rows?: Maybe<Scalars['Int']>;
};

export type FileAddedActivity = Activity & {
  __typename?: 'FileAddedActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: FileAddedActivityDetails;
};

export type FileAddedActivityDetails = ActivityDetails & {
  __typename?: 'FileAddedActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  fileName?: Maybe<Scalars['String']>;
  fileCount?: Maybe<Scalars['Int']>;
};

export enum Filter {
  DateRange = 'dateRange',
  Range = 'range',
  Select = 'select',
  Boolean = 'boolean',
  User = 'user',
  Contact = 'contact',
  Tag = 'tag',
  QuoteStatus = 'quoteStatus',
  InvoiceStatus = 'invoiceStatus',
  OutstandingInvoices = 'outstandingInvoices',
  PaymentRequests = 'paymentRequests',
  ActivityType = 'activityType',
  Company = 'company',
  Stage = 'stage',
  QuoteType = 'quoteType',
  EventType = 'eventType',
  CompanyViaContacts = 'companyViaContacts',
  DealStatus = 'dealStatus',
  LeadSource = 'leadSource'
}

export type FollowUp = {
  __typename?: 'FollowUp';
  key: Scalars['String'];
  subject: Scalars['String'];
  message: Scalars['String'];
  smsMessage?: Maybe<Scalars['String']>;
  quoteTypes: Array<Maybe<Scalars['String']>>;
  isInvoice?: Maybe<Scalars['Boolean']>;
  toggled?: Maybe<Scalars['Int']>;
  sendFollowUpNotice?: Maybe<Scalars['Boolean']>;
  conditions: FollowUpConditions;
  created?: Maybe<Scalars['Float']>;
  sendText?: Maybe<Scalars['Boolean']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
  sent?: Maybe<Scalars['Float']>;
  retroactive?: Maybe<Scalars['Boolean']>;
};

export type FollowUpConditions = {
  __typename?: 'FollowUpConditions';
  interval?: Maybe<Scalars['Float']>;
  days?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  fromStatus: Scalars['String'];
  notStatus?: Maybe<Scalars['String']>;
};

export type FollowUpSentActivity = Activity & {
  __typename?: 'FollowUpSentActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: FollowUpSentActivityDetails;
};

export type FollowUpSentActivityDetails = ActivityDetails & {
  __typename?: 'FollowUpSentActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  email?: Maybe<ActivityEmail>;
  smsTo?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type FollowUpsForUser = {
  __typename?: 'FollowUpsForUser';
  userId: Scalars['String'];
  followUps: Array<Maybe<FollowUp>>;
};

export type GeneratePresentationInput = {
  /** The company's website. Scraped for copy and photos. Optional if aboutPrompt is given instead. */
  url?: Maybe<Scalars['String']>;
  /** Free-text description of the company, used in place of (or alongside) a website scrape. */
  aboutPrompt?: Maybe<Scalars['String']>;
  /** What this presentation is for — shapes the copy the AI writes. */
  purposePrompt: Scalars['String'];
  /** Title of the typography preset the generated presentation should use. */
  styleTitle?: Maybe<Scalars['String']>;
  /** Title of the color palette the generated presentation should use. */
  paletteTitle?: Maybe<Scalars['String']>;
  /** The base hex color paletteTitle's palette was derived from. Required to resolve paletteTitle to its actual colors. */
  baseColor?: Maybe<Scalars['String']>;
};

export type GeneratePresentationResult = {
  __typename?: 'GeneratePresentationResult';
  /** Key of the placeholder presentation, already present in presentationOptionsV2. */
  key: Scalars['String'];
  /** Identifies this attempt. The background write-back compare-and-sets on it. */
  generationId: Scalars['String'];
};

export type GetCorporateTypeDataResponse = {
  __typename?: 'GetCorporateTypeDataResponse';
  quoteTypes?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type GetPortalSessionResponse = {
  __typename?: 'GetPortalSessionResponse';
  access_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  redirect_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  linked_customers?: Maybe<Array<Maybe<PortalSessionLinkedCustomer>>>;
};

export type HubspotCompanyInfo = {
  __typename?: 'HubspotCompanyInfo';
  name?: Maybe<Scalars['String']>;
  companyStatus?: Maybe<Scalars['String']>;
  subscriptionType?: Maybe<Scalars['String']>;
  subscriptionStatus?: Maybe<Scalars['String']>;
  healthScore?: Maybe<Scalars['Float']>;
  paymentsStatus?: Maybe<Scalars['String']>;
  numberOfSalesSeats?: Maybe<Scalars['Float']>;
  numberOfTeamSeats?: Maybe<Scalars['Float']>;
  numberOfPainterSeats?: Maybe<Scalars['Float']>;
  lifetimeTotalQuotes?: Maybe<Scalars['Float']>;
  lifetimeSoldQuotes?: Maybe<Scalars['Float']>;
  lifetimeTotalValue?: Maybe<Scalars['Float']>;
  lifetimeSoldValue?: Maybe<Scalars['Float']>;
  currentMrrSubscriptionValue?: Maybe<Scalars['Float']>;
  signUpDate?: Maybe<Scalars['String']>;
  integrations?: Maybe<Scalars['String']>;
};

export type InboundWebhookLogEntry = {
  __typename?: 'InboundWebhookLogEntry';
  timestamp: Scalars['String'];
  level: Scalars['String'];
  message: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  integration?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<Scalars['String']>;
  errorStack?: Maybe<Scalars['String']>;
};

export type InboundWebhookLogsResult = {
  __typename?: 'InboundWebhookLogsResult';
  logs: Array<InboundWebhookLogEntry>;
  total_rows: Scalars['Int'];
};


export type JobCosting = {
  __typename?: 'JobCosting';
  labour?: Maybe<Scalars['Float']>;
  materials?: Maybe<Scalars['Float']>;
  overhead?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  margin?: Maybe<Scalars['Float']>;
};

export type LeadFormSubmissionActivity = Activity & {
  __typename?: 'LeadFormSubmissionActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: LeadFormSubmissionActivityDetails;
};

export type LeadFormSubmissionActivityDetails = ActivityDetails & {
  __typename?: 'LeadFormSubmissionActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  legacyNote?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  formKey?: Maybe<Scalars['String']>;
  newStage?: Maybe<Scalars['String']>;
  uploadedFiles?: Maybe<Array<NoteActivityFile>>;
  leadSource?: Maybe<Scalars['String']>;
  acquisitionSource?: Maybe<Scalars['String']>;
};

export type LeaderboardDataResponse = {
  __typename?: 'LeaderboardDataResponse';
  totalRows?: Maybe<Scalars['Int']>;
  userRank?: Maybe<Scalars['Int']>;
  userRows?: Maybe<Array<Maybe<LeaderboardDataResponseRow>>>;
  topRows?: Maybe<Array<Maybe<LeaderboardDataResponseRow>>>;
};

export type LeaderboardDataResponseRow = {
  __typename?: 'LeaderboardDataResponseRow';
  rank?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['Boolean']>;
  trophy?: Maybe<Scalars['Boolean']>;
  totalSold?: Maybe<Scalars['Float']>;
  totalSoldComment?: Maybe<Scalars['String']>;
  winRateComment?: Maybe<Scalars['String']>;
  numberSold?: Maybe<Scalars['Int']>;
  winRate?: Maybe<Scalars['Float']>;
  businessType?: Maybe<Array<Maybe<Scalars['String']>>>;
  customAvatar?: Maybe<Scalars['String']>;
  playerName?: Maybe<Scalars['String']>;
  projectTypes?: Maybe<Scalars['String']>;
};

export type LeaderboardRankResponse = {
  __typename?: 'LeaderboardRankResponse';
  updatedDate?: Maybe<Scalars['Float']>;
  totalSold?: Maybe<LeaderboardRankResponseItem>;
  winRate?: Maybe<LeaderboardRankResponseItem>;
};

export type LeaderboardRankResponseItem = {
  __typename?: 'LeaderboardRankResponseItem';
  value?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
  valueChange?: Maybe<Scalars['Float']>;
  rankChange?: Maybe<Scalars['Float']>;
};

export type LocationSuggestion = {
  __typename?: 'LocationSuggestion';
  address?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type ManufacturerColor = {
  __typename?: 'ManufacturerColor';
  number: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  localImage?: Maybe<Scalars['String']>;
  hexColor?: Maybe<Scalars['String']>;
  paintWood: Array<Scalars['String']>;
  manufacturer: Scalars['String'];
  productLines?: Maybe<Array<Scalars['String']>>;
  intRank?: Maybe<Scalars['Int']>;
  extRank?: Maybe<Scalars['Int']>;
};

export type ManufacturerProduct = {
  __typename?: 'ManufacturerProduct';
  number: Scalars['String'];
  productLineId: Scalars['String'];
  name: Scalars['String'];
  category: Scalars['String'];
  type: Array<Maybe<Scalars['String']>>;
  coverage: Scalars['Int'];
  size: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  manufacturer: Scalars['String'];
  baseName: Scalars['String'];
  sheen?: Maybe<Scalars['String']>;
};

export type MessageActivity = Activity & {
  __typename?: 'MessageActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: MessageActivityDetails;
};

export type MessageActivityDetails = ActivityDetails & {
  __typename?: 'MessageActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  message: ActivityMessage;
};

export type MfaEnrollment = {
  __typename?: 'MfaEnrollment';
  id: Scalars['String'];
  type: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  enrolled_at?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  syncActivitiesForDoc?: Maybe<Scalars['Boolean']>;
  /** Creates an activity for the message on a quote */
  sendMessage?: Maybe<SendMessageResponse>;
  /** Creates a note */
  createNote?: Maybe<CreateNoteResponse>;
  /** Marks the note as trashed. It does *not* delete the document from the database. */
  deleteNote?: Maybe<Scalars['Boolean']>;
  /** Update the note and file details, returns the updated note */
  updateNote?: Maybe<CreateNoteResponse>;
  /**
   * Pin or unpin a note on a specific document (deal/contact/company). Pinning is
   * per-viewed-document: a note can be pinned on the deal but not its contact. Pinned notes
   * sort to the top of that document's notes/activity feed. Returns the updated note.
   */
  setNotePinned?: Maybe<CreateNoteResponse>;
  /** Creates or updates an event */
  saveEvent?: Maybe<SaveEventResponse>;
  /**
   * Marks the messages as read for the Quote for the user
   *
   * (if a user makes this request, it'll mark customer messages as read)
   */
  readMessages?: Maybe<Array<Maybe<MessageActivity>>>;
  /** Marks the message as deleted. It does *not* delete the document from the database. */
  deleteMessage?: Maybe<Scalars['Boolean']>;
  /** Creates payment activity on a quote or an invoice */
  createPaymentActivity?: Maybe<CreatePaymentActivityResponse>;
  /** Set the rating on a chat-message activity. Pass `null` to clear. */
  rateChatMessage?: Maybe<Activity>;
  /**
   * Soft-delete one or more chat-message activities by setting `details.undo = true`.
   * They will be excluded from chat history display and LLM context but remain for analytics.
   */
  undoChatMessages?: Maybe<Array<Maybe<Activity>>>;
  /** Updates an existing user */
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Updates a users password manually */
  updatePassword?: Maybe<Scalars['Boolean']>;
  resetMfaForUser?: Maybe<Scalars['Boolean']>;
  acknowledgeCheckout?: Maybe<AcknowledgeCheckoutResponse>;
  renewAccount?: Maybe<RenewAccountResponse>;
  newAccount?: Maybe<NewAccountResponse>;
  /**
   * Schedules the caller's own subscription to cancel at the end of the current billing term
   * (via Chargebee's end_of_term cancel) rather than immediately — the account keeps full access
   * until then. Does not tear down the account itself; that happens when
   * handleChargebeeSubscriptionCancel fires once the term actually ends. Use
   * reactivateSubscription to undo a pending scheduled cancellation before it takes effect.
   */
  scheduleCancellation?: Maybe<ScheduleCancellationResponse>;
  /**
   * Cancels a pending scheduled cancellation (see scheduleCancellation) before it takes effect,
   * keeping the subscription active. Only permitted while this account's own cancellationFlow
   * records a pending scheduled cancellation.
   */
  reactivateSubscription?: Maybe<ReactivateSubscriptionResponse>;
  /**
   * Applies the self-serve cancellation flow's one-time $100 retention credit to the caller's own
   * subscription — see #21397. Only permitted once per account ever, and only for accounts with
   * 3+ months of tenure. Persists cancellationFlow.discountRedeemedAt as a permanent marker so this
   * can never be redeemed twice, even across repeat cancellation attempts.
   */
  applyRetentionDiscount?: Maybe<RetentionDiscountResponse>;
  /**
   * Right-sizes the caller's own subscription to match the account's actual active-user counts
   * — see #21540. Reuses the same seat-counting/update primitive already used whenever a user is
   * created, updated, or deactivated (updateAdditionalUsers/updateChargebeeSubscription), so a
   * "downgrade" here is exactly "sync Chargebee to reality" — no separate eligibility or seat
   * computation logic. Chargebee itself decides whether the reduction applies immediately or at
   * end of the current paid term (see updateChargebeeSubscription.ts).
   */
  downgradeSubscription?: Maybe<DowngradeSubscriptionResponse>;
  /**
   * Handles the "support wasn't helpful" cancellation reason — see #21396. Not account-data-gated
   * like the other five reason buckets; captures the customer's free-text account of what happened
   * onto the client doc and syncs it to HubSpot so a senior team member can follow up. Note that
   * nothing notifies anyone at the moment of escalation — the text surfaces in the #churns alert
   * only if the account later actually cancels.
   */
  escalateToSupport?: Maybe<EscalateToSupportResponse>;
  addSubscriptionAddon?: Maybe<AddSubscriptionAddonResponse>;
  generateCheckoutLink: CheckoutResult;
  /** Creates a new client. Options & Meta params are deeply merged with the default fixtures */
  createClient?: Maybe<ClientMeta>;
  /** Updates an existing client */
  updateClient?: Maybe<ClientResponse>;
  /**
   * Updates the caller's own cancellation & retention flow state (reason, competitor tool,
   * coaching-call status, flow status). Always scoped to the authenticated user's own company.
   * Cannot be used to set the "cancellation_scheduled", "cancelled", "reactivated", "saved", or
   * "escalated_to_support" statuses, or the server-only discount/scheduling fields — those are set
   * by other backend logic (escalated_to_support specifically only via escalateToSupport, which
   * also notifies a human).
   */
  updateCancellationFlowState?: Maybe<ClientCancellationFlow>;
  saveOptions?: Maybe<Scalars['JSON']>;
  saveLocationOptions?: Maybe<Scalars['JSON']>;
  savePartialOptions?: Maybe<Scalars['String']>;
  /** Transfer selected doc types from client to new client */
  transferClientDocs?: Maybe<Scalars['Boolean']>;
  /** Delete selected doc types from client en masse */
  deleteClientDocs?: Maybe<Scalars['Boolean']>;
  /**
   * Wipes ALL data (quotes, contacts, deals, events, tasks, activities) from a TEST account and
   * re-seeds its settings from either a fixture template or another account's settings.
   * Test-stage accounts only.
   */
  resetClientForTesting?: Maybe<Scalars['Boolean']>;
  /**
   * Blanks a company's ENTIRE self-serve-cancellation-flow state (reason, status, coaching-call
   * tracking, discountRedeemedAt, etc.) — for QA retesting only, see #21761. discountRedeemedAt is
   * a real, one-time-ever gate for real customers with no other reset path, so a test account that's
   * already redeemed it once is otherwise permanently ineligible.
   *
   * Also backdates meta.created (unless backdateTenure: false) to clear the discount's 3-month
   * minimum-tenure requirement — a fresh test account is always 0 months old and can never reach
   * the discount-eligible path otherwise. Test-stage accounts only.
   */
  resetCancellationFlowForTesting?: Maybe<Scalars['Boolean']>;
  /**
   * Manually re-fetches a company's live subscription from Chargebee and re-runs the exact same
   * reconciliation a subscription_changed webhook would (cancellationFlow.status/
   * cancellationScheduledFor, client.active/subscription.status) — for when a real Chargebee
   * webhook was delayed, deduped, or never delivered, and Admin/the app are showing stale data
   * (see #22012). Superadmin only.
   */
  resyncSubscriptionFromChargebee?: Maybe<Scalars['Boolean']>;
  saveRates?: Maybe<Scalars['JSON']>;
  adminIntegrationsConfig: AdminIntegrationsConfigResponse;
  /** Resize quote images on s3 if missing resize values for all quotes in given range for given db */
  resizeQuoteImages?: Maybe<Scalars['Boolean']>;
  syncOptions?: Maybe<Scalars['JSON']>;
  syncRates?: Maybe<Scalars['JSON']>;
  /** Updates a list of features for clients returned by the search query */
  updateClientFeatures?: Maybe<Scalars['Boolean']>;
  /**
   * Kicks off a background task that bulk-updates the company's existing unpaid quotes/invoices
   * to reflect the given surcharge settings. Quotes/invoices that already have a payment, and paid
   * invoices, are skipped. If no surcharge config is provided, the currently-saved settings are used.
   *
   * Restricted to account admins (and internal staff) to match the settings UI, since it triggers a
   * company-wide rewrite of existing documents.
   */
  updateExistingQuotesSurcharge?: Maybe<Scalars['Boolean']>;
  /** Turns on CRM features and runs necessary side effects for the current company */
  turnOnCRM?: Maybe<TurnOnCrmResult>;
  /** Turns off CRM features and removes the chargebee addon for the current company */
  turnOffCRM?: Maybe<Scalars['Boolean']>;
  /**
   * Deactivates all active painter users for the current company and revokes their Auth0 grants.
   * Used when switching to a plan without Operations, where painter accounts are no longer available.
   * Returns the number of painters that were deactivated.
   */
  deactivateCompanyPainters?: Maybe<Scalars['Int']>;
  deleteDeals: Array<BulkDocsResponseObject>;
  archiveDeals: Array<BulkDocsResponseObject>;
  saveDeal?: Maybe<Deal>;
  updateDealStage?: Maybe<UpdateDealStageResponse>;
  untrashDeals: Array<BulkDocsResponseObject>;
  deleteContacts: Array<BulkDocsResponseObject>;
  saveContact?: Maybe<Contact>;
  deleteCompanies: Array<BulkDocsResponseObject>;
  saveCompany?: Maybe<Company>;
  acceptQuote?: Maybe<AcceptQuoteResponse>;
  /** Accepts the quote using its url */
  acceptAdditionalWork?: Maybe<AcceptAdditionalWorkResponse>;
  addProcessingPayment?: Maybe<AddProcessingPaymentResponse>;
  deletePayment?: Maybe<DeletePaymentResponse>;
  updatePayment?: Maybe<UpdatePaymentResponse>;
  archiveQuotes: Array<BulkDocsResponseObject>;
  /** Declines a quote using its url */
  declineQuote?: Maybe<DeclineQuoteResponse>;
  deleteQuotes: Array<BulkDocsResponseObject>;
  /**
   * autosave: true when this save is a side effect of a state update (e.g. confirming a
   * dialog), not a dedicated user "Save" action. Skips the translation pre-bake, which would
   * otherwise re-translate on every such save.
   */
  saveQuote?: Maybe<Scalars['JSON']>;
  syncQuote?: Maybe<Scalars['JSON']>;
  saveClientQuote?: Maybe<Scalars['JSON']>;
  sendFollowUp?: Maybe<Scalars['Boolean']>;
  sendQuote?: Maybe<SendQuoteResponse>;
  requestReview?: Maybe<RequestReviewResponse>;
  refundPayment: RefundPaymentResponse;
  requestPayment?: Maybe<Scalars['JSON']>;
  recoverInvoice?: Maybe<RecoverInvoiceResponse>;
  /**
   * Updates the 'viewed' activity for the sent quote.
   * Returns false when the activity no longer exists — the client should stop sending heartbeats.
   */
  viewQuoteHeartbeat?: Maybe<Scalars['Boolean']>;
  processEvent: ProcessEventResponse;
  unlinkDeal?: Maybe<Scalars['Boolean']>;
  linkDeal?: Maybe<Scalars['Boolean']>;
  /** Retry only missing work-order translations while preserving all valid cached translations. */
  refreshQuoteTranslations?: Maybe<RefreshQuoteTranslationsResult>;
  /** Creates a new user */
  createUser?: Maybe<User>;
  /** Updates an existing user */
  updateUser?: Maybe<User>;
  /** Updates an existing user */
  deactivateUser?: Maybe<Scalars['Boolean']>;
  /** Transfer selected doc types from user to new user */
  transferUserDocs?: Maybe<Scalars['Boolean']>;
  /** Delete selected doc types belonging to user en masse */
  deleteUserDocs?: Maybe<Scalars['Boolean']>;
  /** Re-index a user's data in Elasticsearch from CouchDB source of truth */
  reindexUser?: Maybe<Scalars['Boolean']>;
  deleteTasks: Array<BulkDocsResponseObject>;
  saveTask?: Maybe<Task>;
  /**
   * Kicks off AI authoring of a v2 presentation: scrapes the given website (when provided) and
   * authors a whole presentation document from it plus the free-text fields.
   *
   * Returns as soon as a placeholder document exists — generation itself takes minutes and runs in
   * a background Lambda, which emails the requester when it lands. Poll the presentation's
   * `advanced.generation.status` (via an options sync) to follow along.
   */
  generatePresentation: GeneratePresentationResult;
  /**
   * Records a PDF download from the customer view so it shows up in PostHog.
   * The customer-view app does not load the PostHog browser SDK (to avoid
   * session-replay cost on a high-traffic public surface), so these downloads
   * are captured here server-side instead. Returns true once the event is queued.
   */
  trackPdfDownloaded: Scalars['Boolean'];
  /** generate new Api key for companyId associated w/ apiKey/auth */
  generateApiKey?: Maybe<ApiKeyDocument>;
  /** deactivate Api key so it is no longer useful */
  deactivateApiKey?: Maybe<ApiKeyDocument>;
  /** update Api key with changes */
  updateApiKey?: Maybe<ApiKeyDocument>;
  regeneratePlayerName?: Maybe<Scalars['String']>;
  associateSupportTicket?: Maybe<Scalars['Boolean']>;
  syncCompanyData?: Maybe<Scalars['JSON']>;
  syncUserData?: Maybe<Scalars['JSON']>;
  rerunInboundWebhook: RerunWebhookResult;
  removeFromPostmarkSuppression: Scalars['Boolean'];
  /**
   * Write the statuses support confirmed in the sync dialog, and record any refunds they ticked.
   *
   * Records only — this never charges or refunds anything at the provider.
   *
   * `silent` writes the documents and sends nothing. Without it, each payment sends what the
   * webhook would have sent: a payment confirmed as successful runs the real
   * `handleSuccessfulPayment` path (customer receipt, merchant notification, payment milestones,
   * integration event), one confirmed as failed sends the payment-failed email, and a recorded
   * refund sends the refund email. A payment left processing sends nothing either way.
   *
   * Omitting the argument means silent, so a direct API call cannot email a customer by accident.
   * The admin dialog always sends it explicitly, and leaves it off by default. Note this is per
   * payment: confirming five successful payments at once sends five receipts.
   */
  applyPaymentSync: ApplyPaymentSyncResult;
  /**
   * Attach a Payrix transaction id to a payment that has none, and move the payment to the status
   * the portal reports.
   *
   * This is the repair for a payment whose txn id was lost — the webhook that would have stamped it
   * errored, or a concurrent save overwrote it. Both the payment and its activity get the id, so the
   * payment can be synced against the portal from then on.
   *
   * Records only: it never charges or refunds anything, and sends no receipt, notification or
   * integration event.
   */
  attachTxnIdToPayment: AttachTxnIdResult;
  /**
   * Record a payment PaintScout never captured, from its Payrix transaction.
   *
   * `silent` writes the payment and its activity directly: no customer receipt, no merchant
   * notification, no payment milestones and no integration event. Without it the payment runs the
   * real `handleSuccessfulPayment` path, which sends all of those — the usual choice, since a
   * payment PaintScout never recorded is one nobody was ever told about.
   *
   * Omitting the argument means silent, so a direct API call cannot email a customer by accident.
   * The admin dialog always sends it explicitly, and leaves it off by default.
   */
  addPaymentByTxnId: AddPaymentResult;
  disconnectPayrix: PayrixConnectionResult;
  swapPayrixMerchantId: PayrixConnectionResult;
  /** Toggle a webhook's enabled state (superadmin/support only) */
  updateWebhookEnabled?: Maybe<WebhookType>;
  /**
   * Opt the caller's own company in/out of a self-serve feature flag (currently just "estimateNext")
   * via the flag's managed company targeting, in the environment this API is deployed to. The opt-in
   * is company-wide, so it needs the same permission as any other account setting. Returns true on
   * success.
   */
  setSelfServeFeatureFlag?: Maybe<Scalars['Boolean']>;
};


export type MutationSyncActivitiesForDocArgs = {
  id: Scalars['String'];
};


export type MutationSendMessageArgs = {
  message: Scalars['String'];
  timestamp?: Maybe<Scalars['Float']>;
  quoteId?: Maybe<Scalars['String']>;
  sendNotification?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateNoteArgs = {
  docId: Scalars['String'];
  docType: Scalars['String'];
  note: Scalars['String'];
  files?: Maybe<Array<Scalars['String']>>;
};


export type MutationDeleteNoteArgs = {
  id: Scalars['String'];
  deleteDoc?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateNoteArgs = {
  id: Scalars['String'];
  note: Scalars['String'];
  files?: Maybe<Array<Scalars['String']>>;
};


export type MutationSetNotePinnedArgs = {
  id: Scalars['String'];
  docId: Scalars['String'];
  pinned: Scalars['Boolean'];
};


export type MutationSaveEventArgs = {
  event: Scalars['JSON'];
  eventTemplate?: Maybe<Scalars['String']>;
};


export type MutationReadMessagesArgs = {
  quoteId?: Maybe<Scalars['String']>;
};


export type MutationDeleteMessageArgs = {
  id: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
};


export type MutationCreatePaymentActivityArgs = {
  ach?: Maybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  deposit?: Maybe<Scalars['Boolean']>;
  docId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerDetails?: Maybe<Scalars['JSON']>;
  source?: Maybe<Scalars['String']>;
  isProcessing?: Maybe<Scalars['Boolean']>;
  isFailed?: Maybe<Scalars['Boolean']>;
  surcharge?: Maybe<Scalars['Float']>;
};


export type MutationRateChatMessageArgs = {
  activityId: Scalars['String'];
  rating?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
};


export type MutationUndoChatMessagesArgs = {
  activityIds: Array<Scalars['String']>;
};


export type MutationResetPasswordArgs = {
  user_id: Scalars['String'];
};


export type MutationUpdatePasswordArgs = {
  user_id: Scalars['String'];
  password: Scalars['String'];
};


export type MutationResetMfaForUserArgs = {
  userId: Scalars['String'];
};


export type MutationAcknowledgeCheckoutArgs = {
  hostedPageId?: Maybe<Scalars['String']>;
  isRenew?: Maybe<Scalars['Boolean']>;
};


export type MutationRenewAccountArgs = {
  plan?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  addon?: Maybe<Scalars['String']>;
};


export type MutationNewAccountArgs = {
  plan: Scalars['String'];
  addons?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationEscalateToSupportArgs = {
  details: Scalars['String'];
};


export type MutationAddSubscriptionAddonArgs = {
  subscriptionId: Scalars['String'];
  addon: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
};


export type MutationGenerateCheckoutLinkArgs = {
  input: CheckoutInput;
  send: Scalars['Boolean'];
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationUpdateClientArgs = {
  id: Scalars['String'];
  meta?: Maybe<ClientMetaInput>;
  options?: Maybe<Scalars['JSON']>;
  internalOptions?: Maybe<Scalars['JSON']>;
  rates?: Maybe<Scalars['JSON']>;
};


export type MutationUpdateCancellationFlowStateArgs = {
  input: ClientCancellationFlowInput;
};


export type MutationSaveOptionsArgs = {
  input?: Maybe<Scalars['JSON']>;
};


export type MutationSaveLocationOptionsArgs = {
  input?: Maybe<Scalars['JSON']>;
  overwrite?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
};


export type MutationSavePartialOptionsArgs = {
  input?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};


export type MutationTransferClientDocsArgs = {
  id: Scalars['String'];
  transferTo: Scalars['String'];
  type: Scalars['String'];
  overwrite?: Maybe<Scalars['Boolean']>;
  sections?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationDeleteClientDocsArgs = {
  id: Scalars['String'];
  type: Scalars['String'];
};


export type MutationResetClientForTestingArgs = {
  id: Scalars['String'];
  mode: Scalars['String'];
  template?: Maybe<Scalars['String']>;
  sourceCompanyId?: Maybe<Scalars['String']>;
};


export type MutationResetCancellationFlowForTestingArgs = {
  id: Scalars['String'];
  backdateTenure?: Maybe<Scalars['Boolean']>;
};


export type MutationResyncSubscriptionFromChargebeeArgs = {
  id: Scalars['String'];
};


export type MutationSaveRatesArgs = {
  input?: Maybe<Scalars['JSON']>;
};


export type MutationAdminIntegrationsConfigArgs = {
  type: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['JSON']>;
};


export type MutationResizeQuoteImagesArgs = {
  db: Scalars['String'];
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
};


export type MutationSyncOptionsArgs = {
  rev: Scalars['String'];
};


export type MutationSyncRatesArgs = {
  rev: Scalars['String'];
};


export type MutationUpdateClientFeaturesArgs = {
  query: Scalars['String'];
  featureList: Scalars['String'];
  value: Scalars['Boolean'];
  email: Scalars['String'];
};


export type MutationUpdateExistingQuotesSurchargeArgs = {
  surcharge?: Maybe<Scalars['JSON']>;
};


export type MutationTurnOnCrmArgs = {
  trial: Scalars['Boolean'];
};


export type MutationDeleteDealsArgs = {
  ids: Array<Scalars['String']>;
  softDelete?: Maybe<Scalars['Boolean']>;
};


export type MutationArchiveDealsArgs = {
  ids: Array<Scalars['String']>;
  unarchive?: Maybe<Scalars['Boolean']>;
};


export type MutationSaveDealArgs = {
  deal: Scalars['JSON'];
  updateLinkedQuoteAddresses?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateDealStageArgs = {
  dealId: Scalars['String'];
  stage: Scalars['String'];
  query?: Maybe<Scalars['String']>;
};


export type MutationUntrashDealsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationDeleteContactsArgs = {
  ids: Array<Scalars['String']>;
  softDelete?: Maybe<Scalars['Boolean']>;
};


export type MutationSaveContactArgs = {
  contact: Scalars['JSON'];
};


export type MutationDeleteCompaniesArgs = {
  ids: Array<Scalars['String']>;
  softDelete?: Maybe<Scalars['Boolean']>;
};


export type MutationSaveCompanyArgs = {
  company: Scalars['JSON'];
};


export type MutationAcceptQuoteArgs = {
  quote: Scalars['JSON'];
  signature?: Maybe<Scalars['String']>;
  quoteId?: Maybe<Scalars['String']>;
};


export type MutationAcceptAdditionalWorkArgs = {
  rev: Scalars['String'];
  signature?: Maybe<Scalars['String']>;
  quoteId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};


export type MutationAddProcessingPaymentArgs = {
  quoteId: Scalars['String'];
  activityId: Scalars['String'];
  amount: Scalars['Float'];
  type: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['Boolean']>;
  txnId?: Maybe<Scalars['String']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['Float']>;
};


export type MutationDeletePaymentArgs = {
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
};


export type MutationUpdatePaymentArgs = {
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};


export type MutationArchiveQuotesArgs = {
  ids: Array<Scalars['String']>;
  unarchive?: Maybe<Scalars['Boolean']>;
};


export type MutationDeclineQuoteArgs = {
  rev: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationDeleteQuotesArgs = {
  ids: Array<Scalars['String']>;
  softDelete?: Maybe<Scalars['Boolean']>;
};


export type MutationSaveQuoteArgs = {
  quote: Scalars['JSON'];
  force?: Maybe<Scalars['Boolean']>;
  autosave?: Maybe<Scalars['Boolean']>;
};


export type MutationSyncQuoteArgs = {
  id: Scalars['String'];
  rev: Scalars['String'];
};


export type MutationSaveClientQuoteArgs = {
  quote: Scalars['JSON'];
  companyId: Scalars['String'];
  clean?: Maybe<Scalars['Boolean']>;
};


export type MutationSendFollowUpArgs = {
  followUp: Scalars['JSON'];
  quoteId: Scalars['String'];
  user: Scalars['JSON'];
};


export type MutationSendQuoteArgs = {
  id: Scalars['String'];
  rev?: Maybe<Scalars['String']>;
  view: Scalars['String'];
  emails: Array<QuoteEmailInput>;
  revision?: Maybe<Scalars['Boolean']>;
};


export type MutationRequestReviewArgs = {
  sms: ReviewSmsInput;
  content: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
};


export type MutationRefundPaymentArgs = {
  activityId: Scalars['String'];
  amount: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
};


export type MutationRequestPaymentArgs = {
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
  email: PaymentRequestEmailInput;
};


export type MutationRecoverInvoiceArgs = {
  id: Scalars['String'];
};


export type MutationViewQuoteHeartbeatArgs = {
  viewedActivityId: Scalars['String'];
  url: Scalars['String'];
  device?: Maybe<Scalars['String']>;
};


export type MutationProcessEventArgs = {
  type: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  async?: Maybe<Scalars['Boolean']>;
  params?: Maybe<Scalars['JSON']>;
};


export type MutationUnlinkDealArgs = {
  quoteId?: Maybe<Scalars['String']>;
};


export type MutationLinkDealArgs = {
  quoteId: Scalars['String'];
  dealId: Scalars['String'];
  updateJobAddress?: Maybe<Scalars['Boolean']>;
};


export type MutationRefreshQuoteTranslationsArgs = {
  quoteId: Scalars['String'];
  companyId: Scalars['String'];
  trigger?: Maybe<Scalars['String']>;
  posthogDistinctId?: Maybe<Scalars['String']>;
  posthogSessionId?: Maybe<Scalars['String']>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
  companyId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationDeactivateUserArgs = {
  id: Scalars['String'];
  companyId: Scalars['String'];
  transferQuotesTo?: Maybe<Scalars['String']>;
  transferType?: Maybe<Scalars['String']>;
};


export type MutationTransferUserDocsArgs = {
  id: Scalars['String'];
  transferTo: Scalars['String'];
  type: Scalars['String'];
  values?: Maybe<Scalars['String']>;
};


export type MutationDeleteUserDocsArgs = {
  id: Scalars['String'];
  type: Scalars['String'];
};


export type MutationReindexUserArgs = {
  id: Scalars['String'];
  companyId: Scalars['String'];
};


export type MutationDeleteTasksArgs = {
  ids: Array<Scalars['String']>;
  softDelete?: Maybe<Scalars['Boolean']>;
};


export type MutationSaveTaskArgs = {
  task: Scalars['JSON'];
  skipActivity?: Maybe<Scalars['Boolean']>;
};


export type MutationGeneratePresentationArgs = {
  input: GeneratePresentationInput;
};


export type MutationTrackPdfDownloadedArgs = {
  quoteId: Scalars['String'];
  companyId: Scalars['String'];
  view?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
};


export type MutationGenerateApiKeyArgs = {
  userId: Scalars['String'];
  companyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type MutationDeactivateApiKeyArgs = {
  id: Scalars['String'];
};


export type MutationUpdateApiKeyArgs = {
  apiKey: UpdateApiKeyInput;
};


export type MutationRegeneratePlayerNameArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type MutationAssociateSupportTicketArgs = {
  conversationId: Scalars['String'];
  logRocketUrl?: Maybe<Scalars['String']>;
};


export type MutationSyncCompanyDataArgs = {
  companyId: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
};


export type MutationSyncUserDataArgs = {
  userId: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
};


export type MutationRerunInboundWebhookArgs = {
  integration: Scalars['String'];
  eventData: Scalars['JSON'];
};


export type MutationRemoveFromPostmarkSuppressionArgs = {
  email: Scalars['String'];
};


export type MutationApplyPaymentSyncArgs = {
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  decisions?: Maybe<Array<PaymentDecisionInput>>;
  refunds?: Maybe<Array<RefundRecordInput>>;
  silent?: Maybe<Scalars['Boolean']>;
  clearErrorFlag?: Maybe<Scalars['Boolean']>;
};


export type MutationAttachTxnIdToPaymentArgs = {
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
  txnId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  silent?: Maybe<Scalars['Boolean']>;
};


export type MutationAddPaymentByTxnIdArgs = {
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  txnId: Scalars['String'];
  deposit?: Maybe<Scalars['Boolean']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  silent?: Maybe<Scalars['Boolean']>;
};


export type MutationDisconnectPayrixArgs = {
  companyId: Scalars['String'];
};


export type MutationSwapPayrixMerchantIdArgs = {
  companyId: Scalars['String'];
  merchantId: Scalars['String'];
};


export type MutationUpdateWebhookEnabledArgs = {
  companyId: Scalars['String'];
  webhookId: Scalars['String'];
  enabled: Scalars['Boolean'];
};


export type MutationSetSelfServeFeatureFlagArgs = {
  flagKey: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type NewAccountResponse = {
  __typename?: 'NewAccountResponse';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  embed?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['Int']>;
  expires_at?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Int']>;
  resource_version?: Maybe<Scalars['Int']>;
};

export type NoteActivity = Activity & {
  __typename?: 'NoteActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: NoteActivityDetails;
  _deleted?: Maybe<Scalars['Boolean']>;
};

export type NoteActivityDetails = ActivityDetails & {
  __typename?: 'NoteActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  legacyNote?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Scalars['String']>>;
  versions?: Maybe<Array<NoteActivityVersion>>;
  /**
   * Pre-baked machine translations of the note body, keyed by lang then content hash:
   * translations[lang][contentHash(note)] = translatedNote. Populated on save when the
   * company has translation languages enabled; the client applies it by hashing the
   * rendered note text and falls back to the original when absent.
   */
  translations?: Maybe<Scalars['JSON']>;
  /**
   * Ids of the documents (deal/contact/company) this note is pinned on. Pinning is
   * per-viewed-document: a note sorts to the top only on the docs listed here.
   */
  pinnedOn?: Maybe<Array<Scalars['String']>>;
};

export type NoteActivityFile = {
  __typename?: 'NoteActivityFile';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NoteActivityVersion = {
  __typename?: 'NoteActivityVersion';
  note: Scalars['String'];
  files?: Maybe<Array<NoteActivityFile>>;
  timestamp: Scalars['Float'];
  owner?: Maybe<Owner>;
};

export enum OfferBucket {
  Downgrade = 'downgrade',
  Discount = 'discount',
  Solve = 'solve',
  LetGo = 'let_go',
  Escalation = 'escalation'
}

export type OfflineQuotesResponse = {
  __typename?: 'OfflineQuotesResponse';
  quotes: Array<Scalars['JSON']>;
  invoices: Array<Scalars['JSON']>;
  templates?: Maybe<Array<Scalars['JSON']>>;
  contacts?: Maybe<Array<Contact>>;
};

export type Owner = {
  __typename?: 'Owner';
  id?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
};

export type OwnerChangedActivity = Activity & {
  __typename?: 'OwnerChangedActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: OwnerChangedActivityDetails;
};

export type OwnerChangedActivityDetails = ActivityDetails & {
  __typename?: 'OwnerChangedActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  oldOwner?: Maybe<Owner>;
  newOwner?: Maybe<Owner>;
};

export type PainterScheduleDeal = {
  __typename?: 'PainterScheduleDeal';
  dealId: Scalars['String'];
  event: Activity;
  dealJobAddress?: Maybe<Scalars['JSON']>;
  /** Lightweight indicators for the day view — full content loads via painterScheduleJob. */
  fileCount?: Maybe<Scalars['Int']>;
  noteCount?: Maybe<Scalars['Int']>;
  hasPaymentDue?: Maybe<Scalars['Boolean']>;
  /** @deprecated Moved to painterScheduleJob, loaded on demand when a job is opened. Always returns []. */
  invoices: Array<Quote>;
  /** @deprecated Moved to painterScheduleJob, loaded on demand when a job is opened. Always returns null. */
  dealFiles?: Maybe<Scalars['JSON']>;
};

export type PainterScheduleJobResponse = {
  __typename?: 'PainterScheduleJobResponse';
  invoices: Array<Quote>;
  dealFiles?: Maybe<Scalars['JSON']>;
};

export type PainterScheduleResponse = {
  __typename?: 'PainterScheduleResponse';
  deals: Array<PainterScheduleDeal>;
};

export type PaymentActivity = Activity & {
  __typename?: 'PaymentActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: PaymentActivityDetails;
};

export type PaymentActivityDetails = ActivityDetails & {
  __typename?: 'PaymentActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['String']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  isProcessing?: Maybe<Scalars['Boolean']>;
  isFailed?: Maybe<Scalars['Boolean']>;
  surcharge?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerDetails?: Maybe<Scalars['JSON']>;
  note?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['Boolean']>;
  paymentDate?: Maybe<Scalars['Float']>;
  isRefund?: Maybe<Scalars['Boolean']>;
  originalAmount?: Maybe<Scalars['Float']>;
};

export type PaymentDecisionInput = {
  paymentId: Scalars['String'];
  /** 'paid', 'failed' or 'processing'. */
  status: Scalars['String'];
};

export type PaymentProcessedResponse = {
  __typename?: 'PaymentProcessedResponse';
  updatedQuote: Scalars['JSON'];
};

export type PaymentReceivedSentActivity = Activity & {
  __typename?: 'PaymentReceivedSentActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: PaymentReceivedSentActivityDetails;
};

export type PaymentReceivedSentActivityDetails = ActivityDetails & {
  __typename?: 'PaymentReceivedSentActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  email?: Maybe<ActivityEmail>;
  amountPaid?: Maybe<Scalars['String']>;
};

export type PaymentRequestEmailInput = {
  to?: Maybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  body: Scalars['String'];
  sms?: Maybe<PaymentRequestSmsInput>;
};

export type PaymentRequestSmsInput = {
  to: Scalars['String'];
};

export type PaymentRequestedActivity = Activity & {
  __typename?: 'PaymentRequestedActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: PaymentRequestedActivityDetails;
};

export type PaymentRequestedActivityDetails = ActivityDetails & {
  __typename?: 'PaymentRequestedActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  email?: Maybe<ActivityEmail>;
  smsTo?: Maybe<Scalars['String']>;
  amountRequested?: Maybe<Scalars['String']>;
  lastSent?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['Boolean']>;
};

export type PaymentSyncEntry = {
  __typename?: 'PaymentSyncEntry';
  paymentId: Scalars['String'];
  txnId?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  /** Portal status label, or null when there was no transaction to read. */
  portalStatus?: Maybe<Scalars['String']>;
  /**
   * 'paid', 'failed' or 'processing'. Null means we are not recommending a change — no txn id, no
   * such txn in Payrix, a status we do not map, or PaintScout already agrees with the portal.
   */
  recommended?: Maybe<Scalars['String']>;
  /** Why. Shown to support next to the payment. */
  reason: Scalars['String'];
  refunds: Array<PaymentSyncRefund>;
};

export type PaymentSyncRefund = {
  __typename?: 'PaymentSyncRefund';
  txnId: Scalars['String'];
  /** Refund amount in dollars, always positive. */
  amount: Scalars['Float'];
  /** Raw Payrix status code on the refund txn. */
  status: Scalars['Int'];
  /** True when Payrix accepted the refund (approved, captured or settled). */
  approved: Scalars['Boolean'];
  created?: Maybe<Scalars['String']>;
  /**
   * True when a matching refund row already exists on the quote, so recording it again would
   * double-count.
   */
  alreadyRecorded: Scalars['Boolean'];
};

export type PayrixConnectionResult = {
  __typename?: 'PayrixConnectionResult';
  success: Scalars['Boolean'];
  /** The merchant id (options.integrations.payrix.apiKey) the company is left with — null after a disconnect. */
  merchantId?: Maybe<Scalars['String']>;
  /** When the merchant record was created in Payrix (epoch ms) — the creation date, not the approval date. */
  merchantCreated?: Maybe<Scalars['Float']>;
};

export type PayrixTxnLookup = {
  __typename?: 'PayrixTxnLookup';
  txnId: Scalars['String'];
  /** Raw Payrix status code and its label. */
  status: Scalars['Int'];
  statusLabel: Scalars['String'];
  /**
   * The status PaintScout should set the payment to: 'paid', 'failed' or 'processing'. Null when we
   * have no mapping for this status and type — decide by hand rather than guess.
   */
  recommended?: Maybe<Scalars['String']>;
  /** Why that status, or why there is no recommendation. Shown next to the choice. */
  recommendedReason: Scalars['String'];
  /** Payrix txn type. 7 is an ACH/EFT sale, everything else here is a card sale. */
  type: Scalars['Int'];
  /**
   * Settled amount in dollars, from the transaction itself. This is authoritative — a request
   * priced with a credit-card surcharge legitimately differs from it when the customer paid by
   * debit.
   */
  amount: Scalars['Float'];
  /** 'ACH', 'Credit Card' or 'Debit Card'. */
  method?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  /** Company id decoded from the transaction's metadata, when it is intact. */
  metadataCompanyId?: Maybe<Scalars['String']>;
  /**
   * Activity id decoded from the transaction's metadata. When this activity still exists, the
   * payment can be rebuilt from it with nothing lost.
   */
  metadataActivityId?: Maybe<Scalars['String']>;
  /** True when the metadata activity exists in PaintScout. */
  activityExists: Scalars['Boolean'];
  /**
   * The metadata's deposit hint. A hint only — it is set client-side as `quote.is_invoice ? 'p' : 'd'`,
   * which is the deposit-mislabelling heuristic documented in docs/flows/payment-processing-flow.md §8.
   * Confirm it by hand.
   */
  depositHint?: Maybe<Scalars['Boolean']>;
  /** True when a payment on the given quote already carries this transaction id. */
  alreadyOnQuote: Scalars['Boolean'];
  /**
   * The outstanding payment request this transaction settles, when exactly one matches its amount.
   * The payment is recorded against that request rather than as a new row, which is what the
   * customer paying it would have done.
   */
  matchedRequestId?: Maybe<Scalars['String']>;
  /**
   * Outstanding requests on the quote whose amount matches this transaction. More than one means we
   * cannot tell them apart, so the operator has to pick.
   */
  matchingRequestIds: Array<Scalars['String']>;
};

export type PexelsPhoto = {
  __typename?: 'PexelsPhoto';
  id: Scalars['Int'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  alt?: Maybe<Scalars['String']>;
  avgColor?: Maybe<Scalars['String']>;
  photographer?: Maybe<Scalars['String']>;
  photographerUrl?: Maybe<Scalars['String']>;
  src: PexelsPhotoSrc;
};

export type PexelsPhotoSrc = {
  __typename?: 'PexelsPhotoSrc';
  original: Scalars['String'];
  large2x?: Maybe<Scalars['String']>;
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
  portrait?: Maybe<Scalars['String']>;
  landscape?: Maybe<Scalars['String']>;
  tiny?: Maybe<Scalars['String']>;
};

export type PexelsSearchResult = {
  __typename?: 'PexelsSearchResult';
  totalResults: Scalars['Int'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  photos: Array<PexelsPhoto>;
};

export type PortalSessionLinkedCustomer = {
  __typename?: 'PortalSessionLinkedCustomer';
  customer_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  has_active_subscription?: Maybe<Scalars['Boolean']>;
  has_billing_address?: Maybe<Scalars['Boolean']>;
  has_payment_method?: Maybe<Scalars['Boolean']>;
  object?: Maybe<Scalars['String']>;
};

export type PostHogSessionRecording = {
  __typename?: 'PostHogSessionRecording';
  id: Scalars['String'];
  start_time?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  recording_duration?: Maybe<Scalars['Float']>;
  active_seconds?: Maybe<Scalars['Float']>;
  inactive_seconds?: Maybe<Scalars['Float']>;
  click_count?: Maybe<Scalars['Int']>;
  keypress_count?: Maybe<Scalars['Int']>;
  mouse_activity_count?: Maybe<Scalars['Int']>;
  console_error_count?: Maybe<Scalars['Int']>;
  console_warn_count?: Maybe<Scalars['Int']>;
  console_log_count?: Maybe<Scalars['Int']>;
  start_url?: Maybe<Scalars['String']>;
  activity_score?: Maybe<Scalars['Float']>;
  ongoing?: Maybe<Scalars['Boolean']>;
  person_name?: Maybe<Scalars['String']>;
  person_email?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PostHogSessionRecordingsResult = {
  __typename?: 'PostHogSessionRecordingsResult';
  recordings: Array<PostHogSessionRecording>;
  hasMore: Scalars['Boolean'];
};

export type PostmarkMessage = {
  __typename?: 'PostmarkMessage';
  tag?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  cc?: Maybe<Scalars['String']>;
  bcc?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  receivedAt?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
};

export type PostmarkMessagesResult = {
  __typename?: 'PostmarkMessagesResult';
  messages: Array<PostmarkMessage>;
  totalCount: Scalars['Int'];
  truncated: Scalars['Boolean'];
};

export type PostmarkSuppressionEntry = {
  __typename?: 'PostmarkSuppressionEntry';
  suppressed: Scalars['Boolean'];
  emailAddress?: Maybe<Scalars['String']>;
  suppressionReason?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
};

export type ProcessEventResponse = {
  __typename?: 'ProcessEventResponse';
  provider?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
  error?: Maybe<Scalars['JSON']>;
};

export type ProcessFileParams = {
  srcUrl: Scalars['String'];
  srcKey: Scalars['String'];
  contentType: Scalars['String'];
  srcBucket: Scalars['String'];
  initialImageWidth?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  activitiesForDoc?: Maybe<SearchActivitiesResponse>;
  /** Returns new activities for a doc for the app */
  newActivitiesForDoc?: Maybe<Array<Maybe<Activity>>>;
  searchActivities?: Maybe<SearchActivitiesResponse>;
  activity?: Maybe<Activity>;
  getNote?: Maybe<NoteActivity>;
  messages?: Maybe<QuoteMessagesResponse>;
  /** Returns new messages for a quote from customer view */
  newMessages?: Maybe<Array<Activity>>;
  unreadMessages?: Maybe<Array<MessageActivity>>;
  unscheduledJobs?: Maybe<UnscheduledJobsResponse>;
  /** Gets the documents necessary for PaintScout to start */
  appDocs?: Maybe<AppDocsResponse>;
  getMfaEnrollments: Array<MfaEnrollment>;
  /**
   * Returns a Chargebee-hosted portal session — this hands the caller a session that lets them
   * edit/cancel the subscription directly within Chargebee's own UI, bypassing every in-app billing
   * permission check. Gated with the same roles/permissions as scheduleCancellation so a non-admin
   * team member can't reach Chargebee's self-serve actions even though the app's own "Manage
   * Billing" button is owner-only (see #22186).
   */
  getPortalSession?: Maybe<GetPortalSessionResponse>;
  subscription?: Maybe<ChargebeeSubscription>;
  subscriptionSummary?: Maybe<ChargebeeSubscriptionSummary>;
  /**
   * Real, live counts for the self-serve cancellation flow's data-loss confirmation screen
   * (replaces the frontend prototype's fake numbers) — see #21399.
   */
  cancellationImpactSummary?: Maybe<CancellationImpactSummary>;
  /**
   * Resolves the caller's own stated cancellation reason + real account data (seat usage, discount
   * history, tenure) to one of five offer buckets — see #21396. Read-only and side-effect-free, so
   * it's safe to call speculatively (e.g. as soon as the cancellation dialog opens). The eligibility
   * rules live here, server-side, so they can't be inspected or bypassed client-side ("so it can't
   * be gamed" per #21062). Acting on the resolved bucket (applying the discount, downgrading, or
   * escalating) is a separate mutation — applyRetentionDiscount / downgradeSubscription /
   * escalateToSupport.
   */
  resolveCancellationOffer?: Maybe<ResolveCancellationOfferResponse>;
  chargebeePlans: Array<ChargebeeItemPrice>;
  chargebeeAddons: Array<ChargebeeItemPrice>;
  chargebeeCharges: Array<ChargebeeItemPrice>;
  chargebeeCoupons: Array<CheckoutCoupon>;
  salesReps: Array<SalesRep>;
  estimateCheckout: CheckoutEstimate;
  oneTimeCharges: Array<ChargebeeOneTimeCharge>;
  adminDashboardStats?: Maybe<AdminDashboardStats>;
  /**
   * Returns information about the client for the user
   *
   * Superadmin can get any client, users must get their own client if not
   */
  client?: Maybe<ClientResponse>;
  searchClients?: Maybe<SearchClientsResponse>;
  searchLocations?: Maybe<SearchLocationsResponse>;
  exportClients?: Maybe<ExportClientsResponse>;
  getCorporateTypeData?: Maybe<GetCorporateTypeDataResponse>;
  searchManufacturerProducts?: Maybe<SearchManufacturerProductsResponse>;
  searchManufacturerColors?: Maybe<SearchManufacturerColorsResponse>;
  /**
   * Returns the LaunchDarkly feature flag value for a given company.
   * Only a fixed set of flag keys may be queried.
   */
  clientFeatureFlag?: Maybe<Scalars['JSON']>;
  deal?: Maybe<Deal>;
  searchDeals?: Maybe<SearchDealsResult>;
  exportDeals?: Maybe<ExportDealsResponse>;
  searchDealsByCompany?: Maybe<SearchDealsResult>;
  searchDealsByStage?: Maybe<SearchDealsResult>;
  dealSummary?: Maybe<DealSummaryResponse>;
  contact?: Maybe<Contact>;
  /** Gets an existing contact from PaintScout by the source_id */
  contactBySource?: Maybe<Contact>;
  /** Searches for PipelineCRM Deals associated with a given contact id */
  searchContactDeals?: Maybe<SearchContactDealsResponse>;
  /** Searches for Salesforce Opportunities associated with a given contact id */
  searchContactOpportunities?: Maybe<SearchContactOpportunitiesResponse>;
  searchContacts?: Maybe<SearchContactsResult>;
  exportContacts?: Maybe<ExportContactsResponse>;
  /** Searches Integration contacts */
  searchContactsByIntegration?: Maybe<SearchContactsByIntegrationResponse>;
  company?: Maybe<Company>;
  searchCompanies?: Maybe<SearchCompaniesResult>;
  exportCompanies?: Maybe<ExportCompaniesResponse>;
  /** Get presigned url for s3 bucket upload to use on frontend */
  getSignedUploadUrl: SignedUploadResponse;
  /** Invokes the task lambda for given task with the params passed */
  processFile: Scalars['Boolean'];
  /**
   * Synchronously converts a HEIC/HEIF file (already uploaded to S3 at fileParams.srcKey)
   * to a JPEG, uploading the result to a sibling key. Unlike processFile, this waits for
   * and returns the converted file's data since the caller needs it immediately to build
   * a renderable QuoteFile - a HEIC file can't be shown in-browser until converted, and
   * there's no async "processing" state on QuoteFile to update later.
   */
  convertHeicToJpeg: ConvertedFile;
  exportQuotes?: Maybe<ExportQuotesResponse>;
  /** Gets the recent quotes belonging to the user to access offline */
  offlineQuotes?: Maybe<OfflineQuotesResponse>;
  /** Returns the entire Quote document */
  quote?: Maybe<Scalars['JSON']>;
  /** Returns the entire Quote document */
  clientQuote?: Maybe<Scalars['JSON']>;
  quoteSummary?: Maybe<QuoteSummaryResponse>;
  /** Creates/gets the url doc for the Quote */
  quoteUrl: QuoteUrlResponse;
  searchQuotes?: Maybe<SearchQuotesResponse>;
  searchClientQuotes?: Maybe<SearchQuotesResponse>;
  paymentProcessed?: Maybe<PaymentProcessedResponse>;
  /** Returns the Quote document for customer view */
  viewQuote?: Maybe<ViewQuoteResponse>;
  exportProductionRates?: Maybe<ExportProductionRatesResponse>;
  exportProducts?: Maybe<ExportProductResponse>;
  exportLineItems?: Maybe<ExportLineItemsResponse>;
  /** Translates customer-facing work-order note content. */
  translateNoteContent: Array<Scalars['String']>;
  /**
   * Live-translates a work-order email's subject and body into the given language. Used by the
   * Send dialog's Work Order Language selector so whichever template the user has selected --
   * including a company's own custom copy, not just the default English template -- gets
   * translated, rather than only ever the one hardcoded default string.
   */
  translateWorkOrderEmailContent: TranslatedEmailContent;
  /** Creates/gets the url doc for the Quote */
  urlDoc: UrlDocument;
  reportFilterOptions?: Maybe<ReportFilterOptionsReponse>;
  reportData?: Maybe<ReportDataResponse>;
  /** Search for users by query string, will fallback to auth0 if es not enabled */
  searchUsers?: Maybe<SearchUsersResponse>;
  user?: Maybe<User>;
  estimator?: Maybe<Estimator>;
  /** Fetch a user's Elasticsearch indexed preferences (for sync debugging) */
  getUserIndexedPreferences?: Maybe<Scalars['JSON']>;
  task?: Maybe<Task>;
  searchTasks?: Maybe<SearchTasksResult>;
  searchTasksByContact?: Maybe<SearchTasksResult>;
  searchTasksByCompany?: Maybe<SearchTasksResult>;
  taskCounts?: Maybe<TaskCounts>;
  locationSuggestions?: Maybe<Array<Maybe<LocationSuggestion>>>;
  pexelsSearch: PexelsSearchResult;
  /** Returns the url for the quotePdf to be downloaded from */
  quotePdf: QuotePdfResponse;
  /** get Api keys for specific companyId associated with given key or contextUser */
  getApiKeys?: Maybe<Array<Maybe<ApiKeyDocument>>>;
  /** get Api key of given id */
  getApiKey?: Maybe<ApiKeyDocument>;
  adminLeaderboard?: Maybe<AdminLeaderboardResponse>;
  leaderboardData?: Maybe<LeaderboardDataResponse>;
  leaderboardRank?: Maybe<LeaderboardRankResponse>;
  /**
   * Returns the CSM (if any) assigned to the current account's HubSpot company record, along with
   * the correct coaching-call booking link for the self-serve cancellation flow — see #21393.
   * Falls back to the no-CSM booking link if there's no assigned/mapped owner, or if the HubSpot
   * lookup itself fails. Gated the same as every other billing/cancellation-flow resolver (account
   * admins + privileged internal roles only) — this still surfaces a booking link tied to the
   * account's billing relationship, not something every staff user should be able to query.
   */
  assignedCsm: CsmBookingInfo;
  hubspotVisitorToken?: Maybe<Scalars['String']>;
  /**
   * A curated summary of the current account's associated HubSpot company record — see #21570.
   * Returns null if no HubSpot company is found or the lookup fails, rather than erroring, since
   * callers should treat this as supplementary context, not a hard dependency. Includes revenue
   * figures (MRR, lifetime sold value), so it's gated the same as the detailed subscription
   * query — not left at plain auth like assignedCsm, which never returns financial data.
   */
  hubspotCompanyInfo?: Maybe<HubspotCompanyInfo>;
  weather: Array<WeatherDay>;
  getAuth0Logs: Auth0LogsResult;
  getInboundWebhookLogs: InboundWebhookLogsResult;
  getPostHogSessionRecordings: PostHogSessionRecordingsResult;
  getPostmarkSuppressionStatus: PostmarkSuppressionEntry;
  getPostmarkMessages: PostmarkMessagesResult;
  getStuckPayments: StuckPaymentsResult;
  /**
   * Find a quote or invoice for the admin payment tools, by document id or by number.
   *
   * Returns a list because a quote and an invoice can share a number — they are numbered from
   * separate sequences — so a number search can legitimately match more than one document.
   *
   * Deliberately not built on `clientQuote`, which is superadmin-only; support staff need this.
   */
  findQuotePayments: Array<AdminPaymentQuote>;
  /**
   * Read the Payrix portal for the given payments and report what should change. Read-only: this
   * query never writes to the quote or its activities.
   */
  getPaymentSyncPreview: Array<PaymentSyncEntry>;
  /**
   * Read one Payrix transaction and report what PaintScout can and cannot rebuild from it.
   * Read-only.
   */
  getPayrixTxnLookup: PayrixTxnLookup;
  /** Get webhooks for a specific company (superadmin/support only) */
  getWebhooks?: Maybe<WebhooksResult>;
  /** Get webhook events for a specific company (superadmin/support only) */
  getWebhookEvents?: Maybe<WebhookEventsResult>;
  painterSchedule?: Maybe<PainterScheduleResponse>;
  painterScheduleJob?: Maybe<PainterScheduleJobResponse>;
};


export type QueryActivitiesForDocArgs = {
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  includeMessages?: Maybe<Scalars['Boolean']>;
};


export type QueryNewActivitiesForDocArgs = {
  id: Scalars['String'];
  since?: Maybe<Scalars['Float']>;
};


export type QuerySearchActivitiesArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
  pinnedForDocId?: Maybe<Scalars['String']>;
  skipSanitize?: Maybe<Scalars['Boolean']>;
  isProductionCalendar?: Maybe<Scalars['Boolean']>;
};


export type QueryActivityArgs = {
  id: Scalars['String'];
};


export type QueryGetNoteArgs = {
  id: Scalars['String'];
};


export type QueryMessagesArgs = {
  quoteId?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryNewMessagesArgs = {
  quoteId?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['Float']>;
};


export type QueryUnreadMessagesArgs = {
  quoteId?: Maybe<Scalars['String']>;
};


export type QueryUnscheduledJobsArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMfaEnrollmentsArgs = {
  userId: Scalars['String'];
};


export type QuerySubscriptionArgs = {
  clientBillingId?: Maybe<Scalars['String']>;
};


export type QuerySubscriptionSummaryArgs = {
  clientBillingId?: Maybe<Scalars['String']>;
};


export type QueryResolveCancellationOfferArgs = {
  reason: CancellationReason;
  afterFollowUp?: Maybe<Scalars['Boolean']>;
};


export type QueryEstimateCheckoutArgs = {
  input: CheckoutInput;
};


export type QueryOneTimeChargesArgs = {
  clientBillingId?: Maybe<Scalars['String']>;
};


export type QueryAdminDashboardStatsArgs = {
  weekAgo: Scalars['Float'];
  now: Scalars['Float'];
  weekFromNow: Scalars['Float'];
};


export type QueryClientArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QuerySearchClientsArgs = {
  query?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QuerySearchLocationsArgs = {
  query?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryExportClientsArgs = {
  query: Scalars['String'];
  exportType: Scalars['String'];
  includeInactive: Scalars['Boolean'];
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QuerySearchManufacturerProductsArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QuerySearchManufacturerColorsArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryClientFeatureFlagArgs = {
  companyId: Scalars['String'];
  flagKey: Scalars['String'];
};


export type QueryDealArgs = {
  id: Scalars['String'];
};


export type QuerySearchDealsArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
  omitInvalidContacts?: Maybe<Scalars['Boolean']>;
};


export type QueryExportDealsArgs = {
  query: Scalars['String'];
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QuerySearchDealsByCompanyArgs = {
  companyId: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QuerySearchDealsByStageArgs = {
  query: Scalars['String'];
  stage: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryDealSummaryArgs = {
  query: Scalars['String'];
  pipeline: Scalars['String'];
};


export type QueryContactArgs = {
  id: Scalars['String'];
};


export type QueryContactBySourceArgs = {
  source: Scalars['String'];
  source_id: Scalars['String'];
};


export type QuerySearchContactDealsArgs = {
  contactSourceId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
};


export type QuerySearchContactOpportunitiesArgs = {
  contactSourceId: Scalars['String'];
  integration: Scalars['String'];
};


export type QuerySearchContactsArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryExportContactsArgs = {
  query: Scalars['String'];
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QuerySearchContactsByIntegrationArgs = {
  integration?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};


export type QueryCompanyArgs = {
  id: Scalars['String'];
};


export type QuerySearchCompaniesArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryExportCompaniesArgs = {
  query: Scalars['String'];
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetSignedUploadUrlArgs = {
  fileKey: Scalars['String'];
};


export type QueryProcessFileArgs = {
  task: Scalars['String'];
  fileParams: ProcessFileParams;
  uploadOptions: UploadOptions;
};


export type QueryConvertHeicToJpegArgs = {
  fileParams: ProcessFileParams;
  uploadOptions: UploadOptions;
};


export type QueryExportQuotesArgs = {
  query: Scalars['String'];
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryQuoteArgs = {
  id: Scalars['String'];
};


export type QueryClientQuoteArgs = {
  id: Scalars['String'];
  companyId: Scalars['String'];
};


export type QueryQuoteSummaryArgs = {
  query: Scalars['String'];
};


export type QueryQuoteUrlArgs = {
  id: Scalars['String'];
  rev: Scalars['String'];
  view: Scalars['String'];
  silent?: Maybe<Scalars['Boolean']>;
  paymentId?: Maybe<Scalars['String']>;
};


export type QuerySearchQuotesArgs = {
  query?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
  skipSanitize?: Maybe<Scalars['Boolean']>;
};


export type QuerySearchClientQuotesArgs = {
  query: Scalars['String'];
  companyId: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryPaymentProcessedArgs = {
  id: Scalars['String'];
  balanceDue: Scalars['Float'];
  activityId?: Maybe<Scalars['String']>;
};


export type QueryViewQuoteArgs = {
  silent?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['Boolean']>;
  revision?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
};


export type QueryExportProductionRatesArgs = {
  id?: Maybe<Scalars['String']>;
  detailed?: Maybe<Scalars['Boolean']>;
  basic?: Maybe<Scalars['Boolean']>;
  preserveFormatting?: Maybe<Scalars['Boolean']>;
};


export type QueryExportProductsArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryExportLineItemsArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryTranslateNoteContentArgs = {
  notes: Array<Scalars['String']>;
  lang: Scalars['String'];
};


export type QueryTranslateWorkOrderEmailContentArgs = {
  subject: Scalars['String'];
  body: Scalars['String'];
  lang: Scalars['String'];
};


export type QueryUrlDocArgs = {
  id: Scalars['String'];
};


export type QueryReportFilterOptionsArgs = {
  filters?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryReportDataArgs = {
  name: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  filters?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  resultsOnly?: Maybe<Scalars['Boolean']>;
};


export type QuerySearchUsersArgs = {
  query?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  includeCrew?: Maybe<Scalars['Boolean']>;
};


export type QueryUserArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryEstimatorArgs = {
  id?: Maybe<Scalars['String']>;
  quoteId?: Maybe<Scalars['String']>;
};


export type QueryGetUserIndexedPreferencesArgs = {
  id: Scalars['String'];
};


export type QueryTaskArgs = {
  id: Scalars['String'];
};


export type QuerySearchTasksArgs = {
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
  skipSanitize?: Maybe<Scalars['Boolean']>;
};


export type QuerySearchTasksByContactArgs = {
  contactId: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QuerySearchTasksByCompanyArgs = {
  companyId: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']>>;
};


export type QueryTaskCountsArgs = {
  query: Scalars['String'];
  skipSanitize?: Maybe<Scalars['Boolean']>;
};


export type QueryLocationSuggestionsArgs = {
  query: Scalars['String'];
  coordinates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};


export type QueryPexelsSearchArgs = {
  query: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  orientation?: Maybe<Scalars['String']>;
};


export type QueryQuotePdfArgs = {
  url: Scalars['String'];
  pdfUrl?: Maybe<Scalars['String']>;
  silent?: Maybe<Scalars['Boolean']>;
  revision?: Maybe<Scalars['Boolean']>;
  paymentId?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
};


export type QueryGetApiKeysArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type QueryGetApiKeyArgs = {
  id: Scalars['String'];
};


export type QueryAdminLeaderboardArgs = {
  intervalStart?: Maybe<Scalars['Float']>;
  intervalLength?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryLeaderboardDataArgs = {
  userId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  intervalStart?: Maybe<Scalars['Float']>;
  intervalLength?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  searchTeam?: Maybe<Scalars['Boolean']>;
};


export type QueryLeaderboardRankArgs = {
  userId: Scalars['String'];
  intervalStart?: Maybe<Scalars['Float']>;
  intervalLength?: Maybe<Scalars['String']>;
};


export type QueryWeatherArgs = {
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};


export type QueryGetAuth0LogsArgs = {
  userId: Scalars['String'];
};


export type QueryGetInboundWebhookLogsArgs = {
  companyId: Scalars['String'];
  integration?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryGetPostHogSessionRecordingsArgs = {
  userId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
};


export type QueryGetPostmarkSuppressionStatusArgs = {
  email: Scalars['String'];
};


export type QueryGetPostmarkMessagesArgs = {
  email: Scalars['String'];
};


export type QueryGetStuckPaymentsArgs = {
  companyId: Scalars['String'];
};


export type QueryFindQuotePaymentsArgs = {
  companyId: Scalars['String'];
  search: Scalars['String'];
};


export type QueryGetPaymentSyncPreviewArgs = {
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  paymentIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetPayrixTxnLookupArgs = {
  companyId: Scalars['String'];
  txnId: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
};


export type QueryGetWebhooksArgs = {
  companyId: Scalars['String'];
};


export type QueryGetWebhookEventsArgs = {
  companyId: Scalars['String'];
  webhookId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
};


export type QueryPainterScheduleArgs = {
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  skipSanitize?: Maybe<Scalars['Boolean']>;
};


export type QueryPainterScheduleJobArgs = {
  dealId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};

export type Quote = {
  __typename?: 'Quote';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  fromTemplate?: Maybe<Scalars['JSON']>;
  jobAddress?: Maybe<Scalars['JSON']>;
  shippingAddress?: Maybe<Scalars['JSON']>;
  billingAddress?: Maybe<Scalars['JSON']>;
  demoTitle?: Maybe<Scalars['String']>;
  job_identifier?: Maybe<Scalars['String']>;
  quote_date?: Maybe<Scalars['Float']>;
  hourly_rate?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
  tax_description?: Maybe<Scalars['String']>;
  is_invoice?: Maybe<Scalars['Boolean']>;
  parent_quote?: Maybe<Scalars['String']>;
  parent_quote_number?: Maybe<Scalars['String']>;
  parent_quote_key?: Maybe<Scalars['String']>;
  child_invoice_number?: Maybe<Scalars['String']>;
  child_invoice_numbers?: Maybe<Array<Maybe<Scalars['Float']>>>;
  child_invoice?: Maybe<Scalars['String']>;
  child_invoices?: Maybe<Array<Maybe<Scalars['String']>>>;
  deal_id?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  discount_type?: Maybe<Scalars['JSON']>;
  discount_rate?: Maybe<Scalars['Float']>;
  discount_description?: Maybe<Scalars['String']>;
  discount_isShown?: Maybe<Scalars['Boolean']>;
  totalAdjustment?: Maybe<Scalars['JSON']>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  discounts?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  clientVisible?: Maybe<Scalars['Boolean']>;
  crewVisible?: Maybe<Scalars['Boolean']>;
  client_note?: Maybe<Scalars['String']>;
  contact?: Maybe<QuoteContact>;
  secondaryContact?: Maybe<QuoteContact>;
  label?: Maybe<Scalars['String']>;
  created_by: Scalars['String'];
  defaultView?: Maybe<Scalars['String']>;
  sendError?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Scalars['JSON']>;
  terms?: Maybe<Scalars['JSON']>;
  presentation?: Maybe<Scalars['JSON']>;
  number?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  customTerms?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['JSON']>;
  int_ext?: Maybe<Scalars['JSON']>;
  additionalWork?: Maybe<Scalars['JSON']>;
  internal_note?: Maybe<Scalars['String']>;
  productString?: Maybe<Scalars['JSON']>;
  areas?: Maybe<Scalars['JSON']>;
  substrates?: Maybe<Scalars['JSON']>;
  lineItems?: Maybe<Scalars['JSON']>;
  groups?: Maybe<Scalars['JSON']>;
  substratesGroupBy?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['JSON']>;
  sentReports?: Maybe<Scalars['JSON']>;
  dates?: Maybe<Scalars['JSON']>;
  lastViewedActivity?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['JSON']>;
  files?: Maybe<Scalars['JSON']>;
  signatures?: Maybe<Scalars['JSON']>;
  followUps?: Maybe<Scalars['JSON']>;
  followUpsDisabled?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<Scalars['JSON']>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  totals?: Maybe<Scalars['JSON']>;
  templateId?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  depositInfo?: Maybe<Scalars['JSON']>;
  source?: Maybe<Scalars['JSON']>;
  lead_source?: Maybe<Scalars['String']>;
  estimatorNotes?: Maybe<Scalars['String']>;
  lastUserSave?: Maybe<Scalars['JSON']>;
  lastMessage?: Maybe<Scalars['JSON']>;
  copyOf?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagDetails?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  trashed?: Maybe<Scalars['Boolean']>;
  trashedDate?: Maybe<Scalars['Float']>;
  trashedBy?: Maybe<Scalars['String']>;
  deleteDate?: Maybe<Scalars['Float']>;
  calculationLock?: Maybe<Scalars['Boolean']>;
  transferredFrom?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  translations?: Maybe<Scalars['JSON']>;
  addedOptionsTotal?: Maybe<Scalars['Float']>;
  additionalWorkTotal?: Maybe<Scalars['Float']>;
  totalHours?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  balanceDue?: Maybe<Scalars['Float']>;
  acceptedDate?: Maybe<Scalars['Float']>;
};

export type QuoteContact = {
  __typename?: 'QuoteContact';
  id?: Maybe<Scalars['String']>;
  rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  contact_type?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['Int']>;
  updated_date?: Maybe<Scalars['Int']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<Scalars['JSON']>;
  billingAddress?: Maybe<Scalars['JSON']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  lead_source?: Maybe<Scalars['String']>;
};

export type QuoteEmailFrom = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type QuoteEmailInput = {
  to?: Maybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  body: Scalars['String'];
  sms?: Maybe<QuoteSmsInput>;
  reminderOptions?: Maybe<ReminderOptionsInput>;
  signature?: Maybe<Scalars['String']>;
  attachPdf?: Maybe<Scalars['Boolean']>;
  silentQuoteLink?: Maybe<Scalars['Boolean']>;
  view?: Maybe<Scalars['String']>;
  from?: Maybe<QuoteEmailFrom>;
  lang?: Maybe<Scalars['String']>;
};

export type QuoteFollowUp = {
  __typename?: 'QuoteFollowUp';
  key: Scalars['String'];
  subject: Scalars['String'];
  message: Scalars['String'];
  smsMessage?: Maybe<Scalars['String']>;
  isInvoice?: Maybe<Scalars['Boolean']>;
  quoteTypes: Array<Scalars['String']>;
  conditions: FollowUpConditions;
  created?: Maybe<Scalars['Float']>;
  toggled?: Maybe<Scalars['Float']>;
  retroactive?: Maybe<Scalars['Boolean']>;
  sendFollowUpNotice?: Maybe<Scalars['Boolean']>;
  sendEmail: Scalars['Boolean'];
  sendText: Scalars['Boolean'];
  sent?: Maybe<Scalars['Float']>;
  fromStatus?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
};

export type QuoteMessagesResponse = {
  __typename?: 'QuoteMessagesResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Activity>>;
};

export type QuoteOwner = {
  __typename?: 'QuoteOwner';
  id?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
};

export type QuotePdfResponse = {
  __typename?: 'QuotePdfResponse';
  quotePdfUrl: Scalars['String'];
};

export type QuoteSmsInput = {
  to?: Maybe<Array<Scalars['String']>>;
  body?: Maybe<Scalars['String']>;
};

export type QuoteSummaryResponse = {
  __typename?: 'QuoteSummaryResponse';
  totalQuotes: Scalars['Float'];
  totalQuotePrice: Scalars['Float'];
  closedQuotes: Scalars['Float'];
  closedQuotePrice: Scalars['Float'];
  wonQuotes: Scalars['Float'];
  wonQuotePrice: Scalars['Float'];
  openQuotes: Scalars['Float'];
  openQuotePrice: Scalars['Float'];
  closeRate?: Maybe<Scalars['Float']>;
  winRate?: Maybe<Scalars['Float']>;
  dollarsWon?: Maybe<Scalars['Float']>;
  averageQuotePrice?: Maybe<Scalars['Float']>;
  averageClosePrice?: Maybe<Scalars['Float']>;
  averageWonPrice?: Maybe<Scalars['Float']>;
  averageOpenPrice?: Maybe<Scalars['Float']>;
};

export type QuoteType = {
  __typename?: 'QuoteType';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type QuoteUrlResponse = {
  __typename?: 'QuoteUrlResponse';
  url: UrlDocument;
  quote?: Maybe<Scalars['JSON']>;
};

export type ReactivateSubscriptionResponse = {
  __typename?: 'ReactivateSubscriptionResponse';
  status?: Maybe<Scalars['String']>;
};

export type RecoverInvoiceResponse = {
  __typename?: 'RecoverInvoiceResponse';
  quote?: Maybe<Scalars['JSON']>;
};

export type RefreshQuoteTranslationsResult = {
  __typename?: 'RefreshQuoteTranslationsResult';
  success: Scalars['Boolean'];
  translationStatus?: Maybe<Array<Maybe<TranslationLangStatus>>>;
  /**
   * The persisted quote, already carrying any newly-generated translations. Callers that only
   * need the freshly pre-baked content (e.g. the Download Work Order dialog) can read this
   * directly instead of issuing a second quote(id) round trip for the same document.
   */
  quote?: Maybe<Scalars['JSON']>;
};

export type RefundPaymentResponse = {
  __typename?: 'RefundPaymentResponse';
  refundTxnId?: Maybe<Scalars['String']>;
  updatedQuote: Scalars['JSON'];
};

export type RefundRecordInput = {
  /** The payment this refund is against. */
  paymentId: Scalars['String'];
  /** The Payrix refund transaction, kept on the refund row for the audit trail. */
  txnId: Scalars['String'];
  /** Refund amount in dollars, positive. */
  amount: Scalars['Float'];
};

export type ReminderOptionsInput = {
  retries?: Maybe<Scalars['Int']>;
  period?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type RenewAccountResponse = {
  __typename?: 'RenewAccountResponse';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  embed?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['Int']>;
  expires_at?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Int']>;
  resource_version?: Maybe<Scalars['Int']>;
};

export type ReportChart = {
  __typename?: 'ReportChart';
  type: Scalars['String'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  invert?: Maybe<Scalars['Boolean']>;
  xAxisTitle?: Maybe<Scalars['String']>;
  yAxisTitle?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  showLegend?: Maybe<Scalars['String']>;
  showXAxisLabels?: Maybe<Scalars['String']>;
  firstColumnSticky?: Maybe<Scalars['Boolean']>;
  allowFullscreen?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
  data?: Maybe<ReportChartData>;
};

export type ReportChartData = {
  __typename?: 'ReportChartData';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  datasets?: Maybe<Array<Maybe<ReportChartDataset>>>;
};

export type ReportChartDataset = {
  __typename?: 'ReportChartDataset';
  label?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Scalars['Float']>>>;
  scatterData?: Maybe<Array<Maybe<ScatterPoint>>>;
  backgroundColor?: Maybe<Array<Maybe<Scalars['String']>>>;
  borderColor?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReportColumnDefinition = {
  __typename?: 'ReportColumnDefinition';
  field: Scalars['String'];
  label: Scalars['String'];
  tooltip?: Maybe<Scalars['String']>;
  tooltipColumn?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  toggleable?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Filter>;
  width?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['JSON']>;
  sortable?: Maybe<Scalars['Boolean']>;
  align?: Maybe<Scalars['String']>;
  nowrap?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Type>;
  sortFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  subFields?: Maybe<Array<Maybe<ReportColumnDefinitionSubField>>>;
  actions?: Maybe<Array<Maybe<ReportColumnDefinitionAction>>>;
  link?: Maybe<ReportColumnDefinitionLink>;
  options?: Maybe<Array<Maybe<ReportFilterOption>>>;
  filterLabel?: Maybe<Scalars['String']>;
  booleanFilterLabels?: Maybe<Scalars['JSON']>;
};

export type ReportColumnDefinitionAction = {
  __typename?: 'ReportColumnDefinitionAction';
  type: Scalars['String'];
  label: Scalars['String'];
  report?: Maybe<Scalars['String']>;
};

export type ReportColumnDefinitionLink = {
  __typename?: 'ReportColumnDefinitionLink';
  href: Scalars['String'];
};

export type ReportColumnDefinitionSubField = {
  __typename?: 'ReportColumnDefinitionSubField';
  key: Scalars['String'];
  field: Scalars['String'];
};

export type ReportDataResponse = {
  __typename?: 'ReportDataResponse';
  name: Scalars['String'];
  title: Scalars['String'];
  options?: Maybe<Scalars['JSON']>;
  totalRows?: Maybe<Scalars['Int']>;
  totalValue?: Maybe<Scalars['Float']>;
  rows?: Maybe<Array<Scalars['JSON']>>;
  columns?: Maybe<Array<Maybe<ReportColumnDefinition>>>;
  chartData?: Maybe<Array<Maybe<ReportChart>>>;
};

export type ReportFilterOption = {
  __typename?: 'ReportFilterOption';
  value?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type ReportFilterOptionField = {
  __typename?: 'ReportFilterOptionField';
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<ReportFilterOption>>>;
};

export type ReportFilterOptionsReponse = {
  __typename?: 'ReportFilterOptionsReponse';
  fields?: Maybe<Array<Maybe<ReportFilterOptionField>>>;
};

export type RequestReviewResponse = {
  __typename?: 'RequestReviewResponse';
  result: Scalars['Boolean'];
};

export type RerunWebhookResult = {
  __typename?: 'RerunWebhookResult';
  statusCode: Scalars['Int'];
};

export type ResolveCancellationOfferResponse = {
  __typename?: 'ResolveCancellationOfferResponse';
  bucket: OfferBucket;
};

export type ResourceApiResponse = {
  __typename?: 'ResourceApiResponse';
  public_id?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  resource_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  bytes?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  backup?: Maybe<Scalars['Boolean']>;
  access_mode?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  secure_url?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  context?: Maybe<Scalars['JSON']>;
  next_cursor?: Maybe<Scalars['String']>;
  derived_next_cursor?: Maybe<Scalars['String']>;
  exif?: Maybe<Scalars['JSON']>;
  image_metadata?: Maybe<Scalars['JSON']>;
  faces?: Maybe<Array<Maybe<Array<Maybe<Scalars['Int']>>>>>;
  quality_analysis?: Maybe<Scalars['Int']>;
  colors?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
  derived?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  moderation?: Maybe<Scalars['JSON']>;
  phash?: Maybe<Scalars['String']>;
  predominant?: Maybe<Scalars['JSON']>;
  coordinates?: Maybe<Scalars['JSON']>;
  access_control?: Maybe<Array<Maybe<Scalars['String']>>>;
  pages?: Maybe<Scalars['Int']>;
};

export type RetentionDiscountResponse = {
  __typename?: 'RetentionDiscountResponse';
  discountRedeemedAt?: Maybe<Scalars['Float']>;
};

export type ReviewSmsInput = {
  to: Scalars['String'];
};

export type SalesRep = {
  __typename?: 'SalesRep';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SaveEventResponse = {
  __typename?: 'SaveEventResponse';
  activity?: Maybe<EventActivity>;
};

export type ScatterPoint = {
  __typename?: 'ScatterPoint';
  x: Scalars['Float'];
  y: Scalars['Float'];
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ScheduleCancellationResponse = {
  __typename?: 'ScheduleCancellationResponse';
  status?: Maybe<Scalars['String']>;
  cancellationScheduledFor?: Maybe<Scalars['Float']>;
};

export type SearchActivitiesResponse = {
  __typename?: 'SearchActivitiesResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  activities?: Maybe<Array<Activity>>;
};

export type SearchClientsResponse = {
  __typename?: 'SearchClientsResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  rows?: Maybe<Array<ClientMeta>>;
};

export type SearchCompaniesResult = {
  __typename?: 'SearchCompaniesResult';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<Company>>>;
};

export type SearchContactDealsResponse = {
  __typename?: 'SearchContactDealsResponse';
  results: Array<Maybe<Scalars['JSON']>>;
};

export type SearchContactOpportunitiesResponse = {
  __typename?: 'SearchContactOpportunitiesResponse';
  results: Array<Maybe<Scalars['JSON']>>;
};

export type SearchContactsByIntegrationResponse = {
  __typename?: 'SearchContactsByIntegrationResponse';
  results: Array<Maybe<Scalars['JSON']>>;
};

export type SearchContactsResult = {
  __typename?: 'SearchContactsResult';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
};

export type SearchDealsResult = {
  __typename?: 'SearchDealsResult';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  deals?: Maybe<Array<Maybe<Deal>>>;
  aggregations?: Maybe<DealSummaryResponse>;
};

export type SearchLocationsResponse = {
  __typename?: 'SearchLocationsResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  rows?: Maybe<Array<ClientMeta>>;
};

export type SearchManufacturerColorsResponse = {
  __typename?: 'SearchManufacturerColorsResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  rows?: Maybe<Array<Maybe<ManufacturerColor>>>;
};

export type SearchManufacturerProductsResponse = {
  __typename?: 'SearchManufacturerProductsResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  rows?: Maybe<Array<Maybe<ManufacturerProduct>>>;
};

/** Returns the entire Quote document */
export type SearchQuotesResponse = {
  __typename?: 'SearchQuotesResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  quotes?: Maybe<Array<Maybe<Quote>>>;
  rawQuotes?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type SearchTasksResult = {
  __typename?: 'SearchTasksResult';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
};

export type SearchUsersResponse = {
  __typename?: 'SearchUsersResponse';
  rows: Array<Maybe<User>>;
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
};

export type SendMessageResponse = {
  __typename?: 'SendMessageResponse';
  activity?: Maybe<MessageActivity>;
  quote?: Maybe<Scalars['JSON']>;
};

export type SendQuoteResponse = {
  __typename?: 'SendQuoteResponse';
  quote?: Maybe<Scalars['JSON']>;
  emails?: Maybe<Array<Maybe<SentEmail>>>;
  urlDocId?: Maybe<Scalars['String']>;
};

export type SentActivity = Activity & {
  __typename?: 'SentActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: SentActivityDetails;
};

export type SentActivityDetails = ActivityDetails & {
  __typename?: 'SentActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  email?: Maybe<ActivityEmail>;
  isWorkOrder?: Maybe<Scalars['Boolean']>;
  /** @deprecated Reminders have been removed. Always returns null. */
  isReminder?: Maybe<Scalars['Boolean']>;
};

export type SentEmail = {
  __typename?: 'SentEmail';
  headers?: Maybe<Scalars['JSON']>;
  response?: Maybe<Scalars['JSON']>;
};

export type SignedUploadResponse = {
  __typename?: 'SignedUploadResponse';
  url: Scalars['String'];
};

export type StageChangedActivity = Activity & {
  __typename?: 'StageChangedActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: StageChangedActivityDetails;
};

export type StageChangedActivityDetails = ActivityDetails & {
  __typename?: 'StageChangedActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  oldStage?: Maybe<Scalars['String']>;
  newStage?: Maybe<Scalars['String']>;
};

export type StuckPaymentsResult = {
  __typename?: 'StuckPaymentsResult';
  quotes: Array<AdminPaymentQuote>;
};

export type Task = CouchDocument & {
  __typename?: 'Task';
  _id: Scalars['String'];
  _rev: Scalars['String'];
  _deleted?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['String']>;
  dealName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  owner?: Maybe<Owner>;
  startDateTime?: Maybe<Scalars['Float']>;
  created: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  contact?: Maybe<Scalars['JSON']>;
  notes?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedDate?: Maybe<Scalars['Float']>;
  jobAddress?: Maybe<Scalars['JSON']>;
  trashed?: Maybe<Scalars['Boolean']>;
  trashedBy?: Maybe<Scalars['String']>;
  trashedDate?: Maybe<Scalars['Float']>;
  deleteDate?: Maybe<Scalars['Float']>;
  template?: Maybe<Scalars['JSON']>;
  /**
   * Pre-baked machine translations of the task's free-text content, keyed by lang then
   * content hash: translations[lang][contentHash(string)] = translatedString. Covers title,
   * notes, and template.templateLabel. Populated on save when the company has translation
   * languages enabled; the client applies it by hashing the rendered string and falls back
   * to the original when absent.
   */
  translations?: Maybe<Scalars['JSON']>;
};

export type TaskActivity = Activity & {
  __typename?: 'TaskActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: TaskActivityDetails;
};

export type TaskActivityDetails = ActivityDetails & {
  __typename?: 'TaskActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  url?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  taskName?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
};

export type TaskCounts = {
  __typename?: 'TaskCounts';
  total: Scalars['Int'];
  completed: Scalars['Int'];
  remaining: Scalars['Int'];
};

export type TimeRange = {
  __typename?: 'TimeRange';
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
};

export type TimeRangeInput = {
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
};

export type TranslatedEmailContent = {
  __typename?: 'TranslatedEmailContent';
  subject: Scalars['String'];
  body: Scalars['String'];
};

export type TranslationLangStatus = {
  __typename?: 'TranslationLangStatus';
  lang: Scalars['String'];
  status: Scalars['String'];
};

export type TurnOnCrmResult = {
  __typename?: 'TurnOnCrmResult';
  success: Scalars['Boolean'];
  trialExpiration?: Maybe<Scalars['Float']>;
  crmAlreadyActive?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export enum Type {
  Date = 'date',
  Currency = 'currency',
  Surcharge = 'surcharge',
  Percentage = 'percentage',
  IdNumber = 'idNumber',
  Boolean = 'boolean',
  User = 'user',
  FullUser = 'fullUser',
  Contact = 'contact',
  Company = 'company',
  Number = 'number',
  Tag = 'tag',
  Status = 'status',
  PaymentStatus = 'paymentStatus',
  PaymentMethod = 'paymentMethod',
  PaymentEvents = 'paymentEvents',
  ActivityType = 'activityType',
  Spacer = 'spacer',
  StartCase = 'startCase',
  Location = 'location',
  Stage = 'stage',
  QuoteType = 'quoteType',
  EventType = 'eventType',
  Deal = 'deal',
  Address = 'address'
}

export type UnscheduledJobsResponse = {
  __typename?: 'UnscheduledJobsResponse';
  total_rows?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  activities?: Maybe<Array<EventActivity>>;
};

export type UpdateApiKeyInput = {
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<ApiKeyOwnerInput>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type UpdateDealStageResponse = {
  __typename?: 'UpdateDealStageResponse';
  deal?: Maybe<Deal>;
  sourceAggregations?: Maybe<DealSummaryResponse>;
  destimationAggregations?: Maybe<DealSummaryResponse>;
};

export type UpdatePaymentResponse = {
  __typename?: 'UpdatePaymentResponse';
  updatedQuote: Scalars['JSON'];
};

export type UpdateUserInput = {
  user_id: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  user_metadata?: Maybe<UserMetadataInput>;
  app_metadata?: Maybe<AppMetadataInput>;
  preferences?: Maybe<Scalars['JSON']>;
  isOnboardingUpdate?: Maybe<Scalars['Boolean']>;
  origin?: Maybe<Scalars['String']>;
};


export type UploadOptions = {
  companyId: Scalars['String'];
  docId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<CsvOwner>;
  s3UploadFeatureEnabled?: Maybe<Scalars['Boolean']>;
  s3MediaUploadEnabled?: Maybe<Scalars['Boolean']>;
};

export type UrlDocument = {
  __typename?: 'UrlDocument';
  _id?: Maybe<Scalars['String']>;
  _rev?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['JSON']>;
  report?: Maybe<Scalars['String']>;
  db?: Maybe<Scalars['String']>;
  recipients?: Maybe<Scalars['JSON']>;
  messages?: Maybe<Scalars['JSON']>;
  host?: Maybe<Scalars['String']>;
  view?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  sendOptions?: Maybe<Scalars['JSON']>;
  updated?: Maybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  user_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  user_metadata?: Maybe<UserMetadata>;
  app_metadata?: Maybe<AppMetadata>;
  last_login?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  logins_count?: Maybe<Scalars['Int']>;
  preferences?: Maybe<Scalars['JSON']>;
  signature?: Maybe<Scalars['String']>;
  client?: Maybe<UserClient>;
};

export type UserClient = {
  __typename?: 'UserClient';
  meta?: Maybe<ClientMeta>;
  options?: Maybe<Scalars['JSON']>;
  rates?: Maybe<Scalars['JSON']>;
};

export type UserMetadata = {
  __typename?: 'UserMetadata';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  customAvatar?: Maybe<CustomAvatar>;
  playerName?: Maybe<Scalars['String']>;
  blockLaunchDialog?: Maybe<Scalars['Boolean']>;
  projectTypes?: Maybe<Scalars['String']>;
  hasJoinedLeaderboard?: Maybe<Scalars['Boolean']>;
  leaderboardOptOut?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  /** @deprecated Salesmate integration removed */
  salesmateId?: Maybe<Scalars['Int']>;
};

export type UserMetadataInput = {
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  customAvatar?: Maybe<CustomAvatarInput>;
  playerName?: Maybe<Scalars['String']>;
  blockLaunchDialog?: Maybe<Scalars['Boolean']>;
  projectTypes?: Maybe<Scalars['String']>;
  hasJoinedLeaderboard?: Maybe<Scalars['Boolean']>;
  leaderboardOptOut?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
};

export type ViewQuoteResponse = {
  __typename?: 'ViewQuoteResponse';
  quote: Scalars['JSON'];
  options: Scalars['JSON'];
  estimator: Scalars['JSON'];
  view: Scalars['String'];
  tableView?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  decryptedEmail?: Maybe<Scalars['String']>;
  availableLangs?: Maybe<Array<Maybe<Scalars['String']>>>;
  translationStatus?: Maybe<Array<Maybe<TranslationLangStatus>>>;
  presentationNext?: Maybe<Scalars['Boolean']>;
  estimateNext?: Maybe<Scalars['Boolean']>;
};

export type ViewedActivity = Activity & {
  __typename?: 'ViewedActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: ViewedActivityDetails;
};

export type ViewedActivityDetails = ActivityDetails & {
  __typename?: 'ViewedActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  viewingEmail?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  notificationPending?: Maybe<Scalars['Boolean']>;
};

export type WarningActivity = Activity & {
  __typename?: 'WarningActivity';
  _id: Scalars['String'];
  _rev?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  docIds: Array<Maybe<Scalars['String']>>;
  assignedUsers?: Maybe<Scalars['JSON']>;
  details: WarningActivityDetails;
};

export type WarningActivityDetails = ActivityDetails & {
  __typename?: 'WarningActivityDetails';
  docType: Scalars['String'];
  activityType: Scalars['String'];
  events?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Owner>;
  quoteOwner?: Maybe<QuoteOwner>;
  trashed?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<ActivityContact>;
  quote?: Maybe<ActivityQuote>;
  invoice?: Maybe<ActivityQuote>;
  deal?: Maybe<ActivityDeal>;
  jobAddress?: Maybe<ActivityJobAddress>;
  timestamp: Scalars['Float'];
  updated?: Maybe<Scalars['Float']>;
  updatedInterval?: Maybe<Scalars['Float']>;
  isAutomated?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  warningMessage?: Maybe<Scalars['String']>;
  warningTitle?: Maybe<Scalars['String']>;
};

export type WeatherDay = {
  __typename?: 'WeatherDay';
  time: Scalars['String'];
  temperature?: Maybe<Scalars['Float']>;
  temperatureMin?: Maybe<Scalars['Float']>;
  temperatureMax?: Maybe<Scalars['Float']>;
  weatherCode?: Maybe<Scalars['Int']>;
  precipitationProbability?: Maybe<Scalars['Float']>;
};

export type WebhookEventType = {
  __typename?: 'WebhookEventType';
  id?: Maybe<Scalars['String']>;
  webhookId: Scalars['String'];
  webhookUrl?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  status: Scalars['String'];
  httpStatus?: Maybe<Scalars['Int']>;
  retryCount?: Maybe<Scalars['Int']>;
  maxRetries?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['Float']>;
  lastAttempt?: Maybe<Scalars['Float']>;
  nextRetry?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
};

export type WebhookEventsResult = {
  __typename?: 'WebhookEventsResult';
  rows?: Maybe<Array<Maybe<WebhookEventType>>>;
  total?: Maybe<Scalars['Int']>;
};

export type WebhookParams = {
  __typename?: 'WebhookParams';
  quoteTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  quoteStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  stageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagsAdded?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagsRemoved?: Maybe<Array<Maybe<Scalars['String']>>>;
  isInvoice?: Maybe<Scalars['Boolean']>;
};

export type WebhookTimestamp = {
  __typename?: 'WebhookTimestamp';
  created?: Maybe<Scalars['Float']>;
  updated?: Maybe<Scalars['Float']>;
};

export type WebhookType = {
  __typename?: 'WebhookType';
  id: Scalars['String'];
  url: Scalars['String'];
  events?: Maybe<Array<Maybe<Scalars['String']>>>;
  enabled?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  timestamp?: Maybe<WebhookTimestamp>;
  deleted?: Maybe<Scalars['Boolean']>;
  params?: Maybe<WebhookParams>;
};

export type WebhooksResult = {
  __typename?: 'WebhooksResult';
  rows?: Maybe<Array<Maybe<WebhookType>>>;
  total?: Maybe<Scalars['Int']>;
};

export type WisetackLoanApplication = {
  __typename?: 'WisetackLoanApplication';
  loanApplicationLink?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  changedStatus?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['Float']>;
  requestedLoanAmount?: Maybe<Scalars['Float']>;
  approvedLoanAmount?: Maybe<Scalars['Float']>;
  settledLoanAmount?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  invoiceNumber?: Maybe<Scalars['Int']>;
  quoteNumber?: Maybe<Scalars['Int']>;
  purchaseId?: Maybe<Scalars['String']>;
  refund?: Maybe<WisetackLoanApplicationRefund>;
  maximumAmount?: Maybe<Scalars['Float']>;
  transactionPurpose?: Maybe<Scalars['String']>;
  serviceCompletedOn?: Maybe<Scalars['Float']>;
  tilaAcceptedOn?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  expirationDate?: Maybe<Scalars['Float']>;
  prequalId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  payouts?: Maybe<Scalars['JSON']>;
};

export type WisetackLoanApplicationRefund = {
  __typename?: 'WisetackLoanApplicationRefund';
  id?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  merchantDebitAmount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Float']>;
};

export type WisetackPrequal = {
  __typename?: 'WisetackPrequal';
  prequalLink?: Maybe<Scalars['String']>;
  prequalId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  signupId?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  prequalStatus?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['Float']>;
  maxQualifiedAmount?: Maybe<Scalars['Float']>;
  aprRange?: Maybe<Array<Maybe<Scalars['String']>>>;
  expirationDate?: Maybe<Scalars['Float']>;
  customerInfo?: Maybe<WisetackPrequalCustomer>;
};

export type WisetackPrequalCustomer = {
  __typename?: 'WisetackPrequalCustomer';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptAdditionalWorkResponse: ResolverTypeWrapper<AcceptAdditionalWorkResponse>;
  AcceptQuoteResponse: ResolverTypeWrapper<AcceptQuoteResponse>;
  AcceptedActivity: ResolverTypeWrapper<AcceptedActivity>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  AcceptedActivityDetails: ResolverTypeWrapper<AcceptedActivityDetails>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  AcknowledgeCheckoutResponse: ResolverTypeWrapper<AcknowledgeCheckoutResponse>;
  Activity: ResolversTypes['AcceptedActivity'] | ResolversTypes['AssignmentActivity'] | ResolversTypes['BasicActivity'] | ResolversTypes['ChatMessageActivity'] | ResolversTypes['DeclinedActivity'] | ResolversTypes['EventActivity'] | ResolversTypes['EventEmailSentActivity'] | ResolversTypes['FileAddedActivity'] | ResolversTypes['FollowUpSentActivity'] | ResolversTypes['LeadFormSubmissionActivity'] | ResolversTypes['MessageActivity'] | ResolversTypes['NoteActivity'] | ResolversTypes['OwnerChangedActivity'] | ResolversTypes['PaymentActivity'] | ResolversTypes['PaymentReceivedSentActivity'] | ResolversTypes['PaymentRequestedActivity'] | ResolversTypes['SentActivity'] | ResolversTypes['StageChangedActivity'] | ResolversTypes['TaskActivity'] | ResolversTypes['ViewedActivity'] | ResolversTypes['WarningActivity'];
  ActivityContact: ResolverTypeWrapper<ActivityContact>;
  ActivityDeal: ResolverTypeWrapper<ActivityDeal>;
  ActivityDetails: ResolversTypes['AcceptedActivityDetails'] | ResolversTypes['AssignmentActivityDetails'] | ResolversTypes['BasicActivityDetails'] | ResolversTypes['ChatMessageActivityDetails'] | ResolversTypes['DeclinedActivityDetails'] | ResolversTypes['EventActivityDetails'] | ResolversTypes['EventEmailSentActivityDetails'] | ResolversTypes['FileAddedActivityDetails'] | ResolversTypes['FollowUpSentActivityDetails'] | ResolversTypes['LeadFormSubmissionActivityDetails'] | ResolversTypes['MessageActivityDetails'] | ResolversTypes['NoteActivityDetails'] | ResolversTypes['OwnerChangedActivityDetails'] | ResolversTypes['PaymentActivityDetails'] | ResolversTypes['PaymentReceivedSentActivityDetails'] | ResolversTypes['PaymentRequestedActivityDetails'] | ResolversTypes['SentActivityDetails'] | ResolversTypes['StageChangedActivityDetails'] | ResolversTypes['TaskActivityDetails'] | ResolversTypes['ViewedActivityDetails'] | ResolversTypes['WarningActivityDetails'];
  ActivityEmail: ResolverTypeWrapper<ActivityEmail>;
  ActivityJobAddress: ResolverTypeWrapper<ActivityJobAddress>;
  ActivityMessage: ResolverTypeWrapper<ActivityMessage>;
  ActivityMessageFrom: ResolverTypeWrapper<ActivityMessageFrom>;
  ActivityQuote: ResolverTypeWrapper<ActivityQuote>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  AddPaymentResult: ResolverTypeWrapper<AddPaymentResult>;
  AddProcessingPaymentResponse: ResolverTypeWrapper<AddProcessingPaymentResponse>;
  AddSubscriptionAddonResponse: ResolverTypeWrapper<AddSubscriptionAddonResponse>;
  AdminDashboardStats: ResolverTypeWrapper<AdminDashboardStats>;
  AdminIntegrationsConfigResponse: ResolverTypeWrapper<AdminIntegrationsConfigResponse>;
  AdminLeaderboardResponse: ResolverTypeWrapper<AdminLeaderboardResponse>;
  AdminLeaderboardRow: ResolverTypeWrapper<AdminLeaderboardRow>;
  AdminPaymentEntry: ResolverTypeWrapper<AdminPaymentEntry>;
  AdminPaymentQuote: ResolverTypeWrapper<AdminPaymentQuote>;
  ApiKeyDocument: ResolverTypeWrapper<ApiKeyDocument>;
  ApiKeyOwnerInput: ApiKeyOwnerInput;
  AppDocsResponse: ResolverTypeWrapper<AppDocsResponse>;
  AppMetaDataUserCompany: ResolverTypeWrapper<AppMetaDataUserCompany>;
  AppMetadata: ResolverTypeWrapper<AppMetadata>;
  AppMetadataInput: AppMetadataInput;
  AppMetadataUser: ResolverTypeWrapper<AppMetadataUser>;
  AppMetadataUserInput: AppMetadataUserInput;
  ApplyPaymentSyncResult: ResolverTypeWrapper<ApplyPaymentSyncResult>;
  AssignedCsm: AssignedCsm;
  AssignmentActivity: ResolverTypeWrapper<AssignmentActivity>;
  AssignmentActivityDetails: ResolverTypeWrapper<AssignmentActivityDetails>;
  AttachTxnIdResult: ResolverTypeWrapper<AttachTxnIdResult>;
  Auth0LogEntry: ResolverTypeWrapper<Auth0LogEntry>;
  Auth0LogsResult: ResolverTypeWrapper<Auth0LogsResult>;
  BasicActivity: ResolverTypeWrapper<BasicActivity>;
  BasicActivityDetails: ResolverTypeWrapper<BasicActivityDetails>;
  BulkDocsResponseObject: ResolverTypeWrapper<BulkDocsResponseObject>;
  CancellationFlowStatus: CancellationFlowStatus;
  CancellationImpactSummary: ResolverTypeWrapper<CancellationImpactSummary>;
  CancellationReason: CancellationReason;
  ChargebeeAddon: ResolverTypeWrapper<ChargebeeAddon>;
  ChargebeeAddonSummary: ResolverTypeWrapper<ChargebeeAddonSummary>;
  ChargebeeBillingContact: ResolverTypeWrapper<ChargebeeBillingContact>;
  ChargebeeCharge: ResolverTypeWrapper<ChargebeeCharge>;
  ChargebeeCoupon: ResolverTypeWrapper<ChargebeeCoupon>;
  ChargebeeDiscount: ResolverTypeWrapper<ChargebeeDiscount>;
  ChargebeeItemPrice: ResolverTypeWrapper<ChargebeeItemPrice>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  ChargebeeOneTimeCharge: ResolverTypeWrapper<ChargebeeOneTimeCharge>;
  ChargebeePlan: ResolverTypeWrapper<ChargebeePlan>;
  ChargebeeSubscription: ResolverTypeWrapper<ChargebeeSubscription>;
  ChargebeeSubscriptionSummary: ResolverTypeWrapper<ChargebeeSubscriptionSummary>;
  ChatMessage: ResolverTypeWrapper<ChatMessage>;
  ChatMessageActivity: ResolverTypeWrapper<ChatMessageActivity>;
  ChatMessageActivityDetails: ResolverTypeWrapper<ChatMessageActivityDetails>;
  ChatMessageUsage: ResolverTypeWrapper<ChatMessageUsage>;
  CheckoutAddonInput: CheckoutAddonInput;
  CheckoutCoupon: ResolverTypeWrapper<CheckoutCoupon>;
  CheckoutEstimate: ResolverTypeWrapper<CheckoutEstimate>;
  CheckoutEstimateLineItem: ResolverTypeWrapper<CheckoutEstimateLineItem>;
  CheckoutInput: CheckoutInput;
  CheckoutResult: ResolverTypeWrapper<CheckoutResult>;
  ClientAggregates: ResolverTypeWrapper<ClientAggregates>;
  ClientAggregatesInput: ClientAggregatesInput;
  ClientCancellationFlow: ResolverTypeWrapper<ClientCancellationFlow>;
  ClientCancellationFlowInput: ClientCancellationFlowInput;
  ClientDunning: ResolverTypeWrapper<ClientDunning>;
  ClientMeta: ResolverTypeWrapper<ClientMeta>;
  ClientMetaInput: ClientMetaInput;
  ClientMetaSubscription: ResolverTypeWrapper<ClientMetaSubscription>;
  ClientMetaSubscriptionInput: ClientMetaSubscriptionInput;
  ClientOptions: ResolverTypeWrapper<ClientOptions>;
  ClientOptionsInput: ClientOptionsInput;
  ClientProduct: ClientProduct;
  ClientResponse: ResolverTypeWrapper<ClientResponse>;
  ClientUserCounts: ResolverTypeWrapper<ClientUserCounts>;
  ClientUserCountsInput: ClientUserCountsInput;
  CloudinaryFile: ResolverTypeWrapper<CloudinaryFile>;
  CoachingCallStatus: CoachingCallStatus;
  Company: ResolverTypeWrapper<Company>;
  CompanySubscription: ResolverTypeWrapper<CompanySubscription>;
  Contact: ResolverTypeWrapper<Contact>;
  ContactGeocode: ResolverTypeWrapper<ContactGeocode>;
  ConvertedFile: ResolverTypeWrapper<ConvertedFile>;
  CouchDocument: ResolversTypes['Contact'] | ResolversTypes['Deal'] | ResolversTypes['Task'];
  CreateClientInput: CreateClientInput;
  CreateNoteResponse: ResolverTypeWrapper<CreateNoteResponse>;
  CreatePaymentActivityResponse: ResolverTypeWrapper<CreatePaymentActivityResponse>;
  CreateUserInput: CreateUserInput;
  CsmBookingInfo: ResolverTypeWrapper<CsmBookingInfo>;
  CsvOwner: CsvOwner;
  CustomAvatar: ResolverTypeWrapper<CustomAvatar>;
  CustomAvatarInput: CustomAvatarInput;
  DateRange: ResolverTypeWrapper<DateRange>;
  DateRangeInput: DateRangeInput;
  Deal: ResolverTypeWrapper<Deal>;
  DealContact: ResolverTypeWrapper<DealContact>;
  DealGeocode: ResolverTypeWrapper<DealGeocode>;
  DealPipeline: ResolverTypeWrapper<DealPipeline>;
  DealStage: ResolverTypeWrapper<DealStage>;
  DealStatus: DealStatus;
  DealSummaryResponse: ResolverTypeWrapper<DealSummaryResponse>;
  DeclineQuoteResponse: ResolverTypeWrapper<DeclineQuoteResponse>;
  DeclinedActivity: ResolverTypeWrapper<DeclinedActivity>;
  DeclinedActivityDetails: ResolverTypeWrapper<DeclinedActivityDetails>;
  DeletePaymentResponse: ResolverTypeWrapper<DeletePaymentResponse>;
  DowngradeSubscriptionResponse: ResolverTypeWrapper<DowngradeSubscriptionResponse>;
  DunningStatus: DunningStatus;
  EscalateToSupportResponse: ResolverTypeWrapper<EscalateToSupportResponse>;
  Estimator: ResolverTypeWrapper<Estimator>;
  EventActivity: ResolverTypeWrapper<EventActivity>;
  EventActivityDetails: ResolverTypeWrapper<EventActivityDetails>;
  EventEmailSentActivity: ResolverTypeWrapper<EventEmailSentActivity>;
  EventEmailSentActivityDetails: ResolverTypeWrapper<EventEmailSentActivityDetails>;
  EventGeocode: ResolverTypeWrapper<EventGeocode>;
  ExportClientsResponse: ResolverTypeWrapper<ExportClientsResponse>;
  ExportCompaniesResponse: ResolverTypeWrapper<ExportCompaniesResponse>;
  ExportContactsResponse: ResolverTypeWrapper<ExportContactsResponse>;
  ExportDealsResponse: ResolverTypeWrapper<ExportDealsResponse>;
  ExportLineItemsResponse: ResolverTypeWrapper<ExportLineItemsResponse>;
  ExportProductResponse: ResolverTypeWrapper<ExportProductResponse>;
  ExportProductionRatesResponse: ResolverTypeWrapper<ExportProductionRatesResponse>;
  ExportQuotesResponse: ResolverTypeWrapper<ExportQuotesResponse>;
  FileAddedActivity: ResolverTypeWrapper<FileAddedActivity>;
  FileAddedActivityDetails: ResolverTypeWrapper<FileAddedActivityDetails>;
  Filter: Filter;
  FollowUp: ResolverTypeWrapper<FollowUp>;
  FollowUpConditions: ResolverTypeWrapper<FollowUpConditions>;
  FollowUpSentActivity: ResolverTypeWrapper<FollowUpSentActivity>;
  FollowUpSentActivityDetails: ResolverTypeWrapper<FollowUpSentActivityDetails>;
  FollowUpsForUser: ResolverTypeWrapper<FollowUpsForUser>;
  GeneratePresentationInput: GeneratePresentationInput;
  GeneratePresentationResult: ResolverTypeWrapper<GeneratePresentationResult>;
  GetCorporateTypeDataResponse: ResolverTypeWrapper<GetCorporateTypeDataResponse>;
  GetPortalSessionResponse: ResolverTypeWrapper<GetPortalSessionResponse>;
  HubspotCompanyInfo: ResolverTypeWrapper<HubspotCompanyInfo>;
  InboundWebhookLogEntry: ResolverTypeWrapper<InboundWebhookLogEntry>;
  InboundWebhookLogsResult: ResolverTypeWrapper<InboundWebhookLogsResult>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  JobCosting: ResolverTypeWrapper<JobCosting>;
  LeadFormSubmissionActivity: ResolverTypeWrapper<LeadFormSubmissionActivity>;
  LeadFormSubmissionActivityDetails: ResolverTypeWrapper<LeadFormSubmissionActivityDetails>;
  LeaderboardDataResponse: ResolverTypeWrapper<LeaderboardDataResponse>;
  LeaderboardDataResponseRow: ResolverTypeWrapper<LeaderboardDataResponseRow>;
  LeaderboardRankResponse: ResolverTypeWrapper<LeaderboardRankResponse>;
  LeaderboardRankResponseItem: ResolverTypeWrapper<LeaderboardRankResponseItem>;
  LocationSuggestion: ResolverTypeWrapper<LocationSuggestion>;
  ManufacturerColor: ResolverTypeWrapper<ManufacturerColor>;
  ManufacturerProduct: ResolverTypeWrapper<ManufacturerProduct>;
  MessageActivity: ResolverTypeWrapper<MessageActivity>;
  MessageActivityDetails: ResolverTypeWrapper<MessageActivityDetails>;
  MfaEnrollment: ResolverTypeWrapper<MfaEnrollment>;
  Mutation: ResolverTypeWrapper<{}>;
  NewAccountResponse: ResolverTypeWrapper<NewAccountResponse>;
  NoteActivity: ResolverTypeWrapper<NoteActivity>;
  NoteActivityDetails: ResolverTypeWrapper<NoteActivityDetails>;
  NoteActivityFile: ResolverTypeWrapper<NoteActivityFile>;
  NoteActivityVersion: ResolverTypeWrapper<NoteActivityVersion>;
  OfferBucket: OfferBucket;
  OfflineQuotesResponse: ResolverTypeWrapper<OfflineQuotesResponse>;
  Owner: ResolverTypeWrapper<Owner>;
  OwnerChangedActivity: ResolverTypeWrapper<OwnerChangedActivity>;
  OwnerChangedActivityDetails: ResolverTypeWrapper<OwnerChangedActivityDetails>;
  PainterScheduleDeal: ResolverTypeWrapper<PainterScheduleDeal>;
  PainterScheduleJobResponse: ResolverTypeWrapper<PainterScheduleJobResponse>;
  PainterScheduleResponse: ResolverTypeWrapper<PainterScheduleResponse>;
  PaymentActivity: ResolverTypeWrapper<PaymentActivity>;
  PaymentActivityDetails: ResolverTypeWrapper<PaymentActivityDetails>;
  PaymentDecisionInput: PaymentDecisionInput;
  PaymentProcessedResponse: ResolverTypeWrapper<PaymentProcessedResponse>;
  PaymentReceivedSentActivity: ResolverTypeWrapper<PaymentReceivedSentActivity>;
  PaymentReceivedSentActivityDetails: ResolverTypeWrapper<PaymentReceivedSentActivityDetails>;
  PaymentRequestEmailInput: PaymentRequestEmailInput;
  PaymentRequestSmsInput: PaymentRequestSmsInput;
  PaymentRequestedActivity: ResolverTypeWrapper<PaymentRequestedActivity>;
  PaymentRequestedActivityDetails: ResolverTypeWrapper<PaymentRequestedActivityDetails>;
  PaymentSyncEntry: ResolverTypeWrapper<PaymentSyncEntry>;
  PaymentSyncRefund: ResolverTypeWrapper<PaymentSyncRefund>;
  PayrixConnectionResult: ResolverTypeWrapper<PayrixConnectionResult>;
  PayrixTxnLookup: ResolverTypeWrapper<PayrixTxnLookup>;
  PexelsPhoto: ResolverTypeWrapper<PexelsPhoto>;
  PexelsPhotoSrc: ResolverTypeWrapper<PexelsPhotoSrc>;
  PexelsSearchResult: ResolverTypeWrapper<PexelsSearchResult>;
  PortalSessionLinkedCustomer: ResolverTypeWrapper<PortalSessionLinkedCustomer>;
  PostHogSessionRecording: ResolverTypeWrapper<PostHogSessionRecording>;
  PostHogSessionRecordingsResult: ResolverTypeWrapper<PostHogSessionRecordingsResult>;
  PostmarkMessage: ResolverTypeWrapper<PostmarkMessage>;
  PostmarkMessagesResult: ResolverTypeWrapper<PostmarkMessagesResult>;
  PostmarkSuppressionEntry: ResolverTypeWrapper<PostmarkSuppressionEntry>;
  ProcessEventResponse: ResolverTypeWrapper<ProcessEventResponse>;
  ProcessFileParams: ProcessFileParams;
  Query: ResolverTypeWrapper<{}>;
  Quote: ResolverTypeWrapper<Quote>;
  QuoteContact: ResolverTypeWrapper<QuoteContact>;
  QuoteEmailFrom: QuoteEmailFrom;
  QuoteEmailInput: QuoteEmailInput;
  QuoteFollowUp: ResolverTypeWrapper<QuoteFollowUp>;
  QuoteMessagesResponse: ResolverTypeWrapper<QuoteMessagesResponse>;
  QuoteOwner: ResolverTypeWrapper<QuoteOwner>;
  QuotePdfResponse: ResolverTypeWrapper<QuotePdfResponse>;
  QuoteSmsInput: QuoteSmsInput;
  QuoteSummaryResponse: ResolverTypeWrapper<QuoteSummaryResponse>;
  QuoteType: ResolverTypeWrapper<QuoteType>;
  QuoteUrlResponse: ResolverTypeWrapper<QuoteUrlResponse>;
  ReactivateSubscriptionResponse: ResolverTypeWrapper<ReactivateSubscriptionResponse>;
  RecoverInvoiceResponse: ResolverTypeWrapper<RecoverInvoiceResponse>;
  RefreshQuoteTranslationsResult: ResolverTypeWrapper<RefreshQuoteTranslationsResult>;
  RefundPaymentResponse: ResolverTypeWrapper<RefundPaymentResponse>;
  RefundRecordInput: RefundRecordInput;
  ReminderOptionsInput: ReminderOptionsInput;
  RenewAccountResponse: ResolverTypeWrapper<RenewAccountResponse>;
  ReportChart: ResolverTypeWrapper<ReportChart>;
  ReportChartData: ResolverTypeWrapper<ReportChartData>;
  ReportChartDataset: ResolverTypeWrapper<ReportChartDataset>;
  ReportColumnDefinition: ResolverTypeWrapper<ReportColumnDefinition>;
  ReportColumnDefinitionAction: ResolverTypeWrapper<ReportColumnDefinitionAction>;
  ReportColumnDefinitionLink: ResolverTypeWrapper<ReportColumnDefinitionLink>;
  ReportColumnDefinitionSubField: ResolverTypeWrapper<ReportColumnDefinitionSubField>;
  ReportDataResponse: ResolverTypeWrapper<ReportDataResponse>;
  ReportFilterOption: ResolverTypeWrapper<ReportFilterOption>;
  ReportFilterOptionField: ResolverTypeWrapper<ReportFilterOptionField>;
  ReportFilterOptionsReponse: ResolverTypeWrapper<ReportFilterOptionsReponse>;
  RequestReviewResponse: ResolverTypeWrapper<RequestReviewResponse>;
  RerunWebhookResult: ResolverTypeWrapper<RerunWebhookResult>;
  ResolveCancellationOfferResponse: ResolverTypeWrapper<ResolveCancellationOfferResponse>;
  ResourceApiResponse: ResolverTypeWrapper<ResourceApiResponse>;
  RetentionDiscountResponse: ResolverTypeWrapper<RetentionDiscountResponse>;
  ReviewSmsInput: ReviewSmsInput;
  SalesRep: ResolverTypeWrapper<SalesRep>;
  SaveEventResponse: ResolverTypeWrapper<SaveEventResponse>;
  ScatterPoint: ResolverTypeWrapper<ScatterPoint>;
  ScheduleCancellationResponse: ResolverTypeWrapper<ScheduleCancellationResponse>;
  SearchActivitiesResponse: ResolverTypeWrapper<SearchActivitiesResponse>;
  SearchClientsResponse: ResolverTypeWrapper<SearchClientsResponse>;
  SearchCompaniesResult: ResolverTypeWrapper<SearchCompaniesResult>;
  SearchContactDealsResponse: ResolverTypeWrapper<SearchContactDealsResponse>;
  SearchContactOpportunitiesResponse: ResolverTypeWrapper<SearchContactOpportunitiesResponse>;
  SearchContactsByIntegrationResponse: ResolverTypeWrapper<SearchContactsByIntegrationResponse>;
  SearchContactsResult: ResolverTypeWrapper<SearchContactsResult>;
  SearchDealsResult: ResolverTypeWrapper<SearchDealsResult>;
  SearchLocationsResponse: ResolverTypeWrapper<SearchLocationsResponse>;
  SearchManufacturerColorsResponse: ResolverTypeWrapper<SearchManufacturerColorsResponse>;
  SearchManufacturerProductsResponse: ResolverTypeWrapper<SearchManufacturerProductsResponse>;
  SearchQuotesResponse: ResolverTypeWrapper<SearchQuotesResponse>;
  SearchTasksResult: ResolverTypeWrapper<SearchTasksResult>;
  SearchUsersResponse: ResolverTypeWrapper<SearchUsersResponse>;
  SendMessageResponse: ResolverTypeWrapper<SendMessageResponse>;
  SendQuoteResponse: ResolverTypeWrapper<SendQuoteResponse>;
  SentActivity: ResolverTypeWrapper<SentActivity>;
  SentActivityDetails: ResolverTypeWrapper<SentActivityDetails>;
  SentEmail: ResolverTypeWrapper<SentEmail>;
  SignedUploadResponse: ResolverTypeWrapper<SignedUploadResponse>;
  StageChangedActivity: ResolverTypeWrapper<StageChangedActivity>;
  StageChangedActivityDetails: ResolverTypeWrapper<StageChangedActivityDetails>;
  StuckPaymentsResult: ResolverTypeWrapper<StuckPaymentsResult>;
  Task: ResolverTypeWrapper<Task>;
  TaskActivity: ResolverTypeWrapper<TaskActivity>;
  TaskActivityDetails: ResolverTypeWrapper<TaskActivityDetails>;
  TaskCounts: ResolverTypeWrapper<TaskCounts>;
  TimeRange: ResolverTypeWrapper<TimeRange>;
  TimeRangeInput: TimeRangeInput;
  TranslatedEmailContent: ResolverTypeWrapper<TranslatedEmailContent>;
  TranslationLangStatus: ResolverTypeWrapper<TranslationLangStatus>;
  TurnOnCrmResult: ResolverTypeWrapper<TurnOnCrmResult>;
  Type: Type;
  UnscheduledJobsResponse: ResolverTypeWrapper<UnscheduledJobsResponse>;
  UpdateApiKeyInput: UpdateApiKeyInput;
  UpdateDealStageResponse: ResolverTypeWrapper<UpdateDealStageResponse>;
  UpdatePaymentResponse: ResolverTypeWrapper<UpdatePaymentResponse>;
  UpdateUserInput: UpdateUserInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  UploadOptions: UploadOptions;
  UrlDocument: ResolverTypeWrapper<UrlDocument>;
  User: ResolverTypeWrapper<User>;
  UserClient: ResolverTypeWrapper<UserClient>;
  UserMetadata: ResolverTypeWrapper<UserMetadata>;
  UserMetadataInput: UserMetadataInput;
  ViewQuoteResponse: ResolverTypeWrapper<ViewQuoteResponse>;
  ViewedActivity: ResolverTypeWrapper<ViewedActivity>;
  ViewedActivityDetails: ResolverTypeWrapper<ViewedActivityDetails>;
  WarningActivity: ResolverTypeWrapper<WarningActivity>;
  WarningActivityDetails: ResolverTypeWrapper<WarningActivityDetails>;
  WeatherDay: ResolverTypeWrapper<WeatherDay>;
  WebhookEventType: ResolverTypeWrapper<WebhookEventType>;
  WebhookEventsResult: ResolverTypeWrapper<WebhookEventsResult>;
  WebhookParams: ResolverTypeWrapper<WebhookParams>;
  WebhookTimestamp: ResolverTypeWrapper<WebhookTimestamp>;
  WebhookType: ResolverTypeWrapper<WebhookType>;
  WebhooksResult: ResolverTypeWrapper<WebhooksResult>;
  WisetackLoanApplication: ResolverTypeWrapper<WisetackLoanApplication>;
  WisetackLoanApplicationRefund: ResolverTypeWrapper<WisetackLoanApplicationRefund>;
  WisetackPrequal: ResolverTypeWrapper<WisetackPrequal>;
  WisetackPrequalCustomer: ResolverTypeWrapper<WisetackPrequalCustomer>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptAdditionalWorkResponse: AcceptAdditionalWorkResponse;
  AcceptQuoteResponse: AcceptQuoteResponse;
  AcceptedActivity: AcceptedActivity;
  String: Scalars['String'];
  Boolean: Scalars['Boolean'];
  AcceptedActivityDetails: AcceptedActivityDetails;
  Float: Scalars['Float'];
  AcknowledgeCheckoutResponse: AcknowledgeCheckoutResponse;
  Activity: ResolversParentTypes['AcceptedActivity'] | ResolversParentTypes['AssignmentActivity'] | ResolversParentTypes['BasicActivity'] | ResolversParentTypes['ChatMessageActivity'] | ResolversParentTypes['DeclinedActivity'] | ResolversParentTypes['EventActivity'] | ResolversParentTypes['EventEmailSentActivity'] | ResolversParentTypes['FileAddedActivity'] | ResolversParentTypes['FollowUpSentActivity'] | ResolversParentTypes['LeadFormSubmissionActivity'] | ResolversParentTypes['MessageActivity'] | ResolversParentTypes['NoteActivity'] | ResolversParentTypes['OwnerChangedActivity'] | ResolversParentTypes['PaymentActivity'] | ResolversParentTypes['PaymentReceivedSentActivity'] | ResolversParentTypes['PaymentRequestedActivity'] | ResolversParentTypes['SentActivity'] | ResolversParentTypes['StageChangedActivity'] | ResolversParentTypes['TaskActivity'] | ResolversParentTypes['ViewedActivity'] | ResolversParentTypes['WarningActivity'];
  ActivityContact: ActivityContact;
  ActivityDeal: ActivityDeal;
  ActivityDetails: ResolversParentTypes['AcceptedActivityDetails'] | ResolversParentTypes['AssignmentActivityDetails'] | ResolversParentTypes['BasicActivityDetails'] | ResolversParentTypes['ChatMessageActivityDetails'] | ResolversParentTypes['DeclinedActivityDetails'] | ResolversParentTypes['EventActivityDetails'] | ResolversParentTypes['EventEmailSentActivityDetails'] | ResolversParentTypes['FileAddedActivityDetails'] | ResolversParentTypes['FollowUpSentActivityDetails'] | ResolversParentTypes['LeadFormSubmissionActivityDetails'] | ResolversParentTypes['MessageActivityDetails'] | ResolversParentTypes['NoteActivityDetails'] | ResolversParentTypes['OwnerChangedActivityDetails'] | ResolversParentTypes['PaymentActivityDetails'] | ResolversParentTypes['PaymentReceivedSentActivityDetails'] | ResolversParentTypes['PaymentRequestedActivityDetails'] | ResolversParentTypes['SentActivityDetails'] | ResolversParentTypes['StageChangedActivityDetails'] | ResolversParentTypes['TaskActivityDetails'] | ResolversParentTypes['ViewedActivityDetails'] | ResolversParentTypes['WarningActivityDetails'];
  ActivityEmail: ActivityEmail;
  ActivityJobAddress: ActivityJobAddress;
  ActivityMessage: ActivityMessage;
  ActivityMessageFrom: ActivityMessageFrom;
  ActivityQuote: ActivityQuote;
  Int: Scalars['Int'];
  AddPaymentResult: AddPaymentResult;
  AddProcessingPaymentResponse: AddProcessingPaymentResponse;
  AddSubscriptionAddonResponse: AddSubscriptionAddonResponse;
  AdminDashboardStats: AdminDashboardStats;
  AdminIntegrationsConfigResponse: AdminIntegrationsConfigResponse;
  AdminLeaderboardResponse: AdminLeaderboardResponse;
  AdminLeaderboardRow: AdminLeaderboardRow;
  AdminPaymentEntry: AdminPaymentEntry;
  AdminPaymentQuote: AdminPaymentQuote;
  ApiKeyDocument: ApiKeyDocument;
  ApiKeyOwnerInput: ApiKeyOwnerInput;
  AppDocsResponse: AppDocsResponse;
  AppMetaDataUserCompany: AppMetaDataUserCompany;
  AppMetadata: AppMetadata;
  AppMetadataInput: AppMetadataInput;
  AppMetadataUser: AppMetadataUser;
  AppMetadataUserInput: AppMetadataUserInput;
  ApplyPaymentSyncResult: ApplyPaymentSyncResult;
  AssignmentActivity: AssignmentActivity;
  AssignmentActivityDetails: AssignmentActivityDetails;
  AttachTxnIdResult: AttachTxnIdResult;
  Auth0LogEntry: Auth0LogEntry;
  Auth0LogsResult: Auth0LogsResult;
  BasicActivity: BasicActivity;
  BasicActivityDetails: BasicActivityDetails;
  BulkDocsResponseObject: BulkDocsResponseObject;
  CancellationImpactSummary: CancellationImpactSummary;
  ChargebeeAddon: ChargebeeAddon;
  ChargebeeAddonSummary: ChargebeeAddonSummary;
  ChargebeeBillingContact: ChargebeeBillingContact;
  ChargebeeCharge: ChargebeeCharge;
  ChargebeeCoupon: ChargebeeCoupon;
  ChargebeeDiscount: ChargebeeDiscount;
  ChargebeeItemPrice: ChargebeeItemPrice;
  ID: Scalars['ID'];
  ChargebeeOneTimeCharge: ChargebeeOneTimeCharge;
  ChargebeePlan: ChargebeePlan;
  ChargebeeSubscription: ChargebeeSubscription;
  ChargebeeSubscriptionSummary: ChargebeeSubscriptionSummary;
  ChatMessage: ChatMessage;
  ChatMessageActivity: ChatMessageActivity;
  ChatMessageActivityDetails: ChatMessageActivityDetails;
  ChatMessageUsage: ChatMessageUsage;
  CheckoutAddonInput: CheckoutAddonInput;
  CheckoutCoupon: CheckoutCoupon;
  CheckoutEstimate: CheckoutEstimate;
  CheckoutEstimateLineItem: CheckoutEstimateLineItem;
  CheckoutInput: CheckoutInput;
  CheckoutResult: CheckoutResult;
  ClientAggregates: ClientAggregates;
  ClientAggregatesInput: ClientAggregatesInput;
  ClientCancellationFlow: ClientCancellationFlow;
  ClientCancellationFlowInput: ClientCancellationFlowInput;
  ClientDunning: ClientDunning;
  ClientMeta: ClientMeta;
  ClientMetaInput: ClientMetaInput;
  ClientMetaSubscription: ClientMetaSubscription;
  ClientMetaSubscriptionInput: ClientMetaSubscriptionInput;
  ClientOptions: ClientOptions;
  ClientOptionsInput: ClientOptionsInput;
  ClientResponse: ClientResponse;
  ClientUserCounts: ClientUserCounts;
  ClientUserCountsInput: ClientUserCountsInput;
  CloudinaryFile: CloudinaryFile;
  Company: Company;
  CompanySubscription: CompanySubscription;
  Contact: Contact;
  ContactGeocode: ContactGeocode;
  ConvertedFile: ConvertedFile;
  CouchDocument: ResolversParentTypes['Contact'] | ResolversParentTypes['Deal'] | ResolversParentTypes['Task'];
  CreateClientInput: CreateClientInput;
  CreateNoteResponse: CreateNoteResponse;
  CreatePaymentActivityResponse: CreatePaymentActivityResponse;
  CreateUserInput: CreateUserInput;
  CsmBookingInfo: CsmBookingInfo;
  CsvOwner: CsvOwner;
  CustomAvatar: CustomAvatar;
  CustomAvatarInput: CustomAvatarInput;
  DateRange: DateRange;
  DateRangeInput: DateRangeInput;
  Deal: Deal;
  DealContact: DealContact;
  DealGeocode: DealGeocode;
  DealPipeline: DealPipeline;
  DealStage: DealStage;
  DealSummaryResponse: DealSummaryResponse;
  DeclineQuoteResponse: DeclineQuoteResponse;
  DeclinedActivity: DeclinedActivity;
  DeclinedActivityDetails: DeclinedActivityDetails;
  DeletePaymentResponse: DeletePaymentResponse;
  DowngradeSubscriptionResponse: DowngradeSubscriptionResponse;
  EscalateToSupportResponse: EscalateToSupportResponse;
  Estimator: Estimator;
  EventActivity: EventActivity;
  EventActivityDetails: EventActivityDetails;
  EventEmailSentActivity: EventEmailSentActivity;
  EventEmailSentActivityDetails: EventEmailSentActivityDetails;
  EventGeocode: EventGeocode;
  ExportClientsResponse: ExportClientsResponse;
  ExportCompaniesResponse: ExportCompaniesResponse;
  ExportContactsResponse: ExportContactsResponse;
  ExportDealsResponse: ExportDealsResponse;
  ExportLineItemsResponse: ExportLineItemsResponse;
  ExportProductResponse: ExportProductResponse;
  ExportProductionRatesResponse: ExportProductionRatesResponse;
  ExportQuotesResponse: ExportQuotesResponse;
  FileAddedActivity: FileAddedActivity;
  FileAddedActivityDetails: FileAddedActivityDetails;
  FollowUp: FollowUp;
  FollowUpConditions: FollowUpConditions;
  FollowUpSentActivity: FollowUpSentActivity;
  FollowUpSentActivityDetails: FollowUpSentActivityDetails;
  FollowUpsForUser: FollowUpsForUser;
  GeneratePresentationInput: GeneratePresentationInput;
  GeneratePresentationResult: GeneratePresentationResult;
  GetCorporateTypeDataResponse: GetCorporateTypeDataResponse;
  GetPortalSessionResponse: GetPortalSessionResponse;
  HubspotCompanyInfo: HubspotCompanyInfo;
  InboundWebhookLogEntry: InboundWebhookLogEntry;
  InboundWebhookLogsResult: InboundWebhookLogsResult;
  JSON: Scalars['JSON'];
  JobCosting: JobCosting;
  LeadFormSubmissionActivity: LeadFormSubmissionActivity;
  LeadFormSubmissionActivityDetails: LeadFormSubmissionActivityDetails;
  LeaderboardDataResponse: LeaderboardDataResponse;
  LeaderboardDataResponseRow: LeaderboardDataResponseRow;
  LeaderboardRankResponse: LeaderboardRankResponse;
  LeaderboardRankResponseItem: LeaderboardRankResponseItem;
  LocationSuggestion: LocationSuggestion;
  ManufacturerColor: ManufacturerColor;
  ManufacturerProduct: ManufacturerProduct;
  MessageActivity: MessageActivity;
  MessageActivityDetails: MessageActivityDetails;
  MfaEnrollment: MfaEnrollment;
  Mutation: {};
  NewAccountResponse: NewAccountResponse;
  NoteActivity: NoteActivity;
  NoteActivityDetails: NoteActivityDetails;
  NoteActivityFile: NoteActivityFile;
  NoteActivityVersion: NoteActivityVersion;
  OfflineQuotesResponse: OfflineQuotesResponse;
  Owner: Owner;
  OwnerChangedActivity: OwnerChangedActivity;
  OwnerChangedActivityDetails: OwnerChangedActivityDetails;
  PainterScheduleDeal: PainterScheduleDeal;
  PainterScheduleJobResponse: PainterScheduleJobResponse;
  PainterScheduleResponse: PainterScheduleResponse;
  PaymentActivity: PaymentActivity;
  PaymentActivityDetails: PaymentActivityDetails;
  PaymentDecisionInput: PaymentDecisionInput;
  PaymentProcessedResponse: PaymentProcessedResponse;
  PaymentReceivedSentActivity: PaymentReceivedSentActivity;
  PaymentReceivedSentActivityDetails: PaymentReceivedSentActivityDetails;
  PaymentRequestEmailInput: PaymentRequestEmailInput;
  PaymentRequestSmsInput: PaymentRequestSmsInput;
  PaymentRequestedActivity: PaymentRequestedActivity;
  PaymentRequestedActivityDetails: PaymentRequestedActivityDetails;
  PaymentSyncEntry: PaymentSyncEntry;
  PaymentSyncRefund: PaymentSyncRefund;
  PayrixConnectionResult: PayrixConnectionResult;
  PayrixTxnLookup: PayrixTxnLookup;
  PexelsPhoto: PexelsPhoto;
  PexelsPhotoSrc: PexelsPhotoSrc;
  PexelsSearchResult: PexelsSearchResult;
  PortalSessionLinkedCustomer: PortalSessionLinkedCustomer;
  PostHogSessionRecording: PostHogSessionRecording;
  PostHogSessionRecordingsResult: PostHogSessionRecordingsResult;
  PostmarkMessage: PostmarkMessage;
  PostmarkMessagesResult: PostmarkMessagesResult;
  PostmarkSuppressionEntry: PostmarkSuppressionEntry;
  ProcessEventResponse: ProcessEventResponse;
  ProcessFileParams: ProcessFileParams;
  Query: {};
  Quote: Quote;
  QuoteContact: QuoteContact;
  QuoteEmailFrom: QuoteEmailFrom;
  QuoteEmailInput: QuoteEmailInput;
  QuoteFollowUp: QuoteFollowUp;
  QuoteMessagesResponse: QuoteMessagesResponse;
  QuoteOwner: QuoteOwner;
  QuotePdfResponse: QuotePdfResponse;
  QuoteSmsInput: QuoteSmsInput;
  QuoteSummaryResponse: QuoteSummaryResponse;
  QuoteType: QuoteType;
  QuoteUrlResponse: QuoteUrlResponse;
  ReactivateSubscriptionResponse: ReactivateSubscriptionResponse;
  RecoverInvoiceResponse: RecoverInvoiceResponse;
  RefreshQuoteTranslationsResult: RefreshQuoteTranslationsResult;
  RefundPaymentResponse: RefundPaymentResponse;
  RefundRecordInput: RefundRecordInput;
  ReminderOptionsInput: ReminderOptionsInput;
  RenewAccountResponse: RenewAccountResponse;
  ReportChart: ReportChart;
  ReportChartData: ReportChartData;
  ReportChartDataset: ReportChartDataset;
  ReportColumnDefinition: ReportColumnDefinition;
  ReportColumnDefinitionAction: ReportColumnDefinitionAction;
  ReportColumnDefinitionLink: ReportColumnDefinitionLink;
  ReportColumnDefinitionSubField: ReportColumnDefinitionSubField;
  ReportDataResponse: ReportDataResponse;
  ReportFilterOption: ReportFilterOption;
  ReportFilterOptionField: ReportFilterOptionField;
  ReportFilterOptionsReponse: ReportFilterOptionsReponse;
  RequestReviewResponse: RequestReviewResponse;
  RerunWebhookResult: RerunWebhookResult;
  ResolveCancellationOfferResponse: ResolveCancellationOfferResponse;
  ResourceApiResponse: ResourceApiResponse;
  RetentionDiscountResponse: RetentionDiscountResponse;
  ReviewSmsInput: ReviewSmsInput;
  SalesRep: SalesRep;
  SaveEventResponse: SaveEventResponse;
  ScatterPoint: ScatterPoint;
  ScheduleCancellationResponse: ScheduleCancellationResponse;
  SearchActivitiesResponse: SearchActivitiesResponse;
  SearchClientsResponse: SearchClientsResponse;
  SearchCompaniesResult: SearchCompaniesResult;
  SearchContactDealsResponse: SearchContactDealsResponse;
  SearchContactOpportunitiesResponse: SearchContactOpportunitiesResponse;
  SearchContactsByIntegrationResponse: SearchContactsByIntegrationResponse;
  SearchContactsResult: SearchContactsResult;
  SearchDealsResult: SearchDealsResult;
  SearchLocationsResponse: SearchLocationsResponse;
  SearchManufacturerColorsResponse: SearchManufacturerColorsResponse;
  SearchManufacturerProductsResponse: SearchManufacturerProductsResponse;
  SearchQuotesResponse: SearchQuotesResponse;
  SearchTasksResult: SearchTasksResult;
  SearchUsersResponse: SearchUsersResponse;
  SendMessageResponse: SendMessageResponse;
  SendQuoteResponse: SendQuoteResponse;
  SentActivity: SentActivity;
  SentActivityDetails: SentActivityDetails;
  SentEmail: SentEmail;
  SignedUploadResponse: SignedUploadResponse;
  StageChangedActivity: StageChangedActivity;
  StageChangedActivityDetails: StageChangedActivityDetails;
  StuckPaymentsResult: StuckPaymentsResult;
  Task: Task;
  TaskActivity: TaskActivity;
  TaskActivityDetails: TaskActivityDetails;
  TaskCounts: TaskCounts;
  TimeRange: TimeRange;
  TimeRangeInput: TimeRangeInput;
  TranslatedEmailContent: TranslatedEmailContent;
  TranslationLangStatus: TranslationLangStatus;
  TurnOnCrmResult: TurnOnCrmResult;
  UnscheduledJobsResponse: UnscheduledJobsResponse;
  UpdateApiKeyInput: UpdateApiKeyInput;
  UpdateDealStageResponse: UpdateDealStageResponse;
  UpdatePaymentResponse: UpdatePaymentResponse;
  UpdateUserInput: UpdateUserInput;
  Upload: Scalars['Upload'];
  UploadOptions: UploadOptions;
  UrlDocument: UrlDocument;
  User: User;
  UserClient: UserClient;
  UserMetadata: UserMetadata;
  UserMetadataInput: UserMetadataInput;
  ViewQuoteResponse: ViewQuoteResponse;
  ViewedActivity: ViewedActivity;
  ViewedActivityDetails: ViewedActivityDetails;
  WarningActivity: WarningActivity;
  WarningActivityDetails: WarningActivityDetails;
  WeatherDay: WeatherDay;
  WebhookEventType: WebhookEventType;
  WebhookEventsResult: WebhookEventsResult;
  WebhookParams: WebhookParams;
  WebhookTimestamp: WebhookTimestamp;
  WebhookType: WebhookType;
  WebhooksResult: WebhooksResult;
  WisetackLoanApplication: WisetackLoanApplication;
  WisetackLoanApplicationRefund: WisetackLoanApplicationRefund;
  WisetackPrequal: WisetackPrequal;
  WisetackPrequalCustomer: WisetackPrequalCustomer;
};

export type GuardDirectiveArgs = {   auth?: Maybe<Scalars['Boolean']>;
  roles?: Maybe<Array<Scalars['String']>>;
  permissions?: Maybe<Array<Scalars['String']>>;
  apiKey?: Maybe<Scalars['Boolean']>;
  corporate?: Maybe<Scalars['Boolean']>;
  customerView?: Maybe<Scalars['Boolean']>;
  sameCompanyArg?: Maybe<Scalars['String']>;
  requireAll?: Maybe<Scalars['Boolean']>; };

export type GuardDirectiveResolver<Result, Parent, ContextType = any, Args = GuardDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AcceptAdditionalWorkResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptAdditionalWorkResponse'] = ResolversParentTypes['AcceptAdditionalWorkResponse']> = {
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcceptQuoteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptQuoteResponse'] = ResolversParentTypes['AcceptQuoteResponse']> = {
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcceptedActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptedActivity'] = ResolversParentTypes['AcceptedActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['AcceptedActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcceptedActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptedActivityDetails'] = ResolversParentTypes['AcceptedActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcknowledgeCheckoutResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcknowledgeCheckoutResponse'] = ResolversParentTypes['AcknowledgeCheckoutResponse']> = {
  billingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Activity'] = ResolversParentTypes['Activity']> = {
  __resolveType: TypeResolveFn<'AcceptedActivity' | 'AssignmentActivity' | 'BasicActivity' | 'ChatMessageActivity' | 'DeclinedActivity' | 'EventActivity' | 'EventEmailSentActivity' | 'FileAddedActivity' | 'FollowUpSentActivity' | 'LeadFormSubmissionActivity' | 'MessageActivity' | 'NoteActivity' | 'OwnerChangedActivity' | 'PaymentActivity' | 'PaymentReceivedSentActivity' | 'PaymentRequestedActivity' | 'SentActivity' | 'StageChangedActivity' | 'TaskActivity' | 'ViewedActivity' | 'WarningActivity', ParentType, ContextType>;
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['ActivityDetails'], ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type ActivityContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityContact'] = ResolversParentTypes['ActivityContact']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredContactMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityDealResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDeal'] = ResolversParentTypes['ActivityDeal']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDetails'] = ResolversParentTypes['ActivityDetails']> = {
  __resolveType: TypeResolveFn<'AcceptedActivityDetails' | 'AssignmentActivityDetails' | 'BasicActivityDetails' | 'ChatMessageActivityDetails' | 'DeclinedActivityDetails' | 'EventActivityDetails' | 'EventEmailSentActivityDetails' | 'FileAddedActivityDetails' | 'FollowUpSentActivityDetails' | 'LeadFormSubmissionActivityDetails' | 'MessageActivityDetails' | 'NoteActivityDetails' | 'OwnerChangedActivityDetails' | 'PaymentActivityDetails' | 'PaymentReceivedSentActivityDetails' | 'PaymentRequestedActivityDetails' | 'SentActivityDetails' | 'StageChangedActivityDetails' | 'TaskActivityDetails' | 'ViewedActivityDetails' | 'WarningActivityDetails', ParentType, ContextType>;
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ActivityEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityEmail'] = ResolversParentTypes['ActivityEmail']> = {
  to?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  smsTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityJobAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityJobAddress'] = ResolversParentTypes['ActivityJobAddress']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityMessage'] = ResolversParentTypes['ActivityMessage']> = {
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  from?: Resolver<ResolversTypes['ActivityMessageFrom'], ParentType, ContextType>;
  smsTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityMessageFromResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityMessageFrom'] = ResolversParentTypes['ActivityMessageFrom']> = {
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCustomer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityQuote'] = ResolversParentTypes['ActivityQuote']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  int_ext?: Resolver<Maybe<ResolversTypes['QuoteType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddPaymentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddPaymentResult'] = ResolversParentTypes['AddPaymentResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  changes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddProcessingPaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddProcessingPaymentResponse'] = ResolversParentTypes['AddProcessingPaymentResponse']> = {
  updatedQuote?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSubscriptionAddonResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSubscriptionAddonResponse'] = ResolversParentTypes['AddSubscriptionAddonResponse']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expires_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resource_version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminDashboardStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminDashboardStats'] = ResolversParentTypes['AdminDashboardStats']> = {
  activeClients?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  activeUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  newTrials?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expiringTrials?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currentTrials?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  newActiveClients?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  newActiveUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminIntegrationsConfigResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminIntegrationsConfigResponse'] = ResolversParentTypes['AdminIntegrationsConfigResponse']> = {
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminLeaderboardResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminLeaderboardResponse'] = ResolversParentTypes['AdminLeaderboardResponse']> = {
  totalRows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdminLeaderboardRow']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminLeaderboardRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminLeaderboardRow'] = ResolversParentTypes['AdminLeaderboardRow']> = {
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  playerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalSold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberSold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customAvatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalSoldComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  winRateComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminPaymentEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminPaymentEntry'] = ResolversParentTypes['AdminPaymentEntry']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deposit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  surcharge?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paymentRequestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestActivityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  forPaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerDetails?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  txnId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portalLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminPaymentQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminPaymentQuote'] = ResolversParentTypes['AdminPaymentQuote']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  contactName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balanceDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentProcessing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentError?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['AdminPaymentEntry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApiKeyDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiKeyDocument'] = ResolversParentTypes['ApiKeyDocument']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppDocsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppDocsResponse'] = ResolversParentTypes['AppDocsResponse']> = {
  options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  companyDetails?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  companies?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  remainingQuotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppMetaDataUserCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppMetaDataUserCompany'] = ResolversParentTypes['AppMetaDataUserCompany']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  billingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flaggedTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonBilling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentCompanyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentExpiryNotice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['CompanySubscription']>, ParentType, ContextType>;
  trialExpired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trialExpiry?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppMetadata'] = ResolversParentTypes['AppMetadata']> = {
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  seatType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  integrations?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  forceFollowUps?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['AppMetadataUser']>, ParentType, ContextType>;
  elasticsearch?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mfa_enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mfa_enrolled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mfa_excluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['AppMetaDataUserCompany']>, ParentType, ContextType>;
  customPermissions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  painterType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastPermissionsUpdated?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedPermissions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppMetadataUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppMetadataUser'] = ResolversParentTypes['AppMetadataUser']> = {
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyPaymentSyncResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyPaymentSyncResult'] = ResolversParentTypes['ApplyPaymentSyncResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  changes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssignmentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignmentActivity'] = ResolversParentTypes['AssignmentActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['AssignmentActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssignmentActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignmentActivityDetails'] = ResolversParentTypes['AssignmentActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  assignees?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  assigner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttachTxnIdResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttachTxnIdResult'] = ResolversParentTypes['AttachTxnIdResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  changes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Auth0LogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Auth0LogEntry'] = ResolversParentTypes['Auth0LogEntry']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_agent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  log_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Auth0LogsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['Auth0LogsResult'] = ResolversParentTypes['Auth0LogsResult']> = {
  logs?: Resolver<Array<ResolversTypes['Auth0LogEntry']>, ParentType, ContextType>;
  truncated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BasicActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BasicActivity'] = ResolversParentTypes['BasicActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['BasicActivityDetails'], ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BasicActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BasicActivityDetails'] = ResolversParentTypes['BasicActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkDocsResponseObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkDocsResponseObject'] = ResolversParentTypes['BulkDocsResponseObject']> = {
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  document?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancellationImpactSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancellationImpactSummary'] = ResolversParentTypes['CancellationImpactSummary']> = {
  totalQuotes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalContacts?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  yearsOfHistory?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeAddonResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeAddon'] = ResolversParentTypes['ChargebeeAddon']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unit_price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeAddonSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeAddonSummary'] = ResolversParentTypes['ChargebeeAddonSummary']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeBillingContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeBillingContact'] = ResolversParentTypes['ChargebeeBillingContact']> = {
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeChargeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeCharge'] = ResolversParentTypes['ChargebeeCharge']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unit_price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeCoupon'] = ResolversParentTypes['ChargebeeCoupon']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeDiscount'] = ResolversParentTypes['ChargebeeDiscount']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  duration_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  period?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  period_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apply_on?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apply_till?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  applied_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeItemPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeItemPrice'] = ResolversParentTypes['ChargebeeItemPrice']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  internalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pricingModel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeOneTimeChargeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeOneTimeCharge'] = ResolversParentTypes['ChargebeeOneTimeCharge']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemPriceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAdhoc?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  invoiceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoiceStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeePlan'] = ResolversParentTypes['ChargebeePlan']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeSubscription'] = ResolversParentTypes['ChargebeeSubscription']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plan_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  plan_quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  plan_unit_price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mrr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  billing_period?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  billing_period_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  current_term_start?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  current_term_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subscription_start?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subscription_activated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  started_at?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cancelled_at?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_to_churn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  addons?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChargebeeAddon']>>>, ParentType, ContextType>;
  charges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChargebeeCharge']>>>, ParentType, ContextType>;
  coupons?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChargebeeCoupon']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChargebeeDiscount']>>>, ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['ChargebeePlan']>, ParentType, ContextType>;
  coreSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  teamSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  crewSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fullSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  liteSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  billingContact?: Resolver<Maybe<ResolversTypes['ChargebeeBillingContact']>, ParentType, ContextType>;
  diff?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  cf_production_pricing_migration_timestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebeeSubscriptionSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebeeSubscriptionSummary'] = ResolversParentTypes['ChargebeeSubscriptionSummary']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plan_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billing_period_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  current_term_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cf_production_pricing_migration_timestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  addons?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChargebeeAddonSummary']>>>, ParentType, ContextType>;
  coreSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  teamSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  crewSeatsAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessage'] = ResolversParentTypes['ChatMessage']> = {
  sender?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolCalls?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usage?: Resolver<Maybe<ResolversTypes['ChatMessageUsage']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageActivity'] = ResolversParentTypes['ChatMessageActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['ChatMessageActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageActivityDetails'] = ResolversParentTypes['ChatMessageActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  undo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  conversationTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageUsage'] = ResolversParentTypes['ChatMessageUsage']> = {
  inputTokens?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  outputTokens?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cacheReadTokens?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cacheCreationTokens?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimatedCostUsd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutCoupon'] = ResolversParentTypes['CheckoutCoupon']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutEstimateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutEstimate'] = ResolversParentTypes['CheckoutEstimate']> = {
  lineItems?: Resolver<Array<ResolversTypes['CheckoutEstimateLineItem']>, ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutEstimateLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutEstimateLineItem'] = ResolversParentTypes['CheckoutEstimateLineItem']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isCharge?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutResult'] = ResolversParentTypes['CheckoutResult']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  estimate?: Resolver<ResolversTypes['CheckoutEstimate'], ParentType, ContextType>;
  emailStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientAggregatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientAggregates'] = ResolversParentTypes['ClientAggregates']> = {
  totalQuotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalInvoices?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalBidValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageBidValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  closeRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  closedQuotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  closedValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageCloseValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientCancellationFlowResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientCancellationFlow'] = ResolversParentTypes['ClientCancellationFlow']> = {
  reason?: Resolver<Maybe<ResolversTypes['CancellationReason']>, ParentType, ContextType>;
  reasonKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  competitorTool?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CancellationFlowStatus']>, ParentType, ContextType>;
  coachingCallStatus?: Resolver<Maybe<ResolversTypes['CoachingCallStatus']>, ParentType, ContextType>;
  coachingCallShownAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coachingCallBookedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountRedeemedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cancellationScheduledFor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pauseScheduledFor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pauseResumesAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  downgradeRequestedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientDunningResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientDunning'] = ResolversParentTypes['ClientDunning']> = {
  status?: Resolver<Maybe<ResolversTypes['DunningStatus']>, ParentType, ContextType>;
  firstPaymentFailedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  restrictedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lockedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientMeta'] = ResolversParentTypes['ClientMeta']> = {
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  banned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  skipHubspotSync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trialExpiry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trialExpired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  billingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentCompanyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonBilling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  includeInLeaderboards?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  excludeFromLeaderboards?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  paymentExpiryNotice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['ClientMetaSubscription']>, ParentType, ContextType>;
  userCounts?: Resolver<Maybe<ResolversTypes['ClientUserCounts']>, ParentType, ContextType>;
  aggregates?: Resolver<Maybe<ResolversTypes['ClientAggregates']>, ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ClientProduct']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  delete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['ClientOptions']>, ParentType, ContextType>;
  cancellationFlow?: Resolver<Maybe<ResolversTypes['ClientCancellationFlow']>, ParentType, ContextType>;
  dunning?: Resolver<Maybe<ResolversTypes['ClientDunning']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientMetaSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientMetaSubscription'] = ResolversParentTypes['ClientMetaSubscription']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  current_term_start?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  current_term_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientOptions'] = ResolversParentTypes['ClientOptions']> = {
  allowDecline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  companyCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyCoordinates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  companyEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyPostal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyProv?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customCss?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmBCCEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  acceptDisclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  acceptAdditionalDisclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declineDisclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberSeparator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wisetackSignupDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientResponse'] = ResolversParentTypes['ClientResponse']> = {
  meta?: Resolver<Maybe<ResolversTypes['ClientMeta']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  internalOptions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  sequence?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  companies?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientUserCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientUserCounts'] = ResolversParentTypes['ClientUserCounts']> = {
  all?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudinaryFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloudinaryFile'] = ResolversParentTypes['CloudinaryFile']> = {
  public_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resource_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  bytes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overwritten?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  original_filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  original_extension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleteDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone_ext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  lead_source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanySubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanySubscription'] = ResolversParentTypes['CompanySubscription']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  current_term_end?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  current_term_start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contact'] = ResolversParentTypes['Contact']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleteDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  demo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondary_first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondary_last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alternate_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  isBillingShipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geocode?: Resolver<Maybe<ResolversTypes['ContactGeocode']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone_ext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alternate_phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alternate_phone_ext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sms_undeliverable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sms_undeliverable_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sms_undeliverable_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyDocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updated_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source_user_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lead_source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  acquisitionSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stAppointmentDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pldDeals?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  salesforceOpportunities?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  internal_note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_contact_method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  wisetackPrequal?: Resolver<Maybe<ResolversTypes['WisetackPrequal']>, ParentType, ContextType>;
  wisetackLoanApplication?: Resolver<Maybe<ResolversTypes['WisetackLoanApplication']>, ParentType, ContextType>;
  wisetackLoanApplications?: Resolver<Maybe<Array<Maybe<ResolversTypes['WisetackLoanApplication']>>>, ParentType, ContextType>;
  PK?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SK?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactGeocodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactGeocode'] = ResolversParentTypes['ContactGeocode']> = {
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConvertedFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConvertedFile'] = ResolversParentTypes['ConvertedFile']> = {
  src?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3PublicKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouchDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouchDocument'] = ResolversParentTypes['CouchDocument']> = {
  __resolveType: TypeResolveFn<'Contact' | 'Deal' | 'Task', ParentType, ContextType>;
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateNoteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateNoteResponse'] = ResolversParentTypes['CreateNoteResponse']> = {
  activity?: Resolver<Maybe<ResolversTypes['NoteActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatePaymentActivityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePaymentActivityResponse'] = ResolversParentTypes['CreatePaymentActivityResponse']> = {
  activity?: Resolver<Maybe<ResolversTypes['PaymentActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CsmBookingInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsmBookingInfo'] = ResolversParentTypes['CsmBookingInfo']> = {
  csm?: Resolver<Maybe<ResolversTypes['AssignedCsm']>, ParentType, ContextType>;
  bookingUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomAvatarResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAvatar'] = ResolversParentTypes['CustomAvatar']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cdnValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudinaryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3PublicKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DateRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateRange'] = ResolversParentTypes['DateRange']> = {
  start?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealResolvers<ContextType = any, ParentType extends ResolversParentTypes['Deal'] = ResolversParentTypes['Deal']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['DealContact']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  valueBeforeTax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quoteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['DealStage']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  geocode?: Resolver<Maybe<ResolversTypes['DealGeocode']>, ParentType, ContextType>;
  job_identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enteredStage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  history?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source_user_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lead_source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  acquisitionSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  ownerHistory?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  estimator?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  projectManager?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  deletedTags?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  pipeline?: Resolver<Maybe<ResolversTypes['DealPipeline']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deleteDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DealStatus']>, ParentType, ContextType>;
  linkedQuoteIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  linkedInvoiceIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  trashedLinkedQuoteIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  trashedLinkedInvoiceIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  linkedProductionEventIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  hasProductionEvent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  taskTemplateOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  jobCosting?: Resolver<Maybe<ResolversTypes['JobCosting']>, ParentType, ContextType>;
  jobEndDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealContact'] = ResolversParentTypes['DealContact']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredContactMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealGeocodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealGeocode'] = ResolversParentTypes['DealGeocode']> = {
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealPipelineResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealPipeline'] = ResolversParentTypes['DealPipeline']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealStageResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealStage'] = ResolversParentTypes['DealStage']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealSummaryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealSummaryResponse'] = ResolversParentTypes['DealSummaryResponse']> = {
  totalDeals?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDealValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclineQuoteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclineQuoteResponse'] = ResolversParentTypes['DeclineQuoteResponse']> = {
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclinedActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclinedActivity'] = ResolversParentTypes['DeclinedActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['DeclinedActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclinedActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclinedActivityDetails'] = ResolversParentTypes['DeclinedActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletePaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePaymentResponse'] = ResolversParentTypes['DeletePaymentResponse']> = {
  updatedQuote?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DowngradeSubscriptionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DowngradeSubscriptionResponse'] = ResolversParentTypes['DowngradeSubscriptionResponse']> = {
  downgradeRequestedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scheduledForEndOfTerm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  changed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EscalateToSupportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EscalateToSupportResponse'] = ResolversParentTypes['EscalateToSupportResponse']> = {
  status?: Resolver<Maybe<ResolversTypes['CancellationFlowStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Estimator'] = ResolversParentTypes['Estimator']> = {
  user_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventActivity'] = ResolversParentTypes['EventActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['EventActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventActivityDetails'] = ResolversParentTypes['EventActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  quoteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geocode?: Resolver<Maybe<ResolversTypes['EventGeocode']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crew?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previousProgress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  production?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canceled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sendReminderEmails?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attendees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventEmailSentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventEmailSentActivity'] = ResolversParentTypes['EventEmailSentActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['EventEmailSentActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventEmailSentActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventEmailSentActivityDetails'] = ResolversParentTypes['EventEmailSentActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geocode?: Resolver<Maybe<ResolversTypes['EventGeocode']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canceled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['ActivityEmail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventGeocodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventGeocode'] = ResolversParentTypes['EventGeocode']> = {
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportClientsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportClientsResponse'] = ResolversParentTypes['ExportClientsResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportCompaniesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportCompaniesResponse'] = ResolversParentTypes['ExportCompaniesResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportContactsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportContactsResponse'] = ResolversParentTypes['ExportContactsResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportDealsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportDealsResponse'] = ResolversParentTypes['ExportDealsResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportLineItemsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportLineItemsResponse'] = ResolversParentTypes['ExportLineItemsResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportProductResponse'] = ResolversParentTypes['ExportProductResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportProductionRatesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportProductionRatesResponse'] = ResolversParentTypes['ExportProductionRatesResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportQuotesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportQuotesResponse'] = ResolversParentTypes['ExportQuotesResponse']> = {
  csv?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileAddedActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileAddedActivity'] = ResolversParentTypes['FileAddedActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['FileAddedActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileAddedActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileAddedActivityDetails'] = ResolversParentTypes['FileAddedActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowUpResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowUp'] = ResolversParentTypes['FollowUp']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  smsMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quoteTypes?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  isInvoice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  toggled?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sendFollowUpNotice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  conditions?: Resolver<ResolversTypes['FollowUpConditions'], ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sendText?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sendEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retroactive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowUpConditionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowUpConditions'] = ResolversParentTypes['FollowUpConditions']> = {
  interval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  months?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fromStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowUpSentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowUpSentActivity'] = ResolversParentTypes['FollowUpSentActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['FollowUpSentActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowUpSentActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowUpSentActivityDetails'] = ResolversParentTypes['FollowUpSentActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['ActivityEmail']>, ParentType, ContextType>;
  smsTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowUpsForUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowUpsForUser'] = ResolversParentTypes['FollowUpsForUser']> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  followUps?: Resolver<Array<Maybe<ResolversTypes['FollowUp']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneratePresentationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneratePresentationResult'] = ResolversParentTypes['GeneratePresentationResult']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  generationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCorporateTypeDataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCorporateTypeDataResponse'] = ResolversParentTypes['GetCorporateTypeDataResponse']> = {
  quoteTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetPortalSessionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetPortalSessionResponse'] = ResolversParentTypes['GetPortalSessionResponse']> = {
  access_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  redirect_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked_customers?: Resolver<Maybe<Array<Maybe<ResolversTypes['PortalSessionLinkedCustomer']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HubspotCompanyInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['HubspotCompanyInfo'] = ResolversParentTypes['HubspotCompanyInfo']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  healthScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paymentsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfSalesSeats?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfTeamSeats?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfPainterSeats?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lifetimeTotalQuotes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lifetimeSoldQuotes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lifetimeTotalValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lifetimeSoldValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currentMrrSubscriptionValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signUpDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  integrations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundWebhookLogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundWebhookLogEntry'] = ResolversParentTypes['InboundWebhookLogEntry']> = {
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  namespace?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorStack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundWebhookLogsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundWebhookLogsResult'] = ResolversParentTypes['InboundWebhookLogsResult']> = {
  logs?: Resolver<Array<ResolversTypes['InboundWebhookLogEntry']>, ParentType, ContextType>;
  total_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type JobCostingResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobCosting'] = ResolversParentTypes['JobCosting']> = {
  labour?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  materials?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  overhead?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  margin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeadFormSubmissionActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeadFormSubmissionActivity'] = ResolversParentTypes['LeadFormSubmissionActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['LeadFormSubmissionActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeadFormSubmissionActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeadFormSubmissionActivityDetails'] = ResolversParentTypes['LeadFormSubmissionActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  legacyNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newStage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadedFiles?: Resolver<Maybe<Array<ResolversTypes['NoteActivityFile']>>, ParentType, ContextType>;
  leadSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  acquisitionSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardDataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeaderboardDataResponse'] = ResolversParentTypes['LeaderboardDataResponse']> = {
  totalRows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userRows?: Resolver<Maybe<Array<Maybe<ResolversTypes['LeaderboardDataResponseRow']>>>, ParentType, ContextType>;
  topRows?: Resolver<Maybe<Array<Maybe<ResolversTypes['LeaderboardDataResponseRow']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardDataResponseRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeaderboardDataResponseRow'] = ResolversParentTypes['LeaderboardDataResponseRow']> = {
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trophy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  totalSold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalSoldComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  winRateComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberSold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  businessType?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  customAvatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectTypes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardRankResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeaderboardRankResponse'] = ResolversParentTypes['LeaderboardRankResponse']> = {
  updatedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalSold?: Resolver<Maybe<ResolversTypes['LeaderboardRankResponseItem']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['LeaderboardRankResponseItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardRankResponseItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeaderboardRankResponseItem'] = ResolversParentTypes['LeaderboardRankResponseItem']> = {
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueChange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rankChange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationSuggestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationSuggestion'] = ResolversParentTypes['LocationSuggestion']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  municipality?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManufacturerColorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManufacturerColor'] = ResolversParentTypes['ManufacturerColor']> = {
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hexColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paintWood?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  manufacturer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productLines?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  intRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  extRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManufacturerProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManufacturerProduct'] = ResolversParentTypes['ManufacturerProduct']> = {
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productLineId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  coverage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  manufacturer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sheen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageActivity'] = ResolversParentTypes['MessageActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['MessageActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageActivityDetails'] = ResolversParentTypes['MessageActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['ActivityMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MfaEnrollmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MfaEnrollment'] = ResolversParentTypes['MfaEnrollment']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enrolled_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  syncActivitiesForDoc?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSyncActivitiesForDocArgs, 'id'>>;
  sendMessage?: Resolver<Maybe<ResolversTypes['SendMessageResponse']>, ParentType, ContextType, RequireFields<MutationSendMessageArgs, 'message'>>;
  createNote?: Resolver<Maybe<ResolversTypes['CreateNoteResponse']>, ParentType, ContextType, RequireFields<MutationCreateNoteArgs, 'docId' | 'docType' | 'note'>>;
  deleteNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteNoteArgs, 'id'>>;
  updateNote?: Resolver<Maybe<ResolversTypes['CreateNoteResponse']>, ParentType, ContextType, RequireFields<MutationUpdateNoteArgs, 'id' | 'note'>>;
  setNotePinned?: Resolver<Maybe<ResolversTypes['CreateNoteResponse']>, ParentType, ContextType, RequireFields<MutationSetNotePinnedArgs, 'id' | 'docId' | 'pinned'>>;
  saveEvent?: Resolver<Maybe<ResolversTypes['SaveEventResponse']>, ParentType, ContextType, RequireFields<MutationSaveEventArgs, 'event'>>;
  readMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageActivity']>>>, ParentType, ContextType, RequireFields<MutationReadMessagesArgs, never>>;
  deleteMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteMessageArgs, 'id'>>;
  createPaymentActivity?: Resolver<Maybe<ResolversTypes['CreatePaymentActivityResponse']>, ParentType, ContextType, RequireFields<MutationCreatePaymentActivityArgs, 'amount' | 'docId' | 'provider'>>;
  rateChatMessage?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType, RequireFields<MutationRateChatMessageArgs, 'activityId'>>;
  undoChatMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['Activity']>>>, ParentType, ContextType, RequireFields<MutationUndoChatMessagesArgs, 'activityIds'>>;
  resetPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'user_id'>>;
  updatePassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdatePasswordArgs, 'user_id' | 'password'>>;
  resetMfaForUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResetMfaForUserArgs, 'userId'>>;
  acknowledgeCheckout?: Resolver<Maybe<ResolversTypes['AcknowledgeCheckoutResponse']>, ParentType, ContextType, RequireFields<MutationAcknowledgeCheckoutArgs, never>>;
  renewAccount?: Resolver<Maybe<ResolversTypes['RenewAccountResponse']>, ParentType, ContextType, RequireFields<MutationRenewAccountArgs, never>>;
  newAccount?: Resolver<Maybe<ResolversTypes['NewAccountResponse']>, ParentType, ContextType, RequireFields<MutationNewAccountArgs, 'plan'>>;
  scheduleCancellation?: Resolver<Maybe<ResolversTypes['ScheduleCancellationResponse']>, ParentType, ContextType>;
  reactivateSubscription?: Resolver<Maybe<ResolversTypes['ReactivateSubscriptionResponse']>, ParentType, ContextType>;
  applyRetentionDiscount?: Resolver<Maybe<ResolversTypes['RetentionDiscountResponse']>, ParentType, ContextType>;
  downgradeSubscription?: Resolver<Maybe<ResolversTypes['DowngradeSubscriptionResponse']>, ParentType, ContextType>;
  escalateToSupport?: Resolver<Maybe<ResolversTypes['EscalateToSupportResponse']>, ParentType, ContextType, RequireFields<MutationEscalateToSupportArgs, 'details'>>;
  addSubscriptionAddon?: Resolver<Maybe<ResolversTypes['AddSubscriptionAddonResponse']>, ParentType, ContextType, RequireFields<MutationAddSubscriptionAddonArgs, 'subscriptionId' | 'addon'>>;
  generateCheckoutLink?: Resolver<ResolversTypes['CheckoutResult'], ParentType, ContextType, RequireFields<MutationGenerateCheckoutLinkArgs, 'input' | 'send'>>;
  createClient?: Resolver<Maybe<ResolversTypes['ClientMeta']>, ParentType, ContextType, RequireFields<MutationCreateClientArgs, 'input'>>;
  updateClient?: Resolver<Maybe<ResolversTypes['ClientResponse']>, ParentType, ContextType, RequireFields<MutationUpdateClientArgs, 'id'>>;
  updateCancellationFlowState?: Resolver<Maybe<ResolversTypes['ClientCancellationFlow']>, ParentType, ContextType, RequireFields<MutationUpdateCancellationFlowStateArgs, 'input'>>;
  saveOptions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSaveOptionsArgs, never>>;
  saveLocationOptions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSaveLocationOptionsArgs, never>>;
  savePartialOptions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSavePartialOptionsArgs, never>>;
  transferClientDocs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationTransferClientDocsArgs, 'id' | 'transferTo' | 'type'>>;
  deleteClientDocs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteClientDocsArgs, 'id' | 'type'>>;
  resetClientForTesting?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResetClientForTestingArgs, 'id' | 'mode'>>;
  resetCancellationFlowForTesting?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResetCancellationFlowForTestingArgs, 'id' | 'backdateTenure'>>;
  resyncSubscriptionFromChargebee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResyncSubscriptionFromChargebeeArgs, 'id'>>;
  saveRates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSaveRatesArgs, never>>;
  adminIntegrationsConfig?: Resolver<ResolversTypes['AdminIntegrationsConfigResponse'], ParentType, ContextType, RequireFields<MutationAdminIntegrationsConfigArgs, 'type'>>;
  resizeQuoteImages?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResizeQuoteImagesArgs, 'db' | 'dateFrom' | 'dateTo'>>;
  syncOptions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSyncOptionsArgs, 'rev'>>;
  syncRates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSyncRatesArgs, 'rev'>>;
  updateClientFeatures?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateClientFeaturesArgs, 'query' | 'featureList' | 'value' | 'email'>>;
  updateExistingQuotesSurcharge?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateExistingQuotesSurchargeArgs, never>>;
  turnOnCRM?: Resolver<Maybe<ResolversTypes['TurnOnCrmResult']>, ParentType, ContextType, RequireFields<MutationTurnOnCrmArgs, 'trial'>>;
  turnOffCRM?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deactivateCompanyPainters?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deleteDeals?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationDeleteDealsArgs, 'ids'>>;
  archiveDeals?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationArchiveDealsArgs, 'ids'>>;
  saveDeal?: Resolver<Maybe<ResolversTypes['Deal']>, ParentType, ContextType, RequireFields<MutationSaveDealArgs, 'deal'>>;
  updateDealStage?: Resolver<Maybe<ResolversTypes['UpdateDealStageResponse']>, ParentType, ContextType, RequireFields<MutationUpdateDealStageArgs, 'dealId' | 'stage'>>;
  untrashDeals?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationUntrashDealsArgs, 'ids'>>;
  deleteContacts?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationDeleteContactsArgs, 'ids'>>;
  saveContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<MutationSaveContactArgs, 'contact'>>;
  deleteCompanies?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationDeleteCompaniesArgs, 'ids'>>;
  saveCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationSaveCompanyArgs, 'company'>>;
  acceptQuote?: Resolver<Maybe<ResolversTypes['AcceptQuoteResponse']>, ParentType, ContextType, RequireFields<MutationAcceptQuoteArgs, 'quote'>>;
  acceptAdditionalWork?: Resolver<Maybe<ResolversTypes['AcceptAdditionalWorkResponse']>, ParentType, ContextType, RequireFields<MutationAcceptAdditionalWorkArgs, 'rev'>>;
  addProcessingPayment?: Resolver<Maybe<ResolversTypes['AddProcessingPaymentResponse']>, ParentType, ContextType, RequireFields<MutationAddProcessingPaymentArgs, 'quoteId' | 'activityId' | 'amount' | 'type'>>;
  deletePayment?: Resolver<Maybe<ResolversTypes['DeletePaymentResponse']>, ParentType, ContextType, RequireFields<MutationDeletePaymentArgs, 'quoteId' | 'paymentId'>>;
  updatePayment?: Resolver<Maybe<ResolversTypes['UpdatePaymentResponse']>, ParentType, ContextType, RequireFields<MutationUpdatePaymentArgs, 'quoteId' | 'paymentId'>>;
  archiveQuotes?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationArchiveQuotesArgs, 'ids'>>;
  declineQuote?: Resolver<Maybe<ResolversTypes['DeclineQuoteResponse']>, ParentType, ContextType, RequireFields<MutationDeclineQuoteArgs, 'rev' | 'reason'>>;
  deleteQuotes?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationDeleteQuotesArgs, 'ids'>>;
  saveQuote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSaveQuoteArgs, 'quote'>>;
  syncQuote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSyncQuoteArgs, 'id' | 'rev'>>;
  saveClientQuote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSaveClientQuoteArgs, 'quote' | 'companyId'>>;
  sendFollowUp?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendFollowUpArgs, 'followUp' | 'quoteId' | 'user'>>;
  sendQuote?: Resolver<Maybe<ResolversTypes['SendQuoteResponse']>, ParentType, ContextType, RequireFields<MutationSendQuoteArgs, 'id' | 'view' | 'emails'>>;
  requestReview?: Resolver<Maybe<ResolversTypes['RequestReviewResponse']>, ParentType, ContextType, RequireFields<MutationRequestReviewArgs, 'sms' | 'content'>>;
  refundPayment?: Resolver<ResolversTypes['RefundPaymentResponse'], ParentType, ContextType, RequireFields<MutationRefundPaymentArgs, 'activityId' | 'amount'>>;
  requestPayment?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationRequestPaymentArgs, 'quoteId' | 'paymentId' | 'email'>>;
  recoverInvoice?: Resolver<Maybe<ResolversTypes['RecoverInvoiceResponse']>, ParentType, ContextType, RequireFields<MutationRecoverInvoiceArgs, 'id'>>;
  viewQuoteHeartbeat?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationViewQuoteHeartbeatArgs, 'viewedActivityId' | 'url'>>;
  processEvent?: Resolver<ResolversTypes['ProcessEventResponse'], ParentType, ContextType, RequireFields<MutationProcessEventArgs, 'type'>>;
  unlinkDeal?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUnlinkDealArgs, never>>;
  linkDeal?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationLinkDealArgs, 'quoteId' | 'dealId'>>;
  refreshQuoteTranslations?: Resolver<Maybe<ResolversTypes['RefreshQuoteTranslationsResult']>, ParentType, ContextType, RequireFields<MutationRefreshQuoteTranslationsArgs, 'quoteId' | 'companyId'>>;
  createUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input'>>;
  deactivateUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeactivateUserArgs, 'id' | 'companyId'>>;
  transferUserDocs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationTransferUserDocsArgs, 'id' | 'transferTo' | 'type'>>;
  deleteUserDocs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteUserDocsArgs, 'id' | 'type'>>;
  reindexUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationReindexUserArgs, 'id' | 'companyId'>>;
  deleteTasks?: Resolver<Array<ResolversTypes['BulkDocsResponseObject']>, ParentType, ContextType, RequireFields<MutationDeleteTasksArgs, 'ids'>>;
  saveTask?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<MutationSaveTaskArgs, 'task'>>;
  generatePresentation?: Resolver<ResolversTypes['GeneratePresentationResult'], ParentType, ContextType, RequireFields<MutationGeneratePresentationArgs, 'input'>>;
  trackPdfDownloaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationTrackPdfDownloadedArgs, 'quoteId' | 'companyId'>>;
  generateApiKey?: Resolver<Maybe<ResolversTypes['ApiKeyDocument']>, ParentType, ContextType, RequireFields<MutationGenerateApiKeyArgs, 'userId'>>;
  deactivateApiKey?: Resolver<Maybe<ResolversTypes['ApiKeyDocument']>, ParentType, ContextType, RequireFields<MutationDeactivateApiKeyArgs, 'id'>>;
  updateApiKey?: Resolver<Maybe<ResolversTypes['ApiKeyDocument']>, ParentType, ContextType, RequireFields<MutationUpdateApiKeyArgs, 'apiKey'>>;
  regeneratePlayerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationRegeneratePlayerNameArgs, never>>;
  associateSupportTicket?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAssociateSupportTicketArgs, 'conversationId'>>;
  syncCompanyData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSyncCompanyDataArgs, 'companyId'>>;
  syncUserData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSyncUserDataArgs, 'userId'>>;
  rerunInboundWebhook?: Resolver<ResolversTypes['RerunWebhookResult'], ParentType, ContextType, RequireFields<MutationRerunInboundWebhookArgs, 'integration' | 'eventData'>>;
  removeFromPostmarkSuppression?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveFromPostmarkSuppressionArgs, 'email'>>;
  applyPaymentSync?: Resolver<ResolversTypes['ApplyPaymentSyncResult'], ParentType, ContextType, RequireFields<MutationApplyPaymentSyncArgs, 'companyId' | 'quoteId' | 'silent'>>;
  attachTxnIdToPayment?: Resolver<ResolversTypes['AttachTxnIdResult'], ParentType, ContextType, RequireFields<MutationAttachTxnIdToPaymentArgs, 'companyId' | 'quoteId' | 'paymentId' | 'txnId' | 'silent'>>;
  addPaymentByTxnId?: Resolver<ResolversTypes['AddPaymentResult'], ParentType, ContextType, RequireFields<MutationAddPaymentByTxnIdArgs, 'companyId' | 'quoteId' | 'txnId' | 'silent'>>;
  disconnectPayrix?: Resolver<ResolversTypes['PayrixConnectionResult'], ParentType, ContextType, RequireFields<MutationDisconnectPayrixArgs, 'companyId'>>;
  swapPayrixMerchantId?: Resolver<ResolversTypes['PayrixConnectionResult'], ParentType, ContextType, RequireFields<MutationSwapPayrixMerchantIdArgs, 'companyId' | 'merchantId'>>;
  updateWebhookEnabled?: Resolver<Maybe<ResolversTypes['WebhookType']>, ParentType, ContextType, RequireFields<MutationUpdateWebhookEnabledArgs, 'companyId' | 'webhookId' | 'enabled'>>;
  setSelfServeFeatureFlag?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSetSelfServeFeatureFlagArgs, 'flagKey' | 'enabled'>>;
};

export type NewAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewAccountResponse'] = ResolversParentTypes['NewAccountResponse']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expires_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resource_version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoteActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteActivity'] = ResolversParentTypes['NoteActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['NoteActivityDetails'], ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoteActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteActivityDetails'] = ResolversParentTypes['NoteActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  legacyNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['NoteActivityVersion']>>, ParentType, ContextType>;
  translations?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  pinnedOn?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoteActivityFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteActivityFile'] = ResolversParentTypes['NoteActivityFile']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoteActivityVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteActivityVersion'] = ResolversParentTypes['NoteActivityVersion']> = {
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  files?: Resolver<Maybe<Array<ResolversTypes['NoteActivityFile']>>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfflineQuotesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfflineQuotesResponse'] = ResolversParentTypes['OfflineQuotesResponse']> = {
  quotes?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  templates?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<Array<ResolversTypes['Contact']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Owner'] = ResolversParentTypes['Owner']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OwnerChangedActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['OwnerChangedActivity'] = ResolversParentTypes['OwnerChangedActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['OwnerChangedActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OwnerChangedActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OwnerChangedActivityDetails'] = ResolversParentTypes['OwnerChangedActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldOwner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  newOwner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PainterScheduleDealResolvers<ContextType = any, ParentType extends ResolversParentTypes['PainterScheduleDeal'] = ResolversParentTypes['PainterScheduleDeal']> = {
  dealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['Activity'], ParentType, ContextType>;
  dealJobAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  fileCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  noteCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasPaymentDue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['Quote']>, ParentType, ContextType>;
  dealFiles?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PainterScheduleJobResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PainterScheduleJobResponse'] = ResolversParentTypes['PainterScheduleJobResponse']> = {
  invoices?: Resolver<Array<ResolversTypes['Quote']>, ParentType, ContextType>;
  dealFiles?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PainterScheduleResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PainterScheduleResponse'] = ResolversParentTypes['PainterScheduleResponse']> = {
  deals?: Resolver<Array<ResolversTypes['PainterScheduleDeal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentActivity'] = ResolversParentTypes['PaymentActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['PaymentActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentActivityDetails'] = ResolversParentTypes['PaymentActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountPaid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentRequestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isProcessing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFailed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  surcharge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerDetails?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deposit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  paymentDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isRefund?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentProcessedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentProcessedResponse'] = ResolversParentTypes['PaymentProcessedResponse']> = {
  updatedQuote?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentReceivedSentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentReceivedSentActivity'] = ResolversParentTypes['PaymentReceivedSentActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['PaymentReceivedSentActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentReceivedSentActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentReceivedSentActivityDetails'] = ResolversParentTypes['PaymentReceivedSentActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['ActivityEmail']>, ParentType, ContextType>;
  amountPaid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentRequestedActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentRequestedActivity'] = ResolversParentTypes['PaymentRequestedActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['PaymentRequestedActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentRequestedActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentRequestedActivityDetails'] = ResolversParentTypes['PaymentRequestedActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['ActivityEmail']>, ParentType, ContextType>;
  smsTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountRequested?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deposit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentSyncEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentSyncEntry'] = ResolversParentTypes['PaymentSyncEntry']> = {
  paymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txnId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portalStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommended?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refunds?: Resolver<Array<ResolversTypes['PaymentSyncRefund']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentSyncRefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentSyncRefund'] = ResolversParentTypes['PaymentSyncRefund']> = {
  txnId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  approved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alreadyRecorded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayrixConnectionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrixConnectionResult'] = ResolversParentTypes['PayrixConnectionResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  merchantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantCreated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayrixTxnLookupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrixTxnLookup'] = ResolversParentTypes['PayrixTxnLookup']> = {
  txnId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recommended?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendedReason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadataCompanyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadataActivityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityExists?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  depositHint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  alreadyOnQuote?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  matchedRequestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchingRequestIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PexelsPhotoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PexelsPhoto'] = ResolversParentTypes['PexelsPhoto']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avgColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photographer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photographerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  src?: Resolver<ResolversTypes['PexelsPhotoSrc'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PexelsPhotoSrcResolvers<ContextType = any, ParentType extends ResolversParentTypes['PexelsPhotoSrc'] = ResolversParentTypes['PexelsPhotoSrc']> = {
  original?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  large2x?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tiny?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PexelsSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PexelsSearchResult'] = ResolversParentTypes['PexelsSearchResult']> = {
  totalResults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  perPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  photos?: Resolver<Array<ResolversTypes['PexelsPhoto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalSessionLinkedCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalSessionLinkedCustomer'] = ResolversParentTypes['PortalSessionLinkedCustomer']> = {
  customer_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_active_subscription?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  has_billing_address?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  has_payment_method?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostHogSessionRecordingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostHogSessionRecording'] = ResolversParentTypes['PostHogSessionRecording']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recording_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  active_seconds?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inactive_seconds?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  click_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  keypress_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mouse_activity_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  console_error_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  console_warn_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  console_log_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activity_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ongoing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  person_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  person_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostHogSessionRecordingsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostHogSessionRecordingsResult'] = ResolversParentTypes['PostHogSessionRecordingsResult']> = {
  recordings?: Resolver<Array<ResolversTypes['PostHogSessionRecording']>, ParentType, ContextType>;
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostmarkMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostmarkMessage'] = ResolversParentTypes['PostmarkMessage']> = {
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostmarkMessagesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostmarkMessagesResult'] = ResolversParentTypes['PostmarkMessagesResult']> = {
  messages?: Resolver<Array<ResolversTypes['PostmarkMessage']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  truncated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostmarkSuppressionEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostmarkSuppressionEntry'] = ResolversParentTypes['PostmarkSuppressionEntry']> = {
  suppressed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suppressionReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessEventResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessEventResponse'] = ResolversParentTypes['ProcessEventResponse']> = {
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  activitiesForDoc?: Resolver<Maybe<ResolversTypes['SearchActivitiesResponse']>, ParentType, ContextType, RequireFields<QueryActivitiesForDocArgs, 'id'>>;
  newActivitiesForDoc?: Resolver<Maybe<Array<Maybe<ResolversTypes['Activity']>>>, ParentType, ContextType, RequireFields<QueryNewActivitiesForDocArgs, 'id'>>;
  searchActivities?: Resolver<Maybe<ResolversTypes['SearchActivitiesResponse']>, ParentType, ContextType, RequireFields<QuerySearchActivitiesArgs, 'query'>>;
  activity?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType, RequireFields<QueryActivityArgs, 'id'>>;
  getNote?: Resolver<Maybe<ResolversTypes['NoteActivity']>, ParentType, ContextType, RequireFields<QueryGetNoteArgs, 'id'>>;
  messages?: Resolver<Maybe<ResolversTypes['QuoteMessagesResponse']>, ParentType, ContextType, RequireFields<QueryMessagesArgs, never>>;
  newMessages?: Resolver<Maybe<Array<ResolversTypes['Activity']>>, ParentType, ContextType, RequireFields<QueryNewMessagesArgs, never>>;
  unreadMessages?: Resolver<Maybe<Array<ResolversTypes['MessageActivity']>>, ParentType, ContextType, RequireFields<QueryUnreadMessagesArgs, never>>;
  unscheduledJobs?: Resolver<Maybe<ResolversTypes['UnscheduledJobsResponse']>, ParentType, ContextType, RequireFields<QueryUnscheduledJobsArgs, 'query'>>;
  appDocs?: Resolver<Maybe<ResolversTypes['AppDocsResponse']>, ParentType, ContextType>;
  getMfaEnrollments?: Resolver<Array<ResolversTypes['MfaEnrollment']>, ParentType, ContextType, RequireFields<QueryGetMfaEnrollmentsArgs, 'userId'>>;
  getPortalSession?: Resolver<Maybe<ResolversTypes['GetPortalSessionResponse']>, ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['ChargebeeSubscription']>, ParentType, ContextType, RequireFields<QuerySubscriptionArgs, never>>;
  subscriptionSummary?: Resolver<Maybe<ResolversTypes['ChargebeeSubscriptionSummary']>, ParentType, ContextType, RequireFields<QuerySubscriptionSummaryArgs, never>>;
  cancellationImpactSummary?: Resolver<Maybe<ResolversTypes['CancellationImpactSummary']>, ParentType, ContextType>;
  resolveCancellationOffer?: Resolver<Maybe<ResolversTypes['ResolveCancellationOfferResponse']>, ParentType, ContextType, RequireFields<QueryResolveCancellationOfferArgs, 'reason' | 'afterFollowUp'>>;
  chargebeePlans?: Resolver<Array<ResolversTypes['ChargebeeItemPrice']>, ParentType, ContextType>;
  chargebeeAddons?: Resolver<Array<ResolversTypes['ChargebeeItemPrice']>, ParentType, ContextType>;
  chargebeeCharges?: Resolver<Array<ResolversTypes['ChargebeeItemPrice']>, ParentType, ContextType>;
  chargebeeCoupons?: Resolver<Array<ResolversTypes['CheckoutCoupon']>, ParentType, ContextType>;
  salesReps?: Resolver<Array<ResolversTypes['SalesRep']>, ParentType, ContextType>;
  estimateCheckout?: Resolver<ResolversTypes['CheckoutEstimate'], ParentType, ContextType, RequireFields<QueryEstimateCheckoutArgs, 'input'>>;
  oneTimeCharges?: Resolver<Array<ResolversTypes['ChargebeeOneTimeCharge']>, ParentType, ContextType, RequireFields<QueryOneTimeChargesArgs, never>>;
  adminDashboardStats?: Resolver<Maybe<ResolversTypes['AdminDashboardStats']>, ParentType, ContextType, RequireFields<QueryAdminDashboardStatsArgs, 'weekAgo' | 'now' | 'weekFromNow'>>;
  client?: Resolver<Maybe<ResolversTypes['ClientResponse']>, ParentType, ContextType, RequireFields<QueryClientArgs, never>>;
  searchClients?: Resolver<Maybe<ResolversTypes['SearchClientsResponse']>, ParentType, ContextType, RequireFields<QuerySearchClientsArgs, never>>;
  searchLocations?: Resolver<Maybe<ResolversTypes['SearchLocationsResponse']>, ParentType, ContextType, RequireFields<QuerySearchLocationsArgs, never>>;
  exportClients?: Resolver<Maybe<ResolversTypes['ExportClientsResponse']>, ParentType, ContextType, RequireFields<QueryExportClientsArgs, 'query' | 'exportType' | 'includeInactive'>>;
  getCorporateTypeData?: Resolver<Maybe<ResolversTypes['GetCorporateTypeDataResponse']>, ParentType, ContextType>;
  searchManufacturerProducts?: Resolver<Maybe<ResolversTypes['SearchManufacturerProductsResponse']>, ParentType, ContextType, RequireFields<QuerySearchManufacturerProductsArgs, 'query'>>;
  searchManufacturerColors?: Resolver<Maybe<ResolversTypes['SearchManufacturerColorsResponse']>, ParentType, ContextType, RequireFields<QuerySearchManufacturerColorsArgs, 'query'>>;
  clientFeatureFlag?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryClientFeatureFlagArgs, 'companyId' | 'flagKey'>>;
  deal?: Resolver<Maybe<ResolversTypes['Deal']>, ParentType, ContextType, RequireFields<QueryDealArgs, 'id'>>;
  searchDeals?: Resolver<Maybe<ResolversTypes['SearchDealsResult']>, ParentType, ContextType, RequireFields<QuerySearchDealsArgs, 'query'>>;
  exportDeals?: Resolver<Maybe<ResolversTypes['ExportDealsResponse']>, ParentType, ContextType, RequireFields<QueryExportDealsArgs, 'query'>>;
  searchDealsByCompany?: Resolver<Maybe<ResolversTypes['SearchDealsResult']>, ParentType, ContextType, RequireFields<QuerySearchDealsByCompanyArgs, 'companyId'>>;
  searchDealsByStage?: Resolver<Maybe<ResolversTypes['SearchDealsResult']>, ParentType, ContextType, RequireFields<QuerySearchDealsByStageArgs, 'query' | 'stage'>>;
  dealSummary?: Resolver<Maybe<ResolversTypes['DealSummaryResponse']>, ParentType, ContextType, RequireFields<QueryDealSummaryArgs, 'query' | 'pipeline'>>;
  contact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<QueryContactArgs, 'id'>>;
  contactBySource?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<QueryContactBySourceArgs, 'source' | 'source_id'>>;
  searchContactDeals?: Resolver<Maybe<ResolversTypes['SearchContactDealsResponse']>, ParentType, ContextType, RequireFields<QuerySearchContactDealsArgs, 'contactSourceId'>>;
  searchContactOpportunities?: Resolver<Maybe<ResolversTypes['SearchContactOpportunitiesResponse']>, ParentType, ContextType, RequireFields<QuerySearchContactOpportunitiesArgs, 'contactSourceId' | 'integration'>>;
  searchContacts?: Resolver<Maybe<ResolversTypes['SearchContactsResult']>, ParentType, ContextType, RequireFields<QuerySearchContactsArgs, 'query'>>;
  exportContacts?: Resolver<Maybe<ResolversTypes['ExportContactsResponse']>, ParentType, ContextType, RequireFields<QueryExportContactsArgs, 'query'>>;
  searchContactsByIntegration?: Resolver<Maybe<ResolversTypes['SearchContactsByIntegrationResponse']>, ParentType, ContextType, RequireFields<QuerySearchContactsByIntegrationArgs, never>>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<QueryCompanyArgs, 'id'>>;
  searchCompanies?: Resolver<Maybe<ResolversTypes['SearchCompaniesResult']>, ParentType, ContextType, RequireFields<QuerySearchCompaniesArgs, 'query'>>;
  exportCompanies?: Resolver<Maybe<ResolversTypes['ExportCompaniesResponse']>, ParentType, ContextType, RequireFields<QueryExportCompaniesArgs, 'query'>>;
  getSignedUploadUrl?: Resolver<ResolversTypes['SignedUploadResponse'], ParentType, ContextType, RequireFields<QueryGetSignedUploadUrlArgs, 'fileKey'>>;
  processFile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryProcessFileArgs, 'task' | 'fileParams' | 'uploadOptions'>>;
  convertHeicToJpeg?: Resolver<ResolversTypes['ConvertedFile'], ParentType, ContextType, RequireFields<QueryConvertHeicToJpegArgs, 'fileParams' | 'uploadOptions'>>;
  exportQuotes?: Resolver<Maybe<ResolversTypes['ExportQuotesResponse']>, ParentType, ContextType, RequireFields<QueryExportQuotesArgs, 'query'>>;
  offlineQuotes?: Resolver<Maybe<ResolversTypes['OfflineQuotesResponse']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryQuoteArgs, 'id'>>;
  clientQuote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryClientQuoteArgs, 'id' | 'companyId'>>;
  quoteSummary?: Resolver<Maybe<ResolversTypes['QuoteSummaryResponse']>, ParentType, ContextType, RequireFields<QueryQuoteSummaryArgs, 'query'>>;
  quoteUrl?: Resolver<ResolversTypes['QuoteUrlResponse'], ParentType, ContextType, RequireFields<QueryQuoteUrlArgs, 'id' | 'rev' | 'view'>>;
  searchQuotes?: Resolver<Maybe<ResolversTypes['SearchQuotesResponse']>, ParentType, ContextType, RequireFields<QuerySearchQuotesArgs, never>>;
  searchClientQuotes?: Resolver<Maybe<ResolversTypes['SearchQuotesResponse']>, ParentType, ContextType, RequireFields<QuerySearchClientQuotesArgs, 'query' | 'companyId'>>;
  paymentProcessed?: Resolver<Maybe<ResolversTypes['PaymentProcessedResponse']>, ParentType, ContextType, RequireFields<QueryPaymentProcessedArgs, 'id' | 'balanceDue'>>;
  viewQuote?: Resolver<Maybe<ResolversTypes['ViewQuoteResponse']>, ParentType, ContextType, RequireFields<QueryViewQuoteArgs, never>>;
  exportProductionRates?: Resolver<Maybe<ResolversTypes['ExportProductionRatesResponse']>, ParentType, ContextType, RequireFields<QueryExportProductionRatesArgs, never>>;
  exportProducts?: Resolver<Maybe<ResolversTypes['ExportProductResponse']>, ParentType, ContextType, RequireFields<QueryExportProductsArgs, never>>;
  exportLineItems?: Resolver<Maybe<ResolversTypes['ExportLineItemsResponse']>, ParentType, ContextType, RequireFields<QueryExportLineItemsArgs, never>>;
  translateNoteContent?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryTranslateNoteContentArgs, 'notes' | 'lang'>>;
  translateWorkOrderEmailContent?: Resolver<ResolversTypes['TranslatedEmailContent'], ParentType, ContextType, RequireFields<QueryTranslateWorkOrderEmailContentArgs, 'subject' | 'body' | 'lang'>>;
  urlDoc?: Resolver<ResolversTypes['UrlDocument'], ParentType, ContextType, RequireFields<QueryUrlDocArgs, 'id'>>;
  reportFilterOptions?: Resolver<Maybe<ResolversTypes['ReportFilterOptionsReponse']>, ParentType, ContextType, RequireFields<QueryReportFilterOptionsArgs, never>>;
  reportData?: Resolver<Maybe<ResolversTypes['ReportDataResponse']>, ParentType, ContextType, RequireFields<QueryReportDataArgs, 'name'>>;
  searchUsers?: Resolver<Maybe<ResolversTypes['SearchUsersResponse']>, ParentType, ContextType, RequireFields<QuerySearchUsersArgs, never>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, never>>;
  estimator?: Resolver<Maybe<ResolversTypes['Estimator']>, ParentType, ContextType, RequireFields<QueryEstimatorArgs, never>>;
  getUserIndexedPreferences?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryGetUserIndexedPreferencesArgs, 'id'>>;
  task?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<QueryTaskArgs, 'id'>>;
  searchTasks?: Resolver<Maybe<ResolversTypes['SearchTasksResult']>, ParentType, ContextType, RequireFields<QuerySearchTasksArgs, 'query'>>;
  searchTasksByContact?: Resolver<Maybe<ResolversTypes['SearchTasksResult']>, ParentType, ContextType, RequireFields<QuerySearchTasksByContactArgs, 'contactId'>>;
  searchTasksByCompany?: Resolver<Maybe<ResolversTypes['SearchTasksResult']>, ParentType, ContextType, RequireFields<QuerySearchTasksByCompanyArgs, 'companyId'>>;
  taskCounts?: Resolver<Maybe<ResolversTypes['TaskCounts']>, ParentType, ContextType, RequireFields<QueryTaskCountsArgs, 'query'>>;
  locationSuggestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['LocationSuggestion']>>>, ParentType, ContextType, RequireFields<QueryLocationSuggestionsArgs, 'query'>>;
  pexelsSearch?: Resolver<ResolversTypes['PexelsSearchResult'], ParentType, ContextType, RequireFields<QueryPexelsSearchArgs, 'query'>>;
  quotePdf?: Resolver<ResolversTypes['QuotePdfResponse'], ParentType, ContextType, RequireFields<QueryQuotePdfArgs, 'url'>>;
  getApiKeys?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApiKeyDocument']>>>, ParentType, ContextType, RequireFields<QueryGetApiKeysArgs, never>>;
  getApiKey?: Resolver<Maybe<ResolversTypes['ApiKeyDocument']>, ParentType, ContextType, RequireFields<QueryGetApiKeyArgs, 'id'>>;
  adminLeaderboard?: Resolver<Maybe<ResolversTypes['AdminLeaderboardResponse']>, ParentType, ContextType, RequireFields<QueryAdminLeaderboardArgs, never>>;
  leaderboardData?: Resolver<Maybe<ResolversTypes['LeaderboardDataResponse']>, ParentType, ContextType, RequireFields<QueryLeaderboardDataArgs, never>>;
  leaderboardRank?: Resolver<Maybe<ResolversTypes['LeaderboardRankResponse']>, ParentType, ContextType, RequireFields<QueryLeaderboardRankArgs, 'userId'>>;
  assignedCsm?: Resolver<ResolversTypes['CsmBookingInfo'], ParentType, ContextType>;
  hubspotVisitorToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hubspotCompanyInfo?: Resolver<Maybe<ResolversTypes['HubspotCompanyInfo']>, ParentType, ContextType>;
  weather?: Resolver<Array<ResolversTypes['WeatherDay']>, ParentType, ContextType, RequireFields<QueryWeatherArgs, 'startDate' | 'endDate'>>;
  getAuth0Logs?: Resolver<ResolversTypes['Auth0LogsResult'], ParentType, ContextType, RequireFields<QueryGetAuth0LogsArgs, 'userId'>>;
  getInboundWebhookLogs?: Resolver<ResolversTypes['InboundWebhookLogsResult'], ParentType, ContextType, RequireFields<QueryGetInboundWebhookLogsArgs, 'companyId'>>;
  getPostHogSessionRecordings?: Resolver<ResolversTypes['PostHogSessionRecordingsResult'], ParentType, ContextType, RequireFields<QueryGetPostHogSessionRecordingsArgs, never>>;
  getPostmarkSuppressionStatus?: Resolver<ResolversTypes['PostmarkSuppressionEntry'], ParentType, ContextType, RequireFields<QueryGetPostmarkSuppressionStatusArgs, 'email'>>;
  getPostmarkMessages?: Resolver<ResolversTypes['PostmarkMessagesResult'], ParentType, ContextType, RequireFields<QueryGetPostmarkMessagesArgs, 'email'>>;
  getStuckPayments?: Resolver<ResolversTypes['StuckPaymentsResult'], ParentType, ContextType, RequireFields<QueryGetStuckPaymentsArgs, 'companyId'>>;
  findQuotePayments?: Resolver<Array<ResolversTypes['AdminPaymentQuote']>, ParentType, ContextType, RequireFields<QueryFindQuotePaymentsArgs, 'companyId' | 'search'>>;
  getPaymentSyncPreview?: Resolver<Array<ResolversTypes['PaymentSyncEntry']>, ParentType, ContextType, RequireFields<QueryGetPaymentSyncPreviewArgs, 'companyId' | 'quoteId'>>;
  getPayrixTxnLookup?: Resolver<ResolversTypes['PayrixTxnLookup'], ParentType, ContextType, RequireFields<QueryGetPayrixTxnLookupArgs, 'companyId' | 'txnId'>>;
  getWebhooks?: Resolver<Maybe<ResolversTypes['WebhooksResult']>, ParentType, ContextType, RequireFields<QueryGetWebhooksArgs, 'companyId'>>;
  getWebhookEvents?: Resolver<Maybe<ResolversTypes['WebhookEventsResult']>, ParentType, ContextType, RequireFields<QueryGetWebhookEventsArgs, 'companyId'>>;
  painterSchedule?: Resolver<Maybe<ResolversTypes['PainterScheduleResponse']>, ParentType, ContextType, RequireFields<QueryPainterScheduleArgs, 'startDate' | 'endDate'>>;
  painterScheduleJob?: Resolver<Maybe<ResolversTypes['PainterScheduleJobResponse']>, ParentType, ContextType, RequireFields<QueryPainterScheduleJobArgs, never>>;
};

export type QuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Quote'] = ResolversParentTypes['Quote']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromTemplate?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  demoTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  job_identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quote_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hourly_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tax_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tax_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_invoice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parent_quote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parent_quote_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parent_quote_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  child_invoice_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  child_invoice_numbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  child_invoice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  child_invoices?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  deal_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_type?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  discount_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_isShown?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  totalAdjustment?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  clientVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  crewVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  client_note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['QuoteContact']>, ParentType, ContextType>;
  secondaryContact?: Resolver<Maybe<ResolversTypes['QuoteContact']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_by?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultView?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendError?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  presentation?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customTerms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  int_ext?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  additionalWork?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  internal_note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productString?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  areas?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  substrates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  lineItems?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  substratesGroupBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  sentReports?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  lastViewedActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  signatures?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  followUps?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  followUpsDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  totals?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  depositInfo?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  lead_source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimatorNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUserSave?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  copyOf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  tagDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trashedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleteDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  calculationLock?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  transferredFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  translations?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  addedOptionsTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  additionalWorkTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalHours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceDue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  acceptedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuoteContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteContact'] = ResolversParentTypes['QuoteContact']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_date?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_date?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lead_source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuoteFollowUpResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteFollowUp'] = ResolversParentTypes['QuoteFollowUp']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  smsMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isInvoice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  quoteTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  conditions?: Resolver<ResolversTypes['FollowUpConditions'], ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  toggled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retroactive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sendFollowUpNotice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sendEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sendText?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fromStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuoteMessagesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteMessagesResponse'] = ResolversParentTypes['QuoteMessagesResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<ResolversTypes['Activity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuoteOwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteOwner'] = ResolversParentTypes['QuoteOwner']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuotePdfResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuotePdfResponse'] = ResolversParentTypes['QuotePdfResponse']> = {
  quotePdfUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuoteSummaryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteSummaryResponse'] = ResolversParentTypes['QuoteSummaryResponse']> = {
  totalQuotes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalQuotePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  closedQuotes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  closedQuotePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  wonQuotes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  wonQuotePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  openQuotes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  openQuotePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  closeRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  winRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dollarsWon?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageQuotePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageClosePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageWonPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageOpenPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuoteTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteType'] = ResolversParentTypes['QuoteType']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuoteUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteUrlResponse'] = ResolversParentTypes['QuoteUrlResponse']> = {
  url?: Resolver<ResolversTypes['UrlDocument'], ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReactivateSubscriptionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReactivateSubscriptionResponse'] = ResolversParentTypes['ReactivateSubscriptionResponse']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecoverInvoiceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecoverInvoiceResponse'] = ResolversParentTypes['RecoverInvoiceResponse']> = {
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefreshQuoteTranslationsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshQuoteTranslationsResult'] = ResolversParentTypes['RefreshQuoteTranslationsResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  translationStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['TranslationLangStatus']>>>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundPaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundPaymentResponse'] = ResolversParentTypes['RefundPaymentResponse']> = {
  refundTxnId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedQuote?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RenewAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RenewAccountResponse'] = ResolversParentTypes['RenewAccountResponse']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expires_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resource_version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportChartResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportChart'] = ResolversParentTypes['ReportChart']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  xAxisTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yAxisTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showLegend?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showXAxisLabels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstColumnSticky?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowFullscreen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['ReportChartData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportChartDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportChartData'] = ResolversParentTypes['ReportChartData']> = {
  labels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  datasets?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportChartDataset']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportChartDatasetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportChartDataset'] = ResolversParentTypes['ReportChartDataset']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  scatterData?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScatterPoint']>>>, ParentType, ContextType>;
  backgroundColor?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  borderColor?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportColumnDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportColumnDefinition'] = ResolversParentTypes['ReportColumnDefinition']> = {
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooltipColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  toggleable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  filter?: Resolver<Maybe<ResolversTypes['Filter']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultValue?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  sortable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  align?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nowrap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Type']>, ParentType, ContextType>;
  sortFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  subFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportColumnDefinitionSubField']>>>, ParentType, ContextType>;
  actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportColumnDefinitionAction']>>>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['ReportColumnDefinitionLink']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportFilterOption']>>>, ParentType, ContextType>;
  filterLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  booleanFilterLabels?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportColumnDefinitionActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportColumnDefinitionAction'] = ResolversParentTypes['ReportColumnDefinitionAction']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  report?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportColumnDefinitionLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportColumnDefinitionLink'] = ResolversParentTypes['ReportColumnDefinitionLink']> = {
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportColumnDefinitionSubFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportColumnDefinitionSubField'] = ResolversParentTypes['ReportColumnDefinitionSubField']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportDataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportDataResponse'] = ResolversParentTypes['ReportDataResponse']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  totalRows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
  columns?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportColumnDefinition']>>>, ParentType, ContextType>;
  chartData?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportChart']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportFilterOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportFilterOption'] = ResolversParentTypes['ReportFilterOption']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportFilterOptionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportFilterOptionField'] = ResolversParentTypes['ReportFilterOptionField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportFilterOption']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportFilterOptionsReponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportFilterOptionsReponse'] = ResolversParentTypes['ReportFilterOptionsReponse']> = {
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportFilterOptionField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestReviewResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestReviewResponse'] = ResolversParentTypes['RequestReviewResponse']> = {
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RerunWebhookResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RerunWebhookResult'] = ResolversParentTypes['RerunWebhookResult']> = {
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResolveCancellationOfferResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResolveCancellationOfferResponse'] = ResolversParentTypes['ResolveCancellationOfferResponse']> = {
  bucket?: Resolver<ResolversTypes['OfferBucket'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResourceApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResourceApiResponse'] = ResolversParentTypes['ResourceApiResponse']> = {
  public_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resource_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bytes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  backup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  access_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  next_cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  derived_next_cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exif?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  image_metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  faces?: Resolver<Maybe<Array<Maybe<Array<Maybe<ResolversTypes['Int']>>>>>, ParentType, ContextType>;
  quality_analysis?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  colors?: Resolver<Maybe<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>>, ParentType, ContextType>;
  derived?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  moderation?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  phash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  predominant?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  coordinates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  access_control?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  pages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RetentionDiscountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetentionDiscountResponse'] = ResolversParentTypes['RetentionDiscountResponse']> = {
  discountRedeemedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesRepResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesRep'] = ResolversParentTypes['SalesRep']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveEventResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveEventResponse'] = ResolversParentTypes['SaveEventResponse']> = {
  activity?: Resolver<Maybe<ResolversTypes['EventActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScatterPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScatterPoint'] = ResolversParentTypes['ScatterPoint']> = {
  x?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  y?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleCancellationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduleCancellationResponse'] = ResolversParentTypes['ScheduleCancellationResponse']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancellationScheduledFor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchActivitiesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchActivitiesResponse'] = ResolversParentTypes['SearchActivitiesResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasMore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  activities?: Resolver<Maybe<Array<ResolversTypes['Activity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchClientsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchClientsResponse'] = ResolversParentTypes['SearchClientsResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<ResolversTypes['ClientMeta']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchCompaniesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchCompaniesResult'] = ResolversParentTypes['SearchCompaniesResult']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Company']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchContactDealsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchContactDealsResponse'] = ResolversParentTypes['SearchContactDealsResponse']> = {
  results?: Resolver<Array<Maybe<ResolversTypes['JSON']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchContactOpportunitiesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchContactOpportunitiesResponse'] = ResolversParentTypes['SearchContactOpportunitiesResponse']> = {
  results?: Resolver<Array<Maybe<ResolversTypes['JSON']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchContactsByIntegrationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchContactsByIntegrationResponse'] = ResolversParentTypes['SearchContactsByIntegrationResponse']> = {
  results?: Resolver<Array<Maybe<ResolversTypes['JSON']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchContactsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchContactsResult'] = ResolversParentTypes['SearchContactsResult']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Contact']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchDealsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchDealsResult'] = ResolversParentTypes['SearchDealsResult']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deals?: Resolver<Maybe<Array<Maybe<ResolversTypes['Deal']>>>, ParentType, ContextType>;
  aggregations?: Resolver<Maybe<ResolversTypes['DealSummaryResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchLocationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchLocationsResponse'] = ResolversParentTypes['SearchLocationsResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<ResolversTypes['ClientMeta']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchManufacturerColorsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchManufacturerColorsResponse'] = ResolversParentTypes['SearchManufacturerColorsResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<Maybe<ResolversTypes['ManufacturerColor']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchManufacturerProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchManufacturerProductsResponse'] = ResolversParentTypes['SearchManufacturerProductsResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<Maybe<ResolversTypes['ManufacturerProduct']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchQuotesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchQuotesResponse'] = ResolversParentTypes['SearchQuotesResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Quote']>>>, ParentType, ContextType>;
  rawQuotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchTasksResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchTasksResult'] = ResolversParentTypes['SearchTasksResult']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Task']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchUsersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchUsersResponse'] = ResolversParentTypes['SearchUsersResponse']> = {
  rows?: Resolver<Array<Maybe<ResolversTypes['User']>>, ParentType, ContextType>;
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendMessageResponse'] = ResolversParentTypes['SendMessageResponse']> = {
  activity?: Resolver<Maybe<ResolversTypes['MessageActivity']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendQuoteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendQuoteResponse'] = ResolversParentTypes['SendQuoteResponse']> = {
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  emails?: Resolver<Maybe<Array<Maybe<ResolversTypes['SentEmail']>>>, ParentType, ContextType>;
  urlDocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SentActivity'] = ResolversParentTypes['SentActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['SentActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SentActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SentActivityDetails'] = ResolversParentTypes['SentActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['ActivityEmail']>, ParentType, ContextType>;
  isWorkOrder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isReminder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SentEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['SentEmail'] = ResolversParentTypes['SentEmail']> = {
  headers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  response?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignedUploadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignedUploadResponse'] = ResolversParentTypes['SignedUploadResponse']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StageChangedActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StageChangedActivity'] = ResolversParentTypes['StageChangedActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['StageChangedActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StageChangedActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StageChangedActivityDetails'] = ResolversParentTypes['StageChangedActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  oldStage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newStage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StuckPaymentsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['StuckPaymentsResult'] = ResolversParentTypes['StuckPaymentsResult']> = {
  quotes?: Resolver<Array<ResolversTypes['AdminPaymentQuote']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['Task'] = ResolversParentTypes['Task']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trashedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deleteDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  translations?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivity'] = ResolversParentTypes['TaskActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['TaskActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityDetails'] = ResolversParentTypes['TaskActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  taskName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskCounts'] = ResolversParentTypes['TaskCounts']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  remaining?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeRange'] = ResolversParentTypes['TimeRange']> = {
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslatedEmailContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslatedEmailContent'] = ResolversParentTypes['TranslatedEmailContent']> = {
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationLangStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslationLangStatus'] = ResolversParentTypes['TranslationLangStatus']> = {
  lang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TurnOnCrmResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TurnOnCrmResult'] = ResolversParentTypes['TurnOnCrmResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  trialExpiration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  crmAlreadyActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnscheduledJobsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnscheduledJobsResponse'] = ResolversParentTypes['UnscheduledJobsResponse']> = {
  total_rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activities?: Resolver<Maybe<Array<ResolversTypes['EventActivity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDealStageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDealStageResponse'] = ResolversParentTypes['UpdateDealStageResponse']> = {
  deal?: Resolver<Maybe<ResolversTypes['Deal']>, ParentType, ContextType>;
  sourceAggregations?: Resolver<Maybe<ResolversTypes['DealSummaryResponse']>, ParentType, ContextType>;
  destimationAggregations?: Resolver<Maybe<ResolversTypes['DealSummaryResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePaymentResponse'] = ResolversParentTypes['UpdatePaymentResponse']> = {
  updatedQuote?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UrlDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['UrlDocument'] = ResolversParentTypes['UrlDocument']> = {
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  report?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  db?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipients?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  host?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  view?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendOptions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  user_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_metadata?: Resolver<Maybe<ResolversTypes['UserMetadata']>, ParentType, ContextType>;
  app_metadata?: Resolver<Maybe<ResolversTypes['AppMetadata']>, ParentType, ContextType>;
  last_login?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  picture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logins_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['UserClient']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserClient'] = ResolversParentTypes['UserClient']> = {
  meta?: Resolver<Maybe<ResolversTypes['ClientMeta']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rates?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMetadata'] = ResolversParentTypes['UserMetadata']> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customAvatar?: Resolver<Maybe<ResolversTypes['CustomAvatar']>, ParentType, ContextType>;
  playerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockLaunchDialog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  projectTypes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasJoinedLeaderboard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  leaderboardOptOut?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesmateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewQuoteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewQuoteResponse'] = ResolversParentTypes['ViewQuoteResponse']> = {
  quote?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  options?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  estimator?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  view?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tableView?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decryptedEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableLangs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  translationStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['TranslationLangStatus']>>>, ParentType, ContextType>;
  presentationNext?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  estimateNext?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewedActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewedActivity'] = ResolversParentTypes['ViewedActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['ViewedActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewedActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewedActivityDetails'] = ResolversParentTypes['ViewedActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  viewingEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notificationPending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WarningActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['WarningActivity'] = ResolversParentTypes['WarningActivity']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _rev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  docIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  assignedUsers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  details?: Resolver<ResolversTypes['WarningActivityDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WarningActivityDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WarningActivityDetails'] = ResolversParentTypes['WarningActivityDetails']> = {
  docType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Owner']>, ParentType, ContextType>;
  quoteOwner?: Resolver<Maybe<ResolversTypes['QuoteOwner']>, ParentType, ContextType>;
  trashed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['ActivityContact']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['ActivityQuote']>, ParentType, ContextType>;
  deal?: Resolver<Maybe<ResolversTypes['ActivityDeal']>, ParentType, ContextType>;
  jobAddress?: Resolver<Maybe<ResolversTypes['ActivityJobAddress']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedInterval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutomated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warningMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warningTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeatherDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeatherDay'] = ResolversParentTypes['WeatherDay']> = {
  time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  temperatureMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  temperatureMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weatherCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  precipitationProbability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookEventTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookEventType'] = ResolversParentTypes['WebhookEventType']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  webhookUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  httpStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  retryCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxRetries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastAttempt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nextRetry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookEventsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookEventsResult'] = ResolversParentTypes['WebhookEventsResult']> = {
  rows?: Resolver<Maybe<Array<Maybe<ResolversTypes['WebhookEventType']>>>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookParams'] = ResolversParentTypes['WebhookParams']> = {
  quoteTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  quoteStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  eventTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  stageIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  tagsAdded?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  tagsRemoved?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  isInvoice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookTimestampResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookTimestamp'] = ResolversParentTypes['WebhookTimestamp']> = {
  created?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookType'] = ResolversParentTypes['WebhookType']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['WebhookTimestamp']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  params?: Resolver<Maybe<ResolversTypes['WebhookParams']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhooksResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhooksResult'] = ResolversParentTypes['WebhooksResult']> = {
  rows?: Resolver<Maybe<Array<Maybe<ResolversTypes['WebhookType']>>>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WisetackLoanApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['WisetackLoanApplication'] = ResolversParentTypes['WisetackLoanApplication']> = {
  loanApplicationLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  changedStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requestedLoanAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  approvedLoanAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  settledLoanAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  invoiceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quoteNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  purchaseId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refund?: Resolver<Maybe<ResolversTypes['WisetackLoanApplicationRefund']>, ParentType, ContextType>;
  maximumAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  transactionPurpose?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceCompletedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tilaAcceptedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  prequalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payouts?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WisetackLoanApplicationRefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['WisetackLoanApplicationRefund'] = ResolversParentTypes['WisetackLoanApplicationRefund']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  merchantDebitAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WisetackPrequalResolvers<ContextType = any, ParentType extends ResolversParentTypes['WisetackPrequal'] = ResolversParentTypes['WisetackPrequal']> = {
  prequalLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prequalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prequalStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxQualifiedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  aprRange?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  customerInfo?: Resolver<Maybe<ResolversTypes['WisetackPrequalCustomer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WisetackPrequalCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['WisetackPrequalCustomer'] = ResolversParentTypes['WisetackPrequalCustomer']> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AcceptAdditionalWorkResponse?: AcceptAdditionalWorkResponseResolvers<ContextType>;
  AcceptQuoteResponse?: AcceptQuoteResponseResolvers<ContextType>;
  AcceptedActivity?: AcceptedActivityResolvers<ContextType>;
  AcceptedActivityDetails?: AcceptedActivityDetailsResolvers<ContextType>;
  AcknowledgeCheckoutResponse?: AcknowledgeCheckoutResponseResolvers<ContextType>;
  Activity?: ActivityResolvers<ContextType>;
  ActivityContact?: ActivityContactResolvers<ContextType>;
  ActivityDeal?: ActivityDealResolvers<ContextType>;
  ActivityDetails?: ActivityDetailsResolvers<ContextType>;
  ActivityEmail?: ActivityEmailResolvers<ContextType>;
  ActivityJobAddress?: ActivityJobAddressResolvers<ContextType>;
  ActivityMessage?: ActivityMessageResolvers<ContextType>;
  ActivityMessageFrom?: ActivityMessageFromResolvers<ContextType>;
  ActivityQuote?: ActivityQuoteResolvers<ContextType>;
  AddPaymentResult?: AddPaymentResultResolvers<ContextType>;
  AddProcessingPaymentResponse?: AddProcessingPaymentResponseResolvers<ContextType>;
  AddSubscriptionAddonResponse?: AddSubscriptionAddonResponseResolvers<ContextType>;
  AdminDashboardStats?: AdminDashboardStatsResolvers<ContextType>;
  AdminIntegrationsConfigResponse?: AdminIntegrationsConfigResponseResolvers<ContextType>;
  AdminLeaderboardResponse?: AdminLeaderboardResponseResolvers<ContextType>;
  AdminLeaderboardRow?: AdminLeaderboardRowResolvers<ContextType>;
  AdminPaymentEntry?: AdminPaymentEntryResolvers<ContextType>;
  AdminPaymentQuote?: AdminPaymentQuoteResolvers<ContextType>;
  ApiKeyDocument?: ApiKeyDocumentResolvers<ContextType>;
  AppDocsResponse?: AppDocsResponseResolvers<ContextType>;
  AppMetaDataUserCompany?: AppMetaDataUserCompanyResolvers<ContextType>;
  AppMetadata?: AppMetadataResolvers<ContextType>;
  AppMetadataUser?: AppMetadataUserResolvers<ContextType>;
  ApplyPaymentSyncResult?: ApplyPaymentSyncResultResolvers<ContextType>;
  AssignmentActivity?: AssignmentActivityResolvers<ContextType>;
  AssignmentActivityDetails?: AssignmentActivityDetailsResolvers<ContextType>;
  AttachTxnIdResult?: AttachTxnIdResultResolvers<ContextType>;
  Auth0LogEntry?: Auth0LogEntryResolvers<ContextType>;
  Auth0LogsResult?: Auth0LogsResultResolvers<ContextType>;
  BasicActivity?: BasicActivityResolvers<ContextType>;
  BasicActivityDetails?: BasicActivityDetailsResolvers<ContextType>;
  BulkDocsResponseObject?: BulkDocsResponseObjectResolvers<ContextType>;
  CancellationImpactSummary?: CancellationImpactSummaryResolvers<ContextType>;
  ChargebeeAddon?: ChargebeeAddonResolvers<ContextType>;
  ChargebeeAddonSummary?: ChargebeeAddonSummaryResolvers<ContextType>;
  ChargebeeBillingContact?: ChargebeeBillingContactResolvers<ContextType>;
  ChargebeeCharge?: ChargebeeChargeResolvers<ContextType>;
  ChargebeeCoupon?: ChargebeeCouponResolvers<ContextType>;
  ChargebeeDiscount?: ChargebeeDiscountResolvers<ContextType>;
  ChargebeeItemPrice?: ChargebeeItemPriceResolvers<ContextType>;
  ChargebeeOneTimeCharge?: ChargebeeOneTimeChargeResolvers<ContextType>;
  ChargebeePlan?: ChargebeePlanResolvers<ContextType>;
  ChargebeeSubscription?: ChargebeeSubscriptionResolvers<ContextType>;
  ChargebeeSubscriptionSummary?: ChargebeeSubscriptionSummaryResolvers<ContextType>;
  ChatMessage?: ChatMessageResolvers<ContextType>;
  ChatMessageActivity?: ChatMessageActivityResolvers<ContextType>;
  ChatMessageActivityDetails?: ChatMessageActivityDetailsResolvers<ContextType>;
  ChatMessageUsage?: ChatMessageUsageResolvers<ContextType>;
  CheckoutCoupon?: CheckoutCouponResolvers<ContextType>;
  CheckoutEstimate?: CheckoutEstimateResolvers<ContextType>;
  CheckoutEstimateLineItem?: CheckoutEstimateLineItemResolvers<ContextType>;
  CheckoutResult?: CheckoutResultResolvers<ContextType>;
  ClientAggregates?: ClientAggregatesResolvers<ContextType>;
  ClientCancellationFlow?: ClientCancellationFlowResolvers<ContextType>;
  ClientDunning?: ClientDunningResolvers<ContextType>;
  ClientMeta?: ClientMetaResolvers<ContextType>;
  ClientMetaSubscription?: ClientMetaSubscriptionResolvers<ContextType>;
  ClientOptions?: ClientOptionsResolvers<ContextType>;
  ClientResponse?: ClientResponseResolvers<ContextType>;
  ClientUserCounts?: ClientUserCountsResolvers<ContextType>;
  CloudinaryFile?: CloudinaryFileResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  CompanySubscription?: CompanySubscriptionResolvers<ContextType>;
  Contact?: ContactResolvers<ContextType>;
  ContactGeocode?: ContactGeocodeResolvers<ContextType>;
  ConvertedFile?: ConvertedFileResolvers<ContextType>;
  CouchDocument?: CouchDocumentResolvers<ContextType>;
  CreateNoteResponse?: CreateNoteResponseResolvers<ContextType>;
  CreatePaymentActivityResponse?: CreatePaymentActivityResponseResolvers<ContextType>;
  CsmBookingInfo?: CsmBookingInfoResolvers<ContextType>;
  CustomAvatar?: CustomAvatarResolvers<ContextType>;
  DateRange?: DateRangeResolvers<ContextType>;
  Deal?: DealResolvers<ContextType>;
  DealContact?: DealContactResolvers<ContextType>;
  DealGeocode?: DealGeocodeResolvers<ContextType>;
  DealPipeline?: DealPipelineResolvers<ContextType>;
  DealStage?: DealStageResolvers<ContextType>;
  DealSummaryResponse?: DealSummaryResponseResolvers<ContextType>;
  DeclineQuoteResponse?: DeclineQuoteResponseResolvers<ContextType>;
  DeclinedActivity?: DeclinedActivityResolvers<ContextType>;
  DeclinedActivityDetails?: DeclinedActivityDetailsResolvers<ContextType>;
  DeletePaymentResponse?: DeletePaymentResponseResolvers<ContextType>;
  DowngradeSubscriptionResponse?: DowngradeSubscriptionResponseResolvers<ContextType>;
  EscalateToSupportResponse?: EscalateToSupportResponseResolvers<ContextType>;
  Estimator?: EstimatorResolvers<ContextType>;
  EventActivity?: EventActivityResolvers<ContextType>;
  EventActivityDetails?: EventActivityDetailsResolvers<ContextType>;
  EventEmailSentActivity?: EventEmailSentActivityResolvers<ContextType>;
  EventEmailSentActivityDetails?: EventEmailSentActivityDetailsResolvers<ContextType>;
  EventGeocode?: EventGeocodeResolvers<ContextType>;
  ExportClientsResponse?: ExportClientsResponseResolvers<ContextType>;
  ExportCompaniesResponse?: ExportCompaniesResponseResolvers<ContextType>;
  ExportContactsResponse?: ExportContactsResponseResolvers<ContextType>;
  ExportDealsResponse?: ExportDealsResponseResolvers<ContextType>;
  ExportLineItemsResponse?: ExportLineItemsResponseResolvers<ContextType>;
  ExportProductResponse?: ExportProductResponseResolvers<ContextType>;
  ExportProductionRatesResponse?: ExportProductionRatesResponseResolvers<ContextType>;
  ExportQuotesResponse?: ExportQuotesResponseResolvers<ContextType>;
  FileAddedActivity?: FileAddedActivityResolvers<ContextType>;
  FileAddedActivityDetails?: FileAddedActivityDetailsResolvers<ContextType>;
  FollowUp?: FollowUpResolvers<ContextType>;
  FollowUpConditions?: FollowUpConditionsResolvers<ContextType>;
  FollowUpSentActivity?: FollowUpSentActivityResolvers<ContextType>;
  FollowUpSentActivityDetails?: FollowUpSentActivityDetailsResolvers<ContextType>;
  FollowUpsForUser?: FollowUpsForUserResolvers<ContextType>;
  GeneratePresentationResult?: GeneratePresentationResultResolvers<ContextType>;
  GetCorporateTypeDataResponse?: GetCorporateTypeDataResponseResolvers<ContextType>;
  GetPortalSessionResponse?: GetPortalSessionResponseResolvers<ContextType>;
  HubspotCompanyInfo?: HubspotCompanyInfoResolvers<ContextType>;
  InboundWebhookLogEntry?: InboundWebhookLogEntryResolvers<ContextType>;
  InboundWebhookLogsResult?: InboundWebhookLogsResultResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JobCosting?: JobCostingResolvers<ContextType>;
  LeadFormSubmissionActivity?: LeadFormSubmissionActivityResolvers<ContextType>;
  LeadFormSubmissionActivityDetails?: LeadFormSubmissionActivityDetailsResolvers<ContextType>;
  LeaderboardDataResponse?: LeaderboardDataResponseResolvers<ContextType>;
  LeaderboardDataResponseRow?: LeaderboardDataResponseRowResolvers<ContextType>;
  LeaderboardRankResponse?: LeaderboardRankResponseResolvers<ContextType>;
  LeaderboardRankResponseItem?: LeaderboardRankResponseItemResolvers<ContextType>;
  LocationSuggestion?: LocationSuggestionResolvers<ContextType>;
  ManufacturerColor?: ManufacturerColorResolvers<ContextType>;
  ManufacturerProduct?: ManufacturerProductResolvers<ContextType>;
  MessageActivity?: MessageActivityResolvers<ContextType>;
  MessageActivityDetails?: MessageActivityDetailsResolvers<ContextType>;
  MfaEnrollment?: MfaEnrollmentResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NewAccountResponse?: NewAccountResponseResolvers<ContextType>;
  NoteActivity?: NoteActivityResolvers<ContextType>;
  NoteActivityDetails?: NoteActivityDetailsResolvers<ContextType>;
  NoteActivityFile?: NoteActivityFileResolvers<ContextType>;
  NoteActivityVersion?: NoteActivityVersionResolvers<ContextType>;
  OfflineQuotesResponse?: OfflineQuotesResponseResolvers<ContextType>;
  Owner?: OwnerResolvers<ContextType>;
  OwnerChangedActivity?: OwnerChangedActivityResolvers<ContextType>;
  OwnerChangedActivityDetails?: OwnerChangedActivityDetailsResolvers<ContextType>;
  PainterScheduleDeal?: PainterScheduleDealResolvers<ContextType>;
  PainterScheduleJobResponse?: PainterScheduleJobResponseResolvers<ContextType>;
  PainterScheduleResponse?: PainterScheduleResponseResolvers<ContextType>;
  PaymentActivity?: PaymentActivityResolvers<ContextType>;
  PaymentActivityDetails?: PaymentActivityDetailsResolvers<ContextType>;
  PaymentProcessedResponse?: PaymentProcessedResponseResolvers<ContextType>;
  PaymentReceivedSentActivity?: PaymentReceivedSentActivityResolvers<ContextType>;
  PaymentReceivedSentActivityDetails?: PaymentReceivedSentActivityDetailsResolvers<ContextType>;
  PaymentRequestedActivity?: PaymentRequestedActivityResolvers<ContextType>;
  PaymentRequestedActivityDetails?: PaymentRequestedActivityDetailsResolvers<ContextType>;
  PaymentSyncEntry?: PaymentSyncEntryResolvers<ContextType>;
  PaymentSyncRefund?: PaymentSyncRefundResolvers<ContextType>;
  PayrixConnectionResult?: PayrixConnectionResultResolvers<ContextType>;
  PayrixTxnLookup?: PayrixTxnLookupResolvers<ContextType>;
  PexelsPhoto?: PexelsPhotoResolvers<ContextType>;
  PexelsPhotoSrc?: PexelsPhotoSrcResolvers<ContextType>;
  PexelsSearchResult?: PexelsSearchResultResolvers<ContextType>;
  PortalSessionLinkedCustomer?: PortalSessionLinkedCustomerResolvers<ContextType>;
  PostHogSessionRecording?: PostHogSessionRecordingResolvers<ContextType>;
  PostHogSessionRecordingsResult?: PostHogSessionRecordingsResultResolvers<ContextType>;
  PostmarkMessage?: PostmarkMessageResolvers<ContextType>;
  PostmarkMessagesResult?: PostmarkMessagesResultResolvers<ContextType>;
  PostmarkSuppressionEntry?: PostmarkSuppressionEntryResolvers<ContextType>;
  ProcessEventResponse?: ProcessEventResponseResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Quote?: QuoteResolvers<ContextType>;
  QuoteContact?: QuoteContactResolvers<ContextType>;
  QuoteFollowUp?: QuoteFollowUpResolvers<ContextType>;
  QuoteMessagesResponse?: QuoteMessagesResponseResolvers<ContextType>;
  QuoteOwner?: QuoteOwnerResolvers<ContextType>;
  QuotePdfResponse?: QuotePdfResponseResolvers<ContextType>;
  QuoteSummaryResponse?: QuoteSummaryResponseResolvers<ContextType>;
  QuoteType?: QuoteTypeResolvers<ContextType>;
  QuoteUrlResponse?: QuoteUrlResponseResolvers<ContextType>;
  ReactivateSubscriptionResponse?: ReactivateSubscriptionResponseResolvers<ContextType>;
  RecoverInvoiceResponse?: RecoverInvoiceResponseResolvers<ContextType>;
  RefreshQuoteTranslationsResult?: RefreshQuoteTranslationsResultResolvers<ContextType>;
  RefundPaymentResponse?: RefundPaymentResponseResolvers<ContextType>;
  RenewAccountResponse?: RenewAccountResponseResolvers<ContextType>;
  ReportChart?: ReportChartResolvers<ContextType>;
  ReportChartData?: ReportChartDataResolvers<ContextType>;
  ReportChartDataset?: ReportChartDatasetResolvers<ContextType>;
  ReportColumnDefinition?: ReportColumnDefinitionResolvers<ContextType>;
  ReportColumnDefinitionAction?: ReportColumnDefinitionActionResolvers<ContextType>;
  ReportColumnDefinitionLink?: ReportColumnDefinitionLinkResolvers<ContextType>;
  ReportColumnDefinitionSubField?: ReportColumnDefinitionSubFieldResolvers<ContextType>;
  ReportDataResponse?: ReportDataResponseResolvers<ContextType>;
  ReportFilterOption?: ReportFilterOptionResolvers<ContextType>;
  ReportFilterOptionField?: ReportFilterOptionFieldResolvers<ContextType>;
  ReportFilterOptionsReponse?: ReportFilterOptionsReponseResolvers<ContextType>;
  RequestReviewResponse?: RequestReviewResponseResolvers<ContextType>;
  RerunWebhookResult?: RerunWebhookResultResolvers<ContextType>;
  ResolveCancellationOfferResponse?: ResolveCancellationOfferResponseResolvers<ContextType>;
  ResourceApiResponse?: ResourceApiResponseResolvers<ContextType>;
  RetentionDiscountResponse?: RetentionDiscountResponseResolvers<ContextType>;
  SalesRep?: SalesRepResolvers<ContextType>;
  SaveEventResponse?: SaveEventResponseResolvers<ContextType>;
  ScatterPoint?: ScatterPointResolvers<ContextType>;
  ScheduleCancellationResponse?: ScheduleCancellationResponseResolvers<ContextType>;
  SearchActivitiesResponse?: SearchActivitiesResponseResolvers<ContextType>;
  SearchClientsResponse?: SearchClientsResponseResolvers<ContextType>;
  SearchCompaniesResult?: SearchCompaniesResultResolvers<ContextType>;
  SearchContactDealsResponse?: SearchContactDealsResponseResolvers<ContextType>;
  SearchContactOpportunitiesResponse?: SearchContactOpportunitiesResponseResolvers<ContextType>;
  SearchContactsByIntegrationResponse?: SearchContactsByIntegrationResponseResolvers<ContextType>;
  SearchContactsResult?: SearchContactsResultResolvers<ContextType>;
  SearchDealsResult?: SearchDealsResultResolvers<ContextType>;
  SearchLocationsResponse?: SearchLocationsResponseResolvers<ContextType>;
  SearchManufacturerColorsResponse?: SearchManufacturerColorsResponseResolvers<ContextType>;
  SearchManufacturerProductsResponse?: SearchManufacturerProductsResponseResolvers<ContextType>;
  SearchQuotesResponse?: SearchQuotesResponseResolvers<ContextType>;
  SearchTasksResult?: SearchTasksResultResolvers<ContextType>;
  SearchUsersResponse?: SearchUsersResponseResolvers<ContextType>;
  SendMessageResponse?: SendMessageResponseResolvers<ContextType>;
  SendQuoteResponse?: SendQuoteResponseResolvers<ContextType>;
  SentActivity?: SentActivityResolvers<ContextType>;
  SentActivityDetails?: SentActivityDetailsResolvers<ContextType>;
  SentEmail?: SentEmailResolvers<ContextType>;
  SignedUploadResponse?: SignedUploadResponseResolvers<ContextType>;
  StageChangedActivity?: StageChangedActivityResolvers<ContextType>;
  StageChangedActivityDetails?: StageChangedActivityDetailsResolvers<ContextType>;
  StuckPaymentsResult?: StuckPaymentsResultResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TaskActivity?: TaskActivityResolvers<ContextType>;
  TaskActivityDetails?: TaskActivityDetailsResolvers<ContextType>;
  TaskCounts?: TaskCountsResolvers<ContextType>;
  TimeRange?: TimeRangeResolvers<ContextType>;
  TranslatedEmailContent?: TranslatedEmailContentResolvers<ContextType>;
  TranslationLangStatus?: TranslationLangStatusResolvers<ContextType>;
  TurnOnCrmResult?: TurnOnCrmResultResolvers<ContextType>;
  UnscheduledJobsResponse?: UnscheduledJobsResponseResolvers<ContextType>;
  UpdateDealStageResponse?: UpdateDealStageResponseResolvers<ContextType>;
  UpdatePaymentResponse?: UpdatePaymentResponseResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UrlDocument?: UrlDocumentResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserClient?: UserClientResolvers<ContextType>;
  UserMetadata?: UserMetadataResolvers<ContextType>;
  ViewQuoteResponse?: ViewQuoteResponseResolvers<ContextType>;
  ViewedActivity?: ViewedActivityResolvers<ContextType>;
  ViewedActivityDetails?: ViewedActivityDetailsResolvers<ContextType>;
  WarningActivity?: WarningActivityResolvers<ContextType>;
  WarningActivityDetails?: WarningActivityDetailsResolvers<ContextType>;
  WeatherDay?: WeatherDayResolvers<ContextType>;
  WebhookEventType?: WebhookEventTypeResolvers<ContextType>;
  WebhookEventsResult?: WebhookEventsResultResolvers<ContextType>;
  WebhookParams?: WebhookParamsResolvers<ContextType>;
  WebhookTimestamp?: WebhookTimestampResolvers<ContextType>;
  WebhookType?: WebhookTypeResolvers<ContextType>;
  WebhooksResult?: WebhooksResultResolvers<ContextType>;
  WisetackLoanApplication?: WisetackLoanApplicationResolvers<ContextType>;
  WisetackLoanApplicationRefund?: WisetackLoanApplicationRefundResolvers<ContextType>;
  WisetackPrequal?: WisetackPrequalResolvers<ContextType>;
  WisetackPrequalCustomer?: WisetackPrequalCustomerResolvers<ContextType>;
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = {
  guard?: GuardDirectiveResolver<any, any, ContextType>;
};


/**
 * @deprecated
 * Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
 */
export type IDirectiveResolvers<ContextType = any> = DirectiveResolvers<ContextType>;
export type ActivitiesForDocQueryVariables = Exact<{
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  bookmark?: Maybe<Scalars['String']>;
  includeMessages?: Maybe<Scalars['Boolean']>;
}>;


export type ActivitiesForDocQuery = (
  { __typename?: 'Query' }
  & { activitiesForDoc?: Maybe<(
    { __typename?: 'SearchActivitiesResponse' }
    & Pick<SearchActivitiesResponse, 'total_rows' | 'bookmark'>
    & { activities?: Maybe<Array<(
      { __typename?: 'AcceptedActivity' }
      & FullActivity_AcceptedActivity_Fragment
    ) | (
      { __typename?: 'AssignmentActivity' }
      & FullActivity_AssignmentActivity_Fragment
    ) | (
      { __typename?: 'BasicActivity' }
      & FullActivity_BasicActivity_Fragment
    ) | (
      { __typename?: 'ChatMessageActivity' }
      & FullActivity_ChatMessageActivity_Fragment
    ) | (
      { __typename?: 'DeclinedActivity' }
      & FullActivity_DeclinedActivity_Fragment
    ) | (
      { __typename?: 'EventActivity' }
      & FullActivity_EventActivity_Fragment
    ) | (
      { __typename?: 'EventEmailSentActivity' }
      & FullActivity_EventEmailSentActivity_Fragment
    ) | (
      { __typename?: 'FileAddedActivity' }
      & FullActivity_FileAddedActivity_Fragment
    ) | (
      { __typename?: 'FollowUpSentActivity' }
      & FullActivity_FollowUpSentActivity_Fragment
    ) | (
      { __typename?: 'LeadFormSubmissionActivity' }
      & FullActivity_LeadFormSubmissionActivity_Fragment
    ) | (
      { __typename?: 'MessageActivity' }
      & FullActivity_MessageActivity_Fragment
    ) | (
      { __typename?: 'NoteActivity' }
      & FullActivity_NoteActivity_Fragment
    ) | (
      { __typename?: 'OwnerChangedActivity' }
      & FullActivity_OwnerChangedActivity_Fragment
    ) | (
      { __typename?: 'PaymentActivity' }
      & FullActivity_PaymentActivity_Fragment
    ) | (
      { __typename?: 'PaymentReceivedSentActivity' }
      & FullActivity_PaymentReceivedSentActivity_Fragment
    ) | (
      { __typename?: 'PaymentRequestedActivity' }
      & FullActivity_PaymentRequestedActivity_Fragment
    ) | (
      { __typename?: 'SentActivity' }
      & FullActivity_SentActivity_Fragment
    ) | (
      { __typename?: 'StageChangedActivity' }
      & FullActivity_StageChangedActivity_Fragment
    ) | (
      { __typename?: 'TaskActivity' }
      & FullActivity_TaskActivity_Fragment
    ) | (
      { __typename?: 'ViewedActivity' }
      & FullActivity_ViewedActivity_Fragment
    ) | (
      { __typename?: 'WarningActivity' }
      & FullActivity_WarningActivity_Fragment
    )>> }
  )> }
);

export type ChatHistoryForQuoteQueryVariables = Exact<{
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type ChatHistoryForQuoteQuery = (
  { __typename?: 'Query' }
  & { activitiesForDoc?: Maybe<(
    { __typename?: 'SearchActivitiesResponse' }
    & Pick<SearchActivitiesResponse, 'total_rows' | 'bookmark'>
    & { activities?: Maybe<Array<(
      { __typename?: 'AcceptedActivity' }
      & FullChatMessageActivity_AcceptedActivity_Fragment
    ) | (
      { __typename?: 'AssignmentActivity' }
      & FullChatMessageActivity_AssignmentActivity_Fragment
    ) | (
      { __typename?: 'BasicActivity' }
      & FullChatMessageActivity_BasicActivity_Fragment
    ) | (
      { __typename?: 'ChatMessageActivity' }
      & FullChatMessageActivity_ChatMessageActivity_Fragment
    ) | (
      { __typename?: 'DeclinedActivity' }
      & FullChatMessageActivity_DeclinedActivity_Fragment
    ) | (
      { __typename?: 'EventActivity' }
      & FullChatMessageActivity_EventActivity_Fragment
    ) | (
      { __typename?: 'EventEmailSentActivity' }
      & FullChatMessageActivity_EventEmailSentActivity_Fragment
    ) | (
      { __typename?: 'FileAddedActivity' }
      & FullChatMessageActivity_FileAddedActivity_Fragment
    ) | (
      { __typename?: 'FollowUpSentActivity' }
      & FullChatMessageActivity_FollowUpSentActivity_Fragment
    ) | (
      { __typename?: 'LeadFormSubmissionActivity' }
      & FullChatMessageActivity_LeadFormSubmissionActivity_Fragment
    ) | (
      { __typename?: 'MessageActivity' }
      & FullChatMessageActivity_MessageActivity_Fragment
    ) | (
      { __typename?: 'NoteActivity' }
      & FullChatMessageActivity_NoteActivity_Fragment
    ) | (
      { __typename?: 'OwnerChangedActivity' }
      & FullChatMessageActivity_OwnerChangedActivity_Fragment
    ) | (
      { __typename?: 'PaymentActivity' }
      & FullChatMessageActivity_PaymentActivity_Fragment
    ) | (
      { __typename?: 'PaymentReceivedSentActivity' }
      & FullChatMessageActivity_PaymentReceivedSentActivity_Fragment
    ) | (
      { __typename?: 'PaymentRequestedActivity' }
      & FullChatMessageActivity_PaymentRequestedActivity_Fragment
    ) | (
      { __typename?: 'SentActivity' }
      & FullChatMessageActivity_SentActivity_Fragment
    ) | (
      { __typename?: 'StageChangedActivity' }
      & FullChatMessageActivity_StageChangedActivity_Fragment
    ) | (
      { __typename?: 'TaskActivity' }
      & FullChatMessageActivity_TaskActivity_Fragment
    ) | (
      { __typename?: 'ViewedActivity' }
      & FullChatMessageActivity_ViewedActivity_Fragment
    ) | (
      { __typename?: 'WarningActivity' }
      & FullChatMessageActivity_WarningActivity_Fragment
    )>> }
  )> }
);

export type NewActivitiesForDocQueryVariables = Exact<{
  id: Scalars['String'];
  since?: Maybe<Scalars['Float']>;
}>;


export type NewActivitiesForDocQuery = (
  { __typename?: 'Query' }
  & { newActivitiesForDoc?: Maybe<Array<Maybe<(
    { __typename?: 'AcceptedActivity' }
    & FullActivity_AcceptedActivity_Fragment
  ) | (
    { __typename?: 'AssignmentActivity' }
    & FullActivity_AssignmentActivity_Fragment
  ) | (
    { __typename?: 'BasicActivity' }
    & FullActivity_BasicActivity_Fragment
  ) | (
    { __typename?: 'ChatMessageActivity' }
    & FullActivity_ChatMessageActivity_Fragment
  ) | (
    { __typename?: 'DeclinedActivity' }
    & FullActivity_DeclinedActivity_Fragment
  ) | (
    { __typename?: 'EventActivity' }
    & FullActivity_EventActivity_Fragment
  ) | (
    { __typename?: 'EventEmailSentActivity' }
    & FullActivity_EventEmailSentActivity_Fragment
  ) | (
    { __typename?: 'FileAddedActivity' }
    & FullActivity_FileAddedActivity_Fragment
  ) | (
    { __typename?: 'FollowUpSentActivity' }
    & FullActivity_FollowUpSentActivity_Fragment
  ) | (
    { __typename?: 'LeadFormSubmissionActivity' }
    & FullActivity_LeadFormSubmissionActivity_Fragment
  ) | (
    { __typename?: 'MessageActivity' }
    & FullActivity_MessageActivity_Fragment
  ) | (
    { __typename?: 'NoteActivity' }
    & FullActivity_NoteActivity_Fragment
  ) | (
    { __typename?: 'OwnerChangedActivity' }
    & FullActivity_OwnerChangedActivity_Fragment
  ) | (
    { __typename?: 'PaymentActivity' }
    & FullActivity_PaymentActivity_Fragment
  ) | (
    { __typename?: 'PaymentReceivedSentActivity' }
    & FullActivity_PaymentReceivedSentActivity_Fragment
  ) | (
    { __typename?: 'PaymentRequestedActivity' }
    & FullActivity_PaymentRequestedActivity_Fragment
  ) | (
    { __typename?: 'SentActivity' }
    & FullActivity_SentActivity_Fragment
  ) | (
    { __typename?: 'StageChangedActivity' }
    & FullActivity_StageChangedActivity_Fragment
  ) | (
    { __typename?: 'TaskActivity' }
    & FullActivity_TaskActivity_Fragment
  ) | (
    { __typename?: 'ViewedActivity' }
    & FullActivity_ViewedActivity_Fragment
  ) | (
    { __typename?: 'WarningActivity' }
    & FullActivity_WarningActivity_Fragment
  )>>> }
);

export type SearchActivitiesQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  pinnedForDocId?: Maybe<Scalars['String']>;
  skipSanitize?: Maybe<Scalars['Boolean']>;
  isProductionCalendar?: Maybe<Scalars['Boolean']>;
}>;


export type SearchActivitiesQuery = (
  { __typename?: 'Query' }
  & { searchActivities?: Maybe<(
    { __typename?: 'SearchActivitiesResponse' }
    & Pick<SearchActivitiesResponse, 'total_rows' | 'bookmark' | 'hasMore'>
    & { activities?: Maybe<Array<(
      { __typename?: 'AcceptedActivity' }
      & FullActivity_AcceptedActivity_Fragment
    ) | (
      { __typename?: 'AssignmentActivity' }
      & FullActivity_AssignmentActivity_Fragment
    ) | (
      { __typename?: 'BasicActivity' }
      & FullActivity_BasicActivity_Fragment
    ) | (
      { __typename?: 'ChatMessageActivity' }
      & FullActivity_ChatMessageActivity_Fragment
    ) | (
      { __typename?: 'DeclinedActivity' }
      & FullActivity_DeclinedActivity_Fragment
    ) | (
      { __typename?: 'EventActivity' }
      & FullActivity_EventActivity_Fragment
    ) | (
      { __typename?: 'EventEmailSentActivity' }
      & FullActivity_EventEmailSentActivity_Fragment
    ) | (
      { __typename?: 'FileAddedActivity' }
      & FullActivity_FileAddedActivity_Fragment
    ) | (
      { __typename?: 'FollowUpSentActivity' }
      & FullActivity_FollowUpSentActivity_Fragment
    ) | (
      { __typename?: 'LeadFormSubmissionActivity' }
      & FullActivity_LeadFormSubmissionActivity_Fragment
    ) | (
      { __typename?: 'MessageActivity' }
      & FullActivity_MessageActivity_Fragment
    ) | (
      { __typename?: 'NoteActivity' }
      & FullActivity_NoteActivity_Fragment
    ) | (
      { __typename?: 'OwnerChangedActivity' }
      & FullActivity_OwnerChangedActivity_Fragment
    ) | (
      { __typename?: 'PaymentActivity' }
      & FullActivity_PaymentActivity_Fragment
    ) | (
      { __typename?: 'PaymentReceivedSentActivity' }
      & FullActivity_PaymentReceivedSentActivity_Fragment
    ) | (
      { __typename?: 'PaymentRequestedActivity' }
      & FullActivity_PaymentRequestedActivity_Fragment
    ) | (
      { __typename?: 'SentActivity' }
      & FullActivity_SentActivity_Fragment
    ) | (
      { __typename?: 'StageChangedActivity' }
      & FullActivity_StageChangedActivity_Fragment
    ) | (
      { __typename?: 'TaskActivity' }
      & FullActivity_TaskActivity_Fragment
    ) | (
      { __typename?: 'ViewedActivity' }
      & FullActivity_ViewedActivity_Fragment
    ) | (
      { __typename?: 'WarningActivity' }
      & FullActivity_WarningActivity_Fragment
    )>> }
  )> }
);

export type ActivityQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ActivityQuery = (
  { __typename?: 'Query' }
  & { activity?: Maybe<(
    { __typename?: 'AcceptedActivity' }
    & FullActivity_AcceptedActivity_Fragment
  ) | (
    { __typename?: 'AssignmentActivity' }
    & FullActivity_AssignmentActivity_Fragment
  ) | (
    { __typename?: 'BasicActivity' }
    & FullActivity_BasicActivity_Fragment
  ) | (
    { __typename?: 'ChatMessageActivity' }
    & FullActivity_ChatMessageActivity_Fragment
  ) | (
    { __typename?: 'DeclinedActivity' }
    & FullActivity_DeclinedActivity_Fragment
  ) | (
    { __typename?: 'EventActivity' }
    & FullActivity_EventActivity_Fragment
  ) | (
    { __typename?: 'EventEmailSentActivity' }
    & FullActivity_EventEmailSentActivity_Fragment
  ) | (
    { __typename?: 'FileAddedActivity' }
    & FullActivity_FileAddedActivity_Fragment
  ) | (
    { __typename?: 'FollowUpSentActivity' }
    & FullActivity_FollowUpSentActivity_Fragment
  ) | (
    { __typename?: 'LeadFormSubmissionActivity' }
    & FullActivity_LeadFormSubmissionActivity_Fragment
  ) | (
    { __typename?: 'MessageActivity' }
    & FullActivity_MessageActivity_Fragment
  ) | (
    { __typename?: 'NoteActivity' }
    & FullActivity_NoteActivity_Fragment
  ) | (
    { __typename?: 'OwnerChangedActivity' }
    & FullActivity_OwnerChangedActivity_Fragment
  ) | (
    { __typename?: 'PaymentActivity' }
    & FullActivity_PaymentActivity_Fragment
  ) | (
    { __typename?: 'PaymentReceivedSentActivity' }
    & FullActivity_PaymentReceivedSentActivity_Fragment
  ) | (
    { __typename?: 'PaymentRequestedActivity' }
    & FullActivity_PaymentRequestedActivity_Fragment
  ) | (
    { __typename?: 'SentActivity' }
    & FullActivity_SentActivity_Fragment
  ) | (
    { __typename?: 'StageChangedActivity' }
    & FullActivity_StageChangedActivity_Fragment
  ) | (
    { __typename?: 'TaskActivity' }
    & FullActivity_TaskActivity_Fragment
  ) | (
    { __typename?: 'ViewedActivity' }
    & FullActivity_ViewedActivity_Fragment
  ) | (
    { __typename?: 'WarningActivity' }
    & FullActivity_WarningActivity_Fragment
  )> }
);

export type MessagesQueryVariables = Exact<{
  quoteId?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type MessagesQuery = (
  { __typename?: 'Query' }
  & { messages?: Maybe<(
    { __typename?: 'QuoteMessagesResponse' }
    & Pick<QuoteMessagesResponse, 'total_rows' | 'bookmark'>
    & { messages?: Maybe<Array<(
      { __typename?: 'AcceptedActivity' }
      & FullMessageActivity_AcceptedActivity_Fragment
    ) | (
      { __typename?: 'AssignmentActivity' }
      & FullMessageActivity_AssignmentActivity_Fragment
    ) | (
      { __typename?: 'BasicActivity' }
      & FullMessageActivity_BasicActivity_Fragment
    ) | (
      { __typename?: 'ChatMessageActivity' }
      & FullMessageActivity_ChatMessageActivity_Fragment
    ) | (
      { __typename?: 'DeclinedActivity' }
      & FullMessageActivity_DeclinedActivity_Fragment
    ) | (
      { __typename?: 'EventActivity' }
      & FullMessageActivity_EventActivity_Fragment
    ) | (
      { __typename?: 'EventEmailSentActivity' }
      & FullMessageActivity_EventEmailSentActivity_Fragment
    ) | (
      { __typename?: 'FileAddedActivity' }
      & FullMessageActivity_FileAddedActivity_Fragment
    ) | (
      { __typename?: 'FollowUpSentActivity' }
      & FullMessageActivity_FollowUpSentActivity_Fragment
    ) | (
      { __typename?: 'LeadFormSubmissionActivity' }
      & FullMessageActivity_LeadFormSubmissionActivity_Fragment
    ) | (
      { __typename?: 'MessageActivity' }
      & FullMessageActivity_MessageActivity_Fragment
    ) | (
      { __typename?: 'NoteActivity' }
      & FullMessageActivity_NoteActivity_Fragment
    ) | (
      { __typename?: 'OwnerChangedActivity' }
      & FullMessageActivity_OwnerChangedActivity_Fragment
    ) | (
      { __typename?: 'PaymentActivity' }
      & FullMessageActivity_PaymentActivity_Fragment
    ) | (
      { __typename?: 'PaymentReceivedSentActivity' }
      & FullMessageActivity_PaymentReceivedSentActivity_Fragment
    ) | (
      { __typename?: 'PaymentRequestedActivity' }
      & FullMessageActivity_PaymentRequestedActivity_Fragment
    ) | (
      { __typename?: 'SentActivity' }
      & FullMessageActivity_SentActivity_Fragment
    ) | (
      { __typename?: 'StageChangedActivity' }
      & FullMessageActivity_StageChangedActivity_Fragment
    ) | (
      { __typename?: 'TaskActivity' }
      & FullMessageActivity_TaskActivity_Fragment
    ) | (
      { __typename?: 'ViewedActivity' }
      & FullMessageActivity_ViewedActivity_Fragment
    ) | (
      { __typename?: 'WarningActivity' }
      & FullMessageActivity_WarningActivity_Fragment
    )>> }
  )> }
);

export type UnreadMessagesQueryVariables = Exact<{
  quoteId?: Maybe<Scalars['String']>;
}>;


export type UnreadMessagesQuery = (
  { __typename?: 'Query' }
  & { unreadMessages?: Maybe<Array<(
    { __typename?: 'MessageActivity' }
    & FullMessageActivity_MessageActivity_Fragment
  )>> }
);

export type NewMessagesQueryVariables = Exact<{
  quoteId?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['Float']>;
}>;


export type NewMessagesQuery = (
  { __typename?: 'Query' }
  & { newMessages?: Maybe<Array<(
    { __typename?: 'AcceptedActivity' }
    & FullMessageActivity_AcceptedActivity_Fragment
  ) | (
    { __typename?: 'AssignmentActivity' }
    & FullMessageActivity_AssignmentActivity_Fragment
  ) | (
    { __typename?: 'BasicActivity' }
    & FullMessageActivity_BasicActivity_Fragment
  ) | (
    { __typename?: 'ChatMessageActivity' }
    & FullMessageActivity_ChatMessageActivity_Fragment
  ) | (
    { __typename?: 'DeclinedActivity' }
    & FullMessageActivity_DeclinedActivity_Fragment
  ) | (
    { __typename?: 'EventActivity' }
    & FullMessageActivity_EventActivity_Fragment
  ) | (
    { __typename?: 'EventEmailSentActivity' }
    & FullMessageActivity_EventEmailSentActivity_Fragment
  ) | (
    { __typename?: 'FileAddedActivity' }
    & FullMessageActivity_FileAddedActivity_Fragment
  ) | (
    { __typename?: 'FollowUpSentActivity' }
    & FullMessageActivity_FollowUpSentActivity_Fragment
  ) | (
    { __typename?: 'LeadFormSubmissionActivity' }
    & FullMessageActivity_LeadFormSubmissionActivity_Fragment
  ) | (
    { __typename?: 'MessageActivity' }
    & FullMessageActivity_MessageActivity_Fragment
  ) | (
    { __typename?: 'NoteActivity' }
    & FullMessageActivity_NoteActivity_Fragment
  ) | (
    { __typename?: 'OwnerChangedActivity' }
    & FullMessageActivity_OwnerChangedActivity_Fragment
  ) | (
    { __typename?: 'PaymentActivity' }
    & FullMessageActivity_PaymentActivity_Fragment
  ) | (
    { __typename?: 'PaymentReceivedSentActivity' }
    & FullMessageActivity_PaymentReceivedSentActivity_Fragment
  ) | (
    { __typename?: 'PaymentRequestedActivity' }
    & FullMessageActivity_PaymentRequestedActivity_Fragment
  ) | (
    { __typename?: 'SentActivity' }
    & FullMessageActivity_SentActivity_Fragment
  ) | (
    { __typename?: 'StageChangedActivity' }
    & FullMessageActivity_StageChangedActivity_Fragment
  ) | (
    { __typename?: 'TaskActivity' }
    & FullMessageActivity_TaskActivity_Fragment
  ) | (
    { __typename?: 'ViewedActivity' }
    & FullMessageActivity_ViewedActivity_Fragment
  ) | (
    { __typename?: 'WarningActivity' }
    & FullMessageActivity_WarningActivity_Fragment
  )>> }
);

export type UnscheduledJobsQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type UnscheduledJobsQuery = (
  { __typename?: 'Query' }
  & { unscheduledJobs?: Maybe<(
    { __typename?: 'UnscheduledJobsResponse' }
    & Pick<UnscheduledJobsResponse, 'total_rows' | 'bookmark'>
    & { activities?: Maybe<Array<(
      { __typename?: 'EventActivity' }
      & FullEventActivity_EventActivity_Fragment
    )>> }
  )> }
);

export type SyncActivitiesForDocMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SyncActivitiesForDocMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncActivitiesForDoc'>
);

export type SendMessageMutationVariables = Exact<{
  message: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  sendNotification?: Maybe<Scalars['Boolean']>;
}>;


export type SendMessageMutation = (
  { __typename?: 'Mutation' }
  & { sendMessage?: Maybe<(
    { __typename?: 'SendMessageResponse' }
    & Pick<SendMessageResponse, 'quote'>
    & { activity?: Maybe<(
      { __typename?: 'MessageActivity' }
      & FullMessageActivity_MessageActivity_Fragment
    )> }
  )> }
);

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
}>;


export type DeleteMessageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteMessage'>
);

export type ReadMessagesMutationVariables = Exact<{
  quoteId?: Maybe<Scalars['String']>;
}>;


export type ReadMessagesMutation = (
  { __typename?: 'Mutation' }
  & { readMessages?: Maybe<Array<Maybe<(
    { __typename?: 'MessageActivity' }
    & Pick<MessageActivity, '_id'>
  )>>> }
);

export type GetNoteQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetNoteQuery = (
  { __typename?: 'Query' }
  & { getNote?: Maybe<(
    { __typename?: 'NoteActivity' }
    & FullNoteActivity_NoteActivity_Fragment
  )> }
);

export type CreateNoteMutationVariables = Exact<{
  docId: Scalars['String'];
  docType: Scalars['String'];
  note: Scalars['String'];
  files?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateNoteMutation = (
  { __typename?: 'Mutation' }
  & { createNote?: Maybe<(
    { __typename?: 'CreateNoteResponse' }
    & { activity?: Maybe<(
      { __typename?: 'NoteActivity' }
      & FullNoteActivity_NoteActivity_Fragment
    )> }
  )> }
);

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['String'];
  deleteDoc?: Maybe<Scalars['Boolean']>;
}>;


export type DeleteNoteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteNote'>
);

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['String'];
  note: Scalars['String'];
  files?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateNoteMutation = (
  { __typename?: 'Mutation' }
  & { updateNote?: Maybe<(
    { __typename?: 'CreateNoteResponse' }
    & { activity?: Maybe<(
      { __typename?: 'NoteActivity' }
      & FullNoteActivity_NoteActivity_Fragment
    )> }
  )> }
);

export type SetNotePinnedMutationVariables = Exact<{
  id: Scalars['String'];
  docId: Scalars['String'];
  pinned: Scalars['Boolean'];
}>;


export type SetNotePinnedMutation = (
  { __typename?: 'Mutation' }
  & { setNotePinned?: Maybe<(
    { __typename?: 'CreateNoteResponse' }
    & { activity?: Maybe<(
      { __typename?: 'NoteActivity' }
      & FullNoteActivity_NoteActivity_Fragment
    )> }
  )> }
);

export type SaveEventMutationVariables = Exact<{
  event: Scalars['JSON'];
  eventTemplate?: Maybe<Scalars['String']>;
}>;


export type SaveEventMutation = (
  { __typename?: 'Mutation' }
  & { saveEvent?: Maybe<(
    { __typename?: 'SaveEventResponse' }
    & { activity?: Maybe<(
      { __typename?: 'EventActivity' }
      & FullEventActivity_EventActivity_Fragment
    )> }
  )> }
);

export type CreatePaymentActivityMutationVariables = Exact<{
  ach?: Maybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  deposit?: Maybe<Scalars['Boolean']>;
  docId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerDetails?: Maybe<Scalars['JSON']>;
  isProcessing?: Maybe<Scalars['Boolean']>;
  isFailed?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['Float']>;
}>;


export type CreatePaymentActivityMutation = (
  { __typename?: 'Mutation' }
  & { createPaymentActivity?: Maybe<(
    { __typename?: 'CreatePaymentActivityResponse' }
    & { activity?: Maybe<(
      { __typename?: 'PaymentActivity' }
      & FullPaymentActivity_PaymentActivity_Fragment
    )> }
  )> }
);

type CommonActivityDetails_AcceptedActivityDetails_Fragment = (
  { __typename?: 'AcceptedActivityDetails' }
  & Pick<AcceptedActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_AssignmentActivityDetails_Fragment = (
  { __typename?: 'AssignmentActivityDetails' }
  & Pick<AssignmentActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_BasicActivityDetails_Fragment = (
  { __typename?: 'BasicActivityDetails' }
  & Pick<BasicActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_ChatMessageActivityDetails_Fragment = (
  { __typename?: 'ChatMessageActivityDetails' }
  & Pick<ChatMessageActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_DeclinedActivityDetails_Fragment = (
  { __typename?: 'DeclinedActivityDetails' }
  & Pick<DeclinedActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_EventActivityDetails_Fragment = (
  { __typename?: 'EventActivityDetails' }
  & Pick<EventActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_EventEmailSentActivityDetails_Fragment = (
  { __typename?: 'EventEmailSentActivityDetails' }
  & Pick<EventEmailSentActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_FileAddedActivityDetails_Fragment = (
  { __typename?: 'FileAddedActivityDetails' }
  & Pick<FileAddedActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_FollowUpSentActivityDetails_Fragment = (
  { __typename?: 'FollowUpSentActivityDetails' }
  & Pick<FollowUpSentActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment = (
  { __typename?: 'LeadFormSubmissionActivityDetails' }
  & Pick<LeadFormSubmissionActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_MessageActivityDetails_Fragment = (
  { __typename?: 'MessageActivityDetails' }
  & Pick<MessageActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_NoteActivityDetails_Fragment = (
  { __typename?: 'NoteActivityDetails' }
  & Pick<NoteActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_OwnerChangedActivityDetails_Fragment = (
  { __typename?: 'OwnerChangedActivityDetails' }
  & Pick<OwnerChangedActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_PaymentActivityDetails_Fragment = (
  { __typename?: 'PaymentActivityDetails' }
  & Pick<PaymentActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment = (
  { __typename?: 'PaymentReceivedSentActivityDetails' }
  & Pick<PaymentReceivedSentActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_PaymentRequestedActivityDetails_Fragment = (
  { __typename?: 'PaymentRequestedActivityDetails' }
  & Pick<PaymentRequestedActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_SentActivityDetails_Fragment = (
  { __typename?: 'SentActivityDetails' }
  & Pick<SentActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_StageChangedActivityDetails_Fragment = (
  { __typename?: 'StageChangedActivityDetails' }
  & Pick<StageChangedActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_TaskActivityDetails_Fragment = (
  { __typename?: 'TaskActivityDetails' }
  & Pick<TaskActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_ViewedActivityDetails_Fragment = (
  { __typename?: 'ViewedActivityDetails' }
  & Pick<ViewedActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

type CommonActivityDetails_WarningActivityDetails_Fragment = (
  { __typename?: 'WarningActivityDetails' }
  & Pick<WarningActivityDetails, 'activityType' | 'docType' | 'url' | 'events' | 'timestamp' | 'updated' | 'updatedInterval' | 'isAutomated'>
  & { quote?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, invoice?: Maybe<(
    { __typename?: 'ActivityQuote' }
    & Pick<ActivityQuote, 'id' | 'number' | 'status' | 'total' | 'error' | 'dealId'>
    & { int_ext?: Maybe<(
      { __typename?: 'QuoteType' }
      & Pick<QuoteType, 'value' | 'label'>
    )> }
  )>, deal?: Maybe<(
    { __typename?: 'ActivityDeal' }
    & Pick<ActivityDeal, 'id' | 'name' | 'total' | 'stage'>
  )>, contact?: Maybe<(
    { __typename?: 'ActivityContact' }
    & Pick<ActivityContact, 'id' | 'firstName' | 'lastName' | 'secondaryFirstName' | 'secondaryLastName' | 'email' | 'phoneNumber' | 'preferredContactMethod' | 'companyId' | 'companyName'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'title' | 'phoneNumber' | 'avatar'>
  )>, quoteOwner?: Maybe<(
    { __typename?: 'QuoteOwner' }
    & Pick<QuoteOwner, 'id' | 'firstName' | 'lastName' | 'title' | 'email' | 'phoneNumber' | 'avatar'>
  )> }
);

export type CommonActivityDetailsFragment = CommonActivityDetails_AcceptedActivityDetails_Fragment | CommonActivityDetails_AssignmentActivityDetails_Fragment | CommonActivityDetails_BasicActivityDetails_Fragment | CommonActivityDetails_ChatMessageActivityDetails_Fragment | CommonActivityDetails_DeclinedActivityDetails_Fragment | CommonActivityDetails_EventActivityDetails_Fragment | CommonActivityDetails_EventEmailSentActivityDetails_Fragment | CommonActivityDetails_FileAddedActivityDetails_Fragment | CommonActivityDetails_FollowUpSentActivityDetails_Fragment | CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment | CommonActivityDetails_MessageActivityDetails_Fragment | CommonActivityDetails_NoteActivityDetails_Fragment | CommonActivityDetails_OwnerChangedActivityDetails_Fragment | CommonActivityDetails_PaymentActivityDetails_Fragment | CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment | CommonActivityDetails_PaymentRequestedActivityDetails_Fragment | CommonActivityDetails_SentActivityDetails_Fragment | CommonActivityDetails_StageChangedActivityDetails_Fragment | CommonActivityDetails_TaskActivityDetails_Fragment | CommonActivityDetails_ViewedActivityDetails_Fragment | CommonActivityDetails_WarningActivityDetails_Fragment;

type FullActivity_AcceptedActivity_Fragment = (
  { __typename?: 'AcceptedActivity' }
  & Pick<AcceptedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'AcceptedActivityDetails' }
    & Pick<AcceptedActivityDetails, 'additional' | 'signature'>
    & CommonActivityDetails_AcceptedActivityDetails_Fragment
  ) }
);

type FullActivity_AssignmentActivity_Fragment = (
  { __typename?: 'AssignmentActivity' }
  & Pick<AssignmentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'AssignmentActivityDetails' }
    & Pick<AssignmentActivityDetails, 'assignees' | 'assigner'>
    & CommonActivityDetails_AssignmentActivityDetails_Fragment
  ) }
);

type FullActivity_BasicActivity_Fragment = (
  { __typename?: 'BasicActivity' }
  & Pick<BasicActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'BasicActivityDetails' }
    & CommonActivityDetails_BasicActivityDetails_Fragment
  ) }
);

type FullActivity_ChatMessageActivity_Fragment = (
  { __typename?: 'ChatMessageActivity' }
  & Pick<ChatMessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'ChatMessageActivityDetails' }
    & Pick<ChatMessageActivityDetails, 'rating' | 'undo'>
    & { chatMessage: (
      { __typename?: 'ChatMessage' }
      & Pick<ChatMessage, 'sender' | 'text' | 'toolCalls' | 'model' | 'error'>
      & { usage?: Maybe<(
        { __typename?: 'ChatMessageUsage' }
        & Pick<ChatMessageUsage, 'inputTokens' | 'outputTokens' | 'cacheReadTokens' | 'cacheCreationTokens' | 'estimatedCostUsd'>
      )> }
    ) }
    & CommonActivityDetails_ChatMessageActivityDetails_Fragment
  ) }
);

type FullActivity_DeclinedActivity_Fragment = (
  { __typename?: 'DeclinedActivity' }
  & Pick<DeclinedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'DeclinedActivityDetails' }
    & Pick<DeclinedActivityDetails, 'reason'>
    & CommonActivityDetails_DeclinedActivityDetails_Fragment
  ) }
);

type FullActivity_EventActivity_Fragment = (
  { __typename?: 'EventActivity' }
  & Pick<EventActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'EventActivityDetails' }
    & Pick<EventActivityDetails, 'eventType' | 'quoteType' | 'title' | 'address' | 'crew' | 'progress' | 'previousProgress' | 'production' | 'start' | 'end' | 'note' | 'canceled'>
    & { deal?: Maybe<(
      { __typename?: 'ActivityDeal' }
      & Pick<ActivityDeal, 'id' | 'source' | 'name' | 'total' | 'hours' | 'assignedUsers'>
    )>, jobAddress?: Maybe<(
      { __typename?: 'ActivityJobAddress' }
      & Pick<ActivityJobAddress, 'address' | 'city' | 'province' | 'postal'>
    )>, geocode?: Maybe<(
      { __typename?: 'EventGeocode' }
      & Pick<EventGeocode, 'lat' | 'lng'>
    )> }
    & CommonActivityDetails_EventActivityDetails_Fragment
  ) }
);

type FullActivity_EventEmailSentActivity_Fragment = (
  { __typename?: 'EventEmailSentActivity' }
  & Pick<EventEmailSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'EventEmailSentActivityDetails' }
    & Pick<EventEmailSentActivityDetails, 'eventType' | 'address' | 'start' | 'end' | 'note' | 'canceled'>
    & { email?: Maybe<(
      { __typename?: 'ActivityEmail' }
      & Pick<ActivityEmail, 'to' | 'subject' | 'content' | 'smsTo'>
    )>, geocode?: Maybe<(
      { __typename?: 'EventGeocode' }
      & Pick<EventGeocode, 'lat' | 'lng'>
    )> }
    & CommonActivityDetails_EventEmailSentActivityDetails_Fragment
  ) }
);

type FullActivity_FileAddedActivity_Fragment = (
  { __typename?: 'FileAddedActivity' }
  & Pick<FileAddedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'FileAddedActivityDetails' }
    & Pick<FileAddedActivityDetails, 'fileName' | 'fileCount'>
    & CommonActivityDetails_FileAddedActivityDetails_Fragment
  ) }
);

type FullActivity_FollowUpSentActivity_Fragment = (
  { __typename?: 'FollowUpSentActivity' }
  & Pick<FollowUpSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'FollowUpSentActivityDetails' }
    & Pick<FollowUpSentActivityDetails, 'smsTo' | 'text'>
    & { email?: Maybe<(
      { __typename?: 'ActivityEmail' }
      & Pick<ActivityEmail, 'to' | 'subject' | 'content' | 'smsTo'>
    )> }
    & CommonActivityDetails_FollowUpSentActivityDetails_Fragment
  ) }
);

type FullActivity_LeadFormSubmissionActivity_Fragment = (
  { __typename?: 'LeadFormSubmissionActivity' }
  & Pick<LeadFormSubmissionActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'LeadFormSubmissionActivityDetails' }
    & Pick<LeadFormSubmissionActivityDetails, 'note' | 'address' | 'formKey' | 'newStage' | 'leadSource' | 'acquisitionSource'>
    & { uploadedFiles?: Maybe<Array<(
      { __typename?: 'NoteActivityFile' }
      & Pick<NoteActivityFile, 'id' | 'name' | 'url' | 'type'>
    )>> }
    & CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment
  ) }
);

type FullActivity_MessageActivity_Fragment = (
  { __typename?: 'MessageActivity' }
  & Pick<MessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'MessageActivityDetails' }
    & { message: (
      { __typename?: 'ActivityMessage' }
      & Pick<ActivityMessage, 'deleted' | 'text' | 'readAt'>
      & { from: (
        { __typename?: 'ActivityMessageFrom' }
        & Pick<ActivityMessageFrom, 'userId' | 'name' | 'email' | 'isCustomer' | 'isAutomated'>
      ) }
    ) }
    & CommonActivityDetails_MessageActivityDetails_Fragment
  ) }
);

type FullActivity_NoteActivity_Fragment = (
  { __typename?: 'NoteActivity' }
  & Pick<NoteActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'NoteActivityDetails' }
    & Pick<NoteActivityDetails, 'note' | 'translations' | 'files' | 'legacyNote' | 'pinnedOn'>
    & { versions?: Maybe<Array<(
      { __typename?: 'NoteActivityVersion' }
      & Pick<NoteActivityVersion, 'timestamp' | 'note'>
      & { owner?: Maybe<(
        { __typename?: 'Owner' }
        & Pick<Owner, 'id' | 'firstName' | 'lastName'>
      )>, files?: Maybe<Array<(
        { __typename?: 'NoteActivityFile' }
        & Pick<NoteActivityFile, 'id' | 'name' | 'url' | 'type'>
      )>> }
    )>> }
    & CommonActivityDetails_NoteActivityDetails_Fragment
  ) }
);

type FullActivity_OwnerChangedActivity_Fragment = (
  { __typename?: 'OwnerChangedActivity' }
  & Pick<OwnerChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'OwnerChangedActivityDetails' }
    & { newOwner?: Maybe<(
      { __typename?: 'Owner' }
      & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
    )>, oldOwner?: Maybe<(
      { __typename?: 'Owner' }
      & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
    )> }
    & CommonActivityDetails_OwnerChangedActivityDetails_Fragment
  ) }
);

type FullActivity_PaymentActivity_Fragment = (
  { __typename?: 'PaymentActivity' }
  & Pick<PaymentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'PaymentActivityDetails' }
    & Pick<PaymentActivityDetails, 'amountPaid' | 'provider' | 'providerDetails' | 'note' | 'method' | 'deposit' | 'paymentDate' | 'paymentRequestId' | 'isProcessing' | 'isFailed' | 'isRefund' | 'originalAmount' | 'source' | 'surcharge'>
    & CommonActivityDetails_PaymentActivityDetails_Fragment
  ) }
);

type FullActivity_PaymentReceivedSentActivity_Fragment = (
  { __typename?: 'PaymentReceivedSentActivity' }
  & Pick<PaymentReceivedSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'PaymentReceivedSentActivityDetails' }
    & Pick<PaymentReceivedSentActivityDetails, 'amountPaid'>
    & { email?: Maybe<(
      { __typename?: 'ActivityEmail' }
      & Pick<ActivityEmail, 'to' | 'subject' | 'content' | 'smsTo'>
    )> }
    & CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment
  ) }
);

type FullActivity_PaymentRequestedActivity_Fragment = (
  { __typename?: 'PaymentRequestedActivity' }
  & Pick<PaymentRequestedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'PaymentRequestedActivityDetails' }
    & Pick<PaymentRequestedActivityDetails, 'amountRequested' | 'status' | 'note' | 'deposit' | 'smsTo' | 'lastSent'>
    & { email?: Maybe<(
      { __typename?: 'ActivityEmail' }
      & Pick<ActivityEmail, 'to' | 'subject' | 'content' | 'smsTo'>
    )> }
    & CommonActivityDetails_PaymentRequestedActivityDetails_Fragment
  ) }
);

type FullActivity_SentActivity_Fragment = (
  { __typename?: 'SentActivity' }
  & Pick<SentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'SentActivityDetails' }
    & Pick<SentActivityDetails, 'isWorkOrder'>
    & { email?: Maybe<(
      { __typename?: 'ActivityEmail' }
      & Pick<ActivityEmail, 'to' | 'subject' | 'content' | 'smsTo'>
    )> }
    & CommonActivityDetails_SentActivityDetails_Fragment
  ) }
);

type FullActivity_StageChangedActivity_Fragment = (
  { __typename?: 'StageChangedActivity' }
  & Pick<StageChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'StageChangedActivityDetails' }
    & Pick<StageChangedActivityDetails, 'oldStage' | 'newStage'>
    & CommonActivityDetails_StageChangedActivityDetails_Fragment
  ) }
);

type FullActivity_TaskActivity_Fragment = (
  { __typename?: 'TaskActivity' }
  & Pick<TaskActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'TaskActivityDetails' }
    & Pick<TaskActivityDetails, 'taskName' | 'templateId'>
    & CommonActivityDetails_TaskActivityDetails_Fragment
  ) }
);

type FullActivity_ViewedActivity_Fragment = (
  { __typename?: 'ViewedActivity' }
  & Pick<ViewedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'ViewedActivityDetails' }
    & Pick<ViewedActivityDetails, 'viewingEmail' | 'device'>
    & CommonActivityDetails_ViewedActivityDetails_Fragment
  ) }
);

type FullActivity_WarningActivity_Fragment = (
  { __typename?: 'WarningActivity' }
  & Pick<WarningActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds' | 'assignedUsers'>
  & { details: (
    { __typename?: 'WarningActivityDetails' }
    & Pick<WarningActivityDetails, 'warningMessage' | 'warningTitle'>
    & CommonActivityDetails_WarningActivityDetails_Fragment
  ) }
);

export type FullActivityFragment = FullActivity_AcceptedActivity_Fragment | FullActivity_AssignmentActivity_Fragment | FullActivity_BasicActivity_Fragment | FullActivity_ChatMessageActivity_Fragment | FullActivity_DeclinedActivity_Fragment | FullActivity_EventActivity_Fragment | FullActivity_EventEmailSentActivity_Fragment | FullActivity_FileAddedActivity_Fragment | FullActivity_FollowUpSentActivity_Fragment | FullActivity_LeadFormSubmissionActivity_Fragment | FullActivity_MessageActivity_Fragment | FullActivity_NoteActivity_Fragment | FullActivity_OwnerChangedActivity_Fragment | FullActivity_PaymentActivity_Fragment | FullActivity_PaymentReceivedSentActivity_Fragment | FullActivity_PaymentRequestedActivity_Fragment | FullActivity_SentActivity_Fragment | FullActivity_StageChangedActivity_Fragment | FullActivity_TaskActivity_Fragment | FullActivity_ViewedActivity_Fragment | FullActivity_WarningActivity_Fragment;

type FullNoteActivity_AcceptedActivity_Fragment = (
  { __typename?: 'AcceptedActivity' }
  & Pick<AcceptedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AcceptedActivityDetails' }
    & CommonActivityDetails_AcceptedActivityDetails_Fragment
  ) }
);

type FullNoteActivity_AssignmentActivity_Fragment = (
  { __typename?: 'AssignmentActivity' }
  & Pick<AssignmentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AssignmentActivityDetails' }
    & CommonActivityDetails_AssignmentActivityDetails_Fragment
  ) }
);

type FullNoteActivity_BasicActivity_Fragment = (
  { __typename?: 'BasicActivity' }
  & Pick<BasicActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'BasicActivityDetails' }
    & CommonActivityDetails_BasicActivityDetails_Fragment
  ) }
);

type FullNoteActivity_ChatMessageActivity_Fragment = (
  { __typename?: 'ChatMessageActivity' }
  & Pick<ChatMessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ChatMessageActivityDetails' }
    & CommonActivityDetails_ChatMessageActivityDetails_Fragment
  ) }
);

type FullNoteActivity_DeclinedActivity_Fragment = (
  { __typename?: 'DeclinedActivity' }
  & Pick<DeclinedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'DeclinedActivityDetails' }
    & CommonActivityDetails_DeclinedActivityDetails_Fragment
  ) }
);

type FullNoteActivity_EventActivity_Fragment = (
  { __typename?: 'EventActivity' }
  & Pick<EventActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventActivityDetails' }
    & CommonActivityDetails_EventActivityDetails_Fragment
  ) }
);

type FullNoteActivity_EventEmailSentActivity_Fragment = (
  { __typename?: 'EventEmailSentActivity' }
  & Pick<EventEmailSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventEmailSentActivityDetails' }
    & CommonActivityDetails_EventEmailSentActivityDetails_Fragment
  ) }
);

type FullNoteActivity_FileAddedActivity_Fragment = (
  { __typename?: 'FileAddedActivity' }
  & Pick<FileAddedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FileAddedActivityDetails' }
    & CommonActivityDetails_FileAddedActivityDetails_Fragment
  ) }
);

type FullNoteActivity_FollowUpSentActivity_Fragment = (
  { __typename?: 'FollowUpSentActivity' }
  & Pick<FollowUpSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FollowUpSentActivityDetails' }
    & CommonActivityDetails_FollowUpSentActivityDetails_Fragment
  ) }
);

type FullNoteActivity_LeadFormSubmissionActivity_Fragment = (
  { __typename?: 'LeadFormSubmissionActivity' }
  & Pick<LeadFormSubmissionActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'LeadFormSubmissionActivityDetails' }
    & CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment
  ) }
);

type FullNoteActivity_MessageActivity_Fragment = (
  { __typename?: 'MessageActivity' }
  & Pick<MessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'MessageActivityDetails' }
    & CommonActivityDetails_MessageActivityDetails_Fragment
  ) }
);

type FullNoteActivity_NoteActivity_Fragment = (
  { __typename?: 'NoteActivity' }
  & Pick<NoteActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'NoteActivityDetails' }
    & Pick<NoteActivityDetails, 'note' | 'translations' | 'files' | 'legacyNote' | 'pinnedOn'>
    & { versions?: Maybe<Array<(
      { __typename?: 'NoteActivityVersion' }
      & Pick<NoteActivityVersion, 'timestamp' | 'note'>
      & { owner?: Maybe<(
        { __typename?: 'Owner' }
        & Pick<Owner, 'id' | 'firstName' | 'lastName'>
      )>, files?: Maybe<Array<(
        { __typename?: 'NoteActivityFile' }
        & Pick<NoteActivityFile, 'id' | 'name' | 'url' | 'type'>
      )>> }
    )>> }
    & CommonActivityDetails_NoteActivityDetails_Fragment
  ) }
);

type FullNoteActivity_OwnerChangedActivity_Fragment = (
  { __typename?: 'OwnerChangedActivity' }
  & Pick<OwnerChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'OwnerChangedActivityDetails' }
    & CommonActivityDetails_OwnerChangedActivityDetails_Fragment
  ) }
);

type FullNoteActivity_PaymentActivity_Fragment = (
  { __typename?: 'PaymentActivity' }
  & Pick<PaymentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentActivityDetails' }
    & CommonActivityDetails_PaymentActivityDetails_Fragment
  ) }
);

type FullNoteActivity_PaymentReceivedSentActivity_Fragment = (
  { __typename?: 'PaymentReceivedSentActivity' }
  & Pick<PaymentReceivedSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentReceivedSentActivityDetails' }
    & CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment
  ) }
);

type FullNoteActivity_PaymentRequestedActivity_Fragment = (
  { __typename?: 'PaymentRequestedActivity' }
  & Pick<PaymentRequestedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentRequestedActivityDetails' }
    & CommonActivityDetails_PaymentRequestedActivityDetails_Fragment
  ) }
);

type FullNoteActivity_SentActivity_Fragment = (
  { __typename?: 'SentActivity' }
  & Pick<SentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'SentActivityDetails' }
    & CommonActivityDetails_SentActivityDetails_Fragment
  ) }
);

type FullNoteActivity_StageChangedActivity_Fragment = (
  { __typename?: 'StageChangedActivity' }
  & Pick<StageChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'StageChangedActivityDetails' }
    & CommonActivityDetails_StageChangedActivityDetails_Fragment
  ) }
);

type FullNoteActivity_TaskActivity_Fragment = (
  { __typename?: 'TaskActivity' }
  & Pick<TaskActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'TaskActivityDetails' }
    & CommonActivityDetails_TaskActivityDetails_Fragment
  ) }
);

type FullNoteActivity_ViewedActivity_Fragment = (
  { __typename?: 'ViewedActivity' }
  & Pick<ViewedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ViewedActivityDetails' }
    & CommonActivityDetails_ViewedActivityDetails_Fragment
  ) }
);

type FullNoteActivity_WarningActivity_Fragment = (
  { __typename?: 'WarningActivity' }
  & Pick<WarningActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'WarningActivityDetails' }
    & CommonActivityDetails_WarningActivityDetails_Fragment
  ) }
);

export type FullNoteActivityFragment = FullNoteActivity_AcceptedActivity_Fragment | FullNoteActivity_AssignmentActivity_Fragment | FullNoteActivity_BasicActivity_Fragment | FullNoteActivity_ChatMessageActivity_Fragment | FullNoteActivity_DeclinedActivity_Fragment | FullNoteActivity_EventActivity_Fragment | FullNoteActivity_EventEmailSentActivity_Fragment | FullNoteActivity_FileAddedActivity_Fragment | FullNoteActivity_FollowUpSentActivity_Fragment | FullNoteActivity_LeadFormSubmissionActivity_Fragment | FullNoteActivity_MessageActivity_Fragment | FullNoteActivity_NoteActivity_Fragment | FullNoteActivity_OwnerChangedActivity_Fragment | FullNoteActivity_PaymentActivity_Fragment | FullNoteActivity_PaymentReceivedSentActivity_Fragment | FullNoteActivity_PaymentRequestedActivity_Fragment | FullNoteActivity_SentActivity_Fragment | FullNoteActivity_StageChangedActivity_Fragment | FullNoteActivity_TaskActivity_Fragment | FullNoteActivity_ViewedActivity_Fragment | FullNoteActivity_WarningActivity_Fragment;

type FullMessageActivity_AcceptedActivity_Fragment = (
  { __typename?: 'AcceptedActivity' }
  & Pick<AcceptedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AcceptedActivityDetails' }
    & CommonActivityDetails_AcceptedActivityDetails_Fragment
  ) }
);

type FullMessageActivity_AssignmentActivity_Fragment = (
  { __typename?: 'AssignmentActivity' }
  & Pick<AssignmentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AssignmentActivityDetails' }
    & CommonActivityDetails_AssignmentActivityDetails_Fragment
  ) }
);

type FullMessageActivity_BasicActivity_Fragment = (
  { __typename?: 'BasicActivity' }
  & Pick<BasicActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'BasicActivityDetails' }
    & CommonActivityDetails_BasicActivityDetails_Fragment
  ) }
);

type FullMessageActivity_ChatMessageActivity_Fragment = (
  { __typename?: 'ChatMessageActivity' }
  & Pick<ChatMessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ChatMessageActivityDetails' }
    & CommonActivityDetails_ChatMessageActivityDetails_Fragment
  ) }
);

type FullMessageActivity_DeclinedActivity_Fragment = (
  { __typename?: 'DeclinedActivity' }
  & Pick<DeclinedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'DeclinedActivityDetails' }
    & CommonActivityDetails_DeclinedActivityDetails_Fragment
  ) }
);

type FullMessageActivity_EventActivity_Fragment = (
  { __typename?: 'EventActivity' }
  & Pick<EventActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventActivityDetails' }
    & CommonActivityDetails_EventActivityDetails_Fragment
  ) }
);

type FullMessageActivity_EventEmailSentActivity_Fragment = (
  { __typename?: 'EventEmailSentActivity' }
  & Pick<EventEmailSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventEmailSentActivityDetails' }
    & CommonActivityDetails_EventEmailSentActivityDetails_Fragment
  ) }
);

type FullMessageActivity_FileAddedActivity_Fragment = (
  { __typename?: 'FileAddedActivity' }
  & Pick<FileAddedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FileAddedActivityDetails' }
    & CommonActivityDetails_FileAddedActivityDetails_Fragment
  ) }
);

type FullMessageActivity_FollowUpSentActivity_Fragment = (
  { __typename?: 'FollowUpSentActivity' }
  & Pick<FollowUpSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FollowUpSentActivityDetails' }
    & CommonActivityDetails_FollowUpSentActivityDetails_Fragment
  ) }
);

type FullMessageActivity_LeadFormSubmissionActivity_Fragment = (
  { __typename?: 'LeadFormSubmissionActivity' }
  & Pick<LeadFormSubmissionActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'LeadFormSubmissionActivityDetails' }
    & CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment
  ) }
);

type FullMessageActivity_MessageActivity_Fragment = (
  { __typename?: 'MessageActivity' }
  & Pick<MessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'MessageActivityDetails' }
    & { message: (
      { __typename?: 'ActivityMessage' }
      & Pick<ActivityMessage, 'deleted' | 'text' | 'readAt' | 'smsTo'>
      & { from: (
        { __typename?: 'ActivityMessageFrom' }
        & Pick<ActivityMessageFrom, 'userId' | 'name' | 'email' | 'isCustomer' | 'isAutomated' | 'avatar'>
      ) }
    ) }
    & CommonActivityDetails_MessageActivityDetails_Fragment
  ) }
);

type FullMessageActivity_NoteActivity_Fragment = (
  { __typename?: 'NoteActivity' }
  & Pick<NoteActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'NoteActivityDetails' }
    & CommonActivityDetails_NoteActivityDetails_Fragment
  ) }
);

type FullMessageActivity_OwnerChangedActivity_Fragment = (
  { __typename?: 'OwnerChangedActivity' }
  & Pick<OwnerChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'OwnerChangedActivityDetails' }
    & CommonActivityDetails_OwnerChangedActivityDetails_Fragment
  ) }
);

type FullMessageActivity_PaymentActivity_Fragment = (
  { __typename?: 'PaymentActivity' }
  & Pick<PaymentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentActivityDetails' }
    & CommonActivityDetails_PaymentActivityDetails_Fragment
  ) }
);

type FullMessageActivity_PaymentReceivedSentActivity_Fragment = (
  { __typename?: 'PaymentReceivedSentActivity' }
  & Pick<PaymentReceivedSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentReceivedSentActivityDetails' }
    & CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment
  ) }
);

type FullMessageActivity_PaymentRequestedActivity_Fragment = (
  { __typename?: 'PaymentRequestedActivity' }
  & Pick<PaymentRequestedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentRequestedActivityDetails' }
    & CommonActivityDetails_PaymentRequestedActivityDetails_Fragment
  ) }
);

type FullMessageActivity_SentActivity_Fragment = (
  { __typename?: 'SentActivity' }
  & Pick<SentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'SentActivityDetails' }
    & CommonActivityDetails_SentActivityDetails_Fragment
  ) }
);

type FullMessageActivity_StageChangedActivity_Fragment = (
  { __typename?: 'StageChangedActivity' }
  & Pick<StageChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'StageChangedActivityDetails' }
    & CommonActivityDetails_StageChangedActivityDetails_Fragment
  ) }
);

type FullMessageActivity_TaskActivity_Fragment = (
  { __typename?: 'TaskActivity' }
  & Pick<TaskActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'TaskActivityDetails' }
    & CommonActivityDetails_TaskActivityDetails_Fragment
  ) }
);

type FullMessageActivity_ViewedActivity_Fragment = (
  { __typename?: 'ViewedActivity' }
  & Pick<ViewedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ViewedActivityDetails' }
    & CommonActivityDetails_ViewedActivityDetails_Fragment
  ) }
);

type FullMessageActivity_WarningActivity_Fragment = (
  { __typename?: 'WarningActivity' }
  & Pick<WarningActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'WarningActivityDetails' }
    & CommonActivityDetails_WarningActivityDetails_Fragment
  ) }
);

export type FullMessageActivityFragment = FullMessageActivity_AcceptedActivity_Fragment | FullMessageActivity_AssignmentActivity_Fragment | FullMessageActivity_BasicActivity_Fragment | FullMessageActivity_ChatMessageActivity_Fragment | FullMessageActivity_DeclinedActivity_Fragment | FullMessageActivity_EventActivity_Fragment | FullMessageActivity_EventEmailSentActivity_Fragment | FullMessageActivity_FileAddedActivity_Fragment | FullMessageActivity_FollowUpSentActivity_Fragment | FullMessageActivity_LeadFormSubmissionActivity_Fragment | FullMessageActivity_MessageActivity_Fragment | FullMessageActivity_NoteActivity_Fragment | FullMessageActivity_OwnerChangedActivity_Fragment | FullMessageActivity_PaymentActivity_Fragment | FullMessageActivity_PaymentReceivedSentActivity_Fragment | FullMessageActivity_PaymentRequestedActivity_Fragment | FullMessageActivity_SentActivity_Fragment | FullMessageActivity_StageChangedActivity_Fragment | FullMessageActivity_TaskActivity_Fragment | FullMessageActivity_ViewedActivity_Fragment | FullMessageActivity_WarningActivity_Fragment;

type FullPaymentActivity_AcceptedActivity_Fragment = (
  { __typename?: 'AcceptedActivity' }
  & Pick<AcceptedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AcceptedActivityDetails' }
    & CommonActivityDetails_AcceptedActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_AssignmentActivity_Fragment = (
  { __typename?: 'AssignmentActivity' }
  & Pick<AssignmentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AssignmentActivityDetails' }
    & CommonActivityDetails_AssignmentActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_BasicActivity_Fragment = (
  { __typename?: 'BasicActivity' }
  & Pick<BasicActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'BasicActivityDetails' }
    & CommonActivityDetails_BasicActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_ChatMessageActivity_Fragment = (
  { __typename?: 'ChatMessageActivity' }
  & Pick<ChatMessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ChatMessageActivityDetails' }
    & CommonActivityDetails_ChatMessageActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_DeclinedActivity_Fragment = (
  { __typename?: 'DeclinedActivity' }
  & Pick<DeclinedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'DeclinedActivityDetails' }
    & CommonActivityDetails_DeclinedActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_EventActivity_Fragment = (
  { __typename?: 'EventActivity' }
  & Pick<EventActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventActivityDetails' }
    & CommonActivityDetails_EventActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_EventEmailSentActivity_Fragment = (
  { __typename?: 'EventEmailSentActivity' }
  & Pick<EventEmailSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventEmailSentActivityDetails' }
    & CommonActivityDetails_EventEmailSentActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_FileAddedActivity_Fragment = (
  { __typename?: 'FileAddedActivity' }
  & Pick<FileAddedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FileAddedActivityDetails' }
    & CommonActivityDetails_FileAddedActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_FollowUpSentActivity_Fragment = (
  { __typename?: 'FollowUpSentActivity' }
  & Pick<FollowUpSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FollowUpSentActivityDetails' }
    & CommonActivityDetails_FollowUpSentActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_LeadFormSubmissionActivity_Fragment = (
  { __typename?: 'LeadFormSubmissionActivity' }
  & Pick<LeadFormSubmissionActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'LeadFormSubmissionActivityDetails' }
    & CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_MessageActivity_Fragment = (
  { __typename?: 'MessageActivity' }
  & Pick<MessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'MessageActivityDetails' }
    & CommonActivityDetails_MessageActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_NoteActivity_Fragment = (
  { __typename?: 'NoteActivity' }
  & Pick<NoteActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'NoteActivityDetails' }
    & CommonActivityDetails_NoteActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_OwnerChangedActivity_Fragment = (
  { __typename?: 'OwnerChangedActivity' }
  & Pick<OwnerChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'OwnerChangedActivityDetails' }
    & CommonActivityDetails_OwnerChangedActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_PaymentActivity_Fragment = (
  { __typename?: 'PaymentActivity' }
  & Pick<PaymentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentActivityDetails' }
    & Pick<PaymentActivityDetails, 'amountPaid' | 'provider' | 'providerDetails' | 'note' | 'method' | 'deposit' | 'paymentDate' | 'paymentRequestId' | 'isProcessing' | 'isFailed' | 'isRefund' | 'originalAmount' | 'source' | 'surcharge' | 'trashed'>
    & CommonActivityDetails_PaymentActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_PaymentReceivedSentActivity_Fragment = (
  { __typename?: 'PaymentReceivedSentActivity' }
  & Pick<PaymentReceivedSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentReceivedSentActivityDetails' }
    & CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_PaymentRequestedActivity_Fragment = (
  { __typename?: 'PaymentRequestedActivity' }
  & Pick<PaymentRequestedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentRequestedActivityDetails' }
    & CommonActivityDetails_PaymentRequestedActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_SentActivity_Fragment = (
  { __typename?: 'SentActivity' }
  & Pick<SentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'SentActivityDetails' }
    & CommonActivityDetails_SentActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_StageChangedActivity_Fragment = (
  { __typename?: 'StageChangedActivity' }
  & Pick<StageChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'StageChangedActivityDetails' }
    & CommonActivityDetails_StageChangedActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_TaskActivity_Fragment = (
  { __typename?: 'TaskActivity' }
  & Pick<TaskActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'TaskActivityDetails' }
    & CommonActivityDetails_TaskActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_ViewedActivity_Fragment = (
  { __typename?: 'ViewedActivity' }
  & Pick<ViewedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ViewedActivityDetails' }
    & CommonActivityDetails_ViewedActivityDetails_Fragment
  ) }
);

type FullPaymentActivity_WarningActivity_Fragment = (
  { __typename?: 'WarningActivity' }
  & Pick<WarningActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'WarningActivityDetails' }
    & CommonActivityDetails_WarningActivityDetails_Fragment
  ) }
);

export type FullPaymentActivityFragment = FullPaymentActivity_AcceptedActivity_Fragment | FullPaymentActivity_AssignmentActivity_Fragment | FullPaymentActivity_BasicActivity_Fragment | FullPaymentActivity_ChatMessageActivity_Fragment | FullPaymentActivity_DeclinedActivity_Fragment | FullPaymentActivity_EventActivity_Fragment | FullPaymentActivity_EventEmailSentActivity_Fragment | FullPaymentActivity_FileAddedActivity_Fragment | FullPaymentActivity_FollowUpSentActivity_Fragment | FullPaymentActivity_LeadFormSubmissionActivity_Fragment | FullPaymentActivity_MessageActivity_Fragment | FullPaymentActivity_NoteActivity_Fragment | FullPaymentActivity_OwnerChangedActivity_Fragment | FullPaymentActivity_PaymentActivity_Fragment | FullPaymentActivity_PaymentReceivedSentActivity_Fragment | FullPaymentActivity_PaymentRequestedActivity_Fragment | FullPaymentActivity_SentActivity_Fragment | FullPaymentActivity_StageChangedActivity_Fragment | FullPaymentActivity_TaskActivity_Fragment | FullPaymentActivity_ViewedActivity_Fragment | FullPaymentActivity_WarningActivity_Fragment;

type FullChatMessageActivity_AcceptedActivity_Fragment = (
  { __typename?: 'AcceptedActivity' }
  & Pick<AcceptedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AcceptedActivityDetails' }
    & CommonActivityDetails_AcceptedActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_AssignmentActivity_Fragment = (
  { __typename?: 'AssignmentActivity' }
  & Pick<AssignmentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AssignmentActivityDetails' }
    & CommonActivityDetails_AssignmentActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_BasicActivity_Fragment = (
  { __typename?: 'BasicActivity' }
  & Pick<BasicActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'BasicActivityDetails' }
    & CommonActivityDetails_BasicActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_ChatMessageActivity_Fragment = (
  { __typename?: 'ChatMessageActivity' }
  & Pick<ChatMessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ChatMessageActivityDetails' }
    & Pick<ChatMessageActivityDetails, 'rating' | 'feedback' | 'undo' | 'conversationTitle'>
    & { chatMessage: (
      { __typename?: 'ChatMessage' }
      & Pick<ChatMessage, 'sender' | 'text' | 'toolCalls' | 'model' | 'error'>
      & { usage?: Maybe<(
        { __typename?: 'ChatMessageUsage' }
        & Pick<ChatMessageUsage, 'inputTokens' | 'outputTokens' | 'cacheReadTokens' | 'cacheCreationTokens' | 'estimatedCostUsd'>
      )> }
    ) }
    & CommonActivityDetails_ChatMessageActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_DeclinedActivity_Fragment = (
  { __typename?: 'DeclinedActivity' }
  & Pick<DeclinedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'DeclinedActivityDetails' }
    & CommonActivityDetails_DeclinedActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_EventActivity_Fragment = (
  { __typename?: 'EventActivity' }
  & Pick<EventActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventActivityDetails' }
    & CommonActivityDetails_EventActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_EventEmailSentActivity_Fragment = (
  { __typename?: 'EventEmailSentActivity' }
  & Pick<EventEmailSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventEmailSentActivityDetails' }
    & CommonActivityDetails_EventEmailSentActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_FileAddedActivity_Fragment = (
  { __typename?: 'FileAddedActivity' }
  & Pick<FileAddedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FileAddedActivityDetails' }
    & CommonActivityDetails_FileAddedActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_FollowUpSentActivity_Fragment = (
  { __typename?: 'FollowUpSentActivity' }
  & Pick<FollowUpSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FollowUpSentActivityDetails' }
    & CommonActivityDetails_FollowUpSentActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_LeadFormSubmissionActivity_Fragment = (
  { __typename?: 'LeadFormSubmissionActivity' }
  & Pick<LeadFormSubmissionActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'LeadFormSubmissionActivityDetails' }
    & CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_MessageActivity_Fragment = (
  { __typename?: 'MessageActivity' }
  & Pick<MessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'MessageActivityDetails' }
    & CommonActivityDetails_MessageActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_NoteActivity_Fragment = (
  { __typename?: 'NoteActivity' }
  & Pick<NoteActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'NoteActivityDetails' }
    & CommonActivityDetails_NoteActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_OwnerChangedActivity_Fragment = (
  { __typename?: 'OwnerChangedActivity' }
  & Pick<OwnerChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'OwnerChangedActivityDetails' }
    & CommonActivityDetails_OwnerChangedActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_PaymentActivity_Fragment = (
  { __typename?: 'PaymentActivity' }
  & Pick<PaymentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentActivityDetails' }
    & CommonActivityDetails_PaymentActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_PaymentReceivedSentActivity_Fragment = (
  { __typename?: 'PaymentReceivedSentActivity' }
  & Pick<PaymentReceivedSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentReceivedSentActivityDetails' }
    & CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_PaymentRequestedActivity_Fragment = (
  { __typename?: 'PaymentRequestedActivity' }
  & Pick<PaymentRequestedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentRequestedActivityDetails' }
    & CommonActivityDetails_PaymentRequestedActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_SentActivity_Fragment = (
  { __typename?: 'SentActivity' }
  & Pick<SentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'SentActivityDetails' }
    & CommonActivityDetails_SentActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_StageChangedActivity_Fragment = (
  { __typename?: 'StageChangedActivity' }
  & Pick<StageChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'StageChangedActivityDetails' }
    & CommonActivityDetails_StageChangedActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_TaskActivity_Fragment = (
  { __typename?: 'TaskActivity' }
  & Pick<TaskActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'TaskActivityDetails' }
    & CommonActivityDetails_TaskActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_ViewedActivity_Fragment = (
  { __typename?: 'ViewedActivity' }
  & Pick<ViewedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ViewedActivityDetails' }
    & CommonActivityDetails_ViewedActivityDetails_Fragment
  ) }
);

type FullChatMessageActivity_WarningActivity_Fragment = (
  { __typename?: 'WarningActivity' }
  & Pick<WarningActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'WarningActivityDetails' }
    & CommonActivityDetails_WarningActivityDetails_Fragment
  ) }
);

export type FullChatMessageActivityFragment = FullChatMessageActivity_AcceptedActivity_Fragment | FullChatMessageActivity_AssignmentActivity_Fragment | FullChatMessageActivity_BasicActivity_Fragment | FullChatMessageActivity_ChatMessageActivity_Fragment | FullChatMessageActivity_DeclinedActivity_Fragment | FullChatMessageActivity_EventActivity_Fragment | FullChatMessageActivity_EventEmailSentActivity_Fragment | FullChatMessageActivity_FileAddedActivity_Fragment | FullChatMessageActivity_FollowUpSentActivity_Fragment | FullChatMessageActivity_LeadFormSubmissionActivity_Fragment | FullChatMessageActivity_MessageActivity_Fragment | FullChatMessageActivity_NoteActivity_Fragment | FullChatMessageActivity_OwnerChangedActivity_Fragment | FullChatMessageActivity_PaymentActivity_Fragment | FullChatMessageActivity_PaymentReceivedSentActivity_Fragment | FullChatMessageActivity_PaymentRequestedActivity_Fragment | FullChatMessageActivity_SentActivity_Fragment | FullChatMessageActivity_StageChangedActivity_Fragment | FullChatMessageActivity_TaskActivity_Fragment | FullChatMessageActivity_ViewedActivity_Fragment | FullChatMessageActivity_WarningActivity_Fragment;

export type RateChatMessageMutationVariables = Exact<{
  activityId: Scalars['String'];
  rating?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
}>;


export type RateChatMessageMutation = (
  { __typename?: 'Mutation' }
  & { rateChatMessage?: Maybe<(
    { __typename?: 'AcceptedActivity' }
    & FullChatMessageActivity_AcceptedActivity_Fragment
  ) | (
    { __typename?: 'AssignmentActivity' }
    & FullChatMessageActivity_AssignmentActivity_Fragment
  ) | (
    { __typename?: 'BasicActivity' }
    & FullChatMessageActivity_BasicActivity_Fragment
  ) | (
    { __typename?: 'ChatMessageActivity' }
    & FullChatMessageActivity_ChatMessageActivity_Fragment
  ) | (
    { __typename?: 'DeclinedActivity' }
    & FullChatMessageActivity_DeclinedActivity_Fragment
  ) | (
    { __typename?: 'EventActivity' }
    & FullChatMessageActivity_EventActivity_Fragment
  ) | (
    { __typename?: 'EventEmailSentActivity' }
    & FullChatMessageActivity_EventEmailSentActivity_Fragment
  ) | (
    { __typename?: 'FileAddedActivity' }
    & FullChatMessageActivity_FileAddedActivity_Fragment
  ) | (
    { __typename?: 'FollowUpSentActivity' }
    & FullChatMessageActivity_FollowUpSentActivity_Fragment
  ) | (
    { __typename?: 'LeadFormSubmissionActivity' }
    & FullChatMessageActivity_LeadFormSubmissionActivity_Fragment
  ) | (
    { __typename?: 'MessageActivity' }
    & FullChatMessageActivity_MessageActivity_Fragment
  ) | (
    { __typename?: 'NoteActivity' }
    & FullChatMessageActivity_NoteActivity_Fragment
  ) | (
    { __typename?: 'OwnerChangedActivity' }
    & FullChatMessageActivity_OwnerChangedActivity_Fragment
  ) | (
    { __typename?: 'PaymentActivity' }
    & FullChatMessageActivity_PaymentActivity_Fragment
  ) | (
    { __typename?: 'PaymentReceivedSentActivity' }
    & FullChatMessageActivity_PaymentReceivedSentActivity_Fragment
  ) | (
    { __typename?: 'PaymentRequestedActivity' }
    & FullChatMessageActivity_PaymentRequestedActivity_Fragment
  ) | (
    { __typename?: 'SentActivity' }
    & FullChatMessageActivity_SentActivity_Fragment
  ) | (
    { __typename?: 'StageChangedActivity' }
    & FullChatMessageActivity_StageChangedActivity_Fragment
  ) | (
    { __typename?: 'TaskActivity' }
    & FullChatMessageActivity_TaskActivity_Fragment
  ) | (
    { __typename?: 'ViewedActivity' }
    & FullChatMessageActivity_ViewedActivity_Fragment
  ) | (
    { __typename?: 'WarningActivity' }
    & FullChatMessageActivity_WarningActivity_Fragment
  )> }
);

export type UndoChatMessagesMutationVariables = Exact<{
  activityIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UndoChatMessagesMutation = (
  { __typename?: 'Mutation' }
  & { undoChatMessages?: Maybe<Array<Maybe<(
    { __typename?: 'AcceptedActivity' }
    & FullChatMessageActivity_AcceptedActivity_Fragment
  ) | (
    { __typename?: 'AssignmentActivity' }
    & FullChatMessageActivity_AssignmentActivity_Fragment
  ) | (
    { __typename?: 'BasicActivity' }
    & FullChatMessageActivity_BasicActivity_Fragment
  ) | (
    { __typename?: 'ChatMessageActivity' }
    & FullChatMessageActivity_ChatMessageActivity_Fragment
  ) | (
    { __typename?: 'DeclinedActivity' }
    & FullChatMessageActivity_DeclinedActivity_Fragment
  ) | (
    { __typename?: 'EventActivity' }
    & FullChatMessageActivity_EventActivity_Fragment
  ) | (
    { __typename?: 'EventEmailSentActivity' }
    & FullChatMessageActivity_EventEmailSentActivity_Fragment
  ) | (
    { __typename?: 'FileAddedActivity' }
    & FullChatMessageActivity_FileAddedActivity_Fragment
  ) | (
    { __typename?: 'FollowUpSentActivity' }
    & FullChatMessageActivity_FollowUpSentActivity_Fragment
  ) | (
    { __typename?: 'LeadFormSubmissionActivity' }
    & FullChatMessageActivity_LeadFormSubmissionActivity_Fragment
  ) | (
    { __typename?: 'MessageActivity' }
    & FullChatMessageActivity_MessageActivity_Fragment
  ) | (
    { __typename?: 'NoteActivity' }
    & FullChatMessageActivity_NoteActivity_Fragment
  ) | (
    { __typename?: 'OwnerChangedActivity' }
    & FullChatMessageActivity_OwnerChangedActivity_Fragment
  ) | (
    { __typename?: 'PaymentActivity' }
    & FullChatMessageActivity_PaymentActivity_Fragment
  ) | (
    { __typename?: 'PaymentReceivedSentActivity' }
    & FullChatMessageActivity_PaymentReceivedSentActivity_Fragment
  ) | (
    { __typename?: 'PaymentRequestedActivity' }
    & FullChatMessageActivity_PaymentRequestedActivity_Fragment
  ) | (
    { __typename?: 'SentActivity' }
    & FullChatMessageActivity_SentActivity_Fragment
  ) | (
    { __typename?: 'StageChangedActivity' }
    & FullChatMessageActivity_StageChangedActivity_Fragment
  ) | (
    { __typename?: 'TaskActivity' }
    & FullChatMessageActivity_TaskActivity_Fragment
  ) | (
    { __typename?: 'ViewedActivity' }
    & FullChatMessageActivity_ViewedActivity_Fragment
  ) | (
    { __typename?: 'WarningActivity' }
    & FullChatMessageActivity_WarningActivity_Fragment
  )>>> }
);

type FullEventActivity_AcceptedActivity_Fragment = (
  { __typename?: 'AcceptedActivity' }
  & Pick<AcceptedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AcceptedActivityDetails' }
    & CommonActivityDetails_AcceptedActivityDetails_Fragment
  ) }
);

type FullEventActivity_AssignmentActivity_Fragment = (
  { __typename?: 'AssignmentActivity' }
  & Pick<AssignmentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'AssignmentActivityDetails' }
    & CommonActivityDetails_AssignmentActivityDetails_Fragment
  ) }
);

type FullEventActivity_BasicActivity_Fragment = (
  { __typename?: 'BasicActivity' }
  & Pick<BasicActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'BasicActivityDetails' }
    & CommonActivityDetails_BasicActivityDetails_Fragment
  ) }
);

type FullEventActivity_ChatMessageActivity_Fragment = (
  { __typename?: 'ChatMessageActivity' }
  & Pick<ChatMessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ChatMessageActivityDetails' }
    & CommonActivityDetails_ChatMessageActivityDetails_Fragment
  ) }
);

type FullEventActivity_DeclinedActivity_Fragment = (
  { __typename?: 'DeclinedActivity' }
  & Pick<DeclinedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'DeclinedActivityDetails' }
    & CommonActivityDetails_DeclinedActivityDetails_Fragment
  ) }
);

type FullEventActivity_EventActivity_Fragment = (
  { __typename?: 'EventActivity' }
  & Pick<EventActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventActivityDetails' }
    & Pick<EventActivityDetails, 'quoteType' | 'eventType' | 'attendees' | 'title' | 'crew' | 'progress' | 'previousProgress' | 'address' | 'production' | 'start' | 'end' | 'note' | 'canceled'>
    & { deal?: Maybe<(
      { __typename?: 'ActivityDeal' }
      & Pick<ActivityDeal, 'id' | 'source' | 'name' | 'total' | 'hours' | 'tags' | 'assignedUsers'>
    )>, geocode?: Maybe<(
      { __typename?: 'EventGeocode' }
      & Pick<EventGeocode, 'lat' | 'lng'>
    )> }
    & CommonActivityDetails_EventActivityDetails_Fragment
  ) }
);

type FullEventActivity_EventEmailSentActivity_Fragment = (
  { __typename?: 'EventEmailSentActivity' }
  & Pick<EventEmailSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'EventEmailSentActivityDetails' }
    & CommonActivityDetails_EventEmailSentActivityDetails_Fragment
  ) }
);

type FullEventActivity_FileAddedActivity_Fragment = (
  { __typename?: 'FileAddedActivity' }
  & Pick<FileAddedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FileAddedActivityDetails' }
    & CommonActivityDetails_FileAddedActivityDetails_Fragment
  ) }
);

type FullEventActivity_FollowUpSentActivity_Fragment = (
  { __typename?: 'FollowUpSentActivity' }
  & Pick<FollowUpSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'FollowUpSentActivityDetails' }
    & CommonActivityDetails_FollowUpSentActivityDetails_Fragment
  ) }
);

type FullEventActivity_LeadFormSubmissionActivity_Fragment = (
  { __typename?: 'LeadFormSubmissionActivity' }
  & Pick<LeadFormSubmissionActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'LeadFormSubmissionActivityDetails' }
    & CommonActivityDetails_LeadFormSubmissionActivityDetails_Fragment
  ) }
);

type FullEventActivity_MessageActivity_Fragment = (
  { __typename?: 'MessageActivity' }
  & Pick<MessageActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'MessageActivityDetails' }
    & CommonActivityDetails_MessageActivityDetails_Fragment
  ) }
);

type FullEventActivity_NoteActivity_Fragment = (
  { __typename?: 'NoteActivity' }
  & Pick<NoteActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'NoteActivityDetails' }
    & CommonActivityDetails_NoteActivityDetails_Fragment
  ) }
);

type FullEventActivity_OwnerChangedActivity_Fragment = (
  { __typename?: 'OwnerChangedActivity' }
  & Pick<OwnerChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'OwnerChangedActivityDetails' }
    & CommonActivityDetails_OwnerChangedActivityDetails_Fragment
  ) }
);

type FullEventActivity_PaymentActivity_Fragment = (
  { __typename?: 'PaymentActivity' }
  & Pick<PaymentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentActivityDetails' }
    & CommonActivityDetails_PaymentActivityDetails_Fragment
  ) }
);

type FullEventActivity_PaymentReceivedSentActivity_Fragment = (
  { __typename?: 'PaymentReceivedSentActivity' }
  & Pick<PaymentReceivedSentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentReceivedSentActivityDetails' }
    & CommonActivityDetails_PaymentReceivedSentActivityDetails_Fragment
  ) }
);

type FullEventActivity_PaymentRequestedActivity_Fragment = (
  { __typename?: 'PaymentRequestedActivity' }
  & Pick<PaymentRequestedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'PaymentRequestedActivityDetails' }
    & CommonActivityDetails_PaymentRequestedActivityDetails_Fragment
  ) }
);

type FullEventActivity_SentActivity_Fragment = (
  { __typename?: 'SentActivity' }
  & Pick<SentActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'SentActivityDetails' }
    & CommonActivityDetails_SentActivityDetails_Fragment
  ) }
);

type FullEventActivity_StageChangedActivity_Fragment = (
  { __typename?: 'StageChangedActivity' }
  & Pick<StageChangedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'StageChangedActivityDetails' }
    & CommonActivityDetails_StageChangedActivityDetails_Fragment
  ) }
);

type FullEventActivity_TaskActivity_Fragment = (
  { __typename?: 'TaskActivity' }
  & Pick<TaskActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'TaskActivityDetails' }
    & CommonActivityDetails_TaskActivityDetails_Fragment
  ) }
);

type FullEventActivity_ViewedActivity_Fragment = (
  { __typename?: 'ViewedActivity' }
  & Pick<ViewedActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'ViewedActivityDetails' }
    & CommonActivityDetails_ViewedActivityDetails_Fragment
  ) }
);

type FullEventActivity_WarningActivity_Fragment = (
  { __typename?: 'WarningActivity' }
  & Pick<WarningActivity, '_id' | 'type' | 'trashed' | 'hidden' | 'docIds'>
  & { details: (
    { __typename?: 'WarningActivityDetails' }
    & CommonActivityDetails_WarningActivityDetails_Fragment
  ) }
);

export type FullEventActivityFragment = FullEventActivity_AcceptedActivity_Fragment | FullEventActivity_AssignmentActivity_Fragment | FullEventActivity_BasicActivity_Fragment | FullEventActivity_ChatMessageActivity_Fragment | FullEventActivity_DeclinedActivity_Fragment | FullEventActivity_EventActivity_Fragment | FullEventActivity_EventEmailSentActivity_Fragment | FullEventActivity_FileAddedActivity_Fragment | FullEventActivity_FollowUpSentActivity_Fragment | FullEventActivity_LeadFormSubmissionActivity_Fragment | FullEventActivity_MessageActivity_Fragment | FullEventActivity_NoteActivity_Fragment | FullEventActivity_OwnerChangedActivity_Fragment | FullEventActivity_PaymentActivity_Fragment | FullEventActivity_PaymentReceivedSentActivity_Fragment | FullEventActivity_PaymentRequestedActivity_Fragment | FullEventActivity_SentActivity_Fragment | FullEventActivity_StageChangedActivity_Fragment | FullEventActivity_TaskActivity_Fragment | FullEventActivity_ViewedActivity_Fragment | FullEventActivity_WarningActivity_Fragment;

export type GetApiKeysQueryVariables = Exact<{
  companyId?: Maybe<Scalars['String']>;
}>;


export type GetApiKeysQuery = (
  { __typename?: 'Query' }
  & { getApiKeys?: Maybe<Array<Maybe<(
    { __typename?: 'ApiKeyDocument' }
    & FullApiKeyDocFragment
  )>>> }
);

export type GetApiKeyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetApiKeyQuery = (
  { __typename?: 'Query' }
  & { getApiKey?: Maybe<(
    { __typename?: 'ApiKeyDocument' }
    & FullApiKeyDocFragment
  )> }
);

export type GenerateApiKeyMutationVariables = Exact<{
  userId: Scalars['String'];
  companyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}>;


export type GenerateApiKeyMutation = (
  { __typename?: 'Mutation' }
  & { generateApiKey?: Maybe<(
    { __typename?: 'ApiKeyDocument' }
    & FullApiKeyDocFragment
  )> }
);

export type DeactivateApiKeyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeactivateApiKeyMutation = (
  { __typename?: 'Mutation' }
  & { deactivateApiKey?: Maybe<(
    { __typename?: 'ApiKeyDocument' }
    & FullApiKeyDocFragment
  )> }
);

export type UpdateApiKeyMutationVariables = Exact<{
  apiKey: UpdateApiKeyInput;
}>;


export type UpdateApiKeyMutation = (
  { __typename?: 'Mutation' }
  & { updateApiKey?: Maybe<(
    { __typename?: 'ApiKeyDocument' }
    & FullApiKeyDocFragment
  )> }
);

export type FullApiKeyDocFragment = (
  { __typename?: 'ApiKeyDocument' }
  & Pick<ApiKeyDocument, '_id' | '_rev' | 'companyId' | 'created' | 'name' | 'archived'>
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'email' | 'firstName' | 'lastName' | 'phoneNumber'>
  )> }
);

export type PublicUserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'user_id' | 'email' | 'name' | 'picture' | 'preferences' | 'signature'>
  & { user_metadata?: Maybe<(
    { __typename?: 'UserMetadata' }
    & Pick<UserMetadata, 'firstName' | 'lastName' | 'phoneNumber' | 'phoneExtension' | 'title' | 'language' | 'playerName' | 'blockLaunchDialog' | 'projectTypes' | 'hasJoinedLeaderboard' | 'color' | 'leaderboardOptOut'>
    & { customAvatar?: Maybe<(
      { __typename?: 'CustomAvatar' }
      & Pick<CustomAvatar, 'label' | 'fileType' | 'width' | 'height' | 'value' | 'cdnValue' | 'cloudinaryId' | 's3PublicKey'>
    )> }
  )>, app_metadata?: Maybe<(
    { __typename?: 'AppMetadata' }
    & Pick<AppMetadata, 'active' | 'roles' | 'accountOwner' | 'permissions' | 'customPermissions' | 'companyId' | 'mfa_enabled' | 'isOwner' | 'painterType'>
    & { user?: Maybe<(
      { __typename?: 'AppMetadataUser' }
      & Pick<AppMetadataUser, '_id'>
    )> }
  )>, client?: Maybe<(
    { __typename?: 'UserClient' }
    & Pick<UserClient, 'options'>
    & { meta?: Maybe<(
      { __typename?: 'ClientMeta' }
      & Pick<ClientMeta, '_id' | '_rev' | 'type' | 'active' | 'trialExpiry' | 'billingId' | 'parentCompanyId' | 'plan' | 'name' | 'address' | 'city' | 'province' | 'country' | 'postal' | 'phone' | 'email' | 'notes'>
    )> }
  )> }
);

export type AppDocsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppDocsQuery = (
  { __typename?: 'Query' }
  & { appDocs?: Maybe<(
    { __typename?: 'AppDocsResponse' }
    & Pick<AppDocsResponse, 'options' | 'rates' | 'companies' | 'companyDetails' | 'preferences' | 'remainingQuotes'>
  )> }
);

export type UserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & PublicUserFragment
  )> }
);

export type EstimatorQueryVariables = Exact<{
  id: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
}>;


export type EstimatorQuery = (
  { __typename?: 'Query' }
  & { estimator?: Maybe<(
    { __typename?: 'Estimator' }
    & Pick<Estimator, 'user_id' | 'name' | 'title' | 'description' | 'image' | 'signature'>
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'User' }
    & PublicUserFragment
  )> }
);

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
  companyId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser?: Maybe<(
    { __typename?: 'User' }
    & PublicUserFragment
  )> }
);

export type UpdatePasswordMutationVariables = Exact<{
  user_id: Scalars['String'];
  password: Scalars['String'];
}>;


export type UpdatePasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updatePassword'>
);

export type ResetPasswordMutationVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetPassword'>
);

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['String'];
  companyId: Scalars['String'];
  transferQuotesTo?: Maybe<Scalars['String']>;
  transferType?: Maybe<Scalars['String']>;
}>;


export type DeactivateUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deactivateUser'>
);

export type TransferUserDocsMutationVariables = Exact<{
  id: Scalars['String'];
  transferTo: Scalars['String'];
  type: Scalars['String'];
  values?: Maybe<Scalars['String']>;
}>;


export type TransferUserDocsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'transferUserDocs'>
);

export type DeleteUserDocsMutationVariables = Exact<{
  id: Scalars['String'];
  type: Scalars['String'];
}>;


export type DeleteUserDocsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteUserDocs'>
);

export type GetMfaEnrollmentsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetMfaEnrollmentsQuery = (
  { __typename?: 'Query' }
  & { getMfaEnrollments: Array<(
    { __typename?: 'MfaEnrollment' }
    & Pick<MfaEnrollment, 'id' | 'type' | 'name' | 'phone_number' | 'email' | 'enrolled_at'>
  )> }
);

export type ResetMfaForUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ResetMfaForUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetMfaForUser'>
);

export type SearchUsersQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  includeCrew?: Maybe<Scalars['Boolean']>;
}>;


export type SearchUsersQuery = (
  { __typename?: 'Query' }
  & { searchUsers?: Maybe<(
    { __typename?: 'SearchUsersResponse' }
    & Pick<SearchUsersResponse, 'bookmark' | 'total_rows'>
    & { rows: Array<Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'user_id' | 'name' | 'email' | 'last_login' | 'created' | 'picture' | 'logins_count' | 'preferences'>
      & { user_metadata?: Maybe<(
        { __typename?: 'UserMetadata' }
        & Pick<UserMetadata, 'phoneNumber' | 'lastName' | 'firstName' | 'title' | 'playerName' | 'blockLaunchDialog' | 'projectTypes' | 'hasJoinedLeaderboard' | 'color' | 'leaderboardOptOut'>
        & { customAvatar?: Maybe<(
          { __typename?: 'CustomAvatar' }
          & Pick<CustomAvatar, 'label' | 'fileType' | 'width' | 'height' | 'value' | 'cdnValue' | 'cloudinaryId' | 's3PublicKey'>
        )> }
      )>, app_metadata?: Maybe<(
        { __typename?: 'AppMetadata' }
        & Pick<AppMetadata, 'active' | 'companyId' | 'roles' | 'isOwner' | 'painterType' | 'resolvedPermissions'>
      )> }
    )>> }
  )> }
);

export type SearchUsersAdminQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  includeCrew?: Maybe<Scalars['Boolean']>;
}>;


export type SearchUsersAdminQuery = (
  { __typename?: 'Query' }
  & { searchUsers?: Maybe<(
    { __typename?: 'SearchUsersResponse' }
    & Pick<SearchUsersResponse, 'bookmark' | 'total_rows'>
    & { rows: Array<Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'user_id' | 'name' | 'email' | 'last_login' | 'created'>
      & { user_metadata?: Maybe<(
        { __typename?: 'UserMetadata' }
        & Pick<UserMetadata, 'phoneNumber' | 'lastName' | 'firstName' | 'title'>
      )>, app_metadata?: Maybe<(
        { __typename?: 'AppMetadata' }
        & Pick<AppMetadata, 'active' | 'companyId' | 'roles' | 'mfa_enrolled' | 'mfa_excluded' | 'stage' | 'isOwner'>
        & { company?: Maybe<(
          { __typename?: 'AppMetaDataUserCompany' }
          & Pick<AppMetaDataUserCompany, 'name' | 'plan'>
          & { subscription?: Maybe<(
            { __typename?: 'CompanySubscription' }
            & Pick<CompanySubscription, 'status'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type SubscriptionQueryVariables = Exact<{
  clientBillingId?: Maybe<Scalars['String']>;
}>;


export type SubscriptionQuery = (
  { __typename?: 'Query' }
  & { subscription?: Maybe<(
    { __typename?: 'ChargebeeSubscription' }
    & Pick<ChargebeeSubscription, 'plan_id' | 'plan_quantity' | 'plan_unit_price' | 'currency_code' | 'status' | 'billing_period_unit' | 'current_term_start' | 'current_term_end' | 'cancelled_at' | 'subscription_activated' | 'coreSeatsAvailable' | 'teamSeatsAvailable' | 'crewSeatsAvailable' | 'cf_production_pricing_migration_timestamp'>
    & { addons?: Maybe<Array<Maybe<(
      { __typename?: 'ChargebeeAddon' }
      & Pick<ChargebeeAddon, 'id' | 'quantity' | 'unit_price' | 'amount' | 'name'>
    )>>>, charges?: Maybe<Array<Maybe<(
      { __typename?: 'ChargebeeCharge' }
      & Pick<ChargebeeCharge, 'id' | 'quantity' | 'unit_price' | 'amount' | 'name'>
    )>>>, coupons?: Maybe<Array<Maybe<(
      { __typename?: 'ChargebeeCoupon' }
      & Pick<ChargebeeCoupon, 'id' | 'name' | 'discount_amount' | 'discount_percentage' | 'duration_type'>
    )>>>, plan?: Maybe<(
      { __typename?: 'ChargebeePlan' }
      & Pick<ChargebeePlan, 'name' | 'invoice_name'>
    )>, billingContact?: Maybe<(
      { __typename?: 'ChargebeeBillingContact' }
      & Pick<ChargebeeBillingContact, 'first_name' | 'last_name' | 'email' | 'phone'>
    )> }
  )> }
);

export type SubscriptionSummaryQueryVariables = Exact<{
  clientBillingId?: Maybe<Scalars['String']>;
}>;


export type SubscriptionSummaryQuery = (
  { __typename?: 'Query' }
  & { subscriptionSummary?: Maybe<(
    { __typename?: 'ChargebeeSubscriptionSummary' }
    & Pick<ChargebeeSubscriptionSummary, 'status' | 'plan_id' | 'billing_period_unit' | 'current_term_end' | 'cf_production_pricing_migration_timestamp' | 'coreSeatsAvailable' | 'teamSeatsAvailable' | 'crewSeatsAvailable'>
    & { addons?: Maybe<Array<Maybe<(
      { __typename?: 'ChargebeeAddonSummary' }
      & Pick<ChargebeeAddonSummary, 'id' | 'name'>
    )>>> }
  )> }
);

export type OneTimeChargesQueryVariables = Exact<{
  clientBillingId?: Maybe<Scalars['String']>;
}>;


export type OneTimeChargesQuery = (
  { __typename?: 'Query' }
  & { oneTimeCharges: Array<(
    { __typename?: 'ChargebeeOneTimeCharge' }
    & Pick<ChargebeeOneTimeCharge, 'id' | 'description' | 'quantity' | 'amount' | 'discountAmount' | 'currencyCode' | 'date' | 'itemPriceId' | 'isAdhoc' | 'invoiceId' | 'invoiceStatus'>
  )> }
);

export type ChargebeePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type ChargebeePlansQuery = (
  { __typename?: 'Query' }
  & { chargebeePlans: Array<(
    { __typename?: 'ChargebeeItemPrice' }
    & Pick<ChargebeeItemPrice, 'id' | 'name' | 'itemType' | 'pricingModel' | 'price' | 'currencyCode'>
  )> }
);

export type ChargebeeAddonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ChargebeeAddonsQuery = (
  { __typename?: 'Query' }
  & { chargebeeAddons: Array<(
    { __typename?: 'ChargebeeItemPrice' }
    & Pick<ChargebeeItemPrice, 'id' | 'name' | 'itemType' | 'pricingModel' | 'price' | 'currencyCode'>
  )> }
);

export type ChargebeeCouponsQueryVariables = Exact<{ [key: string]: never; }>;


export type ChargebeeCouponsQuery = (
  { __typename?: 'Query' }
  & { chargebeeCoupons: Array<(
    { __typename?: 'CheckoutCoupon' }
    & Pick<CheckoutCoupon, 'id' | 'name' | 'discountType' | 'discountAmount' | 'discountPercentage'>
  )> }
);

export type SalesRepsQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesRepsQuery = (
  { __typename?: 'Query' }
  & { salesReps: Array<(
    { __typename?: 'SalesRep' }
    & Pick<SalesRep, 'id' | 'name'>
  )> }
);

export type EstimateCheckoutQueryVariables = Exact<{
  input: CheckoutInput;
}>;


export type EstimateCheckoutQuery = (
  { __typename?: 'Query' }
  & { estimateCheckout: (
    { __typename?: 'CheckoutEstimate' }
    & Pick<CheckoutEstimate, 'subTotal' | 'discountTotal' | 'taxTotal' | 'total' | 'currencyCode'>
    & { lineItems: Array<(
      { __typename?: 'CheckoutEstimateLineItem' }
      & Pick<CheckoutEstimateLineItem, 'description' | 'quantity' | 'amount'>
    )> }
  ) }
);

export type GenerateCheckoutLinkMutationVariables = Exact<{
  input: CheckoutInput;
  send: Scalars['Boolean'];
}>;


export type GenerateCheckoutLinkMutation = (
  { __typename?: 'Mutation' }
  & { generateCheckoutLink: (
    { __typename?: 'CheckoutResult' }
    & Pick<CheckoutResult, 'url' | 'expiresAt' | 'emailStatus'>
    & { estimate: (
      { __typename?: 'CheckoutEstimate' }
      & Pick<CheckoutEstimate, 'subTotal' | 'discountTotal' | 'taxTotal' | 'total' | 'currencyCode'>
      & { lineItems: Array<(
        { __typename?: 'CheckoutEstimateLineItem' }
        & Pick<CheckoutEstimateLineItem, 'description' | 'quantity' | 'amount'>
      )> }
    ) }
  ) }
);

export type ClientQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type ClientQuery = (
  { __typename?: 'Query' }
  & { client?: Maybe<(
    { __typename?: 'ClientResponse' }
    & Pick<ClientResponse, 'options' | 'internalOptions' | 'rates' | 'sequence' | 'companies'>
    & { meta?: Maybe<(
      { __typename?: 'ClientMeta' }
      & FullMetaFragment
    )> }
  )> }
);

export type GetCorporateTypeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCorporateTypeDataQuery = (
  { __typename?: 'Query' }
  & { getCorporateTypeData?: Maybe<(
    { __typename?: 'GetCorporateTypeDataResponse' }
    & Pick<GetCorporateTypeDataResponse, 'quoteTypes'>
  )> }
);

export type SearchManufacturerProductsQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchManufacturerProductsQuery = (
  { __typename?: 'Query' }
  & { searchManufacturerProducts?: Maybe<(
    { __typename?: 'SearchManufacturerProductsResponse' }
    & Pick<SearchManufacturerProductsResponse, 'bookmark' | 'total_rows'>
    & { rows?: Maybe<Array<Maybe<(
      { __typename?: 'ManufacturerProduct' }
      & FullManufacturerProductFragment
    )>>> }
  )> }
);

export type SearchManufacturerColorsQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchManufacturerColorsQuery = (
  { __typename?: 'Query' }
  & { searchManufacturerColors?: Maybe<(
    { __typename?: 'SearchManufacturerColorsResponse' }
    & Pick<SearchManufacturerColorsResponse, 'bookmark' | 'total_rows'>
    & { rows?: Maybe<Array<Maybe<(
      { __typename?: 'ManufacturerColor' }
      & FullManufacturerColorFragment
    )>>> }
  )> }
);

export type CreateClientMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type CreateClientMutation = (
  { __typename?: 'Mutation' }
  & { createClient?: Maybe<(
    { __typename?: 'ClientMeta' }
    & FullMetaFragment
  )> }
);

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['String'];
  meta?: Maybe<ClientMetaInput>;
  options?: Maybe<Scalars['JSON']>;
  internalOptions?: Maybe<Scalars['JSON']>;
  rates?: Maybe<Scalars['JSON']>;
}>;


export type UpdateClientMutation = (
  { __typename?: 'Mutation' }
  & { updateClient?: Maybe<(
    { __typename?: 'ClientResponse' }
    & Pick<ClientResponse, 'options' | 'internalOptions' | 'rates' | 'sequence' | 'companies'>
    & { meta?: Maybe<(
      { __typename?: 'ClientMeta' }
      & FullMetaFragment
    )> }
  )> }
);

export type SyncOptionsMutationVariables = Exact<{
  rev: Scalars['String'];
}>;


export type SyncOptionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncOptions'>
);

export type SyncRatesMutationVariables = Exact<{
  rev: Scalars['String'];
}>;


export type SyncRatesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncRates'>
);

export type SavePartialOptionsMutationVariables = Exact<{
  input?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
}>;


export type SavePartialOptionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'savePartialOptions'>
);

export type SaveOptionsMutationVariables = Exact<{
  options?: Maybe<Scalars['JSON']>;
}>;


export type SaveOptionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveOptions'>
);

export type SaveLocationOptionsMutationVariables = Exact<{
  options?: Maybe<Scalars['JSON']>;
  overwrite?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
}>;


export type SaveLocationOptionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveLocationOptions'>
);

export type SaveRatesMutationVariables = Exact<{
  rates?: Maybe<Scalars['JSON']>;
}>;


export type SaveRatesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveRates'>
);

export type TransferClientDocsMutationVariables = Exact<{
  id: Scalars['String'];
  transferTo: Scalars['String'];
  type: Scalars['String'];
  overwrite?: Maybe<Scalars['Boolean']>;
  sections?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type TransferClientDocsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'transferClientDocs'>
);

export type ResizeQuoteImagesMutationVariables = Exact<{
  db: Scalars['String'];
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
}>;


export type ResizeQuoteImagesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resizeQuoteImages'>
);

export type DeleteClientDocsMutationVariables = Exact<{
  id: Scalars['String'];
  type: Scalars['String'];
}>;


export type DeleteClientDocsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteClientDocs'>
);

export type SearchClientsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchClientsQuery = (
  { __typename?: 'Query' }
  & { searchClients?: Maybe<(
    { __typename?: 'SearchClientsResponse' }
    & Pick<SearchClientsResponse, 'bookmark' | 'total_rows'>
    & { rows?: Maybe<Array<(
      { __typename?: 'ClientMeta' }
      & FullMetaFragment
    )>> }
  )> }
);

export type SearchLocationsQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchLocationsQuery = (
  { __typename?: 'Query' }
  & { searchLocations?: Maybe<(
    { __typename?: 'SearchLocationsResponse' }
    & Pick<SearchLocationsResponse, 'bookmark' | 'total_rows'>
    & { rows?: Maybe<Array<(
      { __typename?: 'ClientMeta' }
      & FullMetaFragment
    )>> }
  )> }
);

export type LeaderboardQueryVariables = Exact<{
  userId: Scalars['String'];
  sort: Scalars['String'];
  searchTeam: Scalars['Boolean'];
}>;


export type LeaderboardQuery = (
  { __typename?: 'Query' }
  & { leaderboardData?: Maybe<(
    { __typename?: 'LeaderboardDataResponse' }
    & Pick<LeaderboardDataResponse, 'totalRows' | 'userRank'>
    & { userRows?: Maybe<Array<Maybe<(
      { __typename?: 'LeaderboardDataResponseRow' }
      & Pick<LeaderboardDataResponseRow, 'rank' | 'name' | 'winRate' | 'totalSold' | 'businessType'>
    )>>>, topRows?: Maybe<Array<Maybe<(
      { __typename?: 'LeaderboardDataResponseRow' }
      & Pick<LeaderboardDataResponseRow, 'rank' | 'name' | 'winRate' | 'totalSold' | 'businessType'>
    )>>> }
  )>, leaderboardRank?: Maybe<(
    { __typename?: 'LeaderboardRankResponse' }
    & { totalSold?: Maybe<(
      { __typename?: 'LeaderboardRankResponseItem' }
      & Pick<LeaderboardRankResponseItem, 'value' | 'rank' | 'valueChange' | 'rankChange' | 'comment'>
    )>, winRate?: Maybe<(
      { __typename?: 'LeaderboardRankResponseItem' }
      & Pick<LeaderboardRankResponseItem, 'value' | 'rank' | 'valueChange' | 'rankChange' | 'comment'>
    )> }
  )> }
);

export type FullMetaFragment = (
  { __typename?: 'ClientMeta' }
  & Pick<ClientMeta, '_id' | '_rev' | 'province' | 'country' | 'postal' | 'phone' | 'email' | 'notes' | 'active' | 'banned' | 'skipHubspotSync' | 'stage' | 'trialExpiry' | 'billingId' | 'nonBilling' | 'includeInLeaderboards' | 'excludeFromLeaderboards' | 'parentCompanyId' | 'paymentExpiryNotice' | 'plan' | 'name' | 'address' | 'city' | 'updated' | 'created' | 'delete'>
  & { userCounts?: Maybe<(
    { __typename?: 'ClientUserCounts' }
    & Pick<ClientUserCounts, 'all'>
  )>, subscription?: Maybe<(
    { __typename?: 'ClientMetaSubscription' }
    & Pick<ClientMetaSubscription, 'plan_id' | 'current_term_start' | 'current_term_end' | 'status'>
  )>, cancellationFlow?: Maybe<(
    { __typename?: 'ClientCancellationFlow' }
    & Pick<ClientCancellationFlow, 'status' | 'cancellationScheduledFor'>
  )>, aggregates?: Maybe<(
    { __typename?: 'ClientAggregates' }
    & Pick<ClientAggregates, 'totalQuotes' | 'totalInvoices' | 'totalBidValue' | 'averageBidValue' | 'closeRate' | 'closedQuotes' | 'closedValue' | 'averageCloseValue'>
  )>, options?: Maybe<(
    { __typename?: 'ClientOptions' }
    & Pick<ClientOptions, 'companyCoordinates'>
  )> }
);

export type FullManufacturerProductFragment = (
  { __typename?: 'ManufacturerProduct' }
  & Pick<ManufacturerProduct, 'number' | 'productLineId' | 'name' | 'category' | 'type' | 'coverage' | 'size' | 'imageUrl' | 'description' | 'manufacturer' | 'baseName' | 'sheen'>
);

export type FullManufacturerColorFragment = (
  { __typename?: 'ManufacturerColor' }
  & Pick<ManufacturerColor, 'number' | 'name' | 'description' | 'image' | 'localImage' | 'hexColor' | 'paintWood' | 'manufacturer' | 'productLines' | 'intRank' | 'extRank'>
);

export type AdminDashboardStatsQueryVariables = Exact<{
  weekAgo: Scalars['Float'];
  now: Scalars['Float'];
  weekFromNow: Scalars['Float'];
}>;


export type AdminDashboardStatsQuery = (
  { __typename?: 'Query' }
  & { adminDashboardStats?: Maybe<(
    { __typename?: 'AdminDashboardStats' }
    & Pick<AdminDashboardStats, 'activeClients' | 'activeUsers' | 'newTrials' | 'expiringTrials' | 'currentTrials' | 'newActiveClients' | 'newActiveUsers'>
  )> }
);

export type CompanyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompanyQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & FullCompanyFragment
  )> }
);

export type SearchCompaniesQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchCompaniesQuery = (
  { __typename?: 'Query' }
  & { searchCompanies?: Maybe<(
    { __typename?: 'SearchCompaniesResult' }
    & Pick<SearchCompaniesResult, 'total_rows' | 'bookmark'>
    & { companies?: Maybe<Array<Maybe<(
      { __typename?: 'Company' }
      & SearchedCompanyFragment
    )>>> }
  )> }
);

export type ExportCompaniesQueryVariables = Exact<{
  query: Scalars['String'];
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportCompaniesQuery = (
  { __typename?: 'Query' }
  & { exportCompanies?: Maybe<(
    { __typename?: 'ExportCompaniesResponse' }
    & Pick<ExportCompaniesResponse, 'csv' | 'rows'>
  )> }
);

export type SaveCompanyMutationVariables = Exact<{
  company: Scalars['JSON'];
}>;


export type SaveCompanyMutation = (
  { __typename?: 'Mutation' }
  & { saveCompany?: Maybe<(
    { __typename?: 'Company' }
    & FullCompanyFragment
  )> }
);

export type DeleteCompaniesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  softDelete?: Maybe<Scalars['Boolean']>;
}>;


export type DeleteCompaniesMutation = (
  { __typename?: 'Mutation' }
  & { deleteCompanies: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type FullCompanyFragment = (
  { __typename?: 'Company' }
  & Pick<Company, '_id' | '_rev' | '_deleted' | 'trashed' | 'trashedBy' | 'deleteDate' | 'type' | 'name' | 'email' | 'address' | 'city' | 'province' | 'country' | 'postal' | 'phone_number' | 'phone_ext' | 'created_by' | 'created' | 'updated' | 'assignedUsers' | 'tags' | 'lead_source' | 'files'>
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
  )> }
);

export type SearchedCompanyFragment = (
  { __typename?: 'Company' }
  & Pick<Company, '_id' | '_rev' | '_deleted' | 'trashed' | 'trashedBy' | 'deleteDate' | 'type' | 'name' | 'email' | 'address' | 'city' | 'province' | 'country' | 'postal' | 'phone_number' | 'phone_ext' | 'created_by' | 'created' | 'updated' | 'assignedUsers' | 'tags' | 'lead_source' | 'files'>
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
  )> }
);

export type ContactQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContactQuery = (
  { __typename?: 'Query' }
  & { contact?: Maybe<(
    { __typename?: 'Contact' }
    & FullContactFragment
  )> }
);

export type ContactBySourceQueryVariables = Exact<{
  source: Scalars['String'];
  source_id: Scalars['String'];
}>;


export type ContactBySourceQuery = (
  { __typename?: 'Query' }
  & { contactBySource?: Maybe<(
    { __typename?: 'Contact' }
    & FullContactFragment
  )> }
);

export type SearchContactsQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchContactsQuery = (
  { __typename?: 'Query' }
  & { searchContacts?: Maybe<(
    { __typename?: 'SearchContactsResult' }
    & Pick<SearchContactsResult, 'total_rows' | 'bookmark'>
    & { contacts?: Maybe<Array<Maybe<(
      { __typename?: 'Contact' }
      & SearchedContactFragment
    )>>> }
  )> }
);

export type SearchContactDealsQueryVariables = Exact<{
  contactSourceId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
}>;


export type SearchContactDealsQuery = (
  { __typename?: 'Query' }
  & { searchContactDeals?: Maybe<(
    { __typename?: 'SearchContactDealsResponse' }
    & Pick<SearchContactDealsResponse, 'results'>
  )> }
);

export type SearchContactOpportunitiesQueryVariables = Exact<{
  contactSourceId: Scalars['String'];
  integration: Scalars['String'];
}>;


export type SearchContactOpportunitiesQuery = (
  { __typename?: 'Query' }
  & { searchContactOpportunities?: Maybe<(
    { __typename?: 'SearchContactOpportunitiesResponse' }
    & Pick<SearchContactOpportunitiesResponse, 'results'>
  )> }
);

export type SearchContactsWithIntegrationQueryVariables = Exact<{
  paintscoutQuery: Scalars['String'];
  integrationQuery: Scalars['String'];
  integration: Scalars['String'];
  useIntegration: Scalars['Boolean'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchContactsWithIntegrationQuery = (
  { __typename?: 'Query' }
  & { paintscout?: Maybe<(
    { __typename?: 'SearchContactsResult' }
    & Pick<SearchContactsResult, 'total_rows' | 'bookmark'>
    & { contacts?: Maybe<Array<Maybe<(
      { __typename?: 'Contact' }
      & FullContactFragment
    )>>> }
  )>, integration?: Maybe<(
    { __typename?: 'SearchContactsByIntegrationResponse' }
    & Pick<SearchContactsByIntegrationResponse, 'results'>
  )> }
);

export type ExportContactsQueryVariables = Exact<{
  query: Scalars['String'];
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportContactsQuery = (
  { __typename?: 'Query' }
  & { exportContacts?: Maybe<(
    { __typename?: 'ExportContactsResponse' }
    & Pick<ExportContactsResponse, 'csv' | 'rows'>
  )> }
);

export type SaveContactMutationVariables = Exact<{
  contact: Scalars['JSON'];
}>;


export type SaveContactMutation = (
  { __typename?: 'Mutation' }
  & { saveContact?: Maybe<(
    { __typename?: 'Contact' }
    & FullContactFragment
  )> }
);

export type DeleteContactsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  softDelete?: Maybe<Scalars['Boolean']>;
}>;


export type DeleteContactsMutation = (
  { __typename?: 'Mutation' }
  & { deleteContacts: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type FullContactFragment = (
  { __typename?: 'Contact' }
  & Pick<Contact, '_id' | '_rev' | '_deleted' | 'trashed' | 'trashedBy' | 'deleteDate' | 'type' | 'first_name' | 'last_name' | 'secondary_first_name' | 'secondary_last_name' | 'email' | 'alternate_email' | 'billingAddress' | 'shippingAddress' | 'isBillingShipping' | 'address' | 'city' | 'province' | 'country' | 'postal' | 'phone_number' | 'phone_ext' | 'alternate_phone' | 'alternate_phone_ext' | 'sms_undeliverable' | 'sms_undeliverable_reason' | 'sms_undeliverable_at' | 'company' | 'companyDocId' | 'contact_type' | 'created_by' | 'created_date' | 'updated_date' | 'preferred_contact_method' | 'tags' | 'files' | 'source_id' | 'source_user_id' | 'source' | 'lead_source' | 'acquisitionSource' | 'internal_note' | 'assignedUsers'>
  & { geocode?: Maybe<(
    { __typename?: 'ContactGeocode' }
    & Pick<ContactGeocode, 'lat' | 'lng'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'phoneExtension' | 'title'>
  )>, wisetackPrequal?: Maybe<(
    { __typename?: 'WisetackPrequal' }
    & Pick<WisetackPrequal, 'prequalLink' | 'prequalId' | 'customerId' | 'merchantId' | 'signupId' | 'prequalStatus' | 'date' | 'startDate' | 'eventType' | 'maxQualifiedAmount' | 'aprRange' | 'expirationDate'>
    & { customerInfo?: Maybe<(
      { __typename?: 'WisetackPrequalCustomer' }
      & Pick<WisetackPrequalCustomer, 'firstName' | 'lastName' | 'mobileNumber'>
    )> }
  )>, wisetackLoanApplications?: Maybe<Array<Maybe<(
    { __typename?: 'WisetackLoanApplication' }
    & Pick<WisetackLoanApplication, 'loanApplicationLink' | 'transactionId' | 'messageId' | 'changedStatus' | 'date' | 'startDate' | 'requestedLoanAmount' | 'approvedLoanAmount' | 'settledLoanAmount' | 'processingFee' | 'invoiceNumber' | 'quoteNumber' | 'purchaseId' | 'maximumAmount' | 'transactionPurpose' | 'serviceCompletedOn' | 'tilaAcceptedOn' | 'createdAt' | 'expirationDate' | 'prequalId' | 'customerId' | 'payouts'>
    & { refund?: Maybe<(
      { __typename?: 'WisetackLoanApplicationRefund' }
      & Pick<WisetackLoanApplicationRefund, 'id' | 'amount' | 'merchantDebitAmount' | 'date'>
    )> }
  )>>> }
);

export type SearchedContactFragment = (
  { __typename?: 'Contact' }
  & Pick<Contact, '_id' | '_rev' | 'type' | 'first_name' | 'last_name' | 'secondary_first_name' | 'secondary_last_name' | 'email' | 'alternate_email' | 'billingAddress' | 'shippingAddress' | 'isBillingShipping' | 'address' | 'city' | 'province' | 'country' | 'postal' | 'phone_number' | 'phone_ext' | 'alternate_phone' | 'sms_undeliverable' | 'company' | 'companyDocId' | 'created_date' | 'updated_date' | 'trashed' | 'trashedBy' | 'deleteDate' | 'preferred_contact_method' | 'tags' | 'files' | 'source_id' | 'source_user_id' | 'source' | 'lead_source' | 'acquisitionSource'>
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
  )>, wisetackPrequal?: Maybe<(
    { __typename?: 'WisetackPrequal' }
    & Pick<WisetackPrequal, 'prequalLink' | 'prequalId' | 'customerId' | 'merchantId' | 'signupId' | 'prequalStatus' | 'date' | 'startDate' | 'eventType' | 'maxQualifiedAmount' | 'aprRange' | 'expirationDate'>
    & { customerInfo?: Maybe<(
      { __typename?: 'WisetackPrequalCustomer' }
      & Pick<WisetackPrequalCustomer, 'firstName' | 'lastName' | 'mobileNumber'>
    )> }
  )>, wisetackLoanApplications?: Maybe<Array<Maybe<(
    { __typename?: 'WisetackLoanApplication' }
    & Pick<WisetackLoanApplication, 'loanApplicationLink' | 'transactionId' | 'messageId' | 'changedStatus' | 'date' | 'startDate' | 'requestedLoanAmount' | 'approvedLoanAmount' | 'settledLoanAmount' | 'processingFee' | 'invoiceNumber' | 'quoteNumber' | 'purchaseId' | 'maximumAmount' | 'transactionPurpose' | 'serviceCompletedOn' | 'tilaAcceptedOn' | 'createdAt' | 'expirationDate' | 'prequalId' | 'customerId' | 'payouts'>
    & { refund?: Maybe<(
      { __typename?: 'WisetackLoanApplicationRefund' }
      & Pick<WisetackLoanApplicationRefund, 'id' | 'amount' | 'merchantDebitAmount' | 'date'>
    )> }
  )>>> }
);

export type DealQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DealQuery = (
  { __typename?: 'Query' }
  & { deal?: Maybe<(
    { __typename?: 'Deal' }
    & FullDealFragment
  )> }
);

export type ExportDealsQueryVariables = Exact<{
  query: Scalars['String'];
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportDealsQuery = (
  { __typename?: 'Query' }
  & { exportDeals?: Maybe<(
    { __typename?: 'ExportDealsResponse' }
    & Pick<ExportDealsResponse, 'csv' | 'rows'>
  )> }
);

export type SearchDealsQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  omitInvalidContacts?: Maybe<Scalars['Boolean']>;
}>;


export type SearchDealsQuery = (
  { __typename?: 'Query' }
  & { searchDeals?: Maybe<(
    { __typename?: 'SearchDealsResult' }
    & Pick<SearchDealsResult, 'total_rows' | 'bookmark'>
    & { deals?: Maybe<Array<Maybe<(
      { __typename?: 'Deal' }
      & SearchedDealFragment
    )>>> }
  )> }
);

export type SearchDealsByCompanyQueryVariables = Exact<{
  companyId: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchDealsByCompanyQuery = (
  { __typename?: 'Query' }
  & { searchDealsByCompany?: Maybe<(
    { __typename?: 'SearchDealsResult' }
    & Pick<SearchDealsResult, 'total_rows' | 'bookmark'>
    & { deals?: Maybe<Array<Maybe<(
      { __typename?: 'Deal' }
      & SearchedDealFragment
    )>>> }
  )> }
);

export type SearchDealsByStageQueryVariables = Exact<{
  query: Scalars['String'];
  stage: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchDealsByStageQuery = (
  { __typename?: 'Query' }
  & { searchDealsByStage?: Maybe<(
    { __typename?: 'SearchDealsResult' }
    & Pick<SearchDealsResult, 'total_rows' | 'bookmark'>
    & { aggregations?: Maybe<(
      { __typename?: 'DealSummaryResponse' }
      & Pick<DealSummaryResponse, 'totalDeals' | 'totalDealValue'>
    )>, deals?: Maybe<Array<Maybe<(
      { __typename?: 'Deal' }
      & SearchedDealFragment
    )>>> }
  )> }
);

export type DealSummaryQueryVariables = Exact<{
  query: Scalars['String'];
  pipeline: Scalars['String'];
}>;


export type DealSummaryQuery = (
  { __typename?: 'Query' }
  & { dealSummary?: Maybe<(
    { __typename?: 'DealSummaryResponse' }
    & Pick<DealSummaryResponse, 'totalDeals' | 'totalDealValue'>
  )> }
);

export type SaveDealMutationVariables = Exact<{
  deal: Scalars['JSON'];
  updateLinkedQuoteAddresses?: Maybe<Scalars['Boolean']>;
}>;


export type SaveDealMutation = (
  { __typename?: 'Mutation' }
  & { saveDeal?: Maybe<(
    { __typename?: 'Deal' }
    & FullDealFragment
  )> }
);

export type DeleteDealsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  softDelete?: Maybe<Scalars['Boolean']>;
}>;


export type DeleteDealsMutation = (
  { __typename?: 'Mutation' }
  & { deleteDeals: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type ArchiveDealsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  unarchive?: Maybe<Scalars['Boolean']>;
}>;


export type ArchiveDealsMutation = (
  { __typename?: 'Mutation' }
  & { archiveDeals: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type UntrashDealsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type UntrashDealsMutation = (
  { __typename?: 'Mutation' }
  & { untrashDeals: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type UpdateDealStageMutationVariables = Exact<{
  dealId: Scalars['String'];
  stage: Scalars['String'];
  query?: Maybe<Scalars['String']>;
}>;


export type UpdateDealStageMutation = (
  { __typename?: 'Mutation' }
  & { updateDealStage?: Maybe<(
    { __typename?: 'UpdateDealStageResponse' }
    & { deal?: Maybe<(
      { __typename?: 'Deal' }
      & FullDealFragment
    )>, sourceAggregations?: Maybe<(
      { __typename?: 'DealSummaryResponse' }
      & Pick<DealSummaryResponse, 'totalDeals' | 'totalDealValue'>
    )>, destimationAggregations?: Maybe<(
      { __typename?: 'DealSummaryResponse' }
      & Pick<DealSummaryResponse, 'totalDeals' | 'totalDealValue'>
    )> }
  )> }
);

export type FullDealFragment = (
  { __typename?: 'Deal' }
  & Pick<Deal, '_id' | '_rev' | '_deleted' | 'type' | 'quoteType' | 'name' | 'jobAddress' | 'value' | 'valueBeforeTax' | 'hours' | 'created_by' | 'created' | 'updated' | 'archived' | 'trashed' | 'deleteDate' | 'lead_source' | 'acquisitionSource' | 'assignedUsers' | 'tags' | 'linkedQuoteIds' | 'linkedInvoiceIds' | 'files' | 'history' | 'ownerHistory' | 'status' | 'taskTemplateOrder'>
  & { contact?: Maybe<(
    { __typename?: 'DealContact' }
    & Pick<DealContact, 'id' | 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'company' | 'companyId' | 'preferredContactMethod'>
  )>, stage?: Maybe<(
    { __typename?: 'DealStage' }
    & Pick<DealStage, 'value'>
  )>, geocode?: Maybe<(
    { __typename?: 'DealGeocode' }
    & Pick<DealGeocode, 'lat' | 'lng'>
  )>, pipeline?: Maybe<(
    { __typename?: 'DealPipeline' }
    & Pick<DealPipeline, 'label' | 'value'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
  )>, jobCosting?: Maybe<(
    { __typename?: 'JobCosting' }
    & Pick<JobCosting, 'labour' | 'materials' | 'overhead' | 'profit' | 'margin'>
  )> }
);

export type SearchedDealFragment = (
  { __typename?: 'Deal' }
  & Pick<Deal, '_id' | '_rev' | '_deleted' | 'quoteType' | 'type' | 'name' | 'jobAddress' | 'value' | 'hours' | 'created_by' | 'created' | 'updated' | 'archived' | 'lead_source' | 'acquisitionSource' | 'assignedUsers' | 'tags' | 'files' | 'history' | 'enteredStage' | 'ownerHistory'>
  & { contact?: Maybe<(
    { __typename?: 'DealContact' }
    & Pick<DealContact, 'id' | 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'company' | 'companyId' | 'preferredContactMethod'>
  )>, stage?: Maybe<(
    { __typename?: 'DealStage' }
    & Pick<DealStage, 'value'>
  )>, geocode?: Maybe<(
    { __typename?: 'DealGeocode' }
    & Pick<DealGeocode, 'lat' | 'lng'>
  )>, pipeline?: Maybe<(
    { __typename?: 'DealPipeline' }
    & Pick<DealPipeline, 'label' | 'value'>
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
  )> }
);

export type GetInboundWebhookLogsQueryVariables = Exact<{
  companyId: Scalars['String'];
  integration?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
}>;


export type GetInboundWebhookLogsQuery = (
  { __typename?: 'Query' }
  & { getInboundWebhookLogs: (
    { __typename?: 'InboundWebhookLogsResult' }
    & Pick<InboundWebhookLogsResult, 'total_rows'>
    & { logs: Array<(
      { __typename?: 'InboundWebhookLogEntry' }
      & Pick<InboundWebhookLogEntry, 'timestamp' | 'level' | 'message' | 'namespace' | 'action' | 'integration' | 'data' | 'errorMessage' | 'errorType' | 'errorStack'>
    )> }
  ) }
);

export type RerunInboundWebhookMutationVariables = Exact<{
  integration: Scalars['String'];
  eventData: Scalars['JSON'];
}>;


export type RerunInboundWebhookMutation = (
  { __typename?: 'Mutation' }
  & { rerunInboundWebhook: (
    { __typename?: 'RerunWebhookResult' }
    & Pick<RerunWebhookResult, 'statusCode'>
  ) }
);

export type AdminPaymentFieldsFragment = (
  { __typename?: 'AdminPaymentEntry' }
  & Pick<AdminPaymentEntry, 'id' | 'activityId' | 'amount' | 'status' | 'type' | 'date' | 'deposit' | 'surcharge' | 'paymentRequestId' | 'requestActivityId' | 'forPaymentId' | 'providerDetails' | 'txnId' | 'portalLink'>
);

export type AdminPaymentQuoteFieldsFragment = (
  { __typename?: 'AdminPaymentQuote' }
  & Pick<AdminPaymentQuote, 'id' | 'number' | 'isInvoice' | 'contactName' | 'amountPaid' | 'balanceDue' | 'paymentProcessing' | 'paymentError'>
  & { payments: Array<(
    { __typename?: 'AdminPaymentEntry' }
    & AdminPaymentFieldsFragment
  )> }
);

export type GetStuckPaymentsQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetStuckPaymentsQuery = (
  { __typename?: 'Query' }
  & { getStuckPayments: (
    { __typename?: 'StuckPaymentsResult' }
    & { quotes: Array<(
      { __typename?: 'AdminPaymentQuote' }
      & AdminPaymentQuoteFieldsFragment
    )> }
  ) }
);

export type FindQuotePaymentsQueryVariables = Exact<{
  companyId: Scalars['String'];
  search: Scalars['String'];
}>;


export type FindQuotePaymentsQuery = (
  { __typename?: 'Query' }
  & { findQuotePayments: Array<(
    { __typename?: 'AdminPaymentQuote' }
    & AdminPaymentQuoteFieldsFragment
  )> }
);

export type GetPaymentSyncPreviewQueryVariables = Exact<{
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  paymentIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPaymentSyncPreviewQuery = (
  { __typename?: 'Query' }
  & { getPaymentSyncPreview: Array<(
    { __typename?: 'PaymentSyncEntry' }
    & Pick<PaymentSyncEntry, 'paymentId' | 'txnId' | 'currentStatus' | 'portalStatus' | 'recommended' | 'reason'>
    & { refunds: Array<(
      { __typename?: 'PaymentSyncRefund' }
      & Pick<PaymentSyncRefund, 'txnId' | 'amount' | 'status' | 'approved' | 'created' | 'alreadyRecorded'>
    )> }
  )> }
);

export type GetPayrixTxnLookupQueryVariables = Exact<{
  companyId: Scalars['String'];
  txnId: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
}>;


export type GetPayrixTxnLookupQuery = (
  { __typename?: 'Query' }
  & { getPayrixTxnLookup: (
    { __typename?: 'PayrixTxnLookup' }
    & Pick<PayrixTxnLookup, 'txnId' | 'status' | 'statusLabel' | 'recommended' | 'recommendedReason' | 'type' | 'amount' | 'method' | 'created' | 'metadataCompanyId' | 'metadataActivityId' | 'activityExists' | 'depositHint' | 'alreadyOnQuote' | 'matchedRequestId' | 'matchingRequestIds'>
  ) }
);

export type ApplyPaymentSyncMutationVariables = Exact<{
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  decisions?: Maybe<Array<PaymentDecisionInput> | PaymentDecisionInput>;
  refunds?: Maybe<Array<RefundRecordInput> | RefundRecordInput>;
  silent?: Maybe<Scalars['Boolean']>;
  clearErrorFlag?: Maybe<Scalars['Boolean']>;
}>;


export type ApplyPaymentSyncMutation = (
  { __typename?: 'Mutation' }
  & { applyPaymentSync: (
    { __typename?: 'ApplyPaymentSyncResult' }
    & Pick<ApplyPaymentSyncResult, 'success' | 'changes'>
  ) }
);

export type AttachTxnIdToPaymentMutationVariables = Exact<{
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
  txnId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  silent?: Maybe<Scalars['Boolean']>;
}>;


export type AttachTxnIdToPaymentMutation = (
  { __typename?: 'Mutation' }
  & { attachTxnIdToPayment: (
    { __typename?: 'AttachTxnIdResult' }
    & Pick<AttachTxnIdResult, 'success' | 'changes'>
  ) }
);

export type AddPaymentByTxnIdMutationVariables = Exact<{
  companyId: Scalars['String'];
  quoteId: Scalars['String'];
  txnId: Scalars['String'];
  deposit?: Maybe<Scalars['Boolean']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  silent?: Maybe<Scalars['Boolean']>;
}>;


export type AddPaymentByTxnIdMutation = (
  { __typename?: 'Mutation' }
  & { addPaymentByTxnId: (
    { __typename?: 'AddPaymentResult' }
    & Pick<AddPaymentResult, 'success' | 'paymentId' | 'changes'>
  ) }
);

export type DisconnectPayrixMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type DisconnectPayrixMutation = (
  { __typename?: 'Mutation' }
  & { disconnectPayrix: (
    { __typename?: 'PayrixConnectionResult' }
    & Pick<PayrixConnectionResult, 'success' | 'merchantId' | 'merchantCreated'>
  ) }
);

export type SwapPayrixMerchantIdMutationVariables = Exact<{
  companyId: Scalars['String'];
  merchantId: Scalars['String'];
}>;


export type SwapPayrixMerchantIdMutation = (
  { __typename?: 'Mutation' }
  & { swapPayrixMerchantId: (
    { __typename?: 'PayrixConnectionResult' }
    & Pick<PayrixConnectionResult, 'success' | 'merchantId' | 'merchantCreated'>
  ) }
);

export type PainterScheduleQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  skipSanitize?: Maybe<Scalars['Boolean']>;
}>;


export type PainterScheduleQuery = (
  { __typename?: 'Query' }
  & { painterSchedule?: Maybe<(
    { __typename?: 'PainterScheduleResponse' }
    & { deals: Array<(
      { __typename?: 'PainterScheduleDeal' }
      & Pick<PainterScheduleDeal, 'dealId' | 'dealJobAddress' | 'fileCount' | 'noteCount' | 'hasPaymentDue'>
      & { event: (
        { __typename?: 'AcceptedActivity' }
        & FullActivity_AcceptedActivity_Fragment
      ) | (
        { __typename?: 'AssignmentActivity' }
        & FullActivity_AssignmentActivity_Fragment
      ) | (
        { __typename?: 'BasicActivity' }
        & FullActivity_BasicActivity_Fragment
      ) | (
        { __typename?: 'ChatMessageActivity' }
        & FullActivity_ChatMessageActivity_Fragment
      ) | (
        { __typename?: 'DeclinedActivity' }
        & FullActivity_DeclinedActivity_Fragment
      ) | (
        { __typename?: 'EventActivity' }
        & FullActivity_EventActivity_Fragment
      ) | (
        { __typename?: 'EventEmailSentActivity' }
        & FullActivity_EventEmailSentActivity_Fragment
      ) | (
        { __typename?: 'FileAddedActivity' }
        & FullActivity_FileAddedActivity_Fragment
      ) | (
        { __typename?: 'FollowUpSentActivity' }
        & FullActivity_FollowUpSentActivity_Fragment
      ) | (
        { __typename?: 'LeadFormSubmissionActivity' }
        & FullActivity_LeadFormSubmissionActivity_Fragment
      ) | (
        { __typename?: 'MessageActivity' }
        & FullActivity_MessageActivity_Fragment
      ) | (
        { __typename?: 'NoteActivity' }
        & FullActivity_NoteActivity_Fragment
      ) | (
        { __typename?: 'OwnerChangedActivity' }
        & FullActivity_OwnerChangedActivity_Fragment
      ) | (
        { __typename?: 'PaymentActivity' }
        & FullActivity_PaymentActivity_Fragment
      ) | (
        { __typename?: 'PaymentReceivedSentActivity' }
        & FullActivity_PaymentReceivedSentActivity_Fragment
      ) | (
        { __typename?: 'PaymentRequestedActivity' }
        & FullActivity_PaymentRequestedActivity_Fragment
      ) | (
        { __typename?: 'SentActivity' }
        & FullActivity_SentActivity_Fragment
      ) | (
        { __typename?: 'StageChangedActivity' }
        & FullActivity_StageChangedActivity_Fragment
      ) | (
        { __typename?: 'TaskActivity' }
        & FullActivity_TaskActivity_Fragment
      ) | (
        { __typename?: 'ViewedActivity' }
        & FullActivity_ViewedActivity_Fragment
      ) | (
        { __typename?: 'WarningActivity' }
        & FullActivity_WarningActivity_Fragment
      ) }
    )> }
  )> }
);

export type PainterScheduleJobQueryVariables = Exact<{
  dealId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
}>;


export type PainterScheduleJobQuery = (
  { __typename?: 'Query' }
  & { painterScheduleJob?: Maybe<(
    { __typename?: 'PainterScheduleJobResponse' }
    & Pick<PainterScheduleJobResponse, 'dealFiles'>
    & { invoices: Array<(
      { __typename?: 'Quote' }
      & PainterScheduleQuoteFragment
    )> }
  )> }
);

export type PainterScheduleQuoteFragment = (
  { __typename?: 'Quote' }
  & Pick<Quote, '_id' | '_rev' | 'type' | 'is_invoice' | 'int_ext' | 'deal_id' | 'number' | 'jobAddress' | 'internal_note' | 'productString' | 'totalHours' | 'defaultView' | 'additionalWork' | 'areas' | 'substrates' | 'lineItems' | 'groups' | 'options' | 'order' | 'files' | 'payments' | 'totals' | 'status' | 'dates' | 'signatures' | 'meta' | 'translations'>
  & { contact?: Maybe<(
    { __typename?: 'QuoteContact' }
    & Pick<QuoteContact, 'first_name' | 'last_name' | 'email' | 'phone_number'>
  )> }
);

export type QuoteQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type QuoteQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'quote'>
);

export type OfflineQuotesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfflineQuotesQuery = (
  { __typename?: 'Query' }
  & { offlineQuotes?: Maybe<(
    { __typename?: 'OfflineQuotesResponse' }
    & Pick<OfflineQuotesResponse, 'quotes' | 'invoices' | 'templates'>
    & { contacts?: Maybe<Array<(
      { __typename?: 'Contact' }
      & FullContactFragment
    )>> }
  )> }
);

export type SearchQuotesQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  skipSanitize?: Maybe<Scalars['Boolean']>;
}>;


export type SearchQuotesQuery = (
  { __typename?: 'Query' }
  & { searchQuotes?: Maybe<(
    { __typename?: 'SearchQuotesResponse' }
    & Pick<SearchQuotesResponse, 'total_rows' | 'bookmark'>
    & { quotes?: Maybe<Array<Maybe<(
      { __typename?: 'Quote' }
      & SearchedQuoteFragment
    )>>> }
  )> }
);

export type ViewQuoteQueryVariables = Exact<{
  silent?: Maybe<Scalars['Boolean']>;
  pdf?: Maybe<Scalars['Boolean']>;
  revision?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
}>;


export type ViewQuoteQuery = (
  { __typename?: 'Query' }
  & { viewQuote?: Maybe<(
    { __typename?: 'ViewQuoteResponse' }
    & Pick<ViewQuoteResponse, 'quote' | 'options' | 'estimator' | 'view' | 'tableView' | 'companyId' | 'decryptedEmail' | 'availableLangs' | 'presentationNext' | 'estimateNext'>
  )> }
);

export type PaymentProcessedQueryVariables = Exact<{
  id: Scalars['String'];
  balanceDue: Scalars['Float'];
  activityId?: Maybe<Scalars['String']>;
}>;


export type PaymentProcessedQuery = (
  { __typename?: 'Query' }
  & { paymentProcessed?: Maybe<(
    { __typename?: 'PaymentProcessedResponse' }
    & Pick<PaymentProcessedResponse, 'updatedQuote'>
  )> }
);

export type ClientQuoteQueryVariables = Exact<{
  id: Scalars['String'];
  companyId: Scalars['String'];
}>;


export type ClientQuoteQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'clientQuote'>
);

export type QuoteUrlQueryVariables = Exact<{
  id: Scalars['String'];
  rev: Scalars['String'];
  view: Scalars['String'];
}>;


export type QuoteUrlQuery = (
  { __typename?: 'Query' }
  & { quoteUrl: (
    { __typename?: 'QuoteUrlResponse' }
    & Pick<QuoteUrlResponse, 'quote'>
    & { url: (
      { __typename?: 'UrlDocument' }
      & Pick<UrlDocument, '_id' | 'link'>
    ) }
  ) }
);

export type SearchClientQuotesQueryVariables = Exact<{
  query: Scalars['String'];
  companyId: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchClientQuotesQuery = (
  { __typename?: 'Query' }
  & { searchClientQuotes?: Maybe<(
    { __typename?: 'SearchQuotesResponse' }
    & Pick<SearchQuotesResponse, 'total_rows' | 'bookmark' | 'rawQuotes'>
  )> }
);

export type QuoteSummaryQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type QuoteSummaryQuery = (
  { __typename?: 'Query' }
  & { quoteSummary?: Maybe<(
    { __typename?: 'QuoteSummaryResponse' }
    & Pick<QuoteSummaryResponse, 'totalQuotes' | 'totalQuotePrice' | 'openQuotes' | 'openQuotePrice' | 'wonQuotes' | 'wonQuotePrice' | 'closedQuotes' | 'closedQuotePrice' | 'closeRate' | 'winRate' | 'dollarsWon' | 'averageClosePrice' | 'averageQuotePrice' | 'averageOpenPrice' | 'averageWonPrice'>
  )> }
);

export type LinkDealMutationVariables = Exact<{
  quoteId: Scalars['String'];
  dealId: Scalars['String'];
  updateJobAddress?: Maybe<Scalars['Boolean']>;
}>;


export type LinkDealMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'linkDeal'>
);

export type UnlinkDealMutationVariables = Exact<{
  quoteId: Scalars['String'];
}>;


export type UnlinkDealMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unlinkDeal'>
);

export type AcceptQuoteMutationVariables = Exact<{
  quote: Scalars['JSON'];
  signature?: Maybe<Scalars['String']>;
  quoteId?: Maybe<Scalars['String']>;
}>;


export type AcceptQuoteMutation = (
  { __typename?: 'Mutation' }
  & { acceptQuote?: Maybe<(
    { __typename?: 'AcceptQuoteResponse' }
    & Pick<AcceptQuoteResponse, 'quote'>
  )> }
);

export type DeclineQuoteMutationVariables = Exact<{
  rev: Scalars['String'];
  reason: Scalars['String'];
}>;


export type DeclineQuoteMutation = (
  { __typename?: 'Mutation' }
  & { declineQuote?: Maybe<(
    { __typename?: 'DeclineQuoteResponse' }
    & Pick<DeclineQuoteResponse, 'quote'>
  )> }
);

export type AcceptAdditionalWorkMutationVariables = Exact<{
  rev: Scalars['String'];
  signature?: Maybe<Scalars['String']>;
  quoteId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
}>;


export type AcceptAdditionalWorkMutation = (
  { __typename?: 'Mutation' }
  & { acceptAdditionalWork?: Maybe<(
    { __typename?: 'AcceptAdditionalWorkResponse' }
    & Pick<AcceptAdditionalWorkResponse, 'quote'>
  )> }
);

export type SaveQuoteMutationVariables = Exact<{
  quote: Scalars['JSON'];
  force?: Maybe<Scalars['Boolean']>;
  autosave?: Maybe<Scalars['Boolean']>;
}>;


export type SaveQuoteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveQuote'>
);

export type DeleteQuotesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  softDelete?: Maybe<Scalars['Boolean']>;
}>;


export type DeleteQuotesMutation = (
  { __typename?: 'Mutation' }
  & { deleteQuotes: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type ArchiveQuotesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  unarchive?: Maybe<Scalars['Boolean']>;
}>;


export type ArchiveQuotesMutation = (
  { __typename?: 'Mutation' }
  & { archiveQuotes: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type SendQuoteMutationVariables = Exact<{
  id: Scalars['String'];
  view: Scalars['String'];
  emails: Array<QuoteEmailInput> | QuoteEmailInput;
  revision?: Maybe<Scalars['Boolean']>;
}>;


export type SendQuoteMutation = (
  { __typename?: 'Mutation' }
  & { sendQuote?: Maybe<(
    { __typename?: 'SendQuoteResponse' }
    & Pick<SendQuoteResponse, 'quote' | 'urlDocId'>
    & { emails?: Maybe<Array<Maybe<(
      { __typename?: 'SentEmail' }
      & Pick<SentEmail, 'headers' | 'response'>
    )>>> }
  )> }
);

export type RequestReviewMutationVariables = Exact<{
  sms: ReviewSmsInput;
  content: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
}>;


export type RequestReviewMutation = (
  { __typename?: 'Mutation' }
  & { requestReview?: Maybe<(
    { __typename?: 'RequestReviewResponse' }
    & Pick<RequestReviewResponse, 'result'>
  )> }
);

export type RequestPaymentMutationVariables = Exact<{
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
  email: PaymentRequestEmailInput;
}>;


export type RequestPaymentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestPayment'>
);

export type RecoverInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RecoverInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { recoverInvoice?: Maybe<(
    { __typename?: 'RecoverInvoiceResponse' }
    & Pick<RecoverInvoiceResponse, 'quote'>
  )> }
);

export type SaveClientQuoteMutationVariables = Exact<{
  quote: Scalars['JSON'];
  companyId: Scalars['String'];
  clean?: Maybe<Scalars['Boolean']>;
}>;


export type SaveClientQuoteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveClientQuote'>
);

export type SyncQuoteMutationVariables = Exact<{
  id: Scalars['String'];
  rev: Scalars['String'];
}>;


export type SyncQuoteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncQuote'>
);

export type DeletePaymentMutationVariables = Exact<{
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
}>;


export type DeletePaymentMutation = (
  { __typename?: 'Mutation' }
  & { deletePayment?: Maybe<(
    { __typename?: 'DeletePaymentResponse' }
    & Pick<DeletePaymentResponse, 'updatedQuote'>
  )> }
);

export type UpdatePaymentMutationVariables = Exact<{
  quoteId: Scalars['String'];
  paymentId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
}>;


export type UpdatePaymentMutation = (
  { __typename?: 'Mutation' }
  & { updatePayment?: Maybe<(
    { __typename?: 'UpdatePaymentResponse' }
    & Pick<UpdatePaymentResponse, 'updatedQuote'>
  )> }
);

export type AddProcessingPaymentMutationVariables = Exact<{
  quoteId: Scalars['String'];
  activityId: Scalars['String'];
  amount: Scalars['Float'];
  type: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['Boolean']>;
  txnId?: Maybe<Scalars['String']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['Float']>;
}>;


export type AddProcessingPaymentMutation = (
  { __typename?: 'Mutation' }
  & { addProcessingPayment?: Maybe<(
    { __typename?: 'AddProcessingPaymentResponse' }
    & Pick<AddProcessingPaymentResponse, 'updatedQuote'>
  )> }
);

export type FullQuoteFragment = (
  { __typename?: 'Quote' }
  & Pick<Quote, '_id' | '_rev' | 'type' | 'name' | 'number' | 'fromTemplate' | 'jobAddress' | 'job_identifier' | 'quote_date' | 'hourly_rate' | 'tax_rate' | 'tax_description' | 'is_invoice' | 'parent_quote' | 'parent_quote_number' | 'discount' | 'discount_type' | 'discount_rate' | 'discount_description' | 'discount_isShown' | 'totalAdjustment' | 'products' | 'discounts' | 'clientVisible' | 'client_note' | 'label' | 'lead_source' | 'created_by' | 'defaultView' | 'sendError' | 'terms' | 'presentation' | 'customTerms' | 'status' | 'int_ext' | 'additionalWork' | 'internal_note' | 'productString' | 'areas' | 'substrates' | 'lineItems' | 'groups' | 'substratesGroupBy' | 'order' | 'sentReports' | 'dates' | 'lastViewedActivity' | 'lastMessage' | 'images' | 'files' | 'signatures' | 'child_invoice' | 'child_invoices' | 'child_invoice_number' | 'child_invoice_numbers' | 'owner' | 'assignedUsers' | 'totals' | 'templateId' | 'payments' | 'depositInfo' | 'source' | 'tags' | 'tagDetails' | 'estimatorNotes' | 'lastUserSave' | 'copyOf'>
  & { contact?: Maybe<(
    { __typename?: 'QuoteContact' }
    & Pick<QuoteContact, 'id' | 'rev' | 'first_name' | 'last_name' | 'email' | 'address' | 'city' | 'province' | 'phone_number'>
  )> }
);

export type SearchedQuoteFragment = (
  { __typename?: 'Quote' }
  & Pick<Quote, '_id' | '_rev' | '_deleted' | 'number' | 'status' | 'jobAddress' | 'demoTitle' | 'job_identifier' | 'archived' | 'owner' | 'quote_date' | 'acceptedDate' | 'totals' | 'sendError' | 'int_ext' | 'lead_source' | 'is_invoice' | 'tags' | 'tagDetails' | 'parent_quote' | 'parent_quote_number' | 'child_invoice_number' | 'child_invoice_numbers' | 'trashed' | 'trashedDate' | 'trashedBy' | 'deleteDate' | 'lastMessage' | 'calculationLock' | 'payments' | 'meta' | 'addedOptionsTotal' | 'additionalWorkTotal' | 'totalHours' | 'amountPaid' | 'balanceDue' | 'deal_id' | 'assignedUsers'>
  & { contact?: Maybe<(
    { __typename?: 'QuoteContact' }
    & Pick<QuoteContact, 'id' | 'first_name' | 'last_name' | 'email' | 'address' | 'city' | 'province' | 'postal' | 'lead_source' | 'phone_number'>
  )> }
);

export type TaskQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TaskQuery = (
  { __typename?: 'Query' }
  & { task?: Maybe<(
    { __typename?: 'Task' }
    & FullTaskFragment
  )> }
);

export type SearchLooseyTasksQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  skipSanitize?: Maybe<Scalars['Boolean']>;
}>;


export type SearchLooseyTasksQuery = (
  { __typename?: 'Query' }
  & { searchTasks?: Maybe<(
    { __typename?: 'SearchTasksResult' }
    & Pick<SearchTasksResult, 'total_rows' | 'bookmark'>
    & { tasks?: Maybe<Array<Maybe<(
      { __typename?: 'Task' }
      & SearchedTaskFragment
    )>>> }
  )> }
);

export type SearchTemplateTasksQueryVariables = Exact<{
  query: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  skipSanitize?: Maybe<Scalars['Boolean']>;
}>;


export type SearchTemplateTasksQuery = (
  { __typename?: 'Query' }
  & { searchTasks?: Maybe<(
    { __typename?: 'SearchTasksResult' }
    & Pick<SearchTasksResult, 'total_rows' | 'bookmark'>
    & { tasks?: Maybe<Array<Maybe<(
      { __typename?: 'Task' }
      & SearchedTaskFragment
    )>>> }
  )> }
);

export type SearchTasksByContactQueryVariables = Exact<{
  contactId: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchTasksByContactQuery = (
  { __typename?: 'Query' }
  & { searchTasksByContact?: Maybe<(
    { __typename?: 'SearchTasksResult' }
    & Pick<SearchTasksResult, 'total_rows' | 'bookmark'>
    & { tasks?: Maybe<Array<Maybe<(
      { __typename?: 'Task' }
      & SearchedTaskFragment
    )>>> }
  )> }
);

export type SearchTasksByCompanyQueryVariables = Exact<{
  companyId: Scalars['String'];
  bookmark?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchTasksByCompanyQuery = (
  { __typename?: 'Query' }
  & { searchTasksByCompany?: Maybe<(
    { __typename?: 'SearchTasksResult' }
    & Pick<SearchTasksResult, 'total_rows' | 'bookmark'>
    & { tasks?: Maybe<Array<Maybe<(
      { __typename?: 'Task' }
      & SearchedTaskFragment
    )>>> }
  )> }
);

export type TaskCountsQueryVariables = Exact<{
  query: Scalars['String'];
  skipSanitize?: Maybe<Scalars['Boolean']>;
}>;


export type TaskCountsQuery = (
  { __typename?: 'Query' }
  & { taskCounts?: Maybe<(
    { __typename?: 'TaskCounts' }
    & Pick<TaskCounts, 'total' | 'completed' | 'remaining'>
  )> }
);

export type SaveTaskMutationVariables = Exact<{
  task: Scalars['JSON'];
  skipActivity?: Maybe<Scalars['Boolean']>;
}>;


export type SaveTaskMutation = (
  { __typename?: 'Mutation' }
  & { saveTask?: Maybe<(
    { __typename?: 'Task' }
    & FullTaskFragment
  )> }
);

export type DeleteTasksMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  softDelete?: Maybe<Scalars['Boolean']>;
}>;


export type DeleteTasksMutation = (
  { __typename?: 'Mutation' }
  & { deleteTasks: Array<(
    { __typename?: 'BulkDocsResponseObject' }
    & Pick<BulkDocsResponseObject, '_id' | '_rev' | 'error' | 'reason'>
  )> }
);

export type FullTaskFragment = (
  { __typename?: 'Task' }
  & Pick<Task, '_id' | '_rev' | '_deleted' | 'type' | 'created' | 'updated' | 'dealId' | 'dealName' | 'title' | 'startDateTime' | 'notes' | 'contact' | 'completed' | 'completedDate' | 'jobAddress' | 'template' | 'translations'>
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
  )> }
);

export type SearchedTaskFragment = (
  { __typename?: 'Task' }
  & Pick<Task, '_id' | '_rev' | '_deleted' | 'type' | 'created' | 'updated' | 'dealId' | 'dealName' | 'title' | 'startDateTime' | 'notes' | 'contact' | 'completed' | 'completedDate' | 'jobAddress' | 'template' | 'translations'>
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'firstName' | 'lastName' | 'email'>
  )> }
);

export type WeatherQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type WeatherQuery = (
  { __typename?: 'Query' }
  & { weather: Array<(
    { __typename?: 'WeatherDay' }
    & Pick<WeatherDay, 'time' | 'temperature' | 'temperatureMin' | 'temperatureMax' | 'weatherCode' | 'precipitationProbability'>
  )> }
);

export type GetWebhooksQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetWebhooksQuery = (
  { __typename?: 'Query' }
  & { getWebhooks?: Maybe<(
    { __typename?: 'WebhooksResult' }
    & Pick<WebhooksResult, 'total'>
    & { rows?: Maybe<Array<Maybe<(
      { __typename?: 'WebhookType' }
      & FullWebhookTypeFragment
    )>>> }
  )> }
);

export type GetWebhookEventsQueryVariables = Exact<{
  companyId: Scalars['String'];
  webhookId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
}>;


export type GetWebhookEventsQuery = (
  { __typename?: 'Query' }
  & { getWebhookEvents?: Maybe<(
    { __typename?: 'WebhookEventsResult' }
    & Pick<WebhookEventsResult, 'total'>
    & { rows?: Maybe<Array<Maybe<(
      { __typename?: 'WebhookEventType' }
      & FullWebhookEventTypeFragment
    )>>> }
  )> }
);

export type UpdateWebhookEnabledMutationVariables = Exact<{
  companyId: Scalars['String'];
  webhookId: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type UpdateWebhookEnabledMutation = (
  { __typename?: 'Mutation' }
  & { updateWebhookEnabled?: Maybe<(
    { __typename?: 'WebhookType' }
    & FullWebhookTypeFragment
  )> }
);

export type FullWebhookTypeFragment = (
  { __typename?: 'WebhookType' }
  & Pick<WebhookType, 'id' | 'url' | 'events' | 'enabled' | 'deleted'>
  & { timestamp?: Maybe<(
    { __typename?: 'WebhookTimestamp' }
    & Pick<WebhookTimestamp, 'created' | 'updated'>
  )>, params?: Maybe<(
    { __typename?: 'WebhookParams' }
    & Pick<WebhookParams, 'quoteTypes' | 'quoteStatus' | 'eventTypes' | 'stageIds' | 'tagsAdded' | 'tagsRemoved' | 'isInvoice'>
  )> }
);

export type FullWebhookEventTypeFragment = (
  { __typename?: 'WebhookEventType' }
  & Pick<WebhookEventType, 'id' | 'webhookId' | 'webhookUrl' | 'event' | 'status' | 'httpStatus' | 'retryCount' | 'maxRetries' | 'timestamp' | 'lastAttempt' | 'nextRetry' | 'error' | 'documentId' | 'documentType' | 'payload'>
);

export const CommonActivityDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment CommonActivityDetails on ActivityDetails {
  activityType
  docType
  url
  events
  quote {
    id
    number
    status
    total
    error
    dealId
    int_ext {
      value
      label
    }
  }
  invoice {
    id
    number
    status
    total
    error
    dealId
    int_ext {
      value
      label
    }
  }
  deal {
    id
    name
    total
    stage
  }
  contact {
    id
    firstName
    lastName
    secondaryFirstName
    secondaryLastName
    email
    phoneNumber
    preferredContactMethod
    companyId
    companyName
  }
  owner {
    id
    firstName
    lastName
    title
    phoneNumber
    avatar
  }
  quoteOwner {
    id
    firstName
    lastName
    title
    email
    phoneNumber
    avatar
  }
  timestamp
  updated
  updatedInterval
  isAutomated
}
    `;
export const FullActivityFragmentDoc = /*#__PURE__*/ gql`
    fragment FullActivity on Activity {
  _id
  type
  trashed
  hidden
  docIds
  assignedUsers
  details {
    ...CommonActivityDetails
    ... on MessageActivityDetails {
      message {
        from {
          userId
          name
          email
          isCustomer
          isAutomated
        }
        deleted
        text
        readAt
      }
    }
    ... on ChatMessageActivityDetails {
      rating
      undo
      chatMessage {
        sender
        text
        toolCalls
        model
        error
        usage {
          inputTokens
          outputTokens
          cacheReadTokens
          cacheCreationTokens
          estimatedCostUsd
        }
      }
    }
    ... on NoteActivityDetails {
      note
      translations
      files
      legacyNote
      pinnedOn
      versions {
        timestamp
        owner {
          id
          firstName
          lastName
        }
        note
        files {
          id
          name
          url
          type
        }
      }
    }
    ... on WarningActivityDetails {
      warningMessage
      warningTitle
    }
    ... on SentActivityDetails {
      isWorkOrder
      email {
        to
        subject
        content
        smsTo
      }
    }
    ... on FollowUpSentActivityDetails {
      email {
        to
        subject
        content
        smsTo
      }
      smsTo
      text
    }
    ... on PaymentReceivedSentActivityDetails {
      amountPaid
      email {
        to
        subject
        content
        smsTo
      }
    }
    ... on EventEmailSentActivityDetails {
      email {
        to
        subject
        content
        smsTo
      }
      eventType
      address
      geocode {
        lat
        lng
      }
      start
      end
      note
      canceled
    }
    ... on DeclinedActivityDetails {
      reason
    }
    ... on AcceptedActivityDetails {
      additional
      signature
    }
    ... on ViewedActivityDetails {
      viewingEmail
      device
    }
    ... on PaymentActivityDetails {
      amountPaid
      provider
      providerDetails
      note
      method
      deposit
      paymentDate
      paymentRequestId
      isProcessing
      isFailed
      isRefund
      originalAmount
      source
      surcharge
    }
    ... on PaymentRequestedActivityDetails {
      amountRequested
      status
      note
      deposit
      smsTo
      lastSent
      email {
        to
        subject
        content
        smsTo
      }
    }
    ... on EventActivityDetails {
      deal {
        id
        source
        name
        total
        hours
        assignedUsers
      }
      eventType
      quoteType
      title
      address
      jobAddress {
        address
        city
        province
        postal
      }
      crew
      progress
      previousProgress
      geocode {
        lat
        lng
      }
      production
      start
      end
      note
      canceled
    }
    ... on FileAddedActivityDetails {
      fileName
      fileCount
    }
    ... on TaskActivityDetails {
      taskName
      templateId
    }
    ... on AssignmentActivityDetails {
      assignees
      assigner
    }
    ... on OwnerChangedActivityDetails {
      newOwner {
        id
        firstName
        lastName
        email
      }
      oldOwner {
        id
        firstName
        lastName
        email
      }
    }
    ... on StageChangedActivityDetails {
      oldStage
      newStage
    }
    ... on LeadFormSubmissionActivityDetails {
      note
      address
      formKey
      newStage
      leadSource
      acquisitionSource
      uploadedFiles {
        id
        name
        url
        type
      }
    }
  }
}
    ${CommonActivityDetailsFragmentDoc}`;
export const FullNoteActivityFragmentDoc = /*#__PURE__*/ gql`
    fragment FullNoteActivity on Activity {
  _id
  type
  trashed
  hidden
  docIds
  details {
    ...CommonActivityDetails
    ... on NoteActivityDetails {
      note
      translations
      files
      legacyNote
      pinnedOn
      versions {
        timestamp
        owner {
          id
          firstName
          lastName
        }
        note
        files {
          id
          name
          url
          type
        }
      }
    }
  }
}
    ${CommonActivityDetailsFragmentDoc}`;
export const FullMessageActivityFragmentDoc = /*#__PURE__*/ gql`
    fragment FullMessageActivity on Activity {
  _id
  type
  trashed
  hidden
  docIds
  details {
    ...CommonActivityDetails
    ... on MessageActivityDetails {
      message {
        from {
          userId
          name
          email
          isCustomer
          isAutomated
          avatar
        }
        deleted
        text
        readAt
        smsTo
      }
    }
  }
}
    ${CommonActivityDetailsFragmentDoc}`;
export const FullPaymentActivityFragmentDoc = /*#__PURE__*/ gql`
    fragment FullPaymentActivity on Activity {
  _id
  type
  trashed
  hidden
  docIds
  details {
    ...CommonActivityDetails
    ... on PaymentActivityDetails {
      amountPaid
      provider
      providerDetails
      note
      method
      deposit
      paymentDate
      paymentRequestId
      isProcessing
      isFailed
      isRefund
      originalAmount
      source
      surcharge
      trashed
    }
  }
}
    ${CommonActivityDetailsFragmentDoc}`;
export const FullChatMessageActivityFragmentDoc = /*#__PURE__*/ gql`
    fragment FullChatMessageActivity on Activity {
  _id
  type
  trashed
  hidden
  docIds
  details {
    ...CommonActivityDetails
    ... on ChatMessageActivityDetails {
      rating
      feedback
      undo
      conversationTitle
      chatMessage {
        sender
        text
        toolCalls
        model
        error
        usage {
          inputTokens
          outputTokens
          cacheReadTokens
          cacheCreationTokens
          estimatedCostUsd
        }
      }
    }
  }
}
    ${CommonActivityDetailsFragmentDoc}`;
export const FullEventActivityFragmentDoc = /*#__PURE__*/ gql`
    fragment FullEventActivity on Activity {
  _id
  type
  trashed
  hidden
  docIds
  details {
    ...CommonActivityDetails
    ... on EventActivityDetails {
      deal {
        id
        source
        name
        total
        hours
        tags
        assignedUsers
      }
      quoteType
      eventType
      attendees
      title
      crew
      progress
      previousProgress
      address
      geocode {
        lat
        lng
      }
      production
      start
      end
      note
      canceled
    }
  }
}
    ${CommonActivityDetailsFragmentDoc}`;
export const FullApiKeyDocFragmentDoc = /*#__PURE__*/ gql`
    fragment FullApiKeyDoc on ApiKeyDocument {
  _id
  _rev
  companyId
  created
  name
  owner {
    id
    email
    firstName
    lastName
    phoneNumber
  }
  archived
}
    `;
export const PublicUserFragmentDoc = /*#__PURE__*/ gql`
    fragment PublicUser on User {
  user_id
  email
  name
  user_metadata {
    firstName
    lastName
    phoneNumber
    phoneExtension
    title
    language
    customAvatar {
      label
      fileType
      width
      height
      value
      cdnValue
      cloudinaryId
      s3PublicKey
    }
    playerName
    blockLaunchDialog
    projectTypes
    hasJoinedLeaderboard
    color
    leaderboardOptOut
  }
  app_metadata {
    active
    roles
    accountOwner
    permissions
    customPermissions
    companyId
    mfa_enabled
    isOwner
    painterType
    user {
      _id
    }
  }
  picture
  preferences
  signature
  client {
    meta {
      _id
      _rev
      type
      active
      trialExpiry
      billingId
      parentCompanyId
      plan
      name
      address
      city
      province
      country
      postal
      phone
      email
      notes
    }
    options
  }
}
    `;
export const FullMetaFragmentDoc = /*#__PURE__*/ gql`
    fragment FullMeta on ClientMeta {
  _id
  _rev
  province
  country
  postal
  phone
  email
  notes
  active
  banned
  skipHubspotSync
  stage
  trialExpiry
  billingId
  nonBilling
  includeInLeaderboards
  excludeFromLeaderboards
  parentCompanyId
  paymentExpiryNotice
  userCounts {
    all
  }
  subscription {
    plan_id
    current_term_start
    current_term_end
    status
  }
  cancellationFlow {
    status
    cancellationScheduledFor
  }
  aggregates {
    totalQuotes
    totalInvoices
    totalBidValue
    averageBidValue
    closeRate
    closedQuotes
    closedValue
    averageCloseValue
  }
  plan
  name
  address
  city
  updated
  created
  delete
  options {
    companyCoordinates
  }
}
    `;
export const FullManufacturerProductFragmentDoc = /*#__PURE__*/ gql`
    fragment FullManufacturerProduct on ManufacturerProduct {
  number
  productLineId
  name
  category
  type
  coverage
  size
  imageUrl
  description
  manufacturer
  baseName
  sheen
}
    `;
export const FullManufacturerColorFragmentDoc = /*#__PURE__*/ gql`
    fragment FullManufacturerColor on ManufacturerColor {
  number
  name
  description
  image
  localImage
  hexColor
  paintWood
  manufacturer
  productLines
  intRank
  extRank
}
    `;
export const FullCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment FullCompany on Company {
  _id
  _rev
  _deleted
  trashed
  trashedBy
  deleteDate
  type
  name
  email
  address
  city
  province
  country
  postal
  phone_number
  phone_ext
  created_by
  created
  updated
  assignedUsers
  tags
  lead_source
  files
  owner {
    id
    firstName
    lastName
    email
  }
}
    `;
export const SearchedCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchedCompany on Company {
  _id
  _rev
  _deleted
  trashed
  trashedBy
  deleteDate
  type
  name
  email
  address
  city
  province
  country
  postal
  phone_number
  phone_ext
  created_by
  created
  updated
  assignedUsers
  tags
  lead_source
  files
  owner {
    id
    firstName
    lastName
    email
  }
}
    `;
export const FullContactFragmentDoc = /*#__PURE__*/ gql`
    fragment FullContact on Contact {
  _id
  _rev
  _deleted
  trashed
  trashedBy
  deleteDate
  type
  first_name
  last_name
  secondary_first_name
  secondary_last_name
  email
  alternate_email
  billingAddress
  shippingAddress
  isBillingShipping
  address
  city
  province
  country
  postal
  geocode {
    lat
    lng
  }
  phone_number
  phone_ext
  alternate_phone
  alternate_phone_ext
  sms_undeliverable
  sms_undeliverable_reason
  sms_undeliverable_at
  company
  companyDocId
  contact_type
  created_by
  created_date
  updated_date
  trashed
  trashedBy
  deleteDate
  preferred_contact_method
  tags
  files
  source_id
  source_user_id
  source
  lead_source
  acquisitionSource
  internal_note
  assignedUsers
  owner {
    id
    firstName
    lastName
    email
    phoneNumber
    phoneExtension
    title
  }
  wisetackPrequal {
    prequalLink
    prequalId
    customerId
    merchantId
    signupId
    prequalStatus
    date
    startDate
    eventType
    maxQualifiedAmount
    aprRange
    expirationDate
    customerInfo {
      firstName
      lastName
      mobileNumber
    }
  }
  wisetackLoanApplications {
    loanApplicationLink
    transactionId
    messageId
    changedStatus
    date
    startDate
    requestedLoanAmount
    approvedLoanAmount
    settledLoanAmount
    processingFee
    invoiceNumber
    quoteNumber
    purchaseId
    refund {
      id
      amount
      merchantDebitAmount
      date
    }
    maximumAmount
    transactionPurpose
    serviceCompletedOn
    tilaAcceptedOn
    createdAt
    expirationDate
    prequalId
    customerId
    payouts
  }
}
    `;
export const SearchedContactFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchedContact on Contact {
  _id
  _rev
  type
  first_name
  last_name
  secondary_first_name
  secondary_last_name
  email
  alternate_email
  billingAddress
  shippingAddress
  isBillingShipping
  address
  city
  province
  country
  postal
  phone_number
  phone_ext
  alternate_phone
  sms_undeliverable
  company
  companyDocId
  created_date
  updated_date
  trashed
  trashedBy
  deleteDate
  preferred_contact_method
  tags
  files
  source_id
  source_user_id
  source
  lead_source
  acquisitionSource
  owner {
    id
    firstName
    lastName
    email
  }
  wisetackPrequal {
    prequalLink
    prequalId
    customerId
    merchantId
    signupId
    prequalStatus
    date
    startDate
    eventType
    maxQualifiedAmount
    aprRange
    expirationDate
    customerInfo {
      firstName
      lastName
      mobileNumber
    }
  }
  wisetackLoanApplications {
    loanApplicationLink
    transactionId
    messageId
    changedStatus
    date
    startDate
    requestedLoanAmount
    approvedLoanAmount
    settledLoanAmount
    processingFee
    invoiceNumber
    quoteNumber
    purchaseId
    refund {
      id
      amount
      merchantDebitAmount
      date
    }
    maximumAmount
    transactionPurpose
    serviceCompletedOn
    tilaAcceptedOn
    createdAt
    expirationDate
    prequalId
    customerId
    payouts
  }
}
    `;
export const FullDealFragmentDoc = /*#__PURE__*/ gql`
    fragment FullDeal on Deal {
  _id
  _rev
  _deleted
  type
  quoteType
  contact {
    id
    firstName
    lastName
    email
    phoneNumber
    company
    companyId
    preferredContactMethod
  }
  name
  stage {
    value
  }
  jobAddress
  geocode {
    lat
    lng
  }
  value
  valueBeforeTax
  hours
  created_by
  created
  updated
  archived
  trashed
  deleteDate
  lead_source
  acquisitionSource
  assignedUsers
  tags
  linkedQuoteIds
  linkedInvoiceIds
  pipeline {
    label
    value
  }
  files
  history
  owner {
    id
    firstName
    lastName
    email
  }
  ownerHistory
  status
  taskTemplateOrder
  jobCosting {
    labour
    materials
    overhead
    profit
    margin
  }
}
    `;
export const SearchedDealFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchedDeal on Deal {
  _id
  _rev
  _deleted
  quoteType
  type
  contact {
    id
    firstName
    lastName
    email
    phoneNumber
    company
    companyId
    preferredContactMethod
  }
  name
  stage {
    value
  }
  jobAddress
  geocode {
    lat
    lng
  }
  value
  hours
  created_by
  created
  updated
  archived
  lead_source
  acquisitionSource
  assignedUsers
  tags
  pipeline {
    label
    value
  }
  files
  history
  enteredStage
  owner {
    id
    firstName
    lastName
    email
  }
  ownerHistory
}
    `;
export const AdminPaymentFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment AdminPaymentFields on AdminPaymentEntry {
  id
  activityId
  amount
  status
  type
  date
  deposit
  surcharge
  paymentRequestId
  requestActivityId
  forPaymentId
  providerDetails
  txnId
  portalLink
}
    `;
export const AdminPaymentQuoteFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment AdminPaymentQuoteFields on AdminPaymentQuote {
  id
  number
  isInvoice
  contactName
  amountPaid
  balanceDue
  paymentProcessing
  paymentError
  payments {
    ...AdminPaymentFields
  }
}
    ${AdminPaymentFieldsFragmentDoc}`;
export const PainterScheduleQuoteFragmentDoc = /*#__PURE__*/ gql`
    fragment PainterScheduleQuote on Quote {
  _id
  _rev
  type
  is_invoice
  int_ext
  deal_id
  number
  jobAddress
  internal_note
  productString
  totalHours
  defaultView
  additionalWork
  areas
  substrates
  lineItems
  groups
  options
  order
  files
  payments
  totals
  status
  dates
  signatures
  meta
  translations
  contact {
    first_name
    last_name
    email
    phone_number
  }
}
    `;
export const FullQuoteFragmentDoc = /*#__PURE__*/ gql`
    fragment FullQuote on Quote {
  _id
  _rev
  type
  name
  number
  fromTemplate
  jobAddress
  job_identifier
  quote_date
  hourly_rate
  tax_rate
  tax_description
  is_invoice
  parent_quote
  parent_quote_number
  discount
  discount_type
  discount_rate
  discount_description
  discount_isShown
  totalAdjustment
  products
  discounts
  clientVisible
  client_note
  contact {
    id
    rev
    first_name
    last_name
    email
    address
    city
    province
    phone_number
  }
  label
  lead_source
  created_by
  defaultView
  sendError
  terms
  presentation
  customTerms
  status
  int_ext
  additionalWork
  internal_note
  productString
  areas
  substrates
  lineItems
  groups
  substratesGroupBy
  order
  sentReports
  dates
  lastViewedActivity
  lastMessage
  images
  files
  signatures
  child_invoice
  child_invoices
  child_invoice_number
  child_invoice_numbers
  owner
  assignedUsers
  totals
  templateId
  payments
  depositInfo
  source
  tags
  tagDetails
  estimatorNotes
  lastUserSave
  copyOf
}
    `;
export const SearchedQuoteFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchedQuote on Quote {
  _id
  _rev
  _deleted
  number
  status
  jobAddress
  demoTitle
  job_identifier
  contact {
    id
    first_name
    last_name
    email
    address
    city
    province
    postal
    lead_source
    phone_number
  }
  archived
  owner
  quote_date
  acceptedDate
  totals
  sendError
  int_ext
  lead_source
  is_invoice
  tags
  tagDetails
  parent_quote
  parent_quote_number
  child_invoice_number
  child_invoice_numbers
  trashed
  trashedDate
  trashedBy
  deleteDate
  lastMessage
  calculationLock
  payments
  meta
  addedOptionsTotal
  additionalWorkTotal
  totalHours
  amountPaid
  balanceDue
  deal_id
  assignedUsers
}
    `;
export const FullTaskFragmentDoc = /*#__PURE__*/ gql`
    fragment FullTask on Task {
  _id
  _rev
  _deleted
  type
  created
  updated
  dealId
  dealName
  title
  startDateTime
  notes
  contact
  completed
  completedDate
  jobAddress
  owner {
    id
    firstName
    lastName
    email
  }
  template
  translations
}
    `;
export const SearchedTaskFragmentDoc = /*#__PURE__*/ gql`
    fragment SearchedTask on Task {
  _id
  _rev
  _deleted
  type
  created
  updated
  dealId
  dealName
  title
  startDateTime
  notes
  contact
  completed
  completedDate
  jobAddress
  owner {
    id
    firstName
    lastName
    email
  }
  template
  translations
}
    `;
export const FullWebhookTypeFragmentDoc = /*#__PURE__*/ gql`
    fragment FullWebhookType on WebhookType {
  id
  url
  events
  enabled
  deleted
  timestamp {
    created
    updated
  }
  params {
    quoteTypes
    quoteStatus
    eventTypes
    stageIds
    tagsAdded
    tagsRemoved
    isInvoice
  }
}
    `;
export const FullWebhookEventTypeFragmentDoc = /*#__PURE__*/ gql`
    fragment FullWebhookEventType on WebhookEventType {
  id
  webhookId
  webhookUrl
  event
  status
  httpStatus
  retryCount
  maxRetries
  timestamp
  lastAttempt
  nextRetry
  error
  documentId
  documentType
  payload
}
    `;
export const ActivitiesForDocDocument = /*#__PURE__*/ gql`
    query activitiesForDoc($id: String!, $type: String, $limit: Int = 20, $bookmark: String, $includeMessages: Boolean) {
  activitiesForDoc(
    id: $id
    type: $type
    limit: $limit
    bookmark: $bookmark
    includeMessages: $includeMessages
  ) {
    total_rows
    bookmark
    activities {
      ...FullActivity
    }
  }
}
    ${FullActivityFragmentDoc}`;

/**
 * __useActivitiesForDocQuery__
 *
 * To run a query within a React component, call `useActivitiesForDocQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesForDocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesForDocQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *      bookmark: // value for 'bookmark'
 *      includeMessages: // value for 'includeMessages'
 *   },
 * });
 */
export function useActivitiesForDocQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActivitiesForDocQuery, ActivitiesForDocQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivitiesForDocQuery, ActivitiesForDocQueryVariables>(ActivitiesForDocDocument, options);
      }
export function useActivitiesForDocLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivitiesForDocQuery, ActivitiesForDocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivitiesForDocQuery, ActivitiesForDocQueryVariables>(ActivitiesForDocDocument, options);
        }
export type ActivitiesForDocQueryHookResult = ReturnType<typeof useActivitiesForDocQuery>;
export type ActivitiesForDocLazyQueryHookResult = ReturnType<typeof useActivitiesForDocLazyQuery>;
export type ActivitiesForDocQueryResult = ApolloReactCommon.QueryResult<ActivitiesForDocQuery, ActivitiesForDocQueryVariables>;
export const ChatHistoryForQuoteDocument = /*#__PURE__*/ gql`
    query chatHistoryForQuote($id: String!, $limit: Int = 200) {
  activitiesForDoc(id: $id, type: "chat-message", limit: $limit) {
    total_rows
    bookmark
    activities {
      ...FullChatMessageActivity
    }
  }
}
    ${FullChatMessageActivityFragmentDoc}`;

/**
 * __useChatHistoryForQuoteQuery__
 *
 * To run a query within a React component, call `useChatHistoryForQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatHistoryForQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatHistoryForQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChatHistoryForQuoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatHistoryForQuoteQuery, ChatHistoryForQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatHistoryForQuoteQuery, ChatHistoryForQuoteQueryVariables>(ChatHistoryForQuoteDocument, options);
      }
export function useChatHistoryForQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatHistoryForQuoteQuery, ChatHistoryForQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatHistoryForQuoteQuery, ChatHistoryForQuoteQueryVariables>(ChatHistoryForQuoteDocument, options);
        }
export type ChatHistoryForQuoteQueryHookResult = ReturnType<typeof useChatHistoryForQuoteQuery>;
export type ChatHistoryForQuoteLazyQueryHookResult = ReturnType<typeof useChatHistoryForQuoteLazyQuery>;
export type ChatHistoryForQuoteQueryResult = ApolloReactCommon.QueryResult<ChatHistoryForQuoteQuery, ChatHistoryForQuoteQueryVariables>;
export const NewActivitiesForDocDocument = /*#__PURE__*/ gql`
    query newActivitiesForDoc($id: String!, $since: Float) {
  newActivitiesForDoc(id: $id, since: $since) {
    ...FullActivity
  }
}
    ${FullActivityFragmentDoc}`;

/**
 * __useNewActivitiesForDocQuery__
 *
 * To run a query within a React component, call `useNewActivitiesForDocQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewActivitiesForDocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewActivitiesForDocQuery({
 *   variables: {
 *      id: // value for 'id'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useNewActivitiesForDocQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NewActivitiesForDocQuery, NewActivitiesForDocQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewActivitiesForDocQuery, NewActivitiesForDocQueryVariables>(NewActivitiesForDocDocument, options);
      }
export function useNewActivitiesForDocLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewActivitiesForDocQuery, NewActivitiesForDocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewActivitiesForDocQuery, NewActivitiesForDocQueryVariables>(NewActivitiesForDocDocument, options);
        }
export type NewActivitiesForDocQueryHookResult = ReturnType<typeof useNewActivitiesForDocQuery>;
export type NewActivitiesForDocLazyQueryHookResult = ReturnType<typeof useNewActivitiesForDocLazyQuery>;
export type NewActivitiesForDocQueryResult = ApolloReactCommon.QueryResult<NewActivitiesForDocQuery, NewActivitiesForDocQueryVariables>;
export const SearchActivitiesDocument = /*#__PURE__*/ gql`
    query searchActivities($query: String!, $bookmark: String, $limit: Int, $sort: [String!], $pinnedForDocId: String, $skipSanitize: Boolean, $isProductionCalendar: Boolean) {
  searchActivities(
    query: $query
    bookmark: $bookmark
    limit: $limit
    sort: $sort
    pinnedForDocId: $pinnedForDocId
    skipSanitize: $skipSanitize
    isProductionCalendar: $isProductionCalendar
  ) {
    total_rows
    bookmark
    hasMore
    activities {
      ...FullActivity
    }
  }
}
    ${FullActivityFragmentDoc}`;

/**
 * __useSearchActivitiesQuery__
 *
 * To run a query within a React component, call `useSearchActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchActivitiesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      pinnedForDocId: // value for 'pinnedForDocId'
 *      skipSanitize: // value for 'skipSanitize'
 *      isProductionCalendar: // value for 'isProductionCalendar'
 *   },
 * });
 */
export function useSearchActivitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchActivitiesQuery, SearchActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchActivitiesQuery, SearchActivitiesQueryVariables>(SearchActivitiesDocument, options);
      }
export function useSearchActivitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchActivitiesQuery, SearchActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchActivitiesQuery, SearchActivitiesQueryVariables>(SearchActivitiesDocument, options);
        }
export type SearchActivitiesQueryHookResult = ReturnType<typeof useSearchActivitiesQuery>;
export type SearchActivitiesLazyQueryHookResult = ReturnType<typeof useSearchActivitiesLazyQuery>;
export type SearchActivitiesQueryResult = ApolloReactCommon.QueryResult<SearchActivitiesQuery, SearchActivitiesQueryVariables>;
export const ActivityDocument = /*#__PURE__*/ gql`
    query activity($id: String!) {
  activity(id: $id) {
    ...FullActivity
  }
}
    ${FullActivityFragmentDoc}`;

/**
 * __useActivityQuery__
 *
 * To run a query within a React component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
      }
export function useActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
        }
export type ActivityQueryHookResult = ReturnType<typeof useActivityQuery>;
export type ActivityLazyQueryHookResult = ReturnType<typeof useActivityLazyQuery>;
export type ActivityQueryResult = ApolloReactCommon.QueryResult<ActivityQuery, ActivityQueryVariables>;
export const MessagesDocument = /*#__PURE__*/ gql`
    query messages($quoteId: String, $bookmark: String, $limit: Int = 20) {
  messages(quoteId: $quoteId, bookmark: $bookmark, limit: $limit) {
    total_rows
    bookmark
    messages {
      ...FullMessageActivity
    }
  }
}
    ${FullMessageActivityFragmentDoc}`;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesQueryResult = ApolloReactCommon.QueryResult<MessagesQuery, MessagesQueryVariables>;
export const UnreadMessagesDocument = /*#__PURE__*/ gql`
    query unreadMessages($quoteId: String) {
  unreadMessages(quoteId: $quoteId) {
    ...FullMessageActivity
  }
}
    ${FullMessageActivityFragmentDoc}`;

/**
 * __useUnreadMessagesQuery__
 *
 * To run a query within a React component, call `useUnreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadMessagesQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useUnreadMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnreadMessagesQuery, UnreadMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnreadMessagesQuery, UnreadMessagesQueryVariables>(UnreadMessagesDocument, options);
      }
export function useUnreadMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnreadMessagesQuery, UnreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnreadMessagesQuery, UnreadMessagesQueryVariables>(UnreadMessagesDocument, options);
        }
export type UnreadMessagesQueryHookResult = ReturnType<typeof useUnreadMessagesQuery>;
export type UnreadMessagesLazyQueryHookResult = ReturnType<typeof useUnreadMessagesLazyQuery>;
export type UnreadMessagesQueryResult = ApolloReactCommon.QueryResult<UnreadMessagesQuery, UnreadMessagesQueryVariables>;
export const NewMessagesDocument = /*#__PURE__*/ gql`
    query newMessages($quoteId: String, $since: Float) {
  newMessages(quoteId: $quoteId, since: $since) {
    ...FullMessageActivity
  }
}
    ${FullMessageActivityFragmentDoc}`;

/**
 * __useNewMessagesQuery__
 *
 * To run a query within a React component, call `useNewMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewMessagesQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useNewMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NewMessagesQuery, NewMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewMessagesQuery, NewMessagesQueryVariables>(NewMessagesDocument, options);
      }
export function useNewMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewMessagesQuery, NewMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewMessagesQuery, NewMessagesQueryVariables>(NewMessagesDocument, options);
        }
export type NewMessagesQueryHookResult = ReturnType<typeof useNewMessagesQuery>;
export type NewMessagesLazyQueryHookResult = ReturnType<typeof useNewMessagesLazyQuery>;
export type NewMessagesQueryResult = ApolloReactCommon.QueryResult<NewMessagesQuery, NewMessagesQueryVariables>;
export const UnscheduledJobsDocument = /*#__PURE__*/ gql`
    query unscheduledJobs($query: String!, $bookmark: String, $limit: Int) {
  unscheduledJobs(query: $query, bookmark: $bookmark, limit: $limit) {
    total_rows
    bookmark
    activities {
      ...FullEventActivity
    }
  }
}
    ${FullEventActivityFragmentDoc}`;

/**
 * __useUnscheduledJobsQuery__
 *
 * To run a query within a React component, call `useUnscheduledJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnscheduledJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnscheduledJobsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUnscheduledJobsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnscheduledJobsQuery, UnscheduledJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnscheduledJobsQuery, UnscheduledJobsQueryVariables>(UnscheduledJobsDocument, options);
      }
export function useUnscheduledJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnscheduledJobsQuery, UnscheduledJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnscheduledJobsQuery, UnscheduledJobsQueryVariables>(UnscheduledJobsDocument, options);
        }
export type UnscheduledJobsQueryHookResult = ReturnType<typeof useUnscheduledJobsQuery>;
export type UnscheduledJobsLazyQueryHookResult = ReturnType<typeof useUnscheduledJobsLazyQuery>;
export type UnscheduledJobsQueryResult = ApolloReactCommon.QueryResult<UnscheduledJobsQuery, UnscheduledJobsQueryVariables>;
export const SyncActivitiesForDocDocument = /*#__PURE__*/ gql`
    mutation syncActivitiesForDoc($id: String!) {
  syncActivitiesForDoc(id: $id)
}
    `;
export type SyncActivitiesForDocMutationFn = ApolloReactCommon.MutationFunction<SyncActivitiesForDocMutation, SyncActivitiesForDocMutationVariables>;

/**
 * __useSyncActivitiesForDocMutation__
 *
 * To run a mutation, you first call `useSyncActivitiesForDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncActivitiesForDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncActivitiesForDocMutation, { data, loading, error }] = useSyncActivitiesForDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncActivitiesForDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncActivitiesForDocMutation, SyncActivitiesForDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncActivitiesForDocMutation, SyncActivitiesForDocMutationVariables>(SyncActivitiesForDocDocument, options);
      }
export type SyncActivitiesForDocMutationHookResult = ReturnType<typeof useSyncActivitiesForDocMutation>;
export type SyncActivitiesForDocMutationResult = ApolloReactCommon.MutationResult<SyncActivitiesForDocMutation>;
export type SyncActivitiesForDocMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncActivitiesForDocMutation, SyncActivitiesForDocMutationVariables>;
export const SendMessageDocument = /*#__PURE__*/ gql`
    mutation sendMessage($message: String!, $quoteId: String, $timestamp: Float, $sendNotification: Boolean) {
  sendMessage(
    message: $message
    quoteId: $quoteId
    timestamp: $timestamp
    sendNotification: $sendNotification
  ) {
    activity {
      ...FullMessageActivity
    }
    quote
  }
}
    ${FullMessageActivityFragmentDoc}`;
export type SendMessageMutationFn = ApolloReactCommon.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      quoteId: // value for 'quoteId'
 *      timestamp: // value for 'timestamp'
 *      sendNotification: // value for 'sendNotification'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = ApolloReactCommon.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const DeleteMessageDocument = /*#__PURE__*/ gql`
    mutation deleteMessage($id: String!, $quoteId: String) {
  deleteMessage(id: $id, quoteId: $quoteId)
}
    `;
export type DeleteMessageMutationFn = ApolloReactCommon.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = ApolloReactCommon.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const ReadMessagesDocument = /*#__PURE__*/ gql`
    mutation readMessages($quoteId: String) {
  readMessages(quoteId: $quoteId) {
    _id
  }
}
    `;
export type ReadMessagesMutationFn = ApolloReactCommon.MutationFunction<ReadMessagesMutation, ReadMessagesMutationVariables>;

/**
 * __useReadMessagesMutation__
 *
 * To run a mutation, you first call `useReadMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readMessagesMutation, { data, loading, error }] = useReadMessagesMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useReadMessagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReadMessagesMutation, ReadMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReadMessagesMutation, ReadMessagesMutationVariables>(ReadMessagesDocument, options);
      }
export type ReadMessagesMutationHookResult = ReturnType<typeof useReadMessagesMutation>;
export type ReadMessagesMutationResult = ApolloReactCommon.MutationResult<ReadMessagesMutation>;
export type ReadMessagesMutationOptions = ApolloReactCommon.BaseMutationOptions<ReadMessagesMutation, ReadMessagesMutationVariables>;
export const GetNoteDocument = /*#__PURE__*/ gql`
    query getNote($id: String!) {
  getNote(id: $id) {
    ...FullNoteActivity
  }
}
    ${FullNoteActivityFragmentDoc}`;

/**
 * __useGetNoteQuery__
 *
 * To run a query within a React component, call `useGetNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
      }
export function useGetNoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
        }
export type GetNoteQueryHookResult = ReturnType<typeof useGetNoteQuery>;
export type GetNoteLazyQueryHookResult = ReturnType<typeof useGetNoteLazyQuery>;
export type GetNoteQueryResult = ApolloReactCommon.QueryResult<GetNoteQuery, GetNoteQueryVariables>;
export const CreateNoteDocument = /*#__PURE__*/ gql`
    mutation createNote($docId: String!, $docType: String!, $note: String!, $files: [String!]) {
  createNote(docId: $docId, docType: $docType, note: $note, files: $files) {
    activity {
      ...FullNoteActivity
    }
  }
}
    ${FullNoteActivityFragmentDoc}`;
export type CreateNoteMutationFn = ApolloReactCommon.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      docType: // value for 'docType'
 *      note: // value for 'note'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = ApolloReactCommon.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const DeleteNoteDocument = /*#__PURE__*/ gql`
    mutation deleteNote($id: String!, $deleteDoc: Boolean) {
  deleteNote(id: $id, deleteDoc: $deleteDoc)
}
    `;
export type DeleteNoteMutationFn = ApolloReactCommon.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteDoc: // value for 'deleteDoc'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = ApolloReactCommon.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const UpdateNoteDocument = /*#__PURE__*/ gql`
    mutation updateNote($id: String!, $note: String!, $files: [String!]) {
  updateNote(id: $id, note: $note, files: $files) {
    activity {
      ...FullNoteActivity
    }
  }
}
    ${FullNoteActivityFragmentDoc}`;
export type UpdateNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = ApolloReactCommon.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const SetNotePinnedDocument = /*#__PURE__*/ gql`
    mutation setNotePinned($id: String!, $docId: String!, $pinned: Boolean!) {
  setNotePinned(id: $id, docId: $docId, pinned: $pinned) {
    activity {
      ...FullNoteActivity
    }
  }
}
    ${FullNoteActivityFragmentDoc}`;
export type SetNotePinnedMutationFn = ApolloReactCommon.MutationFunction<SetNotePinnedMutation, SetNotePinnedMutationVariables>;

/**
 * __useSetNotePinnedMutation__
 *
 * To run a mutation, you first call `useSetNotePinnedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotePinnedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotePinnedMutation, { data, loading, error }] = useSetNotePinnedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      docId: // value for 'docId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function useSetNotePinnedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNotePinnedMutation, SetNotePinnedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetNotePinnedMutation, SetNotePinnedMutationVariables>(SetNotePinnedDocument, options);
      }
export type SetNotePinnedMutationHookResult = ReturnType<typeof useSetNotePinnedMutation>;
export type SetNotePinnedMutationResult = ApolloReactCommon.MutationResult<SetNotePinnedMutation>;
export type SetNotePinnedMutationOptions = ApolloReactCommon.BaseMutationOptions<SetNotePinnedMutation, SetNotePinnedMutationVariables>;
export const SaveEventDocument = /*#__PURE__*/ gql`
    mutation saveEvent($event: JSON!, $eventTemplate: String) {
  saveEvent(event: $event, eventTemplate: $eventTemplate) {
    activity {
      ...FullEventActivity
    }
  }
}
    ${FullEventActivityFragmentDoc}`;
export type SaveEventMutationFn = ApolloReactCommon.MutationFunction<SaveEventMutation, SaveEventMutationVariables>;

/**
 * __useSaveEventMutation__
 *
 * To run a mutation, you first call `useSaveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventMutation, { data, loading, error }] = useSaveEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *      eventTemplate: // value for 'eventTemplate'
 *   },
 * });
 */
export function useSaveEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEventMutation, SaveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveEventMutation, SaveEventMutationVariables>(SaveEventDocument, options);
      }
export type SaveEventMutationHookResult = ReturnType<typeof useSaveEventMutation>;
export type SaveEventMutationResult = ApolloReactCommon.MutationResult<SaveEventMutation>;
export type SaveEventMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveEventMutation, SaveEventMutationVariables>;
export const CreatePaymentActivityDocument = /*#__PURE__*/ gql`
    mutation createPaymentActivity($ach: Boolean, $amount: Float!, $deposit: Boolean, $docId: String!, $id: String, $note: String, $paymentRequestId: String, $provider: String!, $providerDetails: JSON, $isProcessing: Boolean, $isFailed: Boolean, $source: String, $surcharge: Float) {
  createPaymentActivity(
    ach: $ach
    amount: $amount
    deposit: $deposit
    docId: $docId
    id: $id
    note: $note
    paymentRequestId: $paymentRequestId
    provider: $provider
    providerDetails: $providerDetails
    isProcessing: $isProcessing
    isFailed: $isFailed
    source: $source
    surcharge: $surcharge
  ) {
    activity {
      ...FullPaymentActivity
    }
  }
}
    ${FullPaymentActivityFragmentDoc}`;
export type CreatePaymentActivityMutationFn = ApolloReactCommon.MutationFunction<CreatePaymentActivityMutation, CreatePaymentActivityMutationVariables>;

/**
 * __useCreatePaymentActivityMutation__
 *
 * To run a mutation, you first call `useCreatePaymentActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentActivityMutation, { data, loading, error }] = useCreatePaymentActivityMutation({
 *   variables: {
 *      ach: // value for 'ach'
 *      amount: // value for 'amount'
 *      deposit: // value for 'deposit'
 *      docId: // value for 'docId'
 *      id: // value for 'id'
 *      note: // value for 'note'
 *      paymentRequestId: // value for 'paymentRequestId'
 *      provider: // value for 'provider'
 *      providerDetails: // value for 'providerDetails'
 *      isProcessing: // value for 'isProcessing'
 *      isFailed: // value for 'isFailed'
 *      source: // value for 'source'
 *      surcharge: // value for 'surcharge'
 *   },
 * });
 */
export function useCreatePaymentActivityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentActivityMutation, CreatePaymentActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentActivityMutation, CreatePaymentActivityMutationVariables>(CreatePaymentActivityDocument, options);
      }
export type CreatePaymentActivityMutationHookResult = ReturnType<typeof useCreatePaymentActivityMutation>;
export type CreatePaymentActivityMutationResult = ApolloReactCommon.MutationResult<CreatePaymentActivityMutation>;
export type CreatePaymentActivityMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePaymentActivityMutation, CreatePaymentActivityMutationVariables>;
export const RateChatMessageDocument = /*#__PURE__*/ gql`
    mutation rateChatMessage($activityId: String!, $rating: Float, $feedback: String) {
  rateChatMessage(activityId: $activityId, rating: $rating, feedback: $feedback) {
    ...FullChatMessageActivity
  }
}
    ${FullChatMessageActivityFragmentDoc}`;
export type RateChatMessageMutationFn = ApolloReactCommon.MutationFunction<RateChatMessageMutation, RateChatMessageMutationVariables>;

/**
 * __useRateChatMessageMutation__
 *
 * To run a mutation, you first call `useRateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateChatMessageMutation, { data, loading, error }] = useRateChatMessageMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      rating: // value for 'rating'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useRateChatMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RateChatMessageMutation, RateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RateChatMessageMutation, RateChatMessageMutationVariables>(RateChatMessageDocument, options);
      }
export type RateChatMessageMutationHookResult = ReturnType<typeof useRateChatMessageMutation>;
export type RateChatMessageMutationResult = ApolloReactCommon.MutationResult<RateChatMessageMutation>;
export type RateChatMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<RateChatMessageMutation, RateChatMessageMutationVariables>;
export const UndoChatMessagesDocument = /*#__PURE__*/ gql`
    mutation undoChatMessages($activityIds: [String!]!) {
  undoChatMessages(activityIds: $activityIds) {
    ...FullChatMessageActivity
  }
}
    ${FullChatMessageActivityFragmentDoc}`;
export type UndoChatMessagesMutationFn = ApolloReactCommon.MutationFunction<UndoChatMessagesMutation, UndoChatMessagesMutationVariables>;

/**
 * __useUndoChatMessagesMutation__
 *
 * To run a mutation, you first call `useUndoChatMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoChatMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoChatMessagesMutation, { data, loading, error }] = useUndoChatMessagesMutation({
 *   variables: {
 *      activityIds: // value for 'activityIds'
 *   },
 * });
 */
export function useUndoChatMessagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndoChatMessagesMutation, UndoChatMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndoChatMessagesMutation, UndoChatMessagesMutationVariables>(UndoChatMessagesDocument, options);
      }
export type UndoChatMessagesMutationHookResult = ReturnType<typeof useUndoChatMessagesMutation>;
export type UndoChatMessagesMutationResult = ApolloReactCommon.MutationResult<UndoChatMessagesMutation>;
export type UndoChatMessagesMutationOptions = ApolloReactCommon.BaseMutationOptions<UndoChatMessagesMutation, UndoChatMessagesMutationVariables>;
export const GetApiKeysDocument = /*#__PURE__*/ gql`
    query getApiKeys($companyId: String) {
  getApiKeys(companyId: $companyId) {
    ...FullApiKeyDoc
  }
}
    ${FullApiKeyDocFragmentDoc}`;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysQueryResult = ApolloReactCommon.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const GetApiKeyDocument = /*#__PURE__*/ gql`
    query getApiKey($id: String!) {
  getApiKey(id: $id) {
    ...FullApiKeyDoc
  }
}
    ${FullApiKeyDocFragmentDoc}`;

/**
 * __useGetApiKeyQuery__
 *
 * To run a query within a React component, call `useGetApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApiKeyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApiKeyQuery, GetApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApiKeyQuery, GetApiKeyQueryVariables>(GetApiKeyDocument, options);
      }
export function useGetApiKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApiKeyQuery, GetApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApiKeyQuery, GetApiKeyQueryVariables>(GetApiKeyDocument, options);
        }
export type GetApiKeyQueryHookResult = ReturnType<typeof useGetApiKeyQuery>;
export type GetApiKeyLazyQueryHookResult = ReturnType<typeof useGetApiKeyLazyQuery>;
export type GetApiKeyQueryResult = ApolloReactCommon.QueryResult<GetApiKeyQuery, GetApiKeyQueryVariables>;
export const GenerateApiKeyDocument = /*#__PURE__*/ gql`
    mutation generateApiKey($userId: String!, $companyId: String, $name: String) {
  generateApiKey(userId: $userId, companyId: $companyId, name: $name) {
    ...FullApiKeyDoc
  }
}
    ${FullApiKeyDocFragmentDoc}`;
export type GenerateApiKeyMutationFn = ApolloReactCommon.MutationFunction<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;

/**
 * __useGenerateApiKeyMutation__
 *
 * To run a mutation, you first call `useGenerateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApiKeyMutation, { data, loading, error }] = useGenerateApiKeyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGenerateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>(GenerateApiKeyDocument, options);
      }
export type GenerateApiKeyMutationHookResult = ReturnType<typeof useGenerateApiKeyMutation>;
export type GenerateApiKeyMutationResult = ApolloReactCommon.MutationResult<GenerateApiKeyMutation>;
export type GenerateApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;
export const DeactivateApiKeyDocument = /*#__PURE__*/ gql`
    mutation deactivateApiKey($id: String!) {
  deactivateApiKey(id: $id) {
    ...FullApiKeyDoc
  }
}
    ${FullApiKeyDocFragmentDoc}`;
export type DeactivateApiKeyMutationFn = ApolloReactCommon.MutationFunction<DeactivateApiKeyMutation, DeactivateApiKeyMutationVariables>;

/**
 * __useDeactivateApiKeyMutation__
 *
 * To run a mutation, you first call `useDeactivateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateApiKeyMutation, { data, loading, error }] = useDeactivateApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateApiKeyMutation, DeactivateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateApiKeyMutation, DeactivateApiKeyMutationVariables>(DeactivateApiKeyDocument, options);
      }
export type DeactivateApiKeyMutationHookResult = ReturnType<typeof useDeactivateApiKeyMutation>;
export type DeactivateApiKeyMutationResult = ApolloReactCommon.MutationResult<DeactivateApiKeyMutation>;
export type DeactivateApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateApiKeyMutation, DeactivateApiKeyMutationVariables>;
export const UpdateApiKeyDocument = /*#__PURE__*/ gql`
    mutation updateApiKey($apiKey: UpdateApiKeyInput!) {
  updateApiKey(apiKey: $apiKey) {
    ...FullApiKeyDoc
  }
}
    ${FullApiKeyDocFragmentDoc}`;
export type UpdateApiKeyMutationFn = ApolloReactCommon.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = ApolloReactCommon.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const AppDocsDocument = /*#__PURE__*/ gql`
    query appDocs {
  appDocs {
    options
    rates
    companies
    companyDetails
    preferences
    remainingQuotes
  }
}
    `;

/**
 * __useAppDocsQuery__
 *
 * To run a query within a React component, call `useAppDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppDocsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppDocsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppDocsQuery, AppDocsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AppDocsQuery, AppDocsQueryVariables>(AppDocsDocument, options);
      }
export function useAppDocsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppDocsQuery, AppDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AppDocsQuery, AppDocsQueryVariables>(AppDocsDocument, options);
        }
export type AppDocsQueryHookResult = ReturnType<typeof useAppDocsQuery>;
export type AppDocsLazyQueryHookResult = ReturnType<typeof useAppDocsLazyQuery>;
export type AppDocsQueryResult = ApolloReactCommon.QueryResult<AppDocsQuery, AppDocsQueryVariables>;
export const UserDocument = /*#__PURE__*/ gql`
    query user($id: String!) {
  user(id: $id) {
    ...PublicUser
  }
}
    ${PublicUserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = ApolloReactCommon.QueryResult<UserQuery, UserQueryVariables>;
export const EstimatorDocument = /*#__PURE__*/ gql`
    query estimator($id: String!, $quoteId: String) {
  estimator(id: $id, quoteId: $quoteId) {
    user_id
    name
    title
    description
    image
    signature
  }
}
    `;

/**
 * __useEstimatorQuery__
 *
 * To run a query within a React component, call `useEstimatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimatorQuery({
 *   variables: {
 *      id: // value for 'id'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useEstimatorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EstimatorQuery, EstimatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EstimatorQuery, EstimatorQueryVariables>(EstimatorDocument, options);
      }
export function useEstimatorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EstimatorQuery, EstimatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EstimatorQuery, EstimatorQueryVariables>(EstimatorDocument, options);
        }
export type EstimatorQueryHookResult = ReturnType<typeof useEstimatorQuery>;
export type EstimatorLazyQueryHookResult = ReturnType<typeof useEstimatorLazyQuery>;
export type EstimatorQueryResult = ApolloReactCommon.QueryResult<EstimatorQuery, EstimatorQueryVariables>;
export const UpdateUserDocument = /*#__PURE__*/ gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...PublicUser
  }
}
    ${PublicUserFragmentDoc}`;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateUserDocument = /*#__PURE__*/ gql`
    mutation createUser($input: CreateUserInput!, $companyId: String, $password: String, $sendEmail: Boolean) {
  createUser(
    input: $input
    companyId: $companyId
    password: $password
    sendEmail: $sendEmail
  ) {
    ...PublicUser
  }
}
    ${PublicUserFragmentDoc}`;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *      password: // value for 'password'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdatePasswordDocument = /*#__PURE__*/ gql`
    mutation updatePassword($user_id: String!, $password: String!) {
  updatePassword(user_id: $user_id, password: $password)
}
    `;
export type UpdatePasswordMutationFn = ApolloReactCommon.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = ApolloReactCommon.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const ResetPasswordDocument = /*#__PURE__*/ gql`
    mutation resetPassword($user_id: String!) {
  resetPassword(user_id: $user_id)
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const DeactivateUserDocument = /*#__PURE__*/ gql`
    mutation deactivateUser($id: String!, $companyId: String!, $transferQuotesTo: String, $transferType: String) {
  deactivateUser(
    id: $id
    companyId: $companyId
    transferQuotesTo: $transferQuotesTo
    transferType: $transferType
  )
}
    `;
export type DeactivateUserMutationFn = ApolloReactCommon.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      transferQuotesTo: // value for 'transferQuotesTo'
 *      transferType: // value for 'transferType'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = ApolloReactCommon.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const TransferUserDocsDocument = /*#__PURE__*/ gql`
    mutation transferUserDocs($id: String!, $transferTo: String!, $type: String!, $values: String) {
  transferUserDocs(id: $id, transferTo: $transferTo, type: $type, values: $values)
}
    `;
export type TransferUserDocsMutationFn = ApolloReactCommon.MutationFunction<TransferUserDocsMutation, TransferUserDocsMutationVariables>;

/**
 * __useTransferUserDocsMutation__
 *
 * To run a mutation, you first call `useTransferUserDocsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferUserDocsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferUserDocsMutation, { data, loading, error }] = useTransferUserDocsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      transferTo: // value for 'transferTo'
 *      type: // value for 'type'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useTransferUserDocsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferUserDocsMutation, TransferUserDocsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TransferUserDocsMutation, TransferUserDocsMutationVariables>(TransferUserDocsDocument, options);
      }
export type TransferUserDocsMutationHookResult = ReturnType<typeof useTransferUserDocsMutation>;
export type TransferUserDocsMutationResult = ApolloReactCommon.MutationResult<TransferUserDocsMutation>;
export type TransferUserDocsMutationOptions = ApolloReactCommon.BaseMutationOptions<TransferUserDocsMutation, TransferUserDocsMutationVariables>;
export const DeleteUserDocsDocument = /*#__PURE__*/ gql`
    mutation deleteUserDocs($id: String!, $type: String!) {
  deleteUserDocs(id: $id, type: $type)
}
    `;
export type DeleteUserDocsMutationFn = ApolloReactCommon.MutationFunction<DeleteUserDocsMutation, DeleteUserDocsMutationVariables>;

/**
 * __useDeleteUserDocsMutation__
 *
 * To run a mutation, you first call `useDeleteUserDocsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDocsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDocsMutation, { data, loading, error }] = useDeleteUserDocsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDeleteUserDocsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserDocsMutation, DeleteUserDocsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserDocsMutation, DeleteUserDocsMutationVariables>(DeleteUserDocsDocument, options);
      }
export type DeleteUserDocsMutationHookResult = ReturnType<typeof useDeleteUserDocsMutation>;
export type DeleteUserDocsMutationResult = ApolloReactCommon.MutationResult<DeleteUserDocsMutation>;
export type DeleteUserDocsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserDocsMutation, DeleteUserDocsMutationVariables>;
export const GetMfaEnrollmentsDocument = /*#__PURE__*/ gql`
    query getMfaEnrollments($userId: String!) {
  getMfaEnrollments(userId: $userId) {
    id
    type
    name
    phone_number
    email
    enrolled_at
  }
}
    `;

/**
 * __useGetMfaEnrollmentsQuery__
 *
 * To run a query within a React component, call `useGetMfaEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfaEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfaEnrollmentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMfaEnrollmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>(GetMfaEnrollmentsDocument, options);
      }
export function useGetMfaEnrollmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>(GetMfaEnrollmentsDocument, options);
        }
export type GetMfaEnrollmentsQueryHookResult = ReturnType<typeof useGetMfaEnrollmentsQuery>;
export type GetMfaEnrollmentsLazyQueryHookResult = ReturnType<typeof useGetMfaEnrollmentsLazyQuery>;
export type GetMfaEnrollmentsQueryResult = ApolloReactCommon.QueryResult<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>;
export const ResetMfaForUserDocument = /*#__PURE__*/ gql`
    mutation resetMfaForUser($userId: String!) {
  resetMfaForUser(userId: $userId)
}
    `;
export type ResetMfaForUserMutationFn = ApolloReactCommon.MutationFunction<ResetMfaForUserMutation, ResetMfaForUserMutationVariables>;

/**
 * __useResetMfaForUserMutation__
 *
 * To run a mutation, you first call `useResetMfaForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMfaForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMfaForUserMutation, { data, loading, error }] = useResetMfaForUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResetMfaForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetMfaForUserMutation, ResetMfaForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetMfaForUserMutation, ResetMfaForUserMutationVariables>(ResetMfaForUserDocument, options);
      }
export type ResetMfaForUserMutationHookResult = ReturnType<typeof useResetMfaForUserMutation>;
export type ResetMfaForUserMutationResult = ApolloReactCommon.MutationResult<ResetMfaForUserMutation>;
export type ResetMfaForUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetMfaForUserMutation, ResetMfaForUserMutationVariables>;
export const SearchUsersDocument = /*#__PURE__*/ gql`
    query searchUsers($query: String, $searchText: String, $bookmark: String, $limit: Int, $includeInactive: Boolean, $includeCrew: Boolean) {
  searchUsers(
    query: $query
    searchText: $searchText
    bookmark: $bookmark
    limit: $limit
    includeInactive: $includeInactive
    includeCrew: $includeCrew
  ) {
    bookmark
    total_rows
    rows {
      user_metadata {
        phoneNumber
        lastName
        firstName
        title
        customAvatar {
          label
          fileType
          width
          height
          value
          cdnValue
          cloudinaryId
          s3PublicKey
        }
        playerName
        blockLaunchDialog
        projectTypes
        hasJoinedLeaderboard
        color
        leaderboardOptOut
        color
      }
      user_id
      name
      email
      last_login
      created
      picture
      logins_count
      app_metadata {
        active
        companyId
        roles
        isOwner
        painterType
        resolvedPermissions
      }
      preferences
    }
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      searchText: // value for 'searchText'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      includeInactive: // value for 'includeInactive'
 *      includeCrew: // value for 'includeCrew'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersQueryResult = ApolloReactCommon.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const SearchUsersAdminDocument = /*#__PURE__*/ gql`
    query searchUsersAdmin($query: String, $searchText: String, $bookmark: String, $limit: Int, $includeInactive: Boolean, $includeCrew: Boolean) {
  searchUsers(
    query: $query
    searchText: $searchText
    bookmark: $bookmark
    limit: $limit
    includeInactive: $includeInactive
    includeCrew: $includeCrew
  ) {
    bookmark
    total_rows
    rows {
      user_metadata {
        phoneNumber
        lastName
        firstName
        title
      }
      user_id
      name
      email
      last_login
      created
      app_metadata {
        active
        companyId
        roles
        mfa_enrolled
        mfa_excluded
        stage
        company {
          name
          plan
          subscription {
            status
          }
        }
        isOwner
      }
    }
  }
}
    `;

/**
 * __useSearchUsersAdminQuery__
 *
 * To run a query within a React component, call `useSearchUsersAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersAdminQuery({
 *   variables: {
 *      query: // value for 'query'
 *      searchText: // value for 'searchText'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      includeInactive: // value for 'includeInactive'
 *      includeCrew: // value for 'includeCrew'
 *   },
 * });
 */
export function useSearchUsersAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUsersAdminQuery, SearchUsersAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersAdminQuery, SearchUsersAdminQueryVariables>(SearchUsersAdminDocument, options);
      }
export function useSearchUsersAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersAdminQuery, SearchUsersAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersAdminQuery, SearchUsersAdminQueryVariables>(SearchUsersAdminDocument, options);
        }
export type SearchUsersAdminQueryHookResult = ReturnType<typeof useSearchUsersAdminQuery>;
export type SearchUsersAdminLazyQueryHookResult = ReturnType<typeof useSearchUsersAdminLazyQuery>;
export type SearchUsersAdminQueryResult = ApolloReactCommon.QueryResult<SearchUsersAdminQuery, SearchUsersAdminQueryVariables>;
export const SubscriptionDocument = /*#__PURE__*/ gql`
    query subscription($clientBillingId: String) {
  subscription(clientBillingId: $clientBillingId) {
    plan_id
    plan_quantity
    plan_unit_price
    currency_code
    status
    billing_period_unit
    current_term_start
    current_term_end
    cancelled_at
    subscription_activated
    addons {
      id
      quantity
      unit_price
      amount
      name
    }
    charges {
      id
      quantity
      unit_price
      amount
      name
    }
    coupons {
      id
      name
      discount_amount
      discount_percentage
      duration_type
    }
    plan {
      name
      invoice_name
    }
    coreSeatsAvailable
    teamSeatsAvailable
    crewSeatsAvailable
    cf_production_pricing_migration_timestamp
    billingContact {
      first_name
      last_name
      email
      phone
    }
  }
}
    `;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      clientBillingId: // value for 'clientBillingId'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionQueryResult = ApolloReactCommon.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const SubscriptionSummaryDocument = /*#__PURE__*/ gql`
    query subscriptionSummary($clientBillingId: String) {
  subscriptionSummary(clientBillingId: $clientBillingId) {
    status
    plan_id
    billing_period_unit
    current_term_end
    cf_production_pricing_migration_timestamp
    addons {
      id
      name
    }
    coreSeatsAvailable
    teamSeatsAvailable
    crewSeatsAvailable
  }
}
    `;

/**
 * __useSubscriptionSummaryQuery__
 *
 * To run a query within a React component, call `useSubscriptionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionSummaryQuery({
 *   variables: {
 *      clientBillingId: // value for 'clientBillingId'
 *   },
 * });
 */
export function useSubscriptionSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionSummaryQuery, SubscriptionSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionSummaryQuery, SubscriptionSummaryQueryVariables>(SubscriptionSummaryDocument, options);
      }
export function useSubscriptionSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionSummaryQuery, SubscriptionSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionSummaryQuery, SubscriptionSummaryQueryVariables>(SubscriptionSummaryDocument, options);
        }
export type SubscriptionSummaryQueryHookResult = ReturnType<typeof useSubscriptionSummaryQuery>;
export type SubscriptionSummaryLazyQueryHookResult = ReturnType<typeof useSubscriptionSummaryLazyQuery>;
export type SubscriptionSummaryQueryResult = ApolloReactCommon.QueryResult<SubscriptionSummaryQuery, SubscriptionSummaryQueryVariables>;
export const OneTimeChargesDocument = /*#__PURE__*/ gql`
    query oneTimeCharges($clientBillingId: String) {
  oneTimeCharges(clientBillingId: $clientBillingId) {
    id
    description
    quantity
    amount
    discountAmount
    currencyCode
    date
    itemPriceId
    isAdhoc
    invoiceId
    invoiceStatus
  }
}
    `;

/**
 * __useOneTimeChargesQuery__
 *
 * To run a query within a React component, call `useOneTimeChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOneTimeChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOneTimeChargesQuery({
 *   variables: {
 *      clientBillingId: // value for 'clientBillingId'
 *   },
 * });
 */
export function useOneTimeChargesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OneTimeChargesQuery, OneTimeChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OneTimeChargesQuery, OneTimeChargesQueryVariables>(OneTimeChargesDocument, options);
      }
export function useOneTimeChargesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OneTimeChargesQuery, OneTimeChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OneTimeChargesQuery, OneTimeChargesQueryVariables>(OneTimeChargesDocument, options);
        }
export type OneTimeChargesQueryHookResult = ReturnType<typeof useOneTimeChargesQuery>;
export type OneTimeChargesLazyQueryHookResult = ReturnType<typeof useOneTimeChargesLazyQuery>;
export type OneTimeChargesQueryResult = ApolloReactCommon.QueryResult<OneTimeChargesQuery, OneTimeChargesQueryVariables>;
export const ChargebeePlansDocument = /*#__PURE__*/ gql`
    query chargebeePlans {
  chargebeePlans {
    id
    name
    itemType
    pricingModel
    price
    currencyCode
  }
}
    `;

/**
 * __useChargebeePlansQuery__
 *
 * To run a query within a React component, call `useChargebeePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargebeePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargebeePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useChargebeePlansQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChargebeePlansQuery, ChargebeePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargebeePlansQuery, ChargebeePlansQueryVariables>(ChargebeePlansDocument, options);
      }
export function useChargebeePlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargebeePlansQuery, ChargebeePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargebeePlansQuery, ChargebeePlansQueryVariables>(ChargebeePlansDocument, options);
        }
export type ChargebeePlansQueryHookResult = ReturnType<typeof useChargebeePlansQuery>;
export type ChargebeePlansLazyQueryHookResult = ReturnType<typeof useChargebeePlansLazyQuery>;
export type ChargebeePlansQueryResult = ApolloReactCommon.QueryResult<ChargebeePlansQuery, ChargebeePlansQueryVariables>;
export const ChargebeeAddonsDocument = /*#__PURE__*/ gql`
    query chargebeeAddons {
  chargebeeAddons {
    id
    name
    itemType
    pricingModel
    price
    currencyCode
  }
}
    `;

/**
 * __useChargebeeAddonsQuery__
 *
 * To run a query within a React component, call `useChargebeeAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargebeeAddonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargebeeAddonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChargebeeAddonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChargebeeAddonsQuery, ChargebeeAddonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargebeeAddonsQuery, ChargebeeAddonsQueryVariables>(ChargebeeAddonsDocument, options);
      }
export function useChargebeeAddonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargebeeAddonsQuery, ChargebeeAddonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargebeeAddonsQuery, ChargebeeAddonsQueryVariables>(ChargebeeAddonsDocument, options);
        }
export type ChargebeeAddonsQueryHookResult = ReturnType<typeof useChargebeeAddonsQuery>;
export type ChargebeeAddonsLazyQueryHookResult = ReturnType<typeof useChargebeeAddonsLazyQuery>;
export type ChargebeeAddonsQueryResult = ApolloReactCommon.QueryResult<ChargebeeAddonsQuery, ChargebeeAddonsQueryVariables>;
export const ChargebeeCouponsDocument = /*#__PURE__*/ gql`
    query chargebeeCoupons {
  chargebeeCoupons {
    id
    name
    discountType
    discountAmount
    discountPercentage
  }
}
    `;

/**
 * __useChargebeeCouponsQuery__
 *
 * To run a query within a React component, call `useChargebeeCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargebeeCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargebeeCouponsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChargebeeCouponsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChargebeeCouponsQuery, ChargebeeCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargebeeCouponsQuery, ChargebeeCouponsQueryVariables>(ChargebeeCouponsDocument, options);
      }
export function useChargebeeCouponsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargebeeCouponsQuery, ChargebeeCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargebeeCouponsQuery, ChargebeeCouponsQueryVariables>(ChargebeeCouponsDocument, options);
        }
export type ChargebeeCouponsQueryHookResult = ReturnType<typeof useChargebeeCouponsQuery>;
export type ChargebeeCouponsLazyQueryHookResult = ReturnType<typeof useChargebeeCouponsLazyQuery>;
export type ChargebeeCouponsQueryResult = ApolloReactCommon.QueryResult<ChargebeeCouponsQuery, ChargebeeCouponsQueryVariables>;
export const SalesRepsDocument = /*#__PURE__*/ gql`
    query salesReps {
  salesReps {
    id
    name
  }
}
    `;

/**
 * __useSalesRepsQuery__
 *
 * To run a query within a React component, call `useSalesRepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesRepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesRepsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesRepsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SalesRepsQuery, SalesRepsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SalesRepsQuery, SalesRepsQueryVariables>(SalesRepsDocument, options);
      }
export function useSalesRepsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SalesRepsQuery, SalesRepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SalesRepsQuery, SalesRepsQueryVariables>(SalesRepsDocument, options);
        }
export type SalesRepsQueryHookResult = ReturnType<typeof useSalesRepsQuery>;
export type SalesRepsLazyQueryHookResult = ReturnType<typeof useSalesRepsLazyQuery>;
export type SalesRepsQueryResult = ApolloReactCommon.QueryResult<SalesRepsQuery, SalesRepsQueryVariables>;
export const EstimateCheckoutDocument = /*#__PURE__*/ gql`
    query estimateCheckout($input: CheckoutInput!) {
  estimateCheckout(input: $input) {
    lineItems {
      description
      quantity
      amount
    }
    subTotal
    discountTotal
    taxTotal
    total
    currencyCode
  }
}
    `;

/**
 * __useEstimateCheckoutQuery__
 *
 * To run a query within a React component, call `useEstimateCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateCheckoutQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstimateCheckoutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EstimateCheckoutQuery, EstimateCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EstimateCheckoutQuery, EstimateCheckoutQueryVariables>(EstimateCheckoutDocument, options);
      }
export function useEstimateCheckoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EstimateCheckoutQuery, EstimateCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EstimateCheckoutQuery, EstimateCheckoutQueryVariables>(EstimateCheckoutDocument, options);
        }
export type EstimateCheckoutQueryHookResult = ReturnType<typeof useEstimateCheckoutQuery>;
export type EstimateCheckoutLazyQueryHookResult = ReturnType<typeof useEstimateCheckoutLazyQuery>;
export type EstimateCheckoutQueryResult = ApolloReactCommon.QueryResult<EstimateCheckoutQuery, EstimateCheckoutQueryVariables>;
export const GenerateCheckoutLinkDocument = /*#__PURE__*/ gql`
    mutation generateCheckoutLink($input: CheckoutInput!, $send: Boolean!) {
  generateCheckoutLink(input: $input, send: $send) {
    url
    expiresAt
    estimate {
      lineItems {
        description
        quantity
        amount
      }
      subTotal
      discountTotal
      taxTotal
      total
      currencyCode
    }
    emailStatus
  }
}
    `;
export type GenerateCheckoutLinkMutationFn = ApolloReactCommon.MutationFunction<GenerateCheckoutLinkMutation, GenerateCheckoutLinkMutationVariables>;

/**
 * __useGenerateCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useGenerateCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCheckoutLinkMutation, { data, loading, error }] = useGenerateCheckoutLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *      send: // value for 'send'
 *   },
 * });
 */
export function useGenerateCheckoutLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateCheckoutLinkMutation, GenerateCheckoutLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateCheckoutLinkMutation, GenerateCheckoutLinkMutationVariables>(GenerateCheckoutLinkDocument, options);
      }
export type GenerateCheckoutLinkMutationHookResult = ReturnType<typeof useGenerateCheckoutLinkMutation>;
export type GenerateCheckoutLinkMutationResult = ApolloReactCommon.MutationResult<GenerateCheckoutLinkMutation>;
export type GenerateCheckoutLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateCheckoutLinkMutation, GenerateCheckoutLinkMutationVariables>;
export const ClientDocument = /*#__PURE__*/ gql`
    query client($id: String) {
  client(id: $id) {
    meta {
      ...FullMeta
    }
    options
    internalOptions
    rates
    sequence
    companies
  }
}
    ${FullMetaFragmentDoc}`;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientQuery, ClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
      }
export function useClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientQueryResult = ApolloReactCommon.QueryResult<ClientQuery, ClientQueryVariables>;
export const GetCorporateTypeDataDocument = /*#__PURE__*/ gql`
    query getCorporateTypeData {
  getCorporateTypeData {
    quoteTypes
  }
}
    `;

/**
 * __useGetCorporateTypeDataQuery__
 *
 * To run a query within a React component, call `useGetCorporateTypeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorporateTypeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorporateTypeDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCorporateTypeDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCorporateTypeDataQuery, GetCorporateTypeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCorporateTypeDataQuery, GetCorporateTypeDataQueryVariables>(GetCorporateTypeDataDocument, options);
      }
export function useGetCorporateTypeDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCorporateTypeDataQuery, GetCorporateTypeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCorporateTypeDataQuery, GetCorporateTypeDataQueryVariables>(GetCorporateTypeDataDocument, options);
        }
export type GetCorporateTypeDataQueryHookResult = ReturnType<typeof useGetCorporateTypeDataQuery>;
export type GetCorporateTypeDataLazyQueryHookResult = ReturnType<typeof useGetCorporateTypeDataLazyQuery>;
export type GetCorporateTypeDataQueryResult = ApolloReactCommon.QueryResult<GetCorporateTypeDataQuery, GetCorporateTypeDataQueryVariables>;
export const SearchManufacturerProductsDocument = /*#__PURE__*/ gql`
    query searchManufacturerProducts($query: String!, $bookmark: String, $limit: Int, $sort: [String!]) {
  searchManufacturerProducts(
    query: $query
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    bookmark
    total_rows
    rows {
      ...FullManufacturerProduct
    }
  }
}
    ${FullManufacturerProductFragmentDoc}`;

/**
 * __useSearchManufacturerProductsQuery__
 *
 * To run a query within a React component, call `useSearchManufacturerProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchManufacturerProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchManufacturerProductsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchManufacturerProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchManufacturerProductsQuery, SearchManufacturerProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchManufacturerProductsQuery, SearchManufacturerProductsQueryVariables>(SearchManufacturerProductsDocument, options);
      }
export function useSearchManufacturerProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchManufacturerProductsQuery, SearchManufacturerProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchManufacturerProductsQuery, SearchManufacturerProductsQueryVariables>(SearchManufacturerProductsDocument, options);
        }
export type SearchManufacturerProductsQueryHookResult = ReturnType<typeof useSearchManufacturerProductsQuery>;
export type SearchManufacturerProductsLazyQueryHookResult = ReturnType<typeof useSearchManufacturerProductsLazyQuery>;
export type SearchManufacturerProductsQueryResult = ApolloReactCommon.QueryResult<SearchManufacturerProductsQuery, SearchManufacturerProductsQueryVariables>;
export const SearchManufacturerColorsDocument = /*#__PURE__*/ gql`
    query searchManufacturerColors($query: String!, $bookmark: String, $limit: Int, $sort: [String!]) {
  searchManufacturerColors(
    query: $query
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    bookmark
    total_rows
    rows {
      ...FullManufacturerColor
    }
  }
}
    ${FullManufacturerColorFragmentDoc}`;

/**
 * __useSearchManufacturerColorsQuery__
 *
 * To run a query within a React component, call `useSearchManufacturerColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchManufacturerColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchManufacturerColorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchManufacturerColorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchManufacturerColorsQuery, SearchManufacturerColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchManufacturerColorsQuery, SearchManufacturerColorsQueryVariables>(SearchManufacturerColorsDocument, options);
      }
export function useSearchManufacturerColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchManufacturerColorsQuery, SearchManufacturerColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchManufacturerColorsQuery, SearchManufacturerColorsQueryVariables>(SearchManufacturerColorsDocument, options);
        }
export type SearchManufacturerColorsQueryHookResult = ReturnType<typeof useSearchManufacturerColorsQuery>;
export type SearchManufacturerColorsLazyQueryHookResult = ReturnType<typeof useSearchManufacturerColorsLazyQuery>;
export type SearchManufacturerColorsQueryResult = ApolloReactCommon.QueryResult<SearchManufacturerColorsQuery, SearchManufacturerColorsQueryVariables>;
export const CreateClientDocument = /*#__PURE__*/ gql`
    mutation createClient($input: CreateClientInput!) {
  createClient(input: $input) {
    ...FullMeta
  }
}
    ${FullMetaFragmentDoc}`;
export type CreateClientMutationFn = ApolloReactCommon.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = ApolloReactCommon.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = /*#__PURE__*/ gql`
    mutation updateClient($id: String!, $meta: ClientMetaInput, $options: JSON, $internalOptions: JSON, $rates: JSON) {
  updateClient(
    id: $id
    meta: $meta
    options: $options
    internalOptions: $internalOptions
    rates: $rates
  ) {
    meta {
      ...FullMeta
    }
    options
    internalOptions
    rates
    sequence
    companies
  }
}
    ${FullMetaFragmentDoc}`;
export type UpdateClientMutationFn = ApolloReactCommon.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      meta: // value for 'meta'
 *      options: // value for 'options'
 *      internalOptions: // value for 'internalOptions'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = ApolloReactCommon.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const SyncOptionsDocument = /*#__PURE__*/ gql`
    mutation syncOptions($rev: String!) {
  syncOptions(rev: $rev)
}
    `;
export type SyncOptionsMutationFn = ApolloReactCommon.MutationFunction<SyncOptionsMutation, SyncOptionsMutationVariables>;

/**
 * __useSyncOptionsMutation__
 *
 * To run a mutation, you first call `useSyncOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOptionsMutation, { data, loading, error }] = useSyncOptionsMutation({
 *   variables: {
 *      rev: // value for 'rev'
 *   },
 * });
 */
export function useSyncOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncOptionsMutation, SyncOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncOptionsMutation, SyncOptionsMutationVariables>(SyncOptionsDocument, options);
      }
export type SyncOptionsMutationHookResult = ReturnType<typeof useSyncOptionsMutation>;
export type SyncOptionsMutationResult = ApolloReactCommon.MutationResult<SyncOptionsMutation>;
export type SyncOptionsMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncOptionsMutation, SyncOptionsMutationVariables>;
export const SyncRatesDocument = /*#__PURE__*/ gql`
    mutation syncRates($rev: String!) {
  syncRates(rev: $rev)
}
    `;
export type SyncRatesMutationFn = ApolloReactCommon.MutationFunction<SyncRatesMutation, SyncRatesMutationVariables>;

/**
 * __useSyncRatesMutation__
 *
 * To run a mutation, you first call `useSyncRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncRatesMutation, { data, loading, error }] = useSyncRatesMutation({
 *   variables: {
 *      rev: // value for 'rev'
 *   },
 * });
 */
export function useSyncRatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncRatesMutation, SyncRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncRatesMutation, SyncRatesMutationVariables>(SyncRatesDocument, options);
      }
export type SyncRatesMutationHookResult = ReturnType<typeof useSyncRatesMutation>;
export type SyncRatesMutationResult = ApolloReactCommon.MutationResult<SyncRatesMutation>;
export type SyncRatesMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncRatesMutation, SyncRatesMutationVariables>;
export const SavePartialOptionsDocument = /*#__PURE__*/ gql`
    mutation savePartialOptions($input: String, $key: String) {
  savePartialOptions(input: $input, key: $key)
}
    `;
export type SavePartialOptionsMutationFn = ApolloReactCommon.MutationFunction<SavePartialOptionsMutation, SavePartialOptionsMutationVariables>;

/**
 * __useSavePartialOptionsMutation__
 *
 * To run a mutation, you first call `useSavePartialOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePartialOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePartialOptionsMutation, { data, loading, error }] = useSavePartialOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSavePartialOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePartialOptionsMutation, SavePartialOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePartialOptionsMutation, SavePartialOptionsMutationVariables>(SavePartialOptionsDocument, options);
      }
export type SavePartialOptionsMutationHookResult = ReturnType<typeof useSavePartialOptionsMutation>;
export type SavePartialOptionsMutationResult = ApolloReactCommon.MutationResult<SavePartialOptionsMutation>;
export type SavePartialOptionsMutationOptions = ApolloReactCommon.BaseMutationOptions<SavePartialOptionsMutation, SavePartialOptionsMutationVariables>;
export const SaveOptionsDocument = /*#__PURE__*/ gql`
    mutation saveOptions($options: JSON) {
  saveOptions(input: $options)
}
    `;
export type SaveOptionsMutationFn = ApolloReactCommon.MutationFunction<SaveOptionsMutation, SaveOptionsMutationVariables>;

/**
 * __useSaveOptionsMutation__
 *
 * To run a mutation, you first call `useSaveOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOptionsMutation, { data, loading, error }] = useSaveOptionsMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSaveOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveOptionsMutation, SaveOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveOptionsMutation, SaveOptionsMutationVariables>(SaveOptionsDocument, options);
      }
export type SaveOptionsMutationHookResult = ReturnType<typeof useSaveOptionsMutation>;
export type SaveOptionsMutationResult = ApolloReactCommon.MutationResult<SaveOptionsMutation>;
export type SaveOptionsMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveOptionsMutation, SaveOptionsMutationVariables>;
export const SaveLocationOptionsDocument = /*#__PURE__*/ gql`
    mutation saveLocationOptions($options: JSON, $overwrite: Boolean, $location: String) {
  saveLocationOptions(input: $options, overwrite: $overwrite, location: $location)
}
    `;
export type SaveLocationOptionsMutationFn = ApolloReactCommon.MutationFunction<SaveLocationOptionsMutation, SaveLocationOptionsMutationVariables>;

/**
 * __useSaveLocationOptionsMutation__
 *
 * To run a mutation, you first call `useSaveLocationOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationOptionsMutation, { data, loading, error }] = useSaveLocationOptionsMutation({
 *   variables: {
 *      options: // value for 'options'
 *      overwrite: // value for 'overwrite'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useSaveLocationOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLocationOptionsMutation, SaveLocationOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLocationOptionsMutation, SaveLocationOptionsMutationVariables>(SaveLocationOptionsDocument, options);
      }
export type SaveLocationOptionsMutationHookResult = ReturnType<typeof useSaveLocationOptionsMutation>;
export type SaveLocationOptionsMutationResult = ApolloReactCommon.MutationResult<SaveLocationOptionsMutation>;
export type SaveLocationOptionsMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveLocationOptionsMutation, SaveLocationOptionsMutationVariables>;
export const SaveRatesDocument = /*#__PURE__*/ gql`
    mutation saveRates($rates: JSON) {
  saveRates(input: $rates)
}
    `;
export type SaveRatesMutationFn = ApolloReactCommon.MutationFunction<SaveRatesMutation, SaveRatesMutationVariables>;

/**
 * __useSaveRatesMutation__
 *
 * To run a mutation, you first call `useSaveRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRatesMutation, { data, loading, error }] = useSaveRatesMutation({
 *   variables: {
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useSaveRatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveRatesMutation, SaveRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveRatesMutation, SaveRatesMutationVariables>(SaveRatesDocument, options);
      }
export type SaveRatesMutationHookResult = ReturnType<typeof useSaveRatesMutation>;
export type SaveRatesMutationResult = ApolloReactCommon.MutationResult<SaveRatesMutation>;
export type SaveRatesMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveRatesMutation, SaveRatesMutationVariables>;
export const TransferClientDocsDocument = /*#__PURE__*/ gql`
    mutation transferClientDocs($id: String!, $transferTo: String!, $type: String!, $overwrite: Boolean, $sections: [String]) {
  transferClientDocs(
    id: $id
    transferTo: $transferTo
    type: $type
    overwrite: $overwrite
    sections: $sections
  )
}
    `;
export type TransferClientDocsMutationFn = ApolloReactCommon.MutationFunction<TransferClientDocsMutation, TransferClientDocsMutationVariables>;

/**
 * __useTransferClientDocsMutation__
 *
 * To run a mutation, you first call `useTransferClientDocsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferClientDocsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferClientDocsMutation, { data, loading, error }] = useTransferClientDocsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      transferTo: // value for 'transferTo'
 *      type: // value for 'type'
 *      overwrite: // value for 'overwrite'
 *      sections: // value for 'sections'
 *   },
 * });
 */
export function useTransferClientDocsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferClientDocsMutation, TransferClientDocsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TransferClientDocsMutation, TransferClientDocsMutationVariables>(TransferClientDocsDocument, options);
      }
export type TransferClientDocsMutationHookResult = ReturnType<typeof useTransferClientDocsMutation>;
export type TransferClientDocsMutationResult = ApolloReactCommon.MutationResult<TransferClientDocsMutation>;
export type TransferClientDocsMutationOptions = ApolloReactCommon.BaseMutationOptions<TransferClientDocsMutation, TransferClientDocsMutationVariables>;
export const ResizeQuoteImagesDocument = /*#__PURE__*/ gql`
    mutation resizeQuoteImages($db: String!, $dateFrom: String!, $dateTo: String!) {
  resizeQuoteImages(db: $db, dateFrom: $dateFrom, dateTo: $dateTo)
}
    `;
export type ResizeQuoteImagesMutationFn = ApolloReactCommon.MutationFunction<ResizeQuoteImagesMutation, ResizeQuoteImagesMutationVariables>;

/**
 * __useResizeQuoteImagesMutation__
 *
 * To run a mutation, you first call `useResizeQuoteImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResizeQuoteImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resizeQuoteImagesMutation, { data, loading, error }] = useResizeQuoteImagesMutation({
 *   variables: {
 *      db: // value for 'db'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useResizeQuoteImagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResizeQuoteImagesMutation, ResizeQuoteImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResizeQuoteImagesMutation, ResizeQuoteImagesMutationVariables>(ResizeQuoteImagesDocument, options);
      }
export type ResizeQuoteImagesMutationHookResult = ReturnType<typeof useResizeQuoteImagesMutation>;
export type ResizeQuoteImagesMutationResult = ApolloReactCommon.MutationResult<ResizeQuoteImagesMutation>;
export type ResizeQuoteImagesMutationOptions = ApolloReactCommon.BaseMutationOptions<ResizeQuoteImagesMutation, ResizeQuoteImagesMutationVariables>;
export const DeleteClientDocsDocument = /*#__PURE__*/ gql`
    mutation deleteClientDocs($id: String!, $type: String!) {
  deleteClientDocs(id: $id, type: $type)
}
    `;
export type DeleteClientDocsMutationFn = ApolloReactCommon.MutationFunction<DeleteClientDocsMutation, DeleteClientDocsMutationVariables>;

/**
 * __useDeleteClientDocsMutation__
 *
 * To run a mutation, you first call `useDeleteClientDocsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientDocsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientDocsMutation, { data, loading, error }] = useDeleteClientDocsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDeleteClientDocsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteClientDocsMutation, DeleteClientDocsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteClientDocsMutation, DeleteClientDocsMutationVariables>(DeleteClientDocsDocument, options);
      }
export type DeleteClientDocsMutationHookResult = ReturnType<typeof useDeleteClientDocsMutation>;
export type DeleteClientDocsMutationResult = ApolloReactCommon.MutationResult<DeleteClientDocsMutation>;
export type DeleteClientDocsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteClientDocsMutation, DeleteClientDocsMutationVariables>;
export const SearchClientsDocument = /*#__PURE__*/ gql`
    query searchClients($query: String, $searchText: String, $bookmark: String, $limit: Int, $sort: [String!]) {
  searchClients(
    query: $query
    searchText: $searchText
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    bookmark
    total_rows
    rows {
      ...FullMeta
    }
  }
}
    ${FullMetaFragmentDoc}`;

/**
 * __useSearchClientsQuery__
 *
 * To run a query within a React component, call `useSearchClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClientsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      searchText: // value for 'searchText'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchClientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchClientsQuery, SearchClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchClientsQuery, SearchClientsQueryVariables>(SearchClientsDocument, options);
      }
export function useSearchClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchClientsQuery, SearchClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchClientsQuery, SearchClientsQueryVariables>(SearchClientsDocument, options);
        }
export type SearchClientsQueryHookResult = ReturnType<typeof useSearchClientsQuery>;
export type SearchClientsLazyQueryHookResult = ReturnType<typeof useSearchClientsLazyQuery>;
export type SearchClientsQueryResult = ApolloReactCommon.QueryResult<SearchClientsQuery, SearchClientsQueryVariables>;
export const SearchLocationsDocument = /*#__PURE__*/ gql`
    query searchLocations($query: String!, $bookmark: String, $limit: Int, $sort: [String!]) {
  searchLocations(query: $query, bookmark: $bookmark, limit: $limit, sort: $sort) {
    bookmark
    total_rows
    rows {
      ...FullMeta
    }
  }
}
    ${FullMetaFragmentDoc}`;

/**
 * __useSearchLocationsQuery__
 *
 * To run a query within a React component, call `useSearchLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchLocationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchLocationsQuery, SearchLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchLocationsQuery, SearchLocationsQueryVariables>(SearchLocationsDocument, options);
      }
export function useSearchLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchLocationsQuery, SearchLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchLocationsQuery, SearchLocationsQueryVariables>(SearchLocationsDocument, options);
        }
export type SearchLocationsQueryHookResult = ReturnType<typeof useSearchLocationsQuery>;
export type SearchLocationsLazyQueryHookResult = ReturnType<typeof useSearchLocationsLazyQuery>;
export type SearchLocationsQueryResult = ApolloReactCommon.QueryResult<SearchLocationsQuery, SearchLocationsQueryVariables>;
export const LeaderboardDocument = /*#__PURE__*/ gql`
    query leaderboard($userId: String!, $sort: String!, $searchTeam: Boolean!) {
  leaderboardData(userId: $userId, sort: $sort, searchTeam: $searchTeam) {
    totalRows
    userRank
    userRows {
      rank
      name
      winRate
      totalSold
      businessType
    }
    topRows {
      rank
      name
      winRate
      totalSold
      businessType
    }
  }
  leaderboardRank(userId: $userId) {
    totalSold {
      value
      rank
      valueChange
      rankChange
      comment
    }
    winRate {
      value
      rank
      valueChange
      rankChange
      comment
    }
  }
}
    `;

/**
 * __useLeaderboardQuery__
 *
 * To run a query within a React component, call `useLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sort: // value for 'sort'
 *      searchTeam: // value for 'searchTeam'
 *   },
 * });
 */
export function useLeaderboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
      }
export function useLeaderboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
        }
export type LeaderboardQueryHookResult = ReturnType<typeof useLeaderboardQuery>;
export type LeaderboardLazyQueryHookResult = ReturnType<typeof useLeaderboardLazyQuery>;
export type LeaderboardQueryResult = ApolloReactCommon.QueryResult<LeaderboardQuery, LeaderboardQueryVariables>;
export const AdminDashboardStatsDocument = /*#__PURE__*/ gql`
    query adminDashboardStats($weekAgo: Float!, $now: Float!, $weekFromNow: Float!) {
  adminDashboardStats(weekAgo: $weekAgo, now: $now, weekFromNow: $weekFromNow) {
    activeClients
    activeUsers
    newTrials
    expiringTrials
    currentTrials
    newActiveClients
    newActiveUsers
  }
}
    `;

/**
 * __useAdminDashboardStatsQuery__
 *
 * To run a query within a React component, call `useAdminDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardStatsQuery({
 *   variables: {
 *      weekAgo: // value for 'weekAgo'
 *      now: // value for 'now'
 *      weekFromNow: // value for 'weekFromNow'
 *   },
 * });
 */
export function useAdminDashboardStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminDashboardStatsQuery, AdminDashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminDashboardStatsQuery, AdminDashboardStatsQueryVariables>(AdminDashboardStatsDocument, options);
      }
export function useAdminDashboardStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminDashboardStatsQuery, AdminDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminDashboardStatsQuery, AdminDashboardStatsQueryVariables>(AdminDashboardStatsDocument, options);
        }
export type AdminDashboardStatsQueryHookResult = ReturnType<typeof useAdminDashboardStatsQuery>;
export type AdminDashboardStatsLazyQueryHookResult = ReturnType<typeof useAdminDashboardStatsLazyQuery>;
export type AdminDashboardStatsQueryResult = ApolloReactCommon.QueryResult<AdminDashboardStatsQuery, AdminDashboardStatsQueryVariables>;
export const CompanyDocument = /*#__PURE__*/ gql`
    query company($id: String!) {
  company(id: $id) {
    ...FullCompany
  }
}
    ${FullCompanyFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = ApolloReactCommon.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const SearchCompaniesDocument = /*#__PURE__*/ gql`
    query searchCompanies($query: String!, $bookmark: String, $limit: Int = 20, $sort: [String!]) {
  searchCompanies(query: $query, bookmark: $bookmark, limit: $limit, sort: $sort) {
    total_rows
    bookmark
    companies {
      ...SearchedCompany
    }
  }
}
    ${SearchedCompanyFragmentDoc}`;

/**
 * __useSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchCompaniesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
      }
export function useSearchCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export type SearchCompaniesQueryHookResult = ReturnType<typeof useSearchCompaniesQuery>;
export type SearchCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCompaniesLazyQuery>;
export type SearchCompaniesQueryResult = ApolloReactCommon.QueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export const ExportCompaniesDocument = /*#__PURE__*/ gql`
    query exportCompanies($query: String!, $sort: [String!]) {
  exportCompanies(query: $query, sort: $sort) {
    csv
    rows
  }
}
    `;

/**
 * __useExportCompaniesQuery__
 *
 * To run a query within a React component, call `useExportCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCompaniesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportCompaniesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExportCompaniesQuery, ExportCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportCompaniesQuery, ExportCompaniesQueryVariables>(ExportCompaniesDocument, options);
      }
export function useExportCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportCompaniesQuery, ExportCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportCompaniesQuery, ExportCompaniesQueryVariables>(ExportCompaniesDocument, options);
        }
export type ExportCompaniesQueryHookResult = ReturnType<typeof useExportCompaniesQuery>;
export type ExportCompaniesLazyQueryHookResult = ReturnType<typeof useExportCompaniesLazyQuery>;
export type ExportCompaniesQueryResult = ApolloReactCommon.QueryResult<ExportCompaniesQuery, ExportCompaniesQueryVariables>;
export const SaveCompanyDocument = /*#__PURE__*/ gql`
    mutation saveCompany($company: JSON!) {
  saveCompany(company: $company) {
    ...FullCompany
  }
}
    ${FullCompanyFragmentDoc}`;
export type SaveCompanyMutationFn = ApolloReactCommon.MutationFunction<SaveCompanyMutation, SaveCompanyMutationVariables>;

/**
 * __useSaveCompanyMutation__
 *
 * To run a mutation, you first call `useSaveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCompanyMutation, { data, loading, error }] = useSaveCompanyMutation({
 *   variables: {
 *      company: // value for 'company'
 *   },
 * });
 */
export function useSaveCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCompanyMutation, SaveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCompanyMutation, SaveCompanyMutationVariables>(SaveCompanyDocument, options);
      }
export type SaveCompanyMutationHookResult = ReturnType<typeof useSaveCompanyMutation>;
export type SaveCompanyMutationResult = ApolloReactCommon.MutationResult<SaveCompanyMutation>;
export type SaveCompanyMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveCompanyMutation, SaveCompanyMutationVariables>;
export const DeleteCompaniesDocument = /*#__PURE__*/ gql`
    mutation deleteCompanies($ids: [String!]!, $softDelete: Boolean) {
  deleteCompanies(ids: $ids, softDelete: $softDelete) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type DeleteCompaniesMutationFn = ApolloReactCommon.MutationFunction<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>;

/**
 * __useDeleteCompaniesMutation__
 *
 * To run a mutation, you first call `useDeleteCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompaniesMutation, { data, loading, error }] = useDeleteCompaniesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      softDelete: // value for 'softDelete'
 *   },
 * });
 */
export function useDeleteCompaniesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>(DeleteCompaniesDocument, options);
      }
export type DeleteCompaniesMutationHookResult = ReturnType<typeof useDeleteCompaniesMutation>;
export type DeleteCompaniesMutationResult = ApolloReactCommon.MutationResult<DeleteCompaniesMutation>;
export type DeleteCompaniesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>;
export const ContactDocument = /*#__PURE__*/ gql`
    query contact($id: String!) {
  contact(id: $id) {
    ...FullContact
  }
}
    ${FullContactFragmentDoc}`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContactQuery, ContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactQueryResult = ApolloReactCommon.QueryResult<ContactQuery, ContactQueryVariables>;
export const ContactBySourceDocument = /*#__PURE__*/ gql`
    query contactBySource($source: String!, $source_id: String!) {
  contactBySource(source: $source, source_id: $source_id) {
    ...FullContact
  }
}
    ${FullContactFragmentDoc}`;

/**
 * __useContactBySourceQuery__
 *
 * To run a query within a React component, call `useContactBySourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactBySourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactBySourceQuery({
 *   variables: {
 *      source: // value for 'source'
 *      source_id: // value for 'source_id'
 *   },
 * });
 */
export function useContactBySourceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContactBySourceQuery, ContactBySourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContactBySourceQuery, ContactBySourceQueryVariables>(ContactBySourceDocument, options);
      }
export function useContactBySourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContactBySourceQuery, ContactBySourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContactBySourceQuery, ContactBySourceQueryVariables>(ContactBySourceDocument, options);
        }
export type ContactBySourceQueryHookResult = ReturnType<typeof useContactBySourceQuery>;
export type ContactBySourceLazyQueryHookResult = ReturnType<typeof useContactBySourceLazyQuery>;
export type ContactBySourceQueryResult = ApolloReactCommon.QueryResult<ContactBySourceQuery, ContactBySourceQueryVariables>;
export const SearchContactsDocument = /*#__PURE__*/ gql`
    query searchContacts($query: String!, $bookmark: String, $limit: Int = 20, $sort: [String!]) {
  searchContacts(query: $query, bookmark: $bookmark, limit: $limit, sort: $sort) {
    total_rows
    bookmark
    contacts {
      ...SearchedContact
    }
  }
}
    ${SearchedContactFragmentDoc}`;

/**
 * __useSearchContactsQuery__
 *
 * To run a query within a React component, call `useSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchContactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
      }
export function useSearchContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
        }
export type SearchContactsQueryHookResult = ReturnType<typeof useSearchContactsQuery>;
export type SearchContactsLazyQueryHookResult = ReturnType<typeof useSearchContactsLazyQuery>;
export type SearchContactsQueryResult = ApolloReactCommon.QueryResult<SearchContactsQuery, SearchContactsQueryVariables>;
export const SearchContactDealsDocument = /*#__PURE__*/ gql`
    query searchContactDeals($contactSourceId: String!, $page: Int) {
  searchContactDeals(contactSourceId: $contactSourceId, page: $page) {
    results
  }
}
    `;

/**
 * __useSearchContactDealsQuery__
 *
 * To run a query within a React component, call `useSearchContactDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactDealsQuery({
 *   variables: {
 *      contactSourceId: // value for 'contactSourceId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchContactDealsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchContactDealsQuery, SearchContactDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchContactDealsQuery, SearchContactDealsQueryVariables>(SearchContactDealsDocument, options);
      }
export function useSearchContactDealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchContactDealsQuery, SearchContactDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchContactDealsQuery, SearchContactDealsQueryVariables>(SearchContactDealsDocument, options);
        }
export type SearchContactDealsQueryHookResult = ReturnType<typeof useSearchContactDealsQuery>;
export type SearchContactDealsLazyQueryHookResult = ReturnType<typeof useSearchContactDealsLazyQuery>;
export type SearchContactDealsQueryResult = ApolloReactCommon.QueryResult<SearchContactDealsQuery, SearchContactDealsQueryVariables>;
export const SearchContactOpportunitiesDocument = /*#__PURE__*/ gql`
    query searchContactOpportunities($contactSourceId: String!, $integration: String!) {
  searchContactOpportunities(
    contactSourceId: $contactSourceId
    integration: $integration
  ) {
    results
  }
}
    `;

/**
 * __useSearchContactOpportunitiesQuery__
 *
 * To run a query within a React component, call `useSearchContactOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactOpportunitiesQuery({
 *   variables: {
 *      contactSourceId: // value for 'contactSourceId'
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useSearchContactOpportunitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchContactOpportunitiesQuery, SearchContactOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchContactOpportunitiesQuery, SearchContactOpportunitiesQueryVariables>(SearchContactOpportunitiesDocument, options);
      }
export function useSearchContactOpportunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchContactOpportunitiesQuery, SearchContactOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchContactOpportunitiesQuery, SearchContactOpportunitiesQueryVariables>(SearchContactOpportunitiesDocument, options);
        }
export type SearchContactOpportunitiesQueryHookResult = ReturnType<typeof useSearchContactOpportunitiesQuery>;
export type SearchContactOpportunitiesLazyQueryHookResult = ReturnType<typeof useSearchContactOpportunitiesLazyQuery>;
export type SearchContactOpportunitiesQueryResult = ApolloReactCommon.QueryResult<SearchContactOpportunitiesQuery, SearchContactOpportunitiesQueryVariables>;
export const SearchContactsWithIntegrationDocument = /*#__PURE__*/ gql`
    query searchContactsWithIntegration($paintscoutQuery: String!, $integrationQuery: String!, $integration: String!, $useIntegration: Boolean!, $bookmark: String, $limit: Int, $sort: [String!]) {
  paintscout: searchContacts(
    query: $paintscoutQuery
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) @skip(if: $useIntegration) {
    total_rows
    bookmark
    contacts {
      ...FullContact
    }
  }
  integration: searchContactsByIntegration(
    query: $integrationQuery
    integration: $integration
  ) @include(if: $useIntegration) {
    results
  }
}
    ${FullContactFragmentDoc}`;

/**
 * __useSearchContactsWithIntegrationQuery__
 *
 * To run a query within a React component, call `useSearchContactsWithIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsWithIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsWithIntegrationQuery({
 *   variables: {
 *      paintscoutQuery: // value for 'paintscoutQuery'
 *      integrationQuery: // value for 'integrationQuery'
 *      integration: // value for 'integration'
 *      useIntegration: // value for 'useIntegration'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchContactsWithIntegrationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchContactsWithIntegrationQuery, SearchContactsWithIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchContactsWithIntegrationQuery, SearchContactsWithIntegrationQueryVariables>(SearchContactsWithIntegrationDocument, options);
      }
export function useSearchContactsWithIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchContactsWithIntegrationQuery, SearchContactsWithIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchContactsWithIntegrationQuery, SearchContactsWithIntegrationQueryVariables>(SearchContactsWithIntegrationDocument, options);
        }
export type SearchContactsWithIntegrationQueryHookResult = ReturnType<typeof useSearchContactsWithIntegrationQuery>;
export type SearchContactsWithIntegrationLazyQueryHookResult = ReturnType<typeof useSearchContactsWithIntegrationLazyQuery>;
export type SearchContactsWithIntegrationQueryResult = ApolloReactCommon.QueryResult<SearchContactsWithIntegrationQuery, SearchContactsWithIntegrationQueryVariables>;
export const ExportContactsDocument = /*#__PURE__*/ gql`
    query exportContacts($query: String!, $sort: [String!]) {
  exportContacts(query: $query, sort: $sort) {
    csv
    rows
  }
}
    `;

/**
 * __useExportContactsQuery__
 *
 * To run a query within a React component, call `useExportContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportContactsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportContactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExportContactsQuery, ExportContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportContactsQuery, ExportContactsQueryVariables>(ExportContactsDocument, options);
      }
export function useExportContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportContactsQuery, ExportContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportContactsQuery, ExportContactsQueryVariables>(ExportContactsDocument, options);
        }
export type ExportContactsQueryHookResult = ReturnType<typeof useExportContactsQuery>;
export type ExportContactsLazyQueryHookResult = ReturnType<typeof useExportContactsLazyQuery>;
export type ExportContactsQueryResult = ApolloReactCommon.QueryResult<ExportContactsQuery, ExportContactsQueryVariables>;
export const SaveContactDocument = /*#__PURE__*/ gql`
    mutation saveContact($contact: JSON!) {
  saveContact(contact: $contact) {
    ...FullContact
  }
}
    ${FullContactFragmentDoc}`;
export type SaveContactMutationFn = ApolloReactCommon.MutationFunction<SaveContactMutation, SaveContactMutationVariables>;

/**
 * __useSaveContactMutation__
 *
 * To run a mutation, you first call `useSaveContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContactMutation, { data, loading, error }] = useSaveContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useSaveContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveContactMutation, SaveContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveContactMutation, SaveContactMutationVariables>(SaveContactDocument, options);
      }
export type SaveContactMutationHookResult = ReturnType<typeof useSaveContactMutation>;
export type SaveContactMutationResult = ApolloReactCommon.MutationResult<SaveContactMutation>;
export type SaveContactMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveContactMutation, SaveContactMutationVariables>;
export const DeleteContactsDocument = /*#__PURE__*/ gql`
    mutation deleteContacts($ids: [String!]!, $softDelete: Boolean) {
  deleteContacts(ids: $ids, softDelete: $softDelete) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type DeleteContactsMutationFn = ApolloReactCommon.MutationFunction<DeleteContactsMutation, DeleteContactsMutationVariables>;

/**
 * __useDeleteContactsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsMutation, { data, loading, error }] = useDeleteContactsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      softDelete: // value for 'softDelete'
 *   },
 * });
 */
export function useDeleteContactsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactsMutation, DeleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContactsMutation, DeleteContactsMutationVariables>(DeleteContactsDocument, options);
      }
export type DeleteContactsMutationHookResult = ReturnType<typeof useDeleteContactsMutation>;
export type DeleteContactsMutationResult = ApolloReactCommon.MutationResult<DeleteContactsMutation>;
export type DeleteContactsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContactsMutation, DeleteContactsMutationVariables>;
export const DealDocument = /*#__PURE__*/ gql`
    query deal($id: String!) {
  deal(id: $id) {
    ...FullDeal
  }
}
    ${FullDealFragmentDoc}`;

/**
 * __useDealQuery__
 *
 * To run a query within a React component, call `useDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealQuery, DealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealQuery, DealQueryVariables>(DealDocument, options);
      }
export function useDealLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealQuery, DealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealQuery, DealQueryVariables>(DealDocument, options);
        }
export type DealQueryHookResult = ReturnType<typeof useDealQuery>;
export type DealLazyQueryHookResult = ReturnType<typeof useDealLazyQuery>;
export type DealQueryResult = ApolloReactCommon.QueryResult<DealQuery, DealQueryVariables>;
export const ExportDealsDocument = /*#__PURE__*/ gql`
    query exportDeals($query: String!, $sort: [String!]) {
  exportDeals(query: $query, sort: $sort) {
    csv
    rows
  }
}
    `;

/**
 * __useExportDealsQuery__
 *
 * To run a query within a React component, call `useExportDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDealsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportDealsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExportDealsQuery, ExportDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportDealsQuery, ExportDealsQueryVariables>(ExportDealsDocument, options);
      }
export function useExportDealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportDealsQuery, ExportDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportDealsQuery, ExportDealsQueryVariables>(ExportDealsDocument, options);
        }
export type ExportDealsQueryHookResult = ReturnType<typeof useExportDealsQuery>;
export type ExportDealsLazyQueryHookResult = ReturnType<typeof useExportDealsLazyQuery>;
export type ExportDealsQueryResult = ApolloReactCommon.QueryResult<ExportDealsQuery, ExportDealsQueryVariables>;
export const SearchDealsDocument = /*#__PURE__*/ gql`
    query searchDeals($query: String!, $bookmark: String, $limit: Int = 20, $sort: [String!], $omitInvalidContacts: Boolean) {
  searchDeals(
    query: $query
    bookmark: $bookmark
    limit: $limit
    sort: $sort
    omitInvalidContacts: $omitInvalidContacts
  ) {
    total_rows
    bookmark
    deals {
      ...SearchedDeal
    }
  }
}
    ${SearchedDealFragmentDoc}`;

/**
 * __useSearchDealsQuery__
 *
 * To run a query within a React component, call `useSearchDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDealsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      omitInvalidContacts: // value for 'omitInvalidContacts'
 *   },
 * });
 */
export function useSearchDealsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDealsQuery, SearchDealsQueryVariables>(SearchDealsDocument, options);
      }
export function useSearchDealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDealsQuery, SearchDealsQueryVariables>(SearchDealsDocument, options);
        }
export type SearchDealsQueryHookResult = ReturnType<typeof useSearchDealsQuery>;
export type SearchDealsLazyQueryHookResult = ReturnType<typeof useSearchDealsLazyQuery>;
export type SearchDealsQueryResult = ApolloReactCommon.QueryResult<SearchDealsQuery, SearchDealsQueryVariables>;
export const SearchDealsByCompanyDocument = /*#__PURE__*/ gql`
    query searchDealsByCompany($companyId: String!, $query: String, $bookmark: String, $limit: Int = 20, $sort: [String!]) {
  searchDealsByCompany(
    companyId: $companyId
    query: $query
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    total_rows
    bookmark
    deals {
      ...SearchedDeal
    }
  }
}
    ${SearchedDealFragmentDoc}`;

/**
 * __useSearchDealsByCompanyQuery__
 *
 * To run a query within a React component, call `useSearchDealsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDealsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDealsByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchDealsByCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchDealsByCompanyQuery, SearchDealsByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDealsByCompanyQuery, SearchDealsByCompanyQueryVariables>(SearchDealsByCompanyDocument, options);
      }
export function useSearchDealsByCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDealsByCompanyQuery, SearchDealsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDealsByCompanyQuery, SearchDealsByCompanyQueryVariables>(SearchDealsByCompanyDocument, options);
        }
export type SearchDealsByCompanyQueryHookResult = ReturnType<typeof useSearchDealsByCompanyQuery>;
export type SearchDealsByCompanyLazyQueryHookResult = ReturnType<typeof useSearchDealsByCompanyLazyQuery>;
export type SearchDealsByCompanyQueryResult = ApolloReactCommon.QueryResult<SearchDealsByCompanyQuery, SearchDealsByCompanyQueryVariables>;
export const SearchDealsByStageDocument = /*#__PURE__*/ gql`
    query searchDealsByStage($query: String!, $stage: String!, $bookmark: String, $limit: Int = 20, $sort: [String!]) {
  searchDealsByStage(
    query: $query
    stage: $stage
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    total_rows
    bookmark
    aggregations {
      totalDeals
      totalDealValue
    }
    deals {
      ...SearchedDeal
    }
  }
}
    ${SearchedDealFragmentDoc}`;

/**
 * __useSearchDealsByStageQuery__
 *
 * To run a query within a React component, call `useSearchDealsByStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDealsByStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDealsByStageQuery({
 *   variables: {
 *      query: // value for 'query'
 *      stage: // value for 'stage'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchDealsByStageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchDealsByStageQuery, SearchDealsByStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDealsByStageQuery, SearchDealsByStageQueryVariables>(SearchDealsByStageDocument, options);
      }
export function useSearchDealsByStageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDealsByStageQuery, SearchDealsByStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDealsByStageQuery, SearchDealsByStageQueryVariables>(SearchDealsByStageDocument, options);
        }
export type SearchDealsByStageQueryHookResult = ReturnType<typeof useSearchDealsByStageQuery>;
export type SearchDealsByStageLazyQueryHookResult = ReturnType<typeof useSearchDealsByStageLazyQuery>;
export type SearchDealsByStageQueryResult = ApolloReactCommon.QueryResult<SearchDealsByStageQuery, SearchDealsByStageQueryVariables>;
export const DealSummaryDocument = /*#__PURE__*/ gql`
    query dealSummary($query: String!, $pipeline: String!) {
  dealSummary(query: $query, pipeline: $pipeline) {
    totalDeals
    totalDealValue
  }
}
    `;

/**
 * __useDealSummaryQuery__
 *
 * To run a query within a React component, call `useDealSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealSummaryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      pipeline: // value for 'pipeline'
 *   },
 * });
 */
export function useDealSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealSummaryQuery, DealSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealSummaryQuery, DealSummaryQueryVariables>(DealSummaryDocument, options);
      }
export function useDealSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealSummaryQuery, DealSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealSummaryQuery, DealSummaryQueryVariables>(DealSummaryDocument, options);
        }
export type DealSummaryQueryHookResult = ReturnType<typeof useDealSummaryQuery>;
export type DealSummaryLazyQueryHookResult = ReturnType<typeof useDealSummaryLazyQuery>;
export type DealSummaryQueryResult = ApolloReactCommon.QueryResult<DealSummaryQuery, DealSummaryQueryVariables>;
export const SaveDealDocument = /*#__PURE__*/ gql`
    mutation saveDeal($deal: JSON!, $updateLinkedQuoteAddresses: Boolean) {
  saveDeal(deal: $deal, updateLinkedQuoteAddresses: $updateLinkedQuoteAddresses) {
    ...FullDeal
  }
}
    ${FullDealFragmentDoc}`;
export type SaveDealMutationFn = ApolloReactCommon.MutationFunction<SaveDealMutation, SaveDealMutationVariables>;

/**
 * __useSaveDealMutation__
 *
 * To run a mutation, you first call `useSaveDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDealMutation, { data, loading, error }] = useSaveDealMutation({
 *   variables: {
 *      deal: // value for 'deal'
 *      updateLinkedQuoteAddresses: // value for 'updateLinkedQuoteAddresses'
 *   },
 * });
 */
export function useSaveDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDealMutation, SaveDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDealMutation, SaveDealMutationVariables>(SaveDealDocument, options);
      }
export type SaveDealMutationHookResult = ReturnType<typeof useSaveDealMutation>;
export type SaveDealMutationResult = ApolloReactCommon.MutationResult<SaveDealMutation>;
export type SaveDealMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveDealMutation, SaveDealMutationVariables>;
export const DeleteDealsDocument = /*#__PURE__*/ gql`
    mutation deleteDeals($ids: [String!]!, $softDelete: Boolean) {
  deleteDeals(ids: $ids, softDelete: $softDelete) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type DeleteDealsMutationFn = ApolloReactCommon.MutationFunction<DeleteDealsMutation, DeleteDealsMutationVariables>;

/**
 * __useDeleteDealsMutation__
 *
 * To run a mutation, you first call `useDeleteDealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealsMutation, { data, loading, error }] = useDeleteDealsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      softDelete: // value for 'softDelete'
 *   },
 * });
 */
export function useDeleteDealsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDealsMutation, DeleteDealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDealsMutation, DeleteDealsMutationVariables>(DeleteDealsDocument, options);
      }
export type DeleteDealsMutationHookResult = ReturnType<typeof useDeleteDealsMutation>;
export type DeleteDealsMutationResult = ApolloReactCommon.MutationResult<DeleteDealsMutation>;
export type DeleteDealsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDealsMutation, DeleteDealsMutationVariables>;
export const ArchiveDealsDocument = /*#__PURE__*/ gql`
    mutation archiveDeals($ids: [String!]!, $unarchive: Boolean) {
  archiveDeals(ids: $ids, unarchive: $unarchive) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type ArchiveDealsMutationFn = ApolloReactCommon.MutationFunction<ArchiveDealsMutation, ArchiveDealsMutationVariables>;

/**
 * __useArchiveDealsMutation__
 *
 * To run a mutation, you first call `useArchiveDealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDealsMutation, { data, loading, error }] = useArchiveDealsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      unarchive: // value for 'unarchive'
 *   },
 * });
 */
export function useArchiveDealsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveDealsMutation, ArchiveDealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveDealsMutation, ArchiveDealsMutationVariables>(ArchiveDealsDocument, options);
      }
export type ArchiveDealsMutationHookResult = ReturnType<typeof useArchiveDealsMutation>;
export type ArchiveDealsMutationResult = ApolloReactCommon.MutationResult<ArchiveDealsMutation>;
export type ArchiveDealsMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveDealsMutation, ArchiveDealsMutationVariables>;
export const UntrashDealsDocument = /*#__PURE__*/ gql`
    mutation untrashDeals($ids: [String!]!) {
  untrashDeals(ids: $ids) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type UntrashDealsMutationFn = ApolloReactCommon.MutationFunction<UntrashDealsMutation, UntrashDealsMutationVariables>;

/**
 * __useUntrashDealsMutation__
 *
 * To run a mutation, you first call `useUntrashDealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntrashDealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untrashDealsMutation, { data, loading, error }] = useUntrashDealsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUntrashDealsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UntrashDealsMutation, UntrashDealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UntrashDealsMutation, UntrashDealsMutationVariables>(UntrashDealsDocument, options);
      }
export type UntrashDealsMutationHookResult = ReturnType<typeof useUntrashDealsMutation>;
export type UntrashDealsMutationResult = ApolloReactCommon.MutationResult<UntrashDealsMutation>;
export type UntrashDealsMutationOptions = ApolloReactCommon.BaseMutationOptions<UntrashDealsMutation, UntrashDealsMutationVariables>;
export const UpdateDealStageDocument = /*#__PURE__*/ gql`
    mutation updateDealStage($dealId: String!, $stage: String!, $query: String) {
  updateDealStage(dealId: $dealId, stage: $stage, query: $query) {
    deal {
      ...FullDeal
    }
    sourceAggregations {
      totalDeals
      totalDealValue
    }
    destimationAggregations {
      totalDeals
      totalDealValue
    }
  }
}
    ${FullDealFragmentDoc}`;
export type UpdateDealStageMutationFn = ApolloReactCommon.MutationFunction<UpdateDealStageMutation, UpdateDealStageMutationVariables>;

/**
 * __useUpdateDealStageMutation__
 *
 * To run a mutation, you first call `useUpdateDealStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealStageMutation, { data, loading, error }] = useUpdateDealStageMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      stage: // value for 'stage'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUpdateDealStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealStageMutation, UpdateDealStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealStageMutation, UpdateDealStageMutationVariables>(UpdateDealStageDocument, options);
      }
export type UpdateDealStageMutationHookResult = ReturnType<typeof useUpdateDealStageMutation>;
export type UpdateDealStageMutationResult = ApolloReactCommon.MutationResult<UpdateDealStageMutation>;
export type UpdateDealStageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDealStageMutation, UpdateDealStageMutationVariables>;
export const GetInboundWebhookLogsDocument = /*#__PURE__*/ gql`
    query getInboundWebhookLogs($companyId: String!, $integration: String, $limit: Int, $from: Int, $startDate: String, $endDate: String) {
  getInboundWebhookLogs(
    companyId: $companyId
    integration: $integration
    limit: $limit
    from: $from
    startDate: $startDate
    endDate: $endDate
  ) {
    logs {
      timestamp
      level
      message
      namespace
      action
      integration
      data
      errorMessage
      errorType
      errorStack
    }
    total_rows
  }
}
    `;

/**
 * __useGetInboundWebhookLogsQuery__
 *
 * To run a query within a React component, call `useGetInboundWebhookLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboundWebhookLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboundWebhookLogsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      integration: // value for 'integration'
 *      limit: // value for 'limit'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetInboundWebhookLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInboundWebhookLogsQuery, GetInboundWebhookLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInboundWebhookLogsQuery, GetInboundWebhookLogsQueryVariables>(GetInboundWebhookLogsDocument, options);
      }
export function useGetInboundWebhookLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInboundWebhookLogsQuery, GetInboundWebhookLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInboundWebhookLogsQuery, GetInboundWebhookLogsQueryVariables>(GetInboundWebhookLogsDocument, options);
        }
export type GetInboundWebhookLogsQueryHookResult = ReturnType<typeof useGetInboundWebhookLogsQuery>;
export type GetInboundWebhookLogsLazyQueryHookResult = ReturnType<typeof useGetInboundWebhookLogsLazyQuery>;
export type GetInboundWebhookLogsQueryResult = ApolloReactCommon.QueryResult<GetInboundWebhookLogsQuery, GetInboundWebhookLogsQueryVariables>;
export const RerunInboundWebhookDocument = /*#__PURE__*/ gql`
    mutation rerunInboundWebhook($integration: String!, $eventData: JSON!) {
  rerunInboundWebhook(integration: $integration, eventData: $eventData) {
    statusCode
  }
}
    `;
export type RerunInboundWebhookMutationFn = ApolloReactCommon.MutationFunction<RerunInboundWebhookMutation, RerunInboundWebhookMutationVariables>;

/**
 * __useRerunInboundWebhookMutation__
 *
 * To run a mutation, you first call `useRerunInboundWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunInboundWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunInboundWebhookMutation, { data, loading, error }] = useRerunInboundWebhookMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *      eventData: // value for 'eventData'
 *   },
 * });
 */
export function useRerunInboundWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RerunInboundWebhookMutation, RerunInboundWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RerunInboundWebhookMutation, RerunInboundWebhookMutationVariables>(RerunInboundWebhookDocument, options);
      }
export type RerunInboundWebhookMutationHookResult = ReturnType<typeof useRerunInboundWebhookMutation>;
export type RerunInboundWebhookMutationResult = ApolloReactCommon.MutationResult<RerunInboundWebhookMutation>;
export type RerunInboundWebhookMutationOptions = ApolloReactCommon.BaseMutationOptions<RerunInboundWebhookMutation, RerunInboundWebhookMutationVariables>;
export const GetStuckPaymentsDocument = /*#__PURE__*/ gql`
    query getStuckPayments($companyId: String!) {
  getStuckPayments(companyId: $companyId) {
    quotes {
      ...AdminPaymentQuoteFields
    }
  }
}
    ${AdminPaymentQuoteFieldsFragmentDoc}`;

/**
 * __useGetStuckPaymentsQuery__
 *
 * To run a query within a React component, call `useGetStuckPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStuckPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStuckPaymentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetStuckPaymentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStuckPaymentsQuery, GetStuckPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStuckPaymentsQuery, GetStuckPaymentsQueryVariables>(GetStuckPaymentsDocument, options);
      }
export function useGetStuckPaymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStuckPaymentsQuery, GetStuckPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStuckPaymentsQuery, GetStuckPaymentsQueryVariables>(GetStuckPaymentsDocument, options);
        }
export type GetStuckPaymentsQueryHookResult = ReturnType<typeof useGetStuckPaymentsQuery>;
export type GetStuckPaymentsLazyQueryHookResult = ReturnType<typeof useGetStuckPaymentsLazyQuery>;
export type GetStuckPaymentsQueryResult = ApolloReactCommon.QueryResult<GetStuckPaymentsQuery, GetStuckPaymentsQueryVariables>;
export const FindQuotePaymentsDocument = /*#__PURE__*/ gql`
    query findQuotePayments($companyId: String!, $search: String!) {
  findQuotePayments(companyId: $companyId, search: $search) {
    ...AdminPaymentQuoteFields
  }
}
    ${AdminPaymentQuoteFieldsFragmentDoc}`;

/**
 * __useFindQuotePaymentsQuery__
 *
 * To run a query within a React component, call `useFindQuotePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindQuotePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindQuotePaymentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFindQuotePaymentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindQuotePaymentsQuery, FindQuotePaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindQuotePaymentsQuery, FindQuotePaymentsQueryVariables>(FindQuotePaymentsDocument, options);
      }
export function useFindQuotePaymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindQuotePaymentsQuery, FindQuotePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindQuotePaymentsQuery, FindQuotePaymentsQueryVariables>(FindQuotePaymentsDocument, options);
        }
export type FindQuotePaymentsQueryHookResult = ReturnType<typeof useFindQuotePaymentsQuery>;
export type FindQuotePaymentsLazyQueryHookResult = ReturnType<typeof useFindQuotePaymentsLazyQuery>;
export type FindQuotePaymentsQueryResult = ApolloReactCommon.QueryResult<FindQuotePaymentsQuery, FindQuotePaymentsQueryVariables>;
export const GetPaymentSyncPreviewDocument = /*#__PURE__*/ gql`
    query getPaymentSyncPreview($companyId: String!, $quoteId: String!, $paymentIds: [String!]) {
  getPaymentSyncPreview(
    companyId: $companyId
    quoteId: $quoteId
    paymentIds: $paymentIds
  ) {
    paymentId
    txnId
    currentStatus
    portalStatus
    recommended
    reason
    refunds {
      txnId
      amount
      status
      approved
      created
      alreadyRecorded
    }
  }
}
    `;

/**
 * __useGetPaymentSyncPreviewQuery__
 *
 * To run a query within a React component, call `useGetPaymentSyncPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentSyncPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentSyncPreviewQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      quoteId: // value for 'quoteId'
 *      paymentIds: // value for 'paymentIds'
 *   },
 * });
 */
export function useGetPaymentSyncPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPaymentSyncPreviewQuery, GetPaymentSyncPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentSyncPreviewQuery, GetPaymentSyncPreviewQueryVariables>(GetPaymentSyncPreviewDocument, options);
      }
export function useGetPaymentSyncPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentSyncPreviewQuery, GetPaymentSyncPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentSyncPreviewQuery, GetPaymentSyncPreviewQueryVariables>(GetPaymentSyncPreviewDocument, options);
        }
export type GetPaymentSyncPreviewQueryHookResult = ReturnType<typeof useGetPaymentSyncPreviewQuery>;
export type GetPaymentSyncPreviewLazyQueryHookResult = ReturnType<typeof useGetPaymentSyncPreviewLazyQuery>;
export type GetPaymentSyncPreviewQueryResult = ApolloReactCommon.QueryResult<GetPaymentSyncPreviewQuery, GetPaymentSyncPreviewQueryVariables>;
export const GetPayrixTxnLookupDocument = /*#__PURE__*/ gql`
    query getPayrixTxnLookup($companyId: String!, $txnId: String!, $quoteId: String) {
  getPayrixTxnLookup(companyId: $companyId, txnId: $txnId, quoteId: $quoteId) {
    txnId
    status
    statusLabel
    recommended
    recommendedReason
    type
    amount
    method
    created
    metadataCompanyId
    metadataActivityId
    activityExists
    depositHint
    alreadyOnQuote
    matchedRequestId
    matchingRequestIds
  }
}
    `;

/**
 * __useGetPayrixTxnLookupQuery__
 *
 * To run a query within a React component, call `useGetPayrixTxnLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrixTxnLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayrixTxnLookupQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      txnId: // value for 'txnId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetPayrixTxnLookupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPayrixTxnLookupQuery, GetPayrixTxnLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayrixTxnLookupQuery, GetPayrixTxnLookupQueryVariables>(GetPayrixTxnLookupDocument, options);
      }
export function useGetPayrixTxnLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayrixTxnLookupQuery, GetPayrixTxnLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayrixTxnLookupQuery, GetPayrixTxnLookupQueryVariables>(GetPayrixTxnLookupDocument, options);
        }
export type GetPayrixTxnLookupQueryHookResult = ReturnType<typeof useGetPayrixTxnLookupQuery>;
export type GetPayrixTxnLookupLazyQueryHookResult = ReturnType<typeof useGetPayrixTxnLookupLazyQuery>;
export type GetPayrixTxnLookupQueryResult = ApolloReactCommon.QueryResult<GetPayrixTxnLookupQuery, GetPayrixTxnLookupQueryVariables>;
export const ApplyPaymentSyncDocument = /*#__PURE__*/ gql`
    mutation applyPaymentSync($companyId: String!, $quoteId: String!, $decisions: [PaymentDecisionInput!], $refunds: [RefundRecordInput!], $silent: Boolean, $clearErrorFlag: Boolean) {
  applyPaymentSync(
    companyId: $companyId
    quoteId: $quoteId
    decisions: $decisions
    refunds: $refunds
    silent: $silent
    clearErrorFlag: $clearErrorFlag
  ) {
    success
    changes
  }
}
    `;
export type ApplyPaymentSyncMutationFn = ApolloReactCommon.MutationFunction<ApplyPaymentSyncMutation, ApplyPaymentSyncMutationVariables>;

/**
 * __useApplyPaymentSyncMutation__
 *
 * To run a mutation, you first call `useApplyPaymentSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyPaymentSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyPaymentSyncMutation, { data, loading, error }] = useApplyPaymentSyncMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      quoteId: // value for 'quoteId'
 *      decisions: // value for 'decisions'
 *      refunds: // value for 'refunds'
 *      silent: // value for 'silent'
 *      clearErrorFlag: // value for 'clearErrorFlag'
 *   },
 * });
 */
export function useApplyPaymentSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyPaymentSyncMutation, ApplyPaymentSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplyPaymentSyncMutation, ApplyPaymentSyncMutationVariables>(ApplyPaymentSyncDocument, options);
      }
export type ApplyPaymentSyncMutationHookResult = ReturnType<typeof useApplyPaymentSyncMutation>;
export type ApplyPaymentSyncMutationResult = ApolloReactCommon.MutationResult<ApplyPaymentSyncMutation>;
export type ApplyPaymentSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<ApplyPaymentSyncMutation, ApplyPaymentSyncMutationVariables>;
export const AttachTxnIdToPaymentDocument = /*#__PURE__*/ gql`
    mutation attachTxnIdToPayment($companyId: String!, $quoteId: String!, $paymentId: String!, $txnId: String!, $status: String, $silent: Boolean) {
  attachTxnIdToPayment(
    companyId: $companyId
    quoteId: $quoteId
    paymentId: $paymentId
    txnId: $txnId
    status: $status
    silent: $silent
  ) {
    success
    changes
  }
}
    `;
export type AttachTxnIdToPaymentMutationFn = ApolloReactCommon.MutationFunction<AttachTxnIdToPaymentMutation, AttachTxnIdToPaymentMutationVariables>;

/**
 * __useAttachTxnIdToPaymentMutation__
 *
 * To run a mutation, you first call `useAttachTxnIdToPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachTxnIdToPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachTxnIdToPaymentMutation, { data, loading, error }] = useAttachTxnIdToPaymentMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      quoteId: // value for 'quoteId'
 *      paymentId: // value for 'paymentId'
 *      txnId: // value for 'txnId'
 *      status: // value for 'status'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useAttachTxnIdToPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AttachTxnIdToPaymentMutation, AttachTxnIdToPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttachTxnIdToPaymentMutation, AttachTxnIdToPaymentMutationVariables>(AttachTxnIdToPaymentDocument, options);
      }
export type AttachTxnIdToPaymentMutationHookResult = ReturnType<typeof useAttachTxnIdToPaymentMutation>;
export type AttachTxnIdToPaymentMutationResult = ApolloReactCommon.MutationResult<AttachTxnIdToPaymentMutation>;
export type AttachTxnIdToPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<AttachTxnIdToPaymentMutation, AttachTxnIdToPaymentMutationVariables>;
export const AddPaymentByTxnIdDocument = /*#__PURE__*/ gql`
    mutation addPaymentByTxnId($companyId: String!, $quoteId: String!, $txnId: String!, $deposit: Boolean, $paymentRequestId: String, $note: String, $silent: Boolean) {
  addPaymentByTxnId(
    companyId: $companyId
    quoteId: $quoteId
    txnId: $txnId
    deposit: $deposit
    paymentRequestId: $paymentRequestId
    note: $note
    silent: $silent
  ) {
    success
    paymentId
    changes
  }
}
    `;
export type AddPaymentByTxnIdMutationFn = ApolloReactCommon.MutationFunction<AddPaymentByTxnIdMutation, AddPaymentByTxnIdMutationVariables>;

/**
 * __useAddPaymentByTxnIdMutation__
 *
 * To run a mutation, you first call `useAddPaymentByTxnIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentByTxnIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentByTxnIdMutation, { data, loading, error }] = useAddPaymentByTxnIdMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      quoteId: // value for 'quoteId'
 *      txnId: // value for 'txnId'
 *      deposit: // value for 'deposit'
 *      paymentRequestId: // value for 'paymentRequestId'
 *      note: // value for 'note'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useAddPaymentByTxnIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPaymentByTxnIdMutation, AddPaymentByTxnIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPaymentByTxnIdMutation, AddPaymentByTxnIdMutationVariables>(AddPaymentByTxnIdDocument, options);
      }
export type AddPaymentByTxnIdMutationHookResult = ReturnType<typeof useAddPaymentByTxnIdMutation>;
export type AddPaymentByTxnIdMutationResult = ApolloReactCommon.MutationResult<AddPaymentByTxnIdMutation>;
export type AddPaymentByTxnIdMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPaymentByTxnIdMutation, AddPaymentByTxnIdMutationVariables>;
export const DisconnectPayrixDocument = /*#__PURE__*/ gql`
    mutation disconnectPayrix($companyId: String!) {
  disconnectPayrix(companyId: $companyId) {
    success
    merchantId
    merchantCreated
  }
}
    `;
export type DisconnectPayrixMutationFn = ApolloReactCommon.MutationFunction<DisconnectPayrixMutation, DisconnectPayrixMutationVariables>;

/**
 * __useDisconnectPayrixMutation__
 *
 * To run a mutation, you first call `useDisconnectPayrixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectPayrixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectPayrixMutation, { data, loading, error }] = useDisconnectPayrixMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDisconnectPayrixMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisconnectPayrixMutation, DisconnectPayrixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectPayrixMutation, DisconnectPayrixMutationVariables>(DisconnectPayrixDocument, options);
      }
export type DisconnectPayrixMutationHookResult = ReturnType<typeof useDisconnectPayrixMutation>;
export type DisconnectPayrixMutationResult = ApolloReactCommon.MutationResult<DisconnectPayrixMutation>;
export type DisconnectPayrixMutationOptions = ApolloReactCommon.BaseMutationOptions<DisconnectPayrixMutation, DisconnectPayrixMutationVariables>;
export const SwapPayrixMerchantIdDocument = /*#__PURE__*/ gql`
    mutation swapPayrixMerchantId($companyId: String!, $merchantId: String!) {
  swapPayrixMerchantId(companyId: $companyId, merchantId: $merchantId) {
    success
    merchantId
    merchantCreated
  }
}
    `;
export type SwapPayrixMerchantIdMutationFn = ApolloReactCommon.MutationFunction<SwapPayrixMerchantIdMutation, SwapPayrixMerchantIdMutationVariables>;

/**
 * __useSwapPayrixMerchantIdMutation__
 *
 * To run a mutation, you first call `useSwapPayrixMerchantIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapPayrixMerchantIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapPayrixMerchantIdMutation, { data, loading, error }] = useSwapPayrixMerchantIdMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useSwapPayrixMerchantIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SwapPayrixMerchantIdMutation, SwapPayrixMerchantIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SwapPayrixMerchantIdMutation, SwapPayrixMerchantIdMutationVariables>(SwapPayrixMerchantIdDocument, options);
      }
export type SwapPayrixMerchantIdMutationHookResult = ReturnType<typeof useSwapPayrixMerchantIdMutation>;
export type SwapPayrixMerchantIdMutationResult = ApolloReactCommon.MutationResult<SwapPayrixMerchantIdMutation>;
export type SwapPayrixMerchantIdMutationOptions = ApolloReactCommon.BaseMutationOptions<SwapPayrixMerchantIdMutation, SwapPayrixMerchantIdMutationVariables>;
export const PainterScheduleDocument = /*#__PURE__*/ gql`
    query painterSchedule($startDate: String!, $endDate: String!, $skipSanitize: Boolean) {
  painterSchedule(
    startDate: $startDate
    endDate: $endDate
    skipSanitize: $skipSanitize
  ) {
    deals {
      dealId
      event {
        ...FullActivity
      }
      dealJobAddress
      fileCount
      noteCount
      hasPaymentDue
    }
  }
}
    ${FullActivityFragmentDoc}`;

/**
 * __usePainterScheduleQuery__
 *
 * To run a query within a React component, call `usePainterScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePainterScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePainterScheduleQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      skipSanitize: // value for 'skipSanitize'
 *   },
 * });
 */
export function usePainterScheduleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PainterScheduleQuery, PainterScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PainterScheduleQuery, PainterScheduleQueryVariables>(PainterScheduleDocument, options);
      }
export function usePainterScheduleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PainterScheduleQuery, PainterScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PainterScheduleQuery, PainterScheduleQueryVariables>(PainterScheduleDocument, options);
        }
export type PainterScheduleQueryHookResult = ReturnType<typeof usePainterScheduleQuery>;
export type PainterScheduleLazyQueryHookResult = ReturnType<typeof usePainterScheduleLazyQuery>;
export type PainterScheduleQueryResult = ApolloReactCommon.QueryResult<PainterScheduleQuery, PainterScheduleQueryVariables>;
export const PainterScheduleJobDocument = /*#__PURE__*/ gql`
    query painterScheduleJob($dealId: String, $invoiceId: String) {
  painterScheduleJob(dealId: $dealId, invoiceId: $invoiceId) {
    invoices {
      ...PainterScheduleQuote
    }
    dealFiles
  }
}
    ${PainterScheduleQuoteFragmentDoc}`;

/**
 * __usePainterScheduleJobQuery__
 *
 * To run a query within a React component, call `usePainterScheduleJobQuery` and pass it any options that fit your needs.
 * When your component renders, `usePainterScheduleJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePainterScheduleJobQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function usePainterScheduleJobQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PainterScheduleJobQuery, PainterScheduleJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PainterScheduleJobQuery, PainterScheduleJobQueryVariables>(PainterScheduleJobDocument, options);
      }
export function usePainterScheduleJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PainterScheduleJobQuery, PainterScheduleJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PainterScheduleJobQuery, PainterScheduleJobQueryVariables>(PainterScheduleJobDocument, options);
        }
export type PainterScheduleJobQueryHookResult = ReturnType<typeof usePainterScheduleJobQuery>;
export type PainterScheduleJobLazyQueryHookResult = ReturnType<typeof usePainterScheduleJobLazyQuery>;
export type PainterScheduleJobQueryResult = ApolloReactCommon.QueryResult<PainterScheduleJobQuery, PainterScheduleJobQueryVariables>;
export const QuoteDocument = /*#__PURE__*/ gql`
    query quote($id: String!) {
  quote(id: $id)
}
    `;

/**
 * __useQuoteQuery__
 *
 * To run a query within a React component, call `useQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
      }
export function useQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
        }
export type QuoteQueryHookResult = ReturnType<typeof useQuoteQuery>;
export type QuoteLazyQueryHookResult = ReturnType<typeof useQuoteLazyQuery>;
export type QuoteQueryResult = ApolloReactCommon.QueryResult<QuoteQuery, QuoteQueryVariables>;
export const OfflineQuotesDocument = /*#__PURE__*/ gql`
    query offlineQuotes {
  offlineQuotes {
    quotes
    invoices
    contacts {
      ...FullContact
    }
    templates
  }
}
    ${FullContactFragmentDoc}`;

/**
 * __useOfflineQuotesQuery__
 *
 * To run a query within a React component, call `useOfflineQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfflineQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfflineQuotesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfflineQuotesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OfflineQuotesQuery, OfflineQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OfflineQuotesQuery, OfflineQuotesQueryVariables>(OfflineQuotesDocument, options);
      }
export function useOfflineQuotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OfflineQuotesQuery, OfflineQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OfflineQuotesQuery, OfflineQuotesQueryVariables>(OfflineQuotesDocument, options);
        }
export type OfflineQuotesQueryHookResult = ReturnType<typeof useOfflineQuotesQuery>;
export type OfflineQuotesLazyQueryHookResult = ReturnType<typeof useOfflineQuotesLazyQuery>;
export type OfflineQuotesQueryResult = ApolloReactCommon.QueryResult<OfflineQuotesQuery, OfflineQuotesQueryVariables>;
export const SearchQuotesDocument = /*#__PURE__*/ gql`
    query searchQuotes($query: String!, $bookmark: String, $limit: Int, $from: Int, $sort: [String!], $skipSanitize: Boolean) {
  searchQuotes(
    query: $query
    bookmark: $bookmark
    limit: $limit
    from: $from
    sort: $sort
    skipSanitize: $skipSanitize
  ) {
    total_rows
    bookmark
    quotes {
      ...SearchedQuote
    }
  }
}
    ${SearchedQuoteFragmentDoc}`;

/**
 * __useSearchQuotesQuery__
 *
 * To run a query within a React component, call `useSearchQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuotesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      from: // value for 'from'
 *      sort: // value for 'sort'
 *      skipSanitize: // value for 'skipSanitize'
 *   },
 * });
 */
export function useSearchQuotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchQuotesQuery, SearchQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchQuotesQuery, SearchQuotesQueryVariables>(SearchQuotesDocument, options);
      }
export function useSearchQuotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchQuotesQuery, SearchQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchQuotesQuery, SearchQuotesQueryVariables>(SearchQuotesDocument, options);
        }
export type SearchQuotesQueryHookResult = ReturnType<typeof useSearchQuotesQuery>;
export type SearchQuotesLazyQueryHookResult = ReturnType<typeof useSearchQuotesLazyQuery>;
export type SearchQuotesQueryResult = ApolloReactCommon.QueryResult<SearchQuotesQuery, SearchQuotesQueryVariables>;
export const ViewQuoteDocument = /*#__PURE__*/ gql`
    query viewQuote($silent: Boolean, $pdf: Boolean, $revision: Boolean, $email: String, $url: String, $lang: String) {
  viewQuote(
    silent: $silent
    pdf: $pdf
    revision: $revision
    email: $email
    url: $url
    lang: $lang
  ) {
    quote
    options
    estimator
    view
    tableView
    companyId
    decryptedEmail
    availableLangs
    presentationNext
    estimateNext
  }
}
    `;

/**
 * __useViewQuoteQuery__
 *
 * To run a query within a React component, call `useViewQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewQuoteQuery({
 *   variables: {
 *      silent: // value for 'silent'
 *      pdf: // value for 'pdf'
 *      revision: // value for 'revision'
 *      email: // value for 'email'
 *      url: // value for 'url'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useViewQuoteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewQuoteQuery, ViewQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewQuoteQuery, ViewQuoteQueryVariables>(ViewQuoteDocument, options);
      }
export function useViewQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewQuoteQuery, ViewQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewQuoteQuery, ViewQuoteQueryVariables>(ViewQuoteDocument, options);
        }
export type ViewQuoteQueryHookResult = ReturnType<typeof useViewQuoteQuery>;
export type ViewQuoteLazyQueryHookResult = ReturnType<typeof useViewQuoteLazyQuery>;
export type ViewQuoteQueryResult = ApolloReactCommon.QueryResult<ViewQuoteQuery, ViewQuoteQueryVariables>;
export const PaymentProcessedDocument = /*#__PURE__*/ gql`
    query paymentProcessed($id: String!, $balanceDue: Float!, $activityId: String) {
  paymentProcessed(id: $id, balanceDue: $balanceDue, activityId: $activityId) {
    updatedQuote
  }
}
    `;

/**
 * __usePaymentProcessedQuery__
 *
 * To run a query within a React component, call `usePaymentProcessedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentProcessedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentProcessedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      balanceDue: // value for 'balanceDue'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function usePaymentProcessedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaymentProcessedQuery, PaymentProcessedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaymentProcessedQuery, PaymentProcessedQueryVariables>(PaymentProcessedDocument, options);
      }
export function usePaymentProcessedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaymentProcessedQuery, PaymentProcessedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaymentProcessedQuery, PaymentProcessedQueryVariables>(PaymentProcessedDocument, options);
        }
export type PaymentProcessedQueryHookResult = ReturnType<typeof usePaymentProcessedQuery>;
export type PaymentProcessedLazyQueryHookResult = ReturnType<typeof usePaymentProcessedLazyQuery>;
export type PaymentProcessedQueryResult = ApolloReactCommon.QueryResult<PaymentProcessedQuery, PaymentProcessedQueryVariables>;
export const ClientQuoteDocument = /*#__PURE__*/ gql`
    query clientQuote($id: String!, $companyId: String!) {
  clientQuote(id: $id, companyId: $companyId)
}
    `;

/**
 * __useClientQuoteQuery__
 *
 * To run a query within a React component, call `useClientQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useClientQuoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClientQuoteQuery, ClientQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientQuoteQuery, ClientQuoteQueryVariables>(ClientQuoteDocument, options);
      }
export function useClientQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientQuoteQuery, ClientQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientQuoteQuery, ClientQuoteQueryVariables>(ClientQuoteDocument, options);
        }
export type ClientQuoteQueryHookResult = ReturnType<typeof useClientQuoteQuery>;
export type ClientQuoteLazyQueryHookResult = ReturnType<typeof useClientQuoteLazyQuery>;
export type ClientQuoteQueryResult = ApolloReactCommon.QueryResult<ClientQuoteQuery, ClientQuoteQueryVariables>;
export const QuoteUrlDocument = /*#__PURE__*/ gql`
    query quoteUrl($id: String!, $rev: String!, $view: String!) {
  quoteUrl(id: $id, rev: $rev, view: $view) {
    url {
      _id
      link
    }
    quote
  }
}
    `;

/**
 * __useQuoteUrlQuery__
 *
 * To run a query within a React component, call `useQuoteUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      rev: // value for 'rev'
 *      view: // value for 'view'
 *   },
 * });
 */
export function useQuoteUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuoteUrlQuery, QuoteUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuoteUrlQuery, QuoteUrlQueryVariables>(QuoteUrlDocument, options);
      }
export function useQuoteUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuoteUrlQuery, QuoteUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuoteUrlQuery, QuoteUrlQueryVariables>(QuoteUrlDocument, options);
        }
export type QuoteUrlQueryHookResult = ReturnType<typeof useQuoteUrlQuery>;
export type QuoteUrlLazyQueryHookResult = ReturnType<typeof useQuoteUrlLazyQuery>;
export type QuoteUrlQueryResult = ApolloReactCommon.QueryResult<QuoteUrlQuery, QuoteUrlQueryVariables>;
export const SearchClientQuotesDocument = /*#__PURE__*/ gql`
    query searchClientQuotes($query: String!, $companyId: String!, $bookmark: String, $limit: Int, $sort: [String!]) {
  searchClientQuotes(
    query: $query
    companyId: $companyId
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    total_rows
    bookmark
    rawQuotes
  }
}
    `;

/**
 * __useSearchClientQuotesQuery__
 *
 * To run a query within a React component, call `useSearchClientQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClientQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClientQuotesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      companyId: // value for 'companyId'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchClientQuotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchClientQuotesQuery, SearchClientQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchClientQuotesQuery, SearchClientQuotesQueryVariables>(SearchClientQuotesDocument, options);
      }
export function useSearchClientQuotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchClientQuotesQuery, SearchClientQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchClientQuotesQuery, SearchClientQuotesQueryVariables>(SearchClientQuotesDocument, options);
        }
export type SearchClientQuotesQueryHookResult = ReturnType<typeof useSearchClientQuotesQuery>;
export type SearchClientQuotesLazyQueryHookResult = ReturnType<typeof useSearchClientQuotesLazyQuery>;
export type SearchClientQuotesQueryResult = ApolloReactCommon.QueryResult<SearchClientQuotesQuery, SearchClientQuotesQueryVariables>;
export const QuoteSummaryDocument = /*#__PURE__*/ gql`
    query quoteSummary($query: String!) {
  quoteSummary(query: $query) {
    totalQuotes
    totalQuotePrice
    openQuotes
    openQuotePrice
    wonQuotes
    wonQuotePrice
    closedQuotes
    closedQuotePrice
    closeRate
    winRate
    dollarsWon
    averageClosePrice
    averageQuotePrice
    averageOpenPrice
    averageWonPrice
  }
}
    `;

/**
 * __useQuoteSummaryQuery__
 *
 * To run a query within a React component, call `useQuoteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteSummaryQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useQuoteSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuoteSummaryQuery, QuoteSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuoteSummaryQuery, QuoteSummaryQueryVariables>(QuoteSummaryDocument, options);
      }
export function useQuoteSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuoteSummaryQuery, QuoteSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuoteSummaryQuery, QuoteSummaryQueryVariables>(QuoteSummaryDocument, options);
        }
export type QuoteSummaryQueryHookResult = ReturnType<typeof useQuoteSummaryQuery>;
export type QuoteSummaryLazyQueryHookResult = ReturnType<typeof useQuoteSummaryLazyQuery>;
export type QuoteSummaryQueryResult = ApolloReactCommon.QueryResult<QuoteSummaryQuery, QuoteSummaryQueryVariables>;
export const LinkDealDocument = /*#__PURE__*/ gql`
    mutation linkDeal($quoteId: String!, $dealId: String!, $updateJobAddress: Boolean) {
  linkDeal(
    quoteId: $quoteId
    dealId: $dealId
    updateJobAddress: $updateJobAddress
  )
}
    `;
export type LinkDealMutationFn = ApolloReactCommon.MutationFunction<LinkDealMutation, LinkDealMutationVariables>;

/**
 * __useLinkDealMutation__
 *
 * To run a mutation, you first call `useLinkDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkDealMutation, { data, loading, error }] = useLinkDealMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      dealId: // value for 'dealId'
 *      updateJobAddress: // value for 'updateJobAddress'
 *   },
 * });
 */
export function useLinkDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkDealMutation, LinkDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkDealMutation, LinkDealMutationVariables>(LinkDealDocument, options);
      }
export type LinkDealMutationHookResult = ReturnType<typeof useLinkDealMutation>;
export type LinkDealMutationResult = ApolloReactCommon.MutationResult<LinkDealMutation>;
export type LinkDealMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkDealMutation, LinkDealMutationVariables>;
export const UnlinkDealDocument = /*#__PURE__*/ gql`
    mutation unlinkDeal($quoteId: String!) {
  unlinkDeal(quoteId: $quoteId)
}
    `;
export type UnlinkDealMutationFn = ApolloReactCommon.MutationFunction<UnlinkDealMutation, UnlinkDealMutationVariables>;

/**
 * __useUnlinkDealMutation__
 *
 * To run a mutation, you first call `useUnlinkDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkDealMutation, { data, loading, error }] = useUnlinkDealMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useUnlinkDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlinkDealMutation, UnlinkDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlinkDealMutation, UnlinkDealMutationVariables>(UnlinkDealDocument, options);
      }
export type UnlinkDealMutationHookResult = ReturnType<typeof useUnlinkDealMutation>;
export type UnlinkDealMutationResult = ApolloReactCommon.MutationResult<UnlinkDealMutation>;
export type UnlinkDealMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlinkDealMutation, UnlinkDealMutationVariables>;
export const AcceptQuoteDocument = /*#__PURE__*/ gql`
    mutation acceptQuote($quote: JSON!, $signature: String, $quoteId: String) {
  acceptQuote(quote: $quote, signature: $signature, quoteId: $quoteId) {
    quote
  }
}
    `;
export type AcceptQuoteMutationFn = ApolloReactCommon.MutationFunction<AcceptQuoteMutation, AcceptQuoteMutationVariables>;

/**
 * __useAcceptQuoteMutation__
 *
 * To run a mutation, you first call `useAcceptQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptQuoteMutation, { data, loading, error }] = useAcceptQuoteMutation({
 *   variables: {
 *      quote: // value for 'quote'
 *      signature: // value for 'signature'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useAcceptQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptQuoteMutation, AcceptQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptQuoteMutation, AcceptQuoteMutationVariables>(AcceptQuoteDocument, options);
      }
export type AcceptQuoteMutationHookResult = ReturnType<typeof useAcceptQuoteMutation>;
export type AcceptQuoteMutationResult = ApolloReactCommon.MutationResult<AcceptQuoteMutation>;
export type AcceptQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptQuoteMutation, AcceptQuoteMutationVariables>;
export const DeclineQuoteDocument = /*#__PURE__*/ gql`
    mutation declineQuote($rev: String!, $reason: String!) {
  declineQuote(rev: $rev, reason: $reason) {
    quote
  }
}
    `;
export type DeclineQuoteMutationFn = ApolloReactCommon.MutationFunction<DeclineQuoteMutation, DeclineQuoteMutationVariables>;

/**
 * __useDeclineQuoteMutation__
 *
 * To run a mutation, you first call `useDeclineQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineQuoteMutation, { data, loading, error }] = useDeclineQuoteMutation({
 *   variables: {
 *      rev: // value for 'rev'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeclineQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeclineQuoteMutation, DeclineQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclineQuoteMutation, DeclineQuoteMutationVariables>(DeclineQuoteDocument, options);
      }
export type DeclineQuoteMutationHookResult = ReturnType<typeof useDeclineQuoteMutation>;
export type DeclineQuoteMutationResult = ApolloReactCommon.MutationResult<DeclineQuoteMutation>;
export type DeclineQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeclineQuoteMutation, DeclineQuoteMutationVariables>;
export const AcceptAdditionalWorkDocument = /*#__PURE__*/ gql`
    mutation acceptAdditionalWork($rev: String!, $signature: String, $quoteId: String, $note: String) {
  acceptAdditionalWork(
    rev: $rev
    signature: $signature
    quoteId: $quoteId
    note: $note
  ) {
    quote
  }
}
    `;
export type AcceptAdditionalWorkMutationFn = ApolloReactCommon.MutationFunction<AcceptAdditionalWorkMutation, AcceptAdditionalWorkMutationVariables>;

/**
 * __useAcceptAdditionalWorkMutation__
 *
 * To run a mutation, you first call `useAcceptAdditionalWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAdditionalWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAdditionalWorkMutation, { data, loading, error }] = useAcceptAdditionalWorkMutation({
 *   variables: {
 *      rev: // value for 'rev'
 *      signature: // value for 'signature'
 *      quoteId: // value for 'quoteId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAcceptAdditionalWorkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptAdditionalWorkMutation, AcceptAdditionalWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptAdditionalWorkMutation, AcceptAdditionalWorkMutationVariables>(AcceptAdditionalWorkDocument, options);
      }
export type AcceptAdditionalWorkMutationHookResult = ReturnType<typeof useAcceptAdditionalWorkMutation>;
export type AcceptAdditionalWorkMutationResult = ApolloReactCommon.MutationResult<AcceptAdditionalWorkMutation>;
export type AcceptAdditionalWorkMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptAdditionalWorkMutation, AcceptAdditionalWorkMutationVariables>;
export const SaveQuoteDocument = /*#__PURE__*/ gql`
    mutation saveQuote($quote: JSON!, $force: Boolean, $autosave: Boolean) {
  saveQuote(quote: $quote, force: $force, autosave: $autosave)
}
    `;
export type SaveQuoteMutationFn = ApolloReactCommon.MutationFunction<SaveQuoteMutation, SaveQuoteMutationVariables>;

/**
 * __useSaveQuoteMutation__
 *
 * To run a mutation, you first call `useSaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuoteMutation, { data, loading, error }] = useSaveQuoteMutation({
 *   variables: {
 *      quote: // value for 'quote'
 *      force: // value for 'force'
 *      autosave: // value for 'autosave'
 *   },
 * });
 */
export function useSaveQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveQuoteMutation, SaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveQuoteMutation, SaveQuoteMutationVariables>(SaveQuoteDocument, options);
      }
export type SaveQuoteMutationHookResult = ReturnType<typeof useSaveQuoteMutation>;
export type SaveQuoteMutationResult = ApolloReactCommon.MutationResult<SaveQuoteMutation>;
export type SaveQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveQuoteMutation, SaveQuoteMutationVariables>;
export const DeleteQuotesDocument = /*#__PURE__*/ gql`
    mutation deleteQuotes($ids: [String!]!, $softDelete: Boolean) {
  deleteQuotes(ids: $ids, softDelete: $softDelete) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type DeleteQuotesMutationFn = ApolloReactCommon.MutationFunction<DeleteQuotesMutation, DeleteQuotesMutationVariables>;

/**
 * __useDeleteQuotesMutation__
 *
 * To run a mutation, you first call `useDeleteQuotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuotesMutation, { data, loading, error }] = useDeleteQuotesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      softDelete: // value for 'softDelete'
 *   },
 * });
 */
export function useDeleteQuotesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteQuotesMutation, DeleteQuotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteQuotesMutation, DeleteQuotesMutationVariables>(DeleteQuotesDocument, options);
      }
export type DeleteQuotesMutationHookResult = ReturnType<typeof useDeleteQuotesMutation>;
export type DeleteQuotesMutationResult = ApolloReactCommon.MutationResult<DeleteQuotesMutation>;
export type DeleteQuotesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteQuotesMutation, DeleteQuotesMutationVariables>;
export const ArchiveQuotesDocument = /*#__PURE__*/ gql`
    mutation archiveQuotes($ids: [String!]!, $unarchive: Boolean) {
  archiveQuotes(ids: $ids, unarchive: $unarchive) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type ArchiveQuotesMutationFn = ApolloReactCommon.MutationFunction<ArchiveQuotesMutation, ArchiveQuotesMutationVariables>;

/**
 * __useArchiveQuotesMutation__
 *
 * To run a mutation, you first call `useArchiveQuotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveQuotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveQuotesMutation, { data, loading, error }] = useArchiveQuotesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      unarchive: // value for 'unarchive'
 *   },
 * });
 */
export function useArchiveQuotesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveQuotesMutation, ArchiveQuotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveQuotesMutation, ArchiveQuotesMutationVariables>(ArchiveQuotesDocument, options);
      }
export type ArchiveQuotesMutationHookResult = ReturnType<typeof useArchiveQuotesMutation>;
export type ArchiveQuotesMutationResult = ApolloReactCommon.MutationResult<ArchiveQuotesMutation>;
export type ArchiveQuotesMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveQuotesMutation, ArchiveQuotesMutationVariables>;
export const SendQuoteDocument = /*#__PURE__*/ gql`
    mutation sendQuote($id: String!, $view: String!, $emails: [QuoteEmailInput!]!, $revision: Boolean) {
  sendQuote(id: $id, emails: $emails, view: $view, revision: $revision) {
    quote
    emails {
      headers
      response
    }
    urlDocId
  }
}
    `;
export type SendQuoteMutationFn = ApolloReactCommon.MutationFunction<SendQuoteMutation, SendQuoteMutationVariables>;

/**
 * __useSendQuoteMutation__
 *
 * To run a mutation, you first call `useSendQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuoteMutation, { data, loading, error }] = useSendQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      view: // value for 'view'
 *      emails: // value for 'emails'
 *      revision: // value for 'revision'
 *   },
 * });
 */
export function useSendQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendQuoteMutation, SendQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendQuoteMutation, SendQuoteMutationVariables>(SendQuoteDocument, options);
      }
export type SendQuoteMutationHookResult = ReturnType<typeof useSendQuoteMutation>;
export type SendQuoteMutationResult = ApolloReactCommon.MutationResult<SendQuoteMutation>;
export type SendQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SendQuoteMutation, SendQuoteMutationVariables>;
export const RequestReviewDocument = /*#__PURE__*/ gql`
    mutation requestReview($sms: ReviewSmsInput!, $content: String!, $quoteId: String, $contactId: String) {
  requestReview(
    sms: $sms
    content: $content
    quoteId: $quoteId
    contactId: $contactId
  ) {
    result
  }
}
    `;
export type RequestReviewMutationFn = ApolloReactCommon.MutationFunction<RequestReviewMutation, RequestReviewMutationVariables>;

/**
 * __useRequestReviewMutation__
 *
 * To run a mutation, you first call `useRequestReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReviewMutation, { data, loading, error }] = useRequestReviewMutation({
 *   variables: {
 *      sms: // value for 'sms'
 *      content: // value for 'content'
 *      quoteId: // value for 'quoteId'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useRequestReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestReviewMutation, RequestReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestReviewMutation, RequestReviewMutationVariables>(RequestReviewDocument, options);
      }
export type RequestReviewMutationHookResult = ReturnType<typeof useRequestReviewMutation>;
export type RequestReviewMutationResult = ApolloReactCommon.MutationResult<RequestReviewMutation>;
export type RequestReviewMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestReviewMutation, RequestReviewMutationVariables>;
export const RequestPaymentDocument = /*#__PURE__*/ gql`
    mutation requestPayment($quoteId: String!, $paymentId: String!, $email: PaymentRequestEmailInput!) {
  requestPayment(quoteId: $quoteId, paymentId: $paymentId, email: $email)
}
    `;
export type RequestPaymentMutationFn = ApolloReactCommon.MutationFunction<RequestPaymentMutation, RequestPaymentMutationVariables>;

/**
 * __useRequestPaymentMutation__
 *
 * To run a mutation, you first call `useRequestPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPaymentMutation, { data, loading, error }] = useRequestPaymentMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      paymentId: // value for 'paymentId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestPaymentMutation, RequestPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestPaymentMutation, RequestPaymentMutationVariables>(RequestPaymentDocument, options);
      }
export type RequestPaymentMutationHookResult = ReturnType<typeof useRequestPaymentMutation>;
export type RequestPaymentMutationResult = ApolloReactCommon.MutationResult<RequestPaymentMutation>;
export type RequestPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestPaymentMutation, RequestPaymentMutationVariables>;
export const RecoverInvoiceDocument = /*#__PURE__*/ gql`
    mutation recoverInvoice($id: String!) {
  recoverInvoice(id: $id) {
    quote
  }
}
    `;
export type RecoverInvoiceMutationFn = ApolloReactCommon.MutationFunction<RecoverInvoiceMutation, RecoverInvoiceMutationVariables>;

/**
 * __useRecoverInvoiceMutation__
 *
 * To run a mutation, you first call `useRecoverInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverInvoiceMutation, { data, loading, error }] = useRecoverInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecoverInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecoverInvoiceMutation, RecoverInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecoverInvoiceMutation, RecoverInvoiceMutationVariables>(RecoverInvoiceDocument, options);
      }
export type RecoverInvoiceMutationHookResult = ReturnType<typeof useRecoverInvoiceMutation>;
export type RecoverInvoiceMutationResult = ApolloReactCommon.MutationResult<RecoverInvoiceMutation>;
export type RecoverInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<RecoverInvoiceMutation, RecoverInvoiceMutationVariables>;
export const SaveClientQuoteDocument = /*#__PURE__*/ gql`
    mutation saveClientQuote($quote: JSON!, $companyId: String!, $clean: Boolean) {
  saveClientQuote(quote: $quote, companyId: $companyId, clean: $clean)
}
    `;
export type SaveClientQuoteMutationFn = ApolloReactCommon.MutationFunction<SaveClientQuoteMutation, SaveClientQuoteMutationVariables>;

/**
 * __useSaveClientQuoteMutation__
 *
 * To run a mutation, you first call `useSaveClientQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientQuoteMutation, { data, loading, error }] = useSaveClientQuoteMutation({
 *   variables: {
 *      quote: // value for 'quote'
 *      companyId: // value for 'companyId'
 *      clean: // value for 'clean'
 *   },
 * });
 */
export function useSaveClientQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveClientQuoteMutation, SaveClientQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveClientQuoteMutation, SaveClientQuoteMutationVariables>(SaveClientQuoteDocument, options);
      }
export type SaveClientQuoteMutationHookResult = ReturnType<typeof useSaveClientQuoteMutation>;
export type SaveClientQuoteMutationResult = ApolloReactCommon.MutationResult<SaveClientQuoteMutation>;
export type SaveClientQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveClientQuoteMutation, SaveClientQuoteMutationVariables>;
export const SyncQuoteDocument = /*#__PURE__*/ gql`
    mutation syncQuote($id: String!, $rev: String!) {
  syncQuote(id: $id, rev: $rev)
}
    `;
export type SyncQuoteMutationFn = ApolloReactCommon.MutationFunction<SyncQuoteMutation, SyncQuoteMutationVariables>;

/**
 * __useSyncQuoteMutation__
 *
 * To run a mutation, you first call `useSyncQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncQuoteMutation, { data, loading, error }] = useSyncQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rev: // value for 'rev'
 *   },
 * });
 */
export function useSyncQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncQuoteMutation, SyncQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncQuoteMutation, SyncQuoteMutationVariables>(SyncQuoteDocument, options);
      }
export type SyncQuoteMutationHookResult = ReturnType<typeof useSyncQuoteMutation>;
export type SyncQuoteMutationResult = ApolloReactCommon.MutationResult<SyncQuoteMutation>;
export type SyncQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncQuoteMutation, SyncQuoteMutationVariables>;
export const DeletePaymentDocument = /*#__PURE__*/ gql`
    mutation deletePayment($quoteId: String!, $paymentId: String!) {
  deletePayment(quoteId: $quoteId, paymentId: $paymentId) {
    updatedQuote
  }
}
    `;
export type DeletePaymentMutationFn = ApolloReactCommon.MutationFunction<DeletePaymentMutation, DeletePaymentMutationVariables>;

/**
 * __useDeletePaymentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMutation, { data, loading, error }] = useDeletePaymentMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDeletePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePaymentMutation, DeletePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePaymentMutation, DeletePaymentMutationVariables>(DeletePaymentDocument, options);
      }
export type DeletePaymentMutationHookResult = ReturnType<typeof useDeletePaymentMutation>;
export type DeletePaymentMutationResult = ApolloReactCommon.MutationResult<DeletePaymentMutation>;
export type DeletePaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const UpdatePaymentDocument = /*#__PURE__*/ gql`
    mutation updatePayment($quoteId: String!, $paymentId: String!, $note: String) {
  updatePayment(quoteId: $quoteId, paymentId: $paymentId, note: $note) {
    updatedQuote
  }
}
    `;
export type UpdatePaymentMutationFn = ApolloReactCommon.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      paymentId: // value for 'paymentId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = ApolloReactCommon.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const AddProcessingPaymentDocument = /*#__PURE__*/ gql`
    mutation addProcessingPayment($quoteId: String!, $activityId: String!, $amount: Float!, $type: String!, $note: String, $deposit: Boolean, $txnId: String, $paymentRequestId: String, $source: String, $surcharge: Float) {
  addProcessingPayment(
    quoteId: $quoteId
    activityId: $activityId
    amount: $amount
    type: $type
    note: $note
    deposit: $deposit
    txnId: $txnId
    paymentRequestId: $paymentRequestId
    source: $source
    surcharge: $surcharge
  ) {
    updatedQuote
  }
}
    `;
export type AddProcessingPaymentMutationFn = ApolloReactCommon.MutationFunction<AddProcessingPaymentMutation, AddProcessingPaymentMutationVariables>;

/**
 * __useAddProcessingPaymentMutation__
 *
 * To run a mutation, you first call `useAddProcessingPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProcessingPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProcessingPaymentMutation, { data, loading, error }] = useAddProcessingPaymentMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      activityId: // value for 'activityId'
 *      amount: // value for 'amount'
 *      type: // value for 'type'
 *      note: // value for 'note'
 *      deposit: // value for 'deposit'
 *      txnId: // value for 'txnId'
 *      paymentRequestId: // value for 'paymentRequestId'
 *      source: // value for 'source'
 *      surcharge: // value for 'surcharge'
 *   },
 * });
 */
export function useAddProcessingPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProcessingPaymentMutation, AddProcessingPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProcessingPaymentMutation, AddProcessingPaymentMutationVariables>(AddProcessingPaymentDocument, options);
      }
export type AddProcessingPaymentMutationHookResult = ReturnType<typeof useAddProcessingPaymentMutation>;
export type AddProcessingPaymentMutationResult = ApolloReactCommon.MutationResult<AddProcessingPaymentMutation>;
export type AddProcessingPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProcessingPaymentMutation, AddProcessingPaymentMutationVariables>;
export const TaskDocument = /*#__PURE__*/ gql`
    query task($id: String!) {
  task(id: $id) {
    ...FullTask
  }
}
    ${FullTaskFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskQuery, TaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = ApolloReactCommon.QueryResult<TaskQuery, TaskQueryVariables>;
export const SearchLooseyTasksDocument = /*#__PURE__*/ gql`
    query searchLooseyTasks($query: String!, $bookmark: String, $limit: Int = 20, $sort: [String!], $skipSanitize: Boolean) {
  searchTasks(
    query: $query
    bookmark: $bookmark
    limit: $limit
    sort: $sort
    skipSanitize: $skipSanitize
  ) {
    total_rows
    bookmark
    tasks {
      ...SearchedTask
    }
  }
}
    ${SearchedTaskFragmentDoc}`;

/**
 * __useSearchLooseyTasksQuery__
 *
 * To run a query within a React component, call `useSearchLooseyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLooseyTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLooseyTasksQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      skipSanitize: // value for 'skipSanitize'
 *   },
 * });
 */
export function useSearchLooseyTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchLooseyTasksQuery, SearchLooseyTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchLooseyTasksQuery, SearchLooseyTasksQueryVariables>(SearchLooseyTasksDocument, options);
      }
export function useSearchLooseyTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchLooseyTasksQuery, SearchLooseyTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchLooseyTasksQuery, SearchLooseyTasksQueryVariables>(SearchLooseyTasksDocument, options);
        }
export type SearchLooseyTasksQueryHookResult = ReturnType<typeof useSearchLooseyTasksQuery>;
export type SearchLooseyTasksLazyQueryHookResult = ReturnType<typeof useSearchLooseyTasksLazyQuery>;
export type SearchLooseyTasksQueryResult = ApolloReactCommon.QueryResult<SearchLooseyTasksQuery, SearchLooseyTasksQueryVariables>;
export const SearchTemplateTasksDocument = /*#__PURE__*/ gql`
    query searchTemplateTasks($query: String!, $bookmark: String, $limit: Int = 20, $sort: [String!], $skipSanitize: Boolean) {
  searchTasks(
    query: $query
    bookmark: $bookmark
    limit: $limit
    sort: $sort
    skipSanitize: $skipSanitize
  ) {
    total_rows
    bookmark
    tasks {
      ...SearchedTask
    }
  }
}
    ${SearchedTaskFragmentDoc}`;

/**
 * __useSearchTemplateTasksQuery__
 *
 * To run a query within a React component, call `useSearchTemplateTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTemplateTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTemplateTasksQuery({
 *   variables: {
 *      query: // value for 'query'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      skipSanitize: // value for 'skipSanitize'
 *   },
 * });
 */
export function useSearchTemplateTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchTemplateTasksQuery, SearchTemplateTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchTemplateTasksQuery, SearchTemplateTasksQueryVariables>(SearchTemplateTasksDocument, options);
      }
export function useSearchTemplateTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTemplateTasksQuery, SearchTemplateTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchTemplateTasksQuery, SearchTemplateTasksQueryVariables>(SearchTemplateTasksDocument, options);
        }
export type SearchTemplateTasksQueryHookResult = ReturnType<typeof useSearchTemplateTasksQuery>;
export type SearchTemplateTasksLazyQueryHookResult = ReturnType<typeof useSearchTemplateTasksLazyQuery>;
export type SearchTemplateTasksQueryResult = ApolloReactCommon.QueryResult<SearchTemplateTasksQuery, SearchTemplateTasksQueryVariables>;
export const SearchTasksByContactDocument = /*#__PURE__*/ gql`
    query searchTasksByContact($contactId: String!, $bookmark: String, $limit: Int = 20, $sort: [String!]) {
  searchTasksByContact(
    contactId: $contactId
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    total_rows
    bookmark
    tasks {
      ...SearchedTask
    }
  }
}
    ${SearchedTaskFragmentDoc}`;

/**
 * __useSearchTasksByContactQuery__
 *
 * To run a query within a React component, call `useSearchTasksByContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTasksByContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTasksByContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchTasksByContactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchTasksByContactQuery, SearchTasksByContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchTasksByContactQuery, SearchTasksByContactQueryVariables>(SearchTasksByContactDocument, options);
      }
export function useSearchTasksByContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTasksByContactQuery, SearchTasksByContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchTasksByContactQuery, SearchTasksByContactQueryVariables>(SearchTasksByContactDocument, options);
        }
export type SearchTasksByContactQueryHookResult = ReturnType<typeof useSearchTasksByContactQuery>;
export type SearchTasksByContactLazyQueryHookResult = ReturnType<typeof useSearchTasksByContactLazyQuery>;
export type SearchTasksByContactQueryResult = ApolloReactCommon.QueryResult<SearchTasksByContactQuery, SearchTasksByContactQueryVariables>;
export const SearchTasksByCompanyDocument = /*#__PURE__*/ gql`
    query searchTasksByCompany($companyId: String!, $bookmark: String, $limit: Int = 20, $sort: [String!]) {
  searchTasksByCompany(
    companyId: $companyId
    bookmark: $bookmark
    limit: $limit
    sort: $sort
  ) {
    total_rows
    bookmark
    tasks {
      ...SearchedTask
    }
  }
}
    ${SearchedTaskFragmentDoc}`;

/**
 * __useSearchTasksByCompanyQuery__
 *
 * To run a query within a React component, call `useSearchTasksByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTasksByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTasksByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      bookmark: // value for 'bookmark'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchTasksByCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchTasksByCompanyQuery, SearchTasksByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchTasksByCompanyQuery, SearchTasksByCompanyQueryVariables>(SearchTasksByCompanyDocument, options);
      }
export function useSearchTasksByCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTasksByCompanyQuery, SearchTasksByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchTasksByCompanyQuery, SearchTasksByCompanyQueryVariables>(SearchTasksByCompanyDocument, options);
        }
export type SearchTasksByCompanyQueryHookResult = ReturnType<typeof useSearchTasksByCompanyQuery>;
export type SearchTasksByCompanyLazyQueryHookResult = ReturnType<typeof useSearchTasksByCompanyLazyQuery>;
export type SearchTasksByCompanyQueryResult = ApolloReactCommon.QueryResult<SearchTasksByCompanyQuery, SearchTasksByCompanyQueryVariables>;
export const TaskCountsDocument = /*#__PURE__*/ gql`
    query taskCounts($query: String!, $skipSanitize: Boolean) {
  taskCounts(query: $query, skipSanitize: $skipSanitize) {
    total
    completed
    remaining
  }
}
    `;

/**
 * __useTaskCountsQuery__
 *
 * To run a query within a React component, call `useTaskCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCountsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      skipSanitize: // value for 'skipSanitize'
 *   },
 * });
 */
export function useTaskCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskCountsQuery, TaskCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCountsQuery, TaskCountsQueryVariables>(TaskCountsDocument, options);
      }
export function useTaskCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCountsQuery, TaskCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCountsQuery, TaskCountsQueryVariables>(TaskCountsDocument, options);
        }
export type TaskCountsQueryHookResult = ReturnType<typeof useTaskCountsQuery>;
export type TaskCountsLazyQueryHookResult = ReturnType<typeof useTaskCountsLazyQuery>;
export type TaskCountsQueryResult = ApolloReactCommon.QueryResult<TaskCountsQuery, TaskCountsQueryVariables>;
export const SaveTaskDocument = /*#__PURE__*/ gql`
    mutation saveTask($task: JSON!, $skipActivity: Boolean) {
  saveTask(task: $task, skipActivity: $skipActivity) {
    ...FullTask
  }
}
    ${FullTaskFragmentDoc}`;
export type SaveTaskMutationFn = ApolloReactCommon.MutationFunction<SaveTaskMutation, SaveTaskMutationVariables>;

/**
 * __useSaveTaskMutation__
 *
 * To run a mutation, you first call `useSaveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTaskMutation, { data, loading, error }] = useSaveTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *      skipActivity: // value for 'skipActivity'
 *   },
 * });
 */
export function useSaveTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTaskMutation, SaveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTaskMutation, SaveTaskMutationVariables>(SaveTaskDocument, options);
      }
export type SaveTaskMutationHookResult = ReturnType<typeof useSaveTaskMutation>;
export type SaveTaskMutationResult = ApolloReactCommon.MutationResult<SaveTaskMutation>;
export type SaveTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveTaskMutation, SaveTaskMutationVariables>;
export const DeleteTasksDocument = /*#__PURE__*/ gql`
    mutation deleteTasks($ids: [String!]!, $softDelete: Boolean) {
  deleteTasks(ids: $ids, softDelete: $softDelete) {
    _id
    _rev
    error
    reason
  }
}
    `;
export type DeleteTasksMutationFn = ApolloReactCommon.MutationFunction<DeleteTasksMutation, DeleteTasksMutationVariables>;

/**
 * __useDeleteTasksMutation__
 *
 * To run a mutation, you first call `useDeleteTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTasksMutation, { data, loading, error }] = useDeleteTasksMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      softDelete: // value for 'softDelete'
 *   },
 * });
 */
export function useDeleteTasksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTasksMutation, DeleteTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTasksMutation, DeleteTasksMutationVariables>(DeleteTasksDocument, options);
      }
export type DeleteTasksMutationHookResult = ReturnType<typeof useDeleteTasksMutation>;
export type DeleteTasksMutationResult = ApolloReactCommon.MutationResult<DeleteTasksMutation>;
export type DeleteTasksMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTasksMutation, DeleteTasksMutationVariables>;
export const WeatherDocument = /*#__PURE__*/ gql`
    query Weather($startDate: String!, $endDate: String!) {
  weather(startDate: $startDate, endDate: $endDate) {
    time
    temperature
    temperatureMin
    temperatureMax
    weatherCode
    precipitationProbability
  }
}
    `;

/**
 * __useWeatherQuery__
 *
 * To run a query within a React component, call `useWeatherQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useWeatherQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeatherQuery, WeatherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeatherQuery, WeatherQueryVariables>(WeatherDocument, options);
      }
export function useWeatherLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeatherQuery, WeatherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeatherQuery, WeatherQueryVariables>(WeatherDocument, options);
        }
export type WeatherQueryHookResult = ReturnType<typeof useWeatherQuery>;
export type WeatherLazyQueryHookResult = ReturnType<typeof useWeatherLazyQuery>;
export type WeatherQueryResult = ApolloReactCommon.QueryResult<WeatherQuery, WeatherQueryVariables>;
export const GetWebhooksDocument = /*#__PURE__*/ gql`
    query getWebhooks($companyId: String!) {
  getWebhooks(companyId: $companyId) {
    rows {
      ...FullWebhookType
    }
    total
  }
}
    ${FullWebhookTypeFragmentDoc}`;

/**
 * __useGetWebhooksQuery__
 *
 * To run a query within a React component, call `useGetWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhooksQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetWebhooksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWebhooksQuery, GetWebhooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWebhooksQuery, GetWebhooksQueryVariables>(GetWebhooksDocument, options);
      }
export function useGetWebhooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebhooksQuery, GetWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWebhooksQuery, GetWebhooksQueryVariables>(GetWebhooksDocument, options);
        }
export type GetWebhooksQueryHookResult = ReturnType<typeof useGetWebhooksQuery>;
export type GetWebhooksLazyQueryHookResult = ReturnType<typeof useGetWebhooksLazyQuery>;
export type GetWebhooksQueryResult = ApolloReactCommon.QueryResult<GetWebhooksQuery, GetWebhooksQueryVariables>;
export const GetWebhookEventsDocument = /*#__PURE__*/ gql`
    query getWebhookEvents($companyId: String!, $webhookId: String, $status: String, $event: String, $limit: Int, $from: Int) {
  getWebhookEvents(
    companyId: $companyId
    webhookId: $webhookId
    status: $status
    event: $event
    limit: $limit
    from: $from
  ) {
    rows {
      ...FullWebhookEventType
    }
    total
  }
}
    ${FullWebhookEventTypeFragmentDoc}`;

/**
 * __useGetWebhookEventsQuery__
 *
 * To run a query within a React component, call `useGetWebhookEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookEventsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      webhookId: // value for 'webhookId'
 *      status: // value for 'status'
 *      event: // value for 'event'
 *      limit: // value for 'limit'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetWebhookEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
      }
export function useGetWebhookEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
        }
export type GetWebhookEventsQueryHookResult = ReturnType<typeof useGetWebhookEventsQuery>;
export type GetWebhookEventsLazyQueryHookResult = ReturnType<typeof useGetWebhookEventsLazyQuery>;
export type GetWebhookEventsQueryResult = ApolloReactCommon.QueryResult<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>;
export const UpdateWebhookEnabledDocument = /*#__PURE__*/ gql`
    mutation updateWebhookEnabled($companyId: String!, $webhookId: String!, $enabled: Boolean!) {
  updateWebhookEnabled(
    companyId: $companyId
    webhookId: $webhookId
    enabled: $enabled
  ) {
    ...FullWebhookType
  }
}
    ${FullWebhookTypeFragmentDoc}`;
export type UpdateWebhookEnabledMutationFn = ApolloReactCommon.MutationFunction<UpdateWebhookEnabledMutation, UpdateWebhookEnabledMutationVariables>;

/**
 * __useUpdateWebhookEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookEnabledMutation, { data, loading, error }] = useUpdateWebhookEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      webhookId: // value for 'webhookId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateWebhookEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebhookEnabledMutation, UpdateWebhookEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebhookEnabledMutation, UpdateWebhookEnabledMutationVariables>(UpdateWebhookEnabledDocument, options);
      }
export type UpdateWebhookEnabledMutationHookResult = ReturnType<typeof useUpdateWebhookEnabledMutation>;
export type UpdateWebhookEnabledMutationResult = ApolloReactCommon.MutationResult<UpdateWebhookEnabledMutation>;
export type UpdateWebhookEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWebhookEnabledMutation, UpdateWebhookEnabledMutationVariables>;